import esLocale from '@one/one-vue/dist/locale/es.mjs'

export default {
    cmr_draft: {
      new: {
        origin_place: 'Lugar de origen',
        destination_place: 'Lugar de destino',
        title: 'Nuevo borrador de documento de transporte',
        btn_create: 'Crear',
        cmrNumber: 'Número de documento de transporte',
        cmrNumber_required: 'El número de documento de transporte es obligatorio',
        sendDate: 'Fecha de envío',
        sendDate_future: 'La fecha de envío debe ser igual o posterior a la fecha actual',
        vehiclePlate: 'Matrícula del vehículo tractor',
        trailerPlate: 'Matrícula del semirremolque',
        nameTransportist: 'Transportista',
        observations: 'Observaciones',
        save_ok: 'Borrador guardado correctamente',
        step_header: 'Cabecera',
        step_lines: 'Líneas',
        authorization_section: 'Autorización',
        authorizationNumber: 'Número de autorización',
        senderAgency: 'Organismo emisor',
        validityPeriod: 'Período de validez',
        cargo_general_data: 'Datos generales mercancía',
        nature: 'Naturaleza',
        weight: 'Peso',
        unitOfMeasure: 'Unidad de medida',
        validityDateFrom: 'Período de validez desde',
        validityDateTo: 'Período de validez hasta',
        validityDateTo_future: 'La fecha "hasta" debe ser posterior a la fecha actual',
        origin_place_seller_centres_exclusive: 'Si informas lugar de origen no puedes añadir centros de vendedor',
        destination_place_seller_centres_exclusive: 'Si informas lugar de destino no puedes añadir centros de vendedor',
        destination_place_buyer_centres_exclusive: 'Si informas lugar de destino no puedes añadir centros de comprador'
      },
      stops: {
        title: 'Paradas',
        no_stops: 'Sin paradas',
        add_stop: 'Añadir parada',
        add_stop_title: 'Añadir parada',
        delete_stop: 'Eliminar parada',
        ship_from: 'Origen',
        final_destination: 'Parada para destino final',
        stop_place: 'Destino',
        stop_place_destination: 'Destino/Parada',
        stops_required_without_origin_destination: 'Si no se indica el lugar de origen y el lugar de destino, es obligatorio añadir al menos una parada.',
        final_destination_required: 'No se ha creado ninguna parada para el destino final. Es obligatorio crear la parada correspondiente a este destino, y el valor debe coincidir exactamente con el dato indicado en el campo Lugar de destino (comas, puntos, otros caracteres, etc). Revise los datos y añada la parada para el destino final',
        lines_required_for_stops: 'Si hay una o varias paradas: - Obligatoriamente debe haber una o varias líneas - No puede haber líneas sin referencia a paradas - Obligatoriamente debe haber al menos una línea que haga referencia a cada una de las paradas definidas',
        creation_date: 'Fecha creación',
        confirm_delete_stop: '¿Desea eliminar la parada?',
        stop_added: 'Parada añadida correctamente',
        stop_deleted: 'Parada eliminada correctamente'
      },
      buttons: {
        delete_draft_tooltip: 'Eliminar borrador',
        duplicate_tooltip: 'Copiar borrador'
      },
      messages: {
        duplicate_confirm: '¿Desea copiar este borrador?',
        duplicate_ok: 'Borrador copiado correctamente'
      }
    },
    cmr_lines: {
      table: {
        line_number: 'Nº de línea',
        description: 'Descripción/Naturaleza',
        article_code: 'Código del artículo',
        article_code_seller: 'Código del vendedor',
        quantity: 'Cantidad',
        weight: 'Peso',
        unit_of_measure: 'Unidad de medida'
      },
      form: {
        title: 'Línea del documento de transporte',
        description: 'Descripción/Naturaleza',
        article_code: 'Código del artículo',
        article_code_seller: 'Código del vendedor',
        quantity: 'Cantidad',
        weight: 'Peso',
        unit_of_measure: 'Unidad de medida'
      },
      buttons: {
        add_line: 'Añadir línea',
        add_line_tooltip: 'Añadir una nueva línea al documento',
        update_line: 'Actualizar línea',
        update_line_tooltip: 'Actualizar la línea seleccionada',
        delete: 'Eliminar',
        delete_tooltip: 'Eliminar líneas seleccionadas',
        submit_for_acceptance: 'Tramitar para aceptación',
        delete_draft_tooltip: 'Eliminar el borrador del documento de transporte'
      },
      confirm_delete_line: '¿Está seguro de que desea eliminar esta línea?',
      confirm_delete_lines: '¿Está seguro de que desea eliminar {count} líneas?',
      line_added: 'Línea añadida correctamente',
      line_updated: 'Línea actualizada correctamente',
      line_deleted: 'Línea eliminada correctamente',
      lines_deleted: 'Líneas eliminadas correctamente',
      no_lines_warning: 'Debe añadir al menos una línea',
      confirm_pending_status: 'El borrador pasará a estar en estado pendiente para su tramitación desde la pantalla de Documento de transporte',
      confirm_pending_status_transportist: 'No se incluye la información completa del transporte (datos obligatorios de transportista y matrículas). Lo puede indicar más tarde, pero siempre antes del envío. Pulse Confirmar para continuar y podrá rellenar los datos faltantes desde la pantalla de Documento de transporte o Cancelar si prefiere añadir la información desde borradores.'
    },
    new_coacsu: {
      title: 'Nuevo resumen de cuenta comercial',
      seller: 'Vendedor',
      buyer: 'Comprador',
      summary_number: 'Número de resumen comercial',
      issue_date: 'Fecha de emisión',
      delivery_date: 'Fecha de entrega',
      additional_data: 'Datos adicionales',
      select_seller: 'Selecciona vendedor',
      select_buyer: 'Selecciona comprador',
      payment_method: 'Método de pago',
      select_payment_method: 'Selecciona método de pago',
      payment_date: 'Fecha de vencimiento',
      currency: 'Divisa',
      registration_date: 'Fecha de registro',
      code: 'Código',
      role: 'Rol',
      steps: {
        header: 'Cabecera',
        lines: 'Líneas'
      },
      seller_code: 'Código vendedor',
      seller_role: 'Rol vendedor',
      buyer_code: 'Código comprador',
      buyer_role: 'Rol comprador',
      lines: {
      title: 'Líneas',
      insert: 'Cargar',
      insert_tooltip: 'Añadir línea',
      line_number: 'Nº línea',
      document_number: 'Nº documento',
      issue_date: 'Fecha emisión',
      payment_date: 'Fecha vencimiento',
      total: 'Total',
      currency: 'Divisa',
      status: 'Estado',
      delete_tooltip: 'Eliminar línea',
      back: 'Volver',
      save: 'Guardar',
      save_tooltip: 'Guardar cambios sin enviar a Editrack',
      generate: 'Crear',
      generate_tooltip: 'Guardar y enviar COACSU a Editrack',
      generating: 'Enviando a Editrack...',
      generate_ok: 'COACSU enviado a Editrack correctamente.',
      cancel: 'Cancelar',
      dialog_title: 'Seleccionar facturas',
      loading_invoices: 'Cargando facturas...',
      no_invoices: 'No hay facturas disponibles con los filtros del COACSU actual.',
      add: 'Añadir ({count})',
      delete_confirm: '¿Desea eliminar esta línea de COACSU?',
      delete_confirm_button: 'Confirmar',
      lines_saved: 'Líneas guardadas correctamente.'
      },
      duplicate: {
        title: 'Factura ya incluida',
        message: 'La factura {invoiceNumber} ya pertenece a un resumen de cuenta comercial existente (N.res cuenta comercial: {coacsuId}). ¿Desea crear uno nuevo de todas formas?',
        confirm: 'Crear de todas formas',
        cancel: 'Cancelar'
      },
      errors: {
        summary_number_required: 'El número de resumen comercial es obligatorio',
        issue_date_required: 'La fecha de emisión es obligatoria',
        payment_date_required: 'La fecha de vencimiento es obligatoria',
        payment_method_required: 'El método de pago es obligatorio',
        save_error: 'No se ha podido guardar el COACSU.',
        load_error: 'No se ha podido cargar el detalle del COACSU.',
        update_error: 'No se ha podido actualizar el COACSU.',
        create_error: 'No se ha podido crear el COACSU.',
        load_invoices: 'No se ha podido cargar el listado de facturas.',
        save_lines: 'No se han podido guardar las líneas.',
        generate_error: 'No se ha podido enviar el COACSU a Editrack.'
      }
    },
  ...esLocale,
  label: 'Español',

  date_format: 'DD/MM/YYYY',
  date_format_long: 'DD/MM/YYYY HH:mm:ss',
  date_format_calendar: 'DD/MM/YYYY',
  date_format_month: 'MM/YYYY',
  date_format_long_calendar: '@:date_format_calendar - HH:mm',
  date_format_long_datepicker: '@:date_format_calendar - HH:mm:ss',
  buttons: {
    btnRecovery: 'Restablecer contraseña',
    btnEnter: 'Entrar',
    btnSend: 'Enviar',
    btnFinish: 'Finalizar',
    btnNext: 'Siguiente',
    btnDelete: 'Eliminar',
    btnDeleteAll: 'Eliminar todas',
    btnDeleteSelected: 'Eliminar seleción',
    btnAdd: 'Cargar',
    btnSave: 'Guardar',
    btnBack: 'Volver',
    btnSaveChanges: 'Guardar',
    btnCancelChanges: 'Restablecer',
    btnCancelChanges_tooltip: 'Cancelar cambios',
    btnSaveChanges_tooltip: 'Guardar cambios',
    btnSendSaveChanges_tooltip: 'Guardar y enviar',
    btnCancel: 'Cancelar',
    btnCancel_tooltip: 'Cancelar cambios',
    btnOk: 'Aceptar',
    btnConfirm: 'Confirmar',
    btnContinue: 'Continuar',
    btnSign: 'Firmar',
    btnBiometricSign: 'Firma biométrica',
    btnClear: 'Limpiar',
    btnDownloadXSL: 'Ver XSL',
    btnViewMetadata: 'Descargar metadatos',
    btnDownloadLabels: 'Descargar etiquetas',
    btnDownload: 'Descargar',
    btnDownloadPdf: 'Descargar PDF',
    btnDownloadOrderRsp: 'Descargar respuesta de pedido',
    btnReSend: 'Reenviar',
    btnCreateInvoice: 'Crear factura rectificativa',
    btnShow: 'Mostrar',
    btnShow_tooltip: 'Mostrar resultados',
    refresh_tooltip: 'Actualizar resultados',
    inicialize_tooltip: 'Recalcular',
    btnChangestatus: 'Cambiar estado',
    btnCoacsu: 'Resumen de cuenta comercial',
    btnCoacsu_error_different_parties: 'No se puede crear el resumen comercial: las facturas seleccionadas deben tener el mismo comprador y el mismo vendedor',
    btnCoacsu_success: 'Resumen comercial creado correctamente',
    btnClose: 'Cerrar',
    btnUpdate: 'Actualizar'
  },

  msg_generics: {
    no: 'No',
    yes: 'Sí',
    deleting: 'Eliminando...',
    sending: 'Enviando...',
    send_ok: 'Enviado correctamente',
    request_success: 'Petición ejecutada correctamente',
    actual_version: 'Versión actual',
    error_not_found: 'No se ha encontrado el fichero',
    error_download_not_found: 'Error en la descarga. No se ha encontrado el fichero/s',
    error_download_pdf: 'No se ha podido realizar la descarga del PDF. Consulte con su administrador.',
    no_match: 'No hay resultados',
    delveryNoteLines_selected: 'Las líneas seleccionadas son las líneas que se enviarán en el albarán',
    field_required: 'Campo obligatorio',
    element_selected: 'Selecciona un elemento',
    min_three_letters: 'Mínimo 3 letras',
    number_required: 'Debe ser un número',
    min_num_character: 'Mínimo {min} caracteres',
    max_num_character: 'Máximo {max} caracteres',
    max_value: 'Debe ser menor a {max}',
    no_file_selected: 'No ha seleccionado un fichero',
    format_invalid: 'Formato no válido',
    format_invalid_req_csv: 'Formato no válido, debe contener la extensión CSV',
    quantity_exceded: 'La cantidad expedida no puede ser superrior a la cantidad pendiente {max}',
    character_invalid: 'Carácter no válido ',
    max_decimals: 'Máximo {max} decimales',
    max_numeric: 'Máximo {max} dígitos',
    format_goods_code_invalid: 'El formato debe ser XXXX XX XX (4 dígitos, un espacio, 2 dígitos, un espacio y 2 dígitos).',
    filter_selected: 'Añadiendo el filtro seleccionado a la búsqueda ...',
    filter_no_selected: 'Debe seleccionar un filtro para la búsqueda',
    filter_date_required: 'No puede eliminar las fechas. Un rango de fechas es obligatorio',
    filter_date: ' Cambiando las fechas de búsqueda ...',
    filter_delete: 'Eliminando filtro y cargando nuevos datos ...',
    filter_delete_all: 'Eliminando todos los filtros de búsqueda ...',
    filter_table_menu: '¿Qué quieres visualizar en la tabla?',
    order_table: 'Ordenando Tabla ...',
    size_table: 'Cambiando tamaño de la tabla ...',
    pagination_table: 'Cambiando paginación de la tabla ...',
    table_select_rows: 'Tienes {num} elementos de la tabla seleccionados',
    load_init: 'Cargando datos ...',
    loading: 'Cargando...',
    no_date: 'No hay fecha',
    no_quantity: 'Sin cantidad',
    no_price: 'Sin precio',
    information: 'Información',
    invoiceDetails: 'Detalle de la factura ',
    download_pdf: 'Descargando PDF...',
    download_csv: 'Descargando CSV...',
    load_download: 'Descargando documento...',
    success: 'Éxito',
    saving: 'Guardando cambios…',
    warning: 'Advertencia',
    document_downloaded: 'Documento descargado',
    download_file_ok: 'La descarga del archivo {filename} fue correcta.',
    download_files_ok: 'La descarga de los archivos fue correcta.',
    download_metadata_ok: 'La descarga del archivo de metadatos fue correcta.',
    success_download: 'El archivo {file} se ha descargado correctamente',
    error_download: 'Error al descargar el archivo',
    error_invalid_link: 'El enlace proporcionado no es válido',
    error_load_data: 'Error al cargar los datos',
    error_unauthorized: 'No tiene acceso a la información solicitada. El enlace ha caducado.',
    order_response_ok: 'El envío de la respuesta del pedido {order} se ha realizado correctamente.',
    update_party: 'Actualizando empresas...',
    update_party_ok: 'Actualización de empresas realizada correctamente',
    delete_file_ok: 'El archivo se ha eliminado correctamente',
    download_ok: 'La descarga fue correcta',
    date_required: 'Selecciona una fecha',
    date_range_required: 'Selecciona un rango de fechas',
    date_diff_error: 'No puede seleccionar un rango superior a un año',
    date_last_connection: 'Fecha última conexión:',
    download_invoice_original: 'Descargando....',
    processing: 'Procesando....',
    download_invoice_formatted: 'Descargando custodiado formateado....',
    download_metadata: 'Descargando metadatos....',
    upload_invoice: 'Subiendo factura ...',
    upload_attachment: 'Subiendo adjunto ...',
    upload_parties_massive: 'Procesando empresas ...',
    upload_centres_massive: 'Procesando centros ...',
    upload_centre_approval_flow_massive: 'Procesando flujos de aprobación ...',
    upload_attachment_ok: 'Fichero subido satisfactoriamente.',
    upload_issue: 'Creando incidencia ...',
    upload_issue_ok: 'Incidencia creada satisfactoriamente.',
    issues_load_delete: 'Eliminando incidencia ...',
    redigitize: 'Enviando solicitud de redigitalización de la factura...',
    redigitize_ok: 'La solictud de redigitalización fue enviada correctamente',
    invoice_access_denied: 'No es posible el acceso a la factura',
    load_document: 'Cargar',
    upload_attachment_interlocutor: 'Adjunto no visible por su interlocutor.',
    add_all_projects: 'Para todos los servicios',
    all_centres: 'Cualquier sociedad / centro',
    file_selected: 'Selecciona un archivo',
    iban: 'El campo Iban es obligatorio',
    ibanKo: 'El Iban introducido no es un correcto',
    bic: 'El campo Bic es obligatorio',
    accountTitular: 'El campo Titular de la cuenta es obligatorio',
    email: 'El campo email es obligatorio',
    emailKo: 'El email introducido no es correcto',
    donwloadModelo: 'Descargar modelo solicitud de cambio de datos',
    popover_clean_filters: 'Borrar filtros',
    no_pending_task_status: 'No se han encontrado estados configurados para el servicio seleccionado.',
    what_show: '¿Qué quieres visualizar en la tabla?',
    alter_configuration: 'Este cambio puede alterar las configuraciones del servicio.',
    placeholder: {
      datepicker: 'Seleccione una fecha'
    },
    date_filter: 'Fecha',
    date: 'Fecha de resolución',
    datepicker: {
      start_placeholder: 'Desde',
      separator: 'HASTA',
      separator_empty: ' ',
      end_placeholder: 'Hasta',
      last_week: 'Última semana',
      last_month: 'Último mes',
      last_three_months: 'Últimos tres meses',
      last_year: 'Último año',
      today: 'Hoy',
      last_two_year: 'Últimos dos años'

    },
    advanced_search: 'Búsqueda avanzada',
    question: {
      yes: 'Sí',
      no: 'No'
    },
    validating_data: 'Validando datos',
    all: 'Todos',
    onlyUserAdmin: 'Solo un usuario SuperAdmin puede seleccionar todas los servicios.',
    nameDuplicate: 'Nombre de perfil duplicado',
    taxDuplicate: 'Impuesto duplicado',
    tax_legal_text_used: 'Existen líneas de factura con el texto legal eliminado del impuesto',
    hostDuplicate: 'Host duplicado',
    detail: 'Detalle',
    global: 'Global'
  },

  lateral_menu: {
    invoices: {
      title: 'Facturas',
      emitted: 'Emitidas',
      received: 'Recibidas',
      third: 'Terceros',
      drafts: 'Borradores',
      accounting_closes: 'Cierres contables',
      draft_accounting_closes: 'Borradores cierres',
      pending_tasks: 'Tareas pendientes'
    },
    receptions: {
      title: 'Recepciones',
      emitted: 'Emitidas',
      received: 'Recibidas'
    },
    carta: {
      title: 'Documento de transporte',
      emitted: 'Documento de transporte'
    },
    delivery: {
      title: 'Albaranes',
      emitted: 'Emitidos',
      received: 'Recibidos'
    },
    orders: {
      title: 'Pedidos',
      emitted: 'Emitidos',
      received: 'Recibidos'
    },
    genrals: {
      title: 'Genrals',
      emitted: 'Emitidos',
      received: 'Recibidos'
    },
    auditory: {
      title: 'Auditoría',
      documents: 'Documentos',
      actions: 'Acciones'
    },
    administration: {
      title: 'Administración',
      projects: 'Servicios',
      parties: 'Empresas',
      users: 'Usuarios',
      plannedProcesses: 'Procesos planificados',
      mailTemplates: 'Plantillas de correo',
      profiles: 'Perfiles',
      taxes: 'Impuestos',
      mailServer: 'Servidores de correo electrónico',
      communication_method: 'Métodos de comunicación',
      articles: 'Artículos'
    },
    sales_report: {
      title: 'Informe de ventas',
      view: 'Ver informe'
    },
    inventory_report: {
      title: 'Informe de inventario',
      view: 'Ver informe'
    },
    remadv: {
      title: 'Aviso de liquidación',
      view: 'Ver aviso de liquidación'
    },
    coacsu: {
      title: ' Resumen de cuenta comercial',
      recibidos: 'Recibidos',
      emitidos: 'Emitidos'
    }
  },

  breadcrumb: {
    empty: '',
    details: 'Detalle',
    // PERFIL
    profile_init: 'Perfil',
    profile_general_data: 'Datos generales',
    profile_password: 'Contraseña',
    profile_media_contact: 'Contactos',
    profile_parties: 'Empresas',
    profile_signature: 'Delegación de firma',

    // FACTURAS
    invoices_init: 'Facturas',
    invoices_emitted: '@:breadcrumb.invoices_init' + ' - Emitidas',
    invoices_received: '@:breadcrumb.invoices_init - Recibidas',
    invoices_third: '@:breadcrumb.invoices_init - Terceros',
    invoices_drafts: '@:breadcrumb.invoices_init - Borradores',
    invoices_ocr: '@:breadcrumb.invoices_init - Pendientes de validar',
    invoices_new_invoice: 'Nueva factura',
    invoices_accounting_closes: '@:breadcrumb.invoices_init - Cierres contables',
    reports_init: 'Reportes',
    reports_emitted: '@:breadcrumb.reports_init - Emitidos',
    reports_received: '@:breadcrumb.reports_init - Recibidos',
    invoices_draft_accounting_closes: '@:breadcrumb.invoices_init - Cierres borradores',
    invoices_pending_tasks_title: '@:breadcrumb.invoices_init - Tareas pendientes',
    invoices_pending_tasks_cover: 'Creación carátula',
    invoices_new_draft_accounting_closes: 'Nuevo cierre contable',
    cmr_draft_edit: 'Nuevo documento de transporte',

    // RECEPCIONES
    receptions_init: 'Recepciones',
    receptions_emitted: '@:breadcrumb.receptions_init - Emitidas',
    receptions_received: '@:breadcrumb.receptions_init - Recibidas',
    receptions_new_invoice: 'Nueva factura',

    // ALBARANES
    delivery_notes_init: 'Albaranes',
    delivery_notes_emitted: '@:breadcrumb.delivery_notes_init - Emitidos',
    delivery_notes_received: '@:breadcrumb.delivery_notes_init - Recibidos',
    deliverynote_new_invoice: 'Nueva factura',
    // CMR
    cmr_init: 'Documento de transporte',
    cmr_draft_init: 'Borrador documento de transporte',
    cmr_draft_new: 'Nuevo borrador',

    // PEDIDOS
    orders_init: 'Pedidos',
    orders_emitted: '@:breadcrumb.orders_init - Emitidos',
    orders_received: '@:breadcrumb.orders_init - Recibidos',
    orders_new_invoice: 'Nueva factura',
    orders_new_deliveryNote: 'Nuevo albarán',

    // GENRALS
    genrals_init: 'Genrals',
    genrals_emitted: '@:breadcrumb.genrals_init - Emitidos',
    genrals_received: '@:breadcrumb.genrals_init - Recibidos',

    // AUDITORIA
    auditory_init: 'Auditoría',
    auditory_documents: '@:breadcrumb.auditory_init - Documentos',
    auditory_actions: '@:breadcrumb.auditory_init - Acciones',

    // ADMINISTRACION
    administration_init: 'Administración',
    administration_project_projects: '@:breadcrumb.administration_init - Servicios',
    administration_party_parties: '@:breadcrumb.administration_init - Empresas',
    administration_project_add_project: 'Añadir servicio',
    administration_project_projectparties: 'Empresas asociadas',
    administration_project_add_party: 'Añadir empresa',
    administration_project_admin_channels: 'Relaciones comerciales',
    administration_project_admin_channels_detail: 'Detalle',
    administration_project_admin_centres: 'Centros',
    administration_project_admin_centresOfBuyer: 'Centros del comprador',
    administration_project_admin_centresOfSeller: 'Centros del vendedor',
    administration_project_admin_centresbuyer: 'Centro comprador',
    administration_project_admin_centresdelivery: 'Lugar de entrega',
    administration_project_admin_centresinvoicee: 'Centro facturado',
    administration_users: '@:breadcrumb.administration_init - Usuarios',
    administration_users_add_user: 'Añadir usuario',
    administration_project_add_centre: 'Añadir centro',
    administration_plannedProcesses: '@:breadcrumb.administration_init - Procesos planificados',
    administration_mailTemplates: '@:breadcrumb.administration_init - Plantillas de correo',
    administration_profiles: '@:breadcrumb.administration_init - Perfiles',
    administration_taxes: '@:breadcrumb.administration_init - Impuestos',
    administration_mailServer: '@:breadcrumb.administration_init - Servidores de correo electrónico',
    administration_mailServer_add_new: 'Crear configuración',
    administration_user_information: '@:breadcrumb.administration_init - Mensaje informativo',
    administration_new: 'Nuevo',
    administration_communication_method: '@:breadcrumb.administration_init - Métodos de comunicación',
    administration_articles: '@:breadcrumb.administration_init - Artículos',

    // ISSUES
    issues_init: 'Incidencias',
    issues_issues: '@:breadcrumb.issues_init',
    issues_add_issue: 'Crear incidencia',

    // DOCUMENTACION
    documentation_init: 'Documentación',
    documentation_documents: '@:breadcrumb.documentation_init',

    // ESTADISTICAS
    statistic_init: 'Estadística',
    statistic_emitted: '@:breadcrumb.statistic_init - Volumen de facturas emitidas',
    statistic_received: '@:breadcrumb.statistic_init - Volumen de facturas recibidas',
    statistic_other: '@:breadcrumb.statistic_init - Facturas generadas desde otro documento, pedido, recepción o albarán',
    statistic_topseller: '@:breadcrumb.statistic_init - Top 20 proveedores por volumen económico y de número de facturas',
    statistic_parties: '@:breadcrumb.statistic_init - Volumen de empresas dadas de alta',
    statistic_rejected: '@:breadcrumb.statistic_init - Facturas: Tipología de rechazos y motivos de redigitalización',

    // SALESREPORT
    salesreport_init: 'Informe de ventas',
    salesreport_view: '@:breadcrumb.salesreport_init',

    // INVENTORY REPORT
    inventoryreport_init: 'Informe de inventario',
    inventoryreport_view: '@:breadcrumb.inventoryreport_init',

    // REMADV
    remadv_init: 'Aviso de liquidación',
    remadv_view: '@:breadcrumb.remadv_init',

    // COACSU
    coacsu_init: 'Resumen de cuenta comercial',
    coacsu_emitted: '@:breadcrumb.coacsu_init - Emitidos',
    coacsu_received: '@:breadcrumb.coacsu_init - Recibidos',
    coacsu_view: '@:breadcrumb.coacsu_init',
    coacsu_detail: 'Resumen de cuenta comercial',
    new_coacsu: {
      title: 'Nuevo resumen de cuenta comercial'
    }
  },

  nav_header: {
    profile: 'Perfil',
    logout: 'Cerrar sesión'
  },

  login: {
    welcome: 'Iniciar sesión',
    twoFactorAuth: 'Doble factor de autenticación',
    cautext: 'TLFNO (CAU) ATENCIÓN AL USUARIO',
    cautelephone: '91 191 00 00',
    canalcautext: 'Atención al cliente: 900 365 365',
    userLabel: 'Usuario',
    passLabel: 'Contraseña',
    codeLabel: 'Introduzca el código de verificación recibido en su correo',
    contratLabel: '¿Aún no disfruta de los beneficios de este servicio?',
    contratLabelRef: 'Consúltenos...',
    helpLabelRef: '¿Necesita ayuda?',
    labelRef1: 'Información básica de protección de datos: ',
    labelRef2: 'Redeia tratará los datos para gestionar el registro y uso de su cuenta. Puede ejercer sus derechos de protección de datos escribiendo un email a la siguiente dirección de correo electrónico digame@redeia.com y acceder a toda la información sobre el tratamiento en nuestra Política de Privacidad.',
    labelRef3: 'Al pulsar “Entrar” declara que ha leído y entiende la ',
    labelRef4: 'Política de Privacidad y Condiciones Generales.',
    rules: {
      username: 'Introduzca el usuario',
      password: 'Introduzca la contraseña',
      email: 'Introduzca un email',
      code: {
        required: 'Por favor ingrese el código de 5 dígitos',
        pattern: 'El código debe ser de 5 dígitos alfanuméricos'
      }
    },
    logging: 'Iniciando sesión...',
    title_new_pass: 'Restablecer contraseña',
    message_new_pass: 'Introduzca los datos del usuario registrado para continuar',
    emailLabel: 'Email',
    sending: 'Enviando...',
    questionLabel: 'Pregunta',
    answerLabel: 'Respuesta',
    passRecovery: 'Restablecer contraseña',
    backLoginForm: 'Volver',
    error: {
      invalid_user: 'La combinación usuario/contraseña no es válida.',
      user_not_found: 'Usuario no encontrado.',
      email_without_account: 'Alguno de los datos del usuario no son correctos.',
      email_sended: 'Se ha enviado un email con la nueva contraseña.',
      bad_final_form: 'Los datos aportados no son correctos. Inténtelo de nuevo',
      invalid_code: 'El código ha sido usado o a expirado',
      reeProv_2: 'Error dnie',
      reeProv_3: 'Error smartcard',
      reeProv_1: 'Error. No existe el usuario introducido',
      reeProv_4: 'Error certificate',
      reeProv_5: 'Usuario o contraseña incorrecta. Recuerde que tiene 3 intentos',
      reeProv_locked: 'Usuario bloqueado',
      reeProv_renew: 'Credenciales expiradas',
      reeProv_exceptionTranslationFilter: 'ExceptionTranslationFilter',
      reeProv_expired: 'Sesión expirada'
    },
    messageMail: 'Si los datos introducidos han sido correctos, en su dirección de correo recibirá su nueva contraseña',
    reeClientes: 'Acceso e-Factura clientes',
    reeCliText: 'Si ya es cliente registrado puede acceder al servicio de facturación electrónica usando su usuario y contraseña',
    reeProveedores: 'Acceso e-Factura proveedores',
    reeProvText: 'Si ya es proveedor registrado puede acceder al servicio de facturación electrónica usando su usuario y contraseña',
    logout_correct: 'Sesión finalizada correctamente',
    infoBrowser: 'Optimizado para Firefox v.67/Chrome v.74/Edge v.18',
    titlevocento: 'Portal para envío y consulta de facturas para proveedores y clientes',
    textvocento: 'Vocento pone a disposición de sus proveedores y clientes una plataforma online que da respuesta a sus necesidades en un único espacio. Un canal de comunicación directo con las herramientas y servicios requeridos para una gestión ágil y eficiente de la operativa diaria. Este portal es una pieza clave en la construcción de una relación de confianza y beneficio mutuo: simplicidad, control y transparencia. Bienvenido a nuestro Portal para envío y consulta de facturas para proveedores y clientes.',
    titlevocento2: 'SOPORTE TÉCNICO',
    horariovocento: 'Horario de Atención al Cliente',
    horario2vocento: 'Lunes a viernes: 9:00 - 19:00',
    horario3vocento: 'En horario de España (UTC/GMT + 1 hora).',
    horario4vocento: 'Los días festivos nacionales no se prestará el servicio',
    avisolegal: 'Aviso Legal',
    politica: 'Política de privacidad',
    cookies: 'Política de Cookies'
  },

  // Perfil
  profile: {
    tabs: {
      general_data: 'Datos generales',
      password: 'Contraseña',
      contact_data: 'Datos de contacto',
      parties: 'Empresas',
      signature_delegation: 'Delegación de firma'
    },

    general_data: {
      username: 'Nombre de usuario',
      profile_form: {
        name: {
          label: 'Nombre',
          placeholder: 'Nombre'
        },
        first_surname: {
          label: 'Primer apellido',
          placeholder: 'Apellido'
        },
        second_surname: {
          label: 'Segundo apellido',
          placeholder: 'Apellido'
        },
        identification_tax_number: {
          label: 'Nº identificación fiscal',
          placeholder: 'Nº identificación fiscal'
        },
        creation_date: {
          label: 'Fecha de creación'
        },
        last_connection_date: {
          label: 'Última conexión'
        },
        departament: {
          label: 'Departamento'
        }
      },
      load: {
        updating: 'Actualizando perfil ...'
      }
    },

    password: {
      change_password: 'Cambio de contraseña',
      change_first_password: 'Debe actualizar su contraseña para continuar',
      change_password_form: {
        old_password: {
          label: 'Contraseña actual',
          placeholder: 'Contraseña actual'
        },
        new_password: {
          label: 'Nueva contraseña',
          placeholder: 'Nueva contraseña'
        },
        confirm_password: {
          label: 'Confirmación nueva contraseña',
          placeholder: 'Nueva contraseña'
        },
        secret_question: {
          label: 'Pregunta secreta',
          placeholder: 'Pregunta secreta'
        },
        current_secret_answer: {
          label: 'Respuesta secreta actual',
          placeholder: 'Respuesta secreta actual'
        },
        new_secret_answer: {
          label: 'Respuesta secreta nueva',
          placeholder: 'Respuesta secreta nueva'
        },
        confirm_secret_answer: {
          label: 'Confirmación nueva respuesta secreta',
          placeholder: 'Nueva respuesta secreta'
        }
      },
      rules_form: {
        pattern: "La contraseña debe tener al menos un dígito, una mayúscula, una minúscula y un carácter especial (!{'@'}#$%^&*_=+-/).",
        pass_eqaul_newpass: 'La nueva contraseña no puede ser la misma que la actual.',
        fobidden_words: 'La nueva contraseña contiene palabras prohibidas.',
        pass_equal_user: 'La nueva contraseña no puede ser igual que el nombre de usuario.',
        newpass_not_equals_confirmation: 'Las contraseñas no coinciden.',
        response_equal_newresponse: 'La nueva respuesta no puede ser la misma que la actual.',
        newresponse_not_equals_confirmation: 'Las respuestas no coinciden.',
        validation_error: 'Errores de validación. Revise el formulario.'
      }
    },
    error: {
      password: {
        required: {
          actual: 'Campo obligatorio: Contraseña actual',
          nueva: 'Campo obligatorio: Nueva contraseña',
          repetida: 'Campo obligatorio: Confirmación nueva contraseña',
          pregunta_secreta: 'Campo obligatorio: Pregunta secreta',
          oldSecretAnswer: 'El campo "Respuesta secreta actual" es obligatorio.',
          newSecretAnswer: 'El campo "Respuesta secreta nueva" es obligatorio.',
          renewSecretAnswer: 'El campo "Confirmación nueva respuesta secreta" es obligatorio.'
        },
        wrongPassword: 'La contraseña actual introducida no es correcta.',
        format_ko: 'Contraseña incorrecta. La nueva contraseña tiene que tener entre 12 y 64 caracteres, y debe contener al menos un número, una letra minúscula, una letra mayúscula y un símbolo alternativo tipo %_.@.',
        forbidden_word: 'Cambie la contraseña. No puede usar ese valor para la contraseña.',
        sameAsToday: 'La nueva contraseña introducida es igual a la actual.',
        sameAsOne: 'La nueva contraseña introducida ya ha sido utilizada anteriormente.',
        sameAsUsername: 'La nueva contraseña introducida es igual al nombre de usuario.',
        wrongConfirmation: 'La confirmación de nueva contraseña debe ser igual a la nueva contraseña.',
        secretAnswer_wrongSecretAnswer: 'La respuesta secreta actual introducida no es correcta.',
        secretAnswer_wrongConfirmation: 'La confirmación de respuesta secreta no coincide con la introducida previamente.',
        maxLength_nueva: 'Longitud máxima del campo "Nueva contraseña": 64 caracteres',
        minLength_nueva: 'Longitud mínima del campo "Nueva contraseña": 12 caracteres',
        maxLength_repetida: 'Longitud máxima del campo "Confirmación nueva contraseña": 64 caracteres',
        minLength_repetida: 'Longitud mínima del campo "Confirmación nueva contraseña": 12 caracteres',
        maxLength_secretQuestion: 'Longitud máxima del campo "Pregunta secreta": 255 caracteres',
        maxLength_oldAnswer: 'Longitud máxima del campo "Respuesta secreta actual": 64 caracteres',
        maxLength_newSecretAnswer: 'Longitud máxima del campo "Respuesta secreta nueva": 64 caracteres',
        maxLength_renewSecretAnswer: 'Longitud máxima del campo "Confirmación nueva respuesta secreta": 64 caracteres'
      },
      contact_data: {
        format_email: 'El formato del correo electrónico no es correcto.',
        format_phone: 'El formato del teléfono no es correcto.',
        user_media_exist: 'El medio seleccionado ya existe para el usuario.',
        user_media_not_found: 'No se encontró el dato de contacto seleccionado',
        required_id: 'El parámetro userMediaId es obligatorio',
        required_type: 'El tipo del parámetro es obligatorio',
        required_value: 'El valor del parámetro es obligatorio'
      },
      general_data: {
        required: {
          name: 'Campo obligatorio: Nombre',
          first_surname: 'Campo obligatorio: Primer apellido'
        },
        validation: {
          maxLength: {
            name: 'Longitud máxima del campo "Nombre": 50 caracteres',
            first_surname: 'Longitud máxima del campo "Primer apellido": 50 caracteres',
            second_surname: 'Longitud máxima del campo "Segundo apellido": 50 caracteres',
            id_number: 'Longitud máxima del campo "Número de identificación fiscal": 20 caracteres'
          }
        }
      },
      parties: {
        validation: {
          maxLength_TaxID: 'Longitud máxima del campo "Número de identificación fiscal": 50 caracteres',
          maxLength_tradeName: 'Longitud máxima del campo "Nombre": 150 caracteres',
          maxLength_gln: 'Longitud máxima del campo "GLN": 15 caracteres',
          date: "'Fecha desde' debe ser anterior a 'Fecha hasta'"
        }
      },
      tamanominimo_name: 'Nombre: el tamaño mínimo es de 3 caracteres.',
      tamanominimo_id: 'ID: el tamaño mínimo es de 3 caracteres.',
      global: 'Se ha producido un error. Contacte con su administrador.'
    },
    contact: {
      contact_data_form: {
        type: {
          placeholder: 'Selecciona un tipo...'
        }
      },
      rules_form: {
        phone_format: 'El formato no corresponde con un número de teléfono',
        email_format: 'El formato no corresponde con un email',
        contact_media_exist: 'El medio seleccionado ya existe para el usuario',
        no_contact_media_exist: 'El dato de contacto de tipo "Correo electrónico" es obligatorio'
      },
      load: {
        add_user_media: 'Añadiendo datos de contacto ...'
      }
    },

    signature: {
      presentation_title: 'INFORMACIÓN',
      presentation_text: 'La delegación de firma electrónica en Indra Soluciones Tecnologías de la Información SL (ESB88018098) permite aplicar una firma electrónica a las facturas emitidas y generadas por su empresa. La firma electrónica a aplicar permite garantizar el origen y asegurar la integridad del contenido a su cliente de acuerdo con el artículo 2 de la Orden',
      presentation_text2: 'EHA/962/2007, de 10 de abril.',
      instructions_title: 'INSTRUCCIONES',
      instructions_text1: 'Cumplimentados los campos de esta entrada manual, se generará un documento PDF que ha de ser firmado electrónicamente con el certificado de la sociedad emisora de las facturas.',
      instructions_text2: 'Una vez firmado puede subir este documento PDF en este ',
      instructions_text2_link: 'enlace',
      instructions_text2_dir: 'https://servicedesk-onesait.atlassian.net/servicedesk/customer/portal/68',
      instructions_text2b: ' para activar la delegación de firma sin que suponga un coste para el emisor.',
      instructions_text4: 'Si las facturas electrónicas se entregasen en este servicio con firma electrónica en el formato requerido, no se requiere esta delegación de firma.',
      dialog_add_pdf: {
        title: 'Cargar documento PDF firmado',
        select_file: 'Seleccionar documento',
      },
      profile_signature_form: {
        valueNif: {
          placeholder: 'Escriba 3 caracteres'
        },
        cargoFir: {
          placeholder: 'Elige cargo del firmante'
        },
        valueFechaDD: {
          placeholder: 'Dia - Formato DD'
        },
        valueFechaMM: {
          placeholder: 'Mes - Formato MM'
        },
        valueFechaAAAA: {
          placeholder: 'Año - Formato AAAA'
        },
        resolucion: {
          placeholder: 'Opcional'
        }
      },
      cFirman: {
        adm: 'Administrador',
        apo: 'Apoderado',
        con: 'Consejero Delegado',
        dir: 'Director',
        ger: 'Gerente',
        rep: 'Representante legal',
        tit: 'Titular (autónomo)'
      },
      taxIdentificationNumber: {
        label: 'NIF DE LA EMPRESA',
        placeholder: 'taxIdentificationNumber'
      },
      corporateName: {
        label: 'RAZÓN SOCIAL DE LA EMPRESA',
        placeholder: 'corporateName'
      },
      cargoFirmante: {
        label: 'CARGO DEL FIRMANTE',
        placeholder: 'cargoFirmante'
      },
      name: {
        label: 'NOMBRE DEL FIRMANTE',
        placeholder: 'Nombre'
      },
      first_surname: {
        label: 'PRIMER APELLIDO DEL FIRMANTE',
        placeholder: 'Apellido'
      },
      second_surname: {
        label: 'SEGUNDO APELLIDO DEL FIRMANTE',
        placeholder: 'Apellido'
      },
      dni: {
        label: 'ID DEL FIRMANTE',
        placeholder: 'DNI/NIE del firmante'
      },
      resolucion: {
        label: 'RESOLUCION',
        placeholder: 'resolucion'
      },
      fecha: {
        label: 'FECHA',
        placeholder: 'fecha'
      },
      poblacionFirma: {
        label: 'POBLACION DONDE SE REALIZARA LA FIRMA',
        placeholder: 'poblacionFirma'
      },
      address: {
        label: 'CALLE / AVENIDA DE LA EMPRESA',
        placeholder: 'address'
      },
      town: {
        label: 'POBLACION DE LA EMPRESA',
        placeholder: 'town'
      },
      postcode: {
        label: 'CODIGO POSTAL DE LA EMPRESA',
        placeholder: 'postcode'
      },
      province: {
        label: 'PROVINCIA DE LA EMPRESA',
        placeholder: 'province'
      },
      countryName: {
        label: 'PAIS DE LA EMPRESA',
        placeholder: 'countryName'
      },
      countryNameUser: {
        label: 'PAIS DEL FIRMANTE',
        placeholder: 'countryName'
      },
      dniError: 'Dato incorrecto, por favor revise el DNI/NIE del firmante'
    },

    parties: {
      filters: {
        country: {
          value: 'País',
          placeholder: 'País'
        },
        enabled: {
          value: 'Habilitado/Deshabilitado',
          placeholder: 'Elige...',
          enabled: 'Habilidado',
          disabled: 'Deshabilitado'
        },
        person: {
          value: 'Tipo de persona',
          placeholder: 'Tipo',
          physical: 'Física',
          legal: 'Jurídica'
        },
        project: {
          value: 'Servicio',
          placeholder: 'Servicio'
        },
        name: {
          value: 'Nombre',
          placeholder: 'Nombre'
        },
        tax_identification_number: {
          value: 'ID fiscal',
          placeholder: 'ID fiscal'
        }
      },
      entity_table: {
        name: 'Nombre',
        tax_identification_number: 'ID Fiscal',
        gln: 'GLN',
        enabled: 'Activo',
        country: 'País',
        province: 'Provincia',
        creation_date: 'Creación',
        business_register: 'R. Mercantil',
        project: 'Servicio'
      }
    },
    notify: {
      changes_ok: 'Cambios guardados con éxito.'
    }
  },
  // Incidencias
  issues: {
    filters: {
      creation_date: {
        value: 'Fecha-hora de registro',
        placeholder: ''
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Escriba 3 caracteres'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Escriba 3 caracteres'
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      issue_type: {
        value: 'Tipo de incidencia',
        placeholder: 'Tipo'
      },
      subject: {
        value: 'Asunto',
        placeholder: 'Asunto'
      },
      priority: {
        value: 'Prioridad',
        placeholder: 'Prioridad'
      },
      description: {
        value: 'Descripción',
        placeholder: 'Descripción'
      }
    },
    historic: {
      title: 'Histórico de estados',
      no_data: 'No existen estados',
      creationDateTime: 'Fecha',
      status: 'Estado',
      comment: 'Comentario',
      user: 'Usuario',
      addStatus_tooltip: 'Cargar nuevo estado',
      addStatus: 'Cargar'
    },
    confirm: {
      title_delete: '¿Estás seguro de querer eliminar esta incidencia?',
      confirm_button_delete: 'Eliminar',
      title_add_status: 'Crear nuevo estado',
      confirm_button_add_status: 'Aceptar'
    },
    notify: {
      delete_ok: 'La incidencia de ha eliminado correctamente.',
      add_status_ok: 'El estado se ha creado correctamente.'
    },
    load: {
      delete: 'Eliminando incidencia ...',
      add_status: 'Creando estado ...'
    },
    dialog_add_issue: {
      title: 'Crear incidencia',
      form_add: {
        type: 'Tipo',
        priority: 'Prioridad',
        project: 'Servicio',
        buyer: 'Comprador',
        seller: 'Vendedor',
        subject: 'Asunto',
        description: 'Descripción'
      },
      notify: {
        error_issue_unique: 'Ya existe una incidencia con esos datos'
      },
      button_add: 'Cargar',
      button_add_tooltip: 'Cargar incidencia'
    },
    dialog_add_status: {
      status: 'Estado',
      comment: 'Comentario',
      load_status: 'Crear estado'
    }
  },
  // Facturas emitidas y recibidas
  invoices: {
    filters: {
      creation_date: {
        value: 'Fecha-hora de registro',
        placeholder: ''
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Escriba 3 caracteres'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Escriba 3 caracteres'
      },
      third: {
        value: 'Tercero',
        placeholder: 'Escriba 3 caracteres'
      },
      issue_date: {
        value: 'Rango fechas emisión',
        placeholder: 'Fecha incidencias'
      },
      operation_date: {
        value: 'Rango fechas operación',
        placeholder: 'Fecha operación'
      },
      modification_date: {
        value: 'Rango fechas último estado',
        placeholder: 'Fecha estado'
      },
      invoice_number: {
        value: 'Nº factura',
        placeholder: 'Nº factura'
      },
      client_invoice_number: {
        value: 'Nº/Dato factura cliente',
        placeholder: 'Nº/Dato factura cliente'
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      document_class: {
        value: 'Clase de factura',
        placeholder: 'Clase de factura'
      },
      communication_method: {
        send: {
          value: 'Mét. envío',
          placeholder: 'Método'
        },
        reception: {
          value: 'Mét. entrada',
          placeholder: 'Método'
        }
      },
      tax_type: {
        value: 'Tipo de impuesto',
        placeholder: 'Impuesto'
      },
      currency: {
        value: 'Divisa',
        placeholder: 'Divisa'
      },
      order_number: {
        value: 'Nº pedido',
        placeholder: 'Pedido'
      },
      contract_number: {
        value: 'Nº contrato/recepción',
        placeholder: 'Contrato/recepción'
      },
      delivery_note: {
        value: 'Nº albarán',
        placeholder: 'Albarán'
      },
      file_number: {
        value: 'Nº expediente',
        placeholder: 'Expediente'
      },
      invoice_series_code: {
        value: 'Nº de serie',
        placeholder: 'Código'
      },
      corrective_invoice_number: {
        value: 'Nº factura rectificada',
        placeholder: 'Nº factura rectificada'
      },
      channel: {
        value: 'Canal',
        placeholder: 'Canal'
      },
      register_number: {
        value: 'Nº registro',
        placeholder: 'Nº registro'
      },
      id_invoice: {
        value: 'Id interno',
        placeholder: 'Id interno'
      },
      no_error_status: {
        value: 'Estados excluidos',
        placeholder: 'Estados excluidos',
        rejected: 'Estados rechazados',
        final: 'Estados finales'
      },
      invoice_type: {
        value: 'Subtipo de factura',
        placeholder: 'Subtipo'
      },
      invoice_type_document: {
        value: 'Tipo de factura',
        placeholder: 'Tipo'
      },
      total_executable_amount_from: {
        value: 'Importe desde',
        placeholder: 'Importe'
      },
      total_executable_amount_to: {
        value: 'Importe hasta',
        placeholder: 'Importe'
      },
      attachments: {
        value: 'Adjuntos',
        placeholder: 'Escoge...'
      },
      sent: {
        value: 'Enviada',
        placeholder: 'Escoge...'
      },
      rate: {
        value: 'Tasa',
        placeholder: 'Tasa'
      },
      cancellationRequest: {
        value: 'Solicitud de anulación',
        placeholder: 'Escoge...'
      }
    },
    dialog_add_invoice: {
      title: 'Cargar factura',
      project: {
        label: 'Servicio',
        placeholder: 'Elige un servicio'
      },
      format: {
        label: 'Formato',
        placeholder: 'Elige un formato'
      },
      communication_method: {
        label: 'Método de entrega',
        placeholder: 'Elige método'
      },
      attachments: {
        label: 'Seleccionar adjunto',
        error_attachment_extension: 'Formato de archivo no admitido',
        error_attachment_extension_values: 'El formato debe ser: ',
        error_attachment_size: 'Tamaño no permitido. El tamaño máximo es de {argumento}',
        error_attachment_empty: 'El adjunto está vacío, tiene tamaño 0',
        error_attachment_duplicated: 'Ya existe un adjunto con el mismo nombre'
      },
      button_select_invoice: 'Seleccionar factura',
      button_upload: 'Cargar'
    },
    attachment: {
      error_attachment_not_found: 'El adjunto no existe.'
    },
    invoices_entity_table: {
      buyer: 'Comprador',
      seller: 'Vendedor',
      thirdParty: 'Tercero',
      invoice_class: 'Clase de factura',
      invoice_number: 'Nº factura',
      issue_date: 'F. emisión',
      creation_date: 'F. registro',
      amount: 'Importe',
      status: 'Estado',
      reception_method: 'Mét. entrada',
      communication_method: 'Mét. envío',
      currency: 'Divisa',
      register_number: 'Nº registro',
      series_code: 'Nº serie',
      buyer_generic_centre: 'Centros del comprador',
      buyer_delivery_centre: 'Lugar de entrega',
      buyer_invoicee_centre: 'Centro facturado',
      buyer_centre: 'Centro comprador',
      seller_centre: 'Centros del vendedor',
      cancellation: 'Anulación',
      project: 'Servicio',
      channel: 'Canal',
      id_invoice: 'Id interno',
      accountingDate: 'F. de contabilización',
      paymentDate: 'F. prevista de pago',
      paymentMethod: 'Forma de pago',
      clientInvoiceNumber: 'Nº/Dato factura cliente',
      csv_title: 'Exportar a CSV. Información',
      csv_message: 'No se pueden exportar más de 180.000 registros, por favor acote la búsqueda'
      // csv_message: 'En la exportación de grandes volúmenes de registros, es posible que se superen los límites de tiempo y/o tamaño y no sea posible generar el archivo. En este caso, inténtelo de nuevo con menor número de resultados'
    },
    tooltip: {
      attachments: 'Adjuntos',
      events: 'Eventos',
      detail: 'Detalle',
      addBuyerCenter: 'Añadir centro comprador',
      downloadPDF: 'Descargar PDF',
      original: 'Descargar custodiado',
      viewCSV: 'Ver XSL',
      sent: 'Enviada',
      withTaxes: 'Con impuestos',
      withoutTaxes: 'Sin impuestos repercutidos',
      adminApprovalFlow: 'Flujo de aprobación'
    },
    buttons: {
      upload_invoice: 'Cargar',
      upload_invoice_tooltip: 'Cargar factura',
      upload_profile_tooltip: 'Crear perfil',
      download_invoices: 'PDF',
      download_invoices_tooltip: 'Descargar visualización en formato PDF',
      download_invoice_signed: 'Custodiado',
      download_invoice_signed_tooltip: 'Descargar custodiado',
      download_csv_tooltip: 'Descargar CSV',
      download_csv_details_tooltip: 'Descargar CSV detalle',
      download_csv_details: 'CSV detalle',
      refresh_invoice: 'Actualizar',
      refresh_tooltip: 'Actualizar facturas'
    },
    loading: {
      download_invoices: 'Descargando Factura(s) a PDF ...',
      download_invoices_original: 'Descargando Custodiado(s) ...',
      upload_wait: 'Actualizando...'
    },
    error: {
      validation: {
        upload_file_formatoinvalido: 'El formato del documento no es valido.El formato permitido es EDI, XML o XSIG.',
        parametro_obligatorio_invoice: 'El fichero factura es obligatorio.',
        parametro_obligatorio_projectId: 'El ID del proyecto es obligatorio.',
        valor_no_en_lista: 'Formato incorrecto; posibles valores: {argumento}',
        parametro_obligatorio_format: 'El formato es obligatorio.',
        proyecto_noexiste_noasociado: 'El proyecto con ID {argumento} no existe o no está asociado al usuario.'
      },
      auditoryEventsSearch_event_code_invalidFormat: 'La factura no cumple con el formato seleccionado.',
      notSupported: 'La versión 1.0 de la extensión no esta soportada'
    }
  },
  invoice_related_documents_table: {
    date: 'Fecha de relación',
    destinationDocument: 'Nº documento',
    destinationDocumentType: 'Tipo documento'
  },
  invoice_detail: {
    related_documents_no_data: 'Esta factura no tiene documentos relacionados',
    source_related_documents: 'Documentos relacionados',
    info_message: 'Algunos de los campos de la información de la factura son editables. Recuerda pulsar en el botón \'Guardar\' para que se apliquen las modificaciones',
    info_message_download: 'Recuerde que es necesario descargar el modelo para enviar y/o guardar los cambios',
    buttons: {
      download_invoice: 'PDF',
      download_labels: 'Etiquetas',
      download_invoice_tooltip: 'Descargar visualización en formato PDF',
      download_original_signed: 'Custodiado',
      download_original_signed_tooltip: 'Descargar custodiado',
      download_original_formatted: 'Formateado',
      download_original_formatted_tooltip: 'Descargar custodiado formateado',
      download_metadata: 'Metadatos',
      download_metadata_tooltip: 'Descargar metadatos',
      generate_metadata_tooltip: 'Generar metadatos',
      download_PDF: 'GENERAR PDF CON LOS DATOS INTRODUCIDOS',
      resend_invoice: 'Reenviar',
      resend_invoice_tooltip: 'Reenviar factura',
      add_attachment: 'Cargar',
      add_attachment_tooltip: 'Cargar adjunto',
      cancel_invoice: 'Anular',
      cancel_invoice_tooltip: 'Solicitar anulación de factura',
      visualize_with_xsl: 'XSL',
      visualize_with_xsl_tooltip: 'Visualizar XSL',
      visualize_with_xml: 'Fichero',
      visualize_with_xml_tooltip: 'Factura electrónica',
      redigitize_invoice: 'Redigitalizar',
      redigitize_invoice_tooltip: 'Enviar solicitud redigitalización factura',
      check_status: 'Estado',
      check_status_tooltip: 'Consultar estado',
      check_payment_emit: 'Cobro',
      check_payment_emit_tooltip: 'Detalle de cobro',
      check_payment: 'Pago',
      check_payment_tooltip: 'Detalle de pago',
      accept_order: 'Aceptar',
      accept_order_tooltip: 'Aceptar pedido',
      error_rules_tooltip: 'Informe de validación'
    },
    dialog_error_rules: {
      title: 'Informe de Validación',
      code: 'Campo',
      description: 'Descripción',
      location: 'Ruta'
    },
    dialog_add_buyer_center: {
      title: 'Añadir centro comprador',
      centres: {
        label: 'Centros',
        placeholder: 'Elige centro de comprador',
        required: 'Centro comprador obligatorio'
      }
    },
    dialog_resend_invoice: {
      title: 'Reenviar factura',
      communication_method: {
        label: 'Método de envío',
        placeholder: 'Elige un método de envío'
      },
      get_emails: 'Obteniendo emails... ',
      new_emails: 'Emails a los que enviar (separar por ;)',
      max_emails: 'Máximo 5 emails',
      no_emails: 'Introduzca al menos un email',
      email_format: 'Formato de los emails introducidos incorrecto (usar ; como separador, el último email no debe acabar en ; )',
      multiple_emails: 'Si no se introduce ningún email, se reenviará a los emails asociados por defecto. Si se introducen emails, se enviarán a los nuevos emails introducidos.'
    },
    dialog_redigitize: {
      title: 'Solicitud redigitalización factura',
      checkboxes: {
        label: 'Motivo del error',
        field_bad_captured: 'Campo mal capturado',
        field_no_captured: 'Campo no capturado',
        field_incorrect: 'Campo capturado incorrecto (tiene otra posición en el PDF)',
        field_others: 'Otros'
      },
      commentary: 'Comentario para digitalización'
    },
    dialog_cancel_invoice: {
      title: 'Solicitar anulación de factura',
      motive: 'Motivo de la petición de anulación'
    },
    dialog_status_data: {
      title: 'Información del estado',
      status: 'Estado',
      motive: 'Motivo',
      description: 'Descripción',
      date: 'Fecha',
      registrationCode: 'Código de registro'
    },
    dialog_payment_data: {
      title_emitted: 'Información de cobro de la factura',
      title_received: 'Información de pago de la factura',
      invoice_number: 'Número factura'
    },
    error_code: {
      ERROR_PARTY: 'Faltan datos obligatorios de la empresa o no cumple la validación prevista.',
      ERROR_LINE_DESCRIPTION: 'Falta la descripción obligatoria en alguna línea.',
      ERROR_DIR_CODE: 'Falta el código DIR3 del organismo destinatario.',
      ERROR_PARTY_ENABLE: 'La empresa está desactivada.',
      ERROR_SELLER_ADDRESS: 'La dirección del vendedor no es coherente con su país.',
      ERROR_BUYER_ADDRESS: 'La dirección del comprador no es coherente con su país.',
      ERROR_PROJECT_PARTY_ENABLE: 'La relación empresa- proyecto está desactivada.',
      ERROR_COMMERCIAL_RELATION: 'No existe una relación comercial válida entre ambas empresas.',
      ERROR_SPONSOR: 'Ninguna de las empresas tiene configuración sponsor válida.',
      ERROR_CENTRE: 'Falta el centro requerido o el informado no es válido.',
      ERROR_UNIQUE_CENTRE: 'Los centros informados no son únicos.',
      ERROR_DUPLICATE_INVOICE: 'Ya existe una factura duplicada.',
      ERROR_DUPLICATE_RECADV: 'Ya existe una recepción duplicada.',
      ERROR_DUPLICATE_ORDER: 'Ya existe un pedido duplicado.',
      ERROR_DUPLICATE_ORDER_RSP: 'Ya existe una respuesta de pedido duplicada.',
      ERROR_DUPLICATE_DELIVERY: 'Ya existe un albarán duplicado.',
      ERROR_DUPLICATE_CMR: 'Ya existe un documento de transporte duplicado.',
      ERROR_DELIVERY_LINE_BATCH: 'Falta el lote en alguna línea de albarán.',
      ERROR_DELIVERY_LINE_SERIAL_NUMBER: 'Falta el número de serie en alguna línea de albarán.',
      ERROR_DELIVERY_LINE_EXPIRATION_DATE: 'Falta la fecha de caducidad en alguna línea de albarán.',
      ERROR_SEND_DATE: 'La fecha de envío no puede ser anterior a hoy.',
      ERROR_DELIVERY_LINE_DATES: 'La fecha de caducidad no es coherente con la fecha de entrega.',
      ERROR_DELIVERY_LINE_QUANTITY: 'La cantidad de las sublíneas no coincide con la línea padre.',
      ERROR_DELIVERY_LINE_SUBLINE_REQUIRED: 'Cada línea debe tener al menos una sublínea.',
      ERROR_DELIVERY_LINE_PACKAGE_GTIN14: 'Las líneas de un mismo embalaje deben compartir el mismo GTIN14.',
      ERROR_DOCUMENT_SIGN: 'El documento debe venir firmado o con firma delegada válida.',
      ERROR_ORDER: 'Falta el pedido obligatorio.',
      ERROR_UNIQUE_ORDER: 'El pedido debe ser único.',
      ERROR_ORDER_FORMAT: 'El formato del pedido no es válido.',
      ERROR_ISSUER_ORDER: 'Falta el pedido del emisor.',
      ERROR_ISSUER_UNIQUE_ORDER: 'El pedido del emisor debe ser único.',
      ERROR_ISSUER_ORDER_FORMAT: 'El formato del pedido del emisor no es válido.',
      ERROR_INVOICE_NUMBER_FORMAT: 'El número de factura no tiene un formato válido.',
      ERROR_EXP: 'Falta el expediente obligatorio.',
      ERROR_UNIQUE_EXP: 'El expediente debe ser único.',
      ERROR_EXP_FORMAT: 'El formato del expediente no es válido.',
      ERROR_CONTRACT: 'Falta el contrato obligatorio.',
      ERROR_UNIQUE_CONTRACT: 'El contrato debe ser único.',
      ERROR_CONTRACT_FORMAT: 'El formato del contrato no es válido.',
      ERROR_INVOICE_DATE: 'La fecha de factura no es válida.',
      ERROR_OPERATION_DATE: 'La fecha de operación no cumple la validación.',
      ERROR_INVOICING_PERIOD: 'El periodo de facturación no es coherente.',
      ERROR_CORRECTIVE_INVOICE: 'La factura rectificativa no cumple las condiciones básicas.',
      ERROR_CORRECTIVE_INVOICE_MANDATORY: 'Falta el bloque correctivo obligatorio.',
      ERROR_ISSUER_TYPE: 'El tipo de emisor no es válido para el documento.',
      ERROR_MODALITY_TYPE: 'La modalidad de factura no es válida.',
      ERROR_PROJECT: 'Falta el proyecto o el informado no es válido.',
      ERROR_INVOICE_PROJECT: 'El proyecto de la factura no es válido.',
      ERROR_INTRASTAT_REQUIRED: 'Faltan los datos Intrastat obligatorios.',
      ERROR_INVOICE_COMMUNICATION_METHOD: 'El método de comunicación de la factura no es válido.',
      ERROR_SPANISH_TAX_IDENTIFICATION_NUMBER: 'El NIF o CIF español no es válido.',
      ERROR_ISSUE_DATE_FUTURE: 'La fecha de emisión no puede ser posterior a la fecha de registro o creación.',
      ERROR_ISSUE_DATE_PAST: 'La fecha de emisión no puede ser anterior a la fecha de registro o creación.',
      ERROR_SIGN: 'El documento debe estar firmado.',
      ERROR_PROJECT_ATTACHMENT_DIRECTORY: 'No existe el directorio de adjuntos del proyecto para la fecha indicada.',
      ERROR_NUMBER_EXP_FIRST_LINE: 'El número de expediente solo puede informarse en la primera línea o en cabecera.',
      ERROR_NUMBER_CONTRACT_FIRST_LINE: 'El número de contrato solo puede informarse en la primera línea o en cabecera.',
      ERROR_NUMBER_TRANSACTION_FIRST_LINE: 'El número de transacción solo puede informarse en la primera línea o en cabecera.',
      ERROR_CHANNEL: 'El canal o documento de canal no es válido.',
      ERROR_TOTAL_LINES_WITHOUT_TAXES: 'El total de líneas sin impuestos no cuadra.',
      ERROR_TOTAL_LINES_DISCOUNTS_AND_CHARGES: 'El total de líneas con descuentos y cargos no cuadra.',
      ERROR_TOTAL_INVOICE: 'El total de factura no cuadra.',
      ERROR_TOTAL_INVOICE_WITH_DISCOUNTS_AND_CHARGES: 'El total de factura con descuentos y cargos no cuadra.',
      ERROR_TOTAL_INVOICE_WITH_DISCOUNTS_CHARGES_AND_TAXES: 'El total de factura con descuentos, cargos e impuestos no cuadra.',
      ERROR_TOTAL_EXECUTABLE_INVOICE: 'El total ejecutable de la factura no cuadra.',
      ERROR_TOTAL_INVOICE_TAXES: 'El total de impuestos de la factura no cuadra.',
      ERROR_CENTRE_ROLE_TYPE: 'El rol de centro informado no es válido.',
      ERROR_CENTRE_ROLE_TYPE_BY_VALUES: 'El centro no cumple los valores permitidos para el rol informado.',
      ERROR_DRAFT_CENTRE_ROLE_TYPE_BY_VALUES: 'El borrador de centro no cumple los valores permitidos para el rol informado.',
      ERROR_CENTRE_ROLE_TYPE_MANDATORY: 'Falta el centro con el rol obligatorio.',
      ERROR_LINE: 'El documento debe incluir al menos una línea.',
      ERROR_LINE_CODE: 'Falta el código de artículo o línea.',
      ERROR_LINE_ORDER_EXIST: 'Alguna línea no tiene pedido asociado.',
      ERROR_PERIOD_DATE_INVOICE: 'Las fechas del periodo de factura no son coherentes.',
      ERROR_SIGNATURE: 'La firma del documento no es válida o no existe.',
      ERROR_LINE_TRANSACTION_REFERENCE: 'Falta el número de pedido o la referencia de transacción en alguna línea.',
      ERROR_RECEIVER_TRANSACTION_REFERENCE: 'Falta la referencia de pedido del receptor en cabecera o líneas.',
      ERROR_CENTRE_VOCENTO_WS: 'Falló la validación de centros contra el servicio Vocento.',
      ERROR_CURRENCY_EXCHANGE: 'El cambio de divisa no es válido o falta.',
      ERROR_IBAN: 'El IBAN no es válido.',
      ERROR_VALID_IBAN: 'El IBAN no supera la validación formal.',
      ERROR_LINE_SEQUENCE_NUMBER: 'El número de secuencia de línea no es válido.',
      ERROR_PAYMENT_MEAN: 'El método de pago no está permitido.',
      ERROR_FILE_SIZE: 'El tamaño total de los ficheros supera el máximo permitido.',
      ERROR_REGISTRATION_DATA: 'Los datos de registro no son válidos o están incompletos.',
      ERROR_REGISTRATION_DATA_INDRAFE: 'Los datos de registro Indrafe no son válidos o están incompletos.',
      ERROR_SEQUENCE_NUMBER: 'El número de secuencia no es válido.',
      ERROR_INVOICE_BUYER_CENTRE: 'El centro del comprador no es válido.',
      ERROR_INVOICE_CENTRE_MASK: 'La máscara del centro de factura no es válida.',
      ERROR_INVOICE_CENTRE_ROL: 'El rol del centro de factura no es válido.',
      ERROR_EIFFAGE_VALIDATION_INVOICE_SERVICE: 'Falló la llamada al servicio externo de validación Eiffage.',
      ERROR_INVOICE_BUYER_DIRE: 'Falta o es inválido el código DIR3 del comprador.',
      ERROR_CORRECTIVE_SIGN: 'La firma de la factura rectificativa no es válida.',
      ERROR_PARTY_NAME: 'El nombre de la empresa no es válido o no cumple el formato.',
      ERROR_LINE_DOCUMENT_CANAL: 'El documento de canal de la línea no es válido.',
      ERROR_INVOICE_CORRECTIVE_METHOD: 'El método de corrección de la factura rectificativa no es válido.',
      ERROR_NIF_CODPAIS: 'El NIF debe incluir el prefijo de país.',
      ERROR_WITHHOLDING_AMOUNT_WITH_TAXABLE_BASE: 'El importe de retención no coincide con la base imponible.',
      ERROR_NON_SIMULTANEOUS_TRANSACTION_AND_CONTRACT: 'No se puede informar pedido y contrato simultáneamente.',
      ERROR_CONTRACT_AND_TRANSACTION_IN_RECADV: 'El pedido y el contrato no coinciden con la recepción registrada.',
      ERROR_EUR_CURRENCY: 'La moneda debe ser euros.',
      ERROR_CENTRE_PERMANENT_ESTABLISHMENT: 'El centro permanente no cumple la configuración territorial.',
      ERROR_IGIC_FROM_CANARY_ISLANDS: 'Falta o no corresponde el IGIC para Canarias.',
      ERROR_IPSI_FROM_CEUTA: 'Falta o no corresponde el IPSI para Ceuta.',
      ERROR_NUMBER_OF_ATTACHED_FILES: 'El número de anexos no es válido.',
      ERROR_ATTACHED_FILES_EXTENSION: 'La extensión de los anexos no está permitida.',
      ERROR_TAXES_IN_PROJECT: 'Los impuestos informados no están permitidos para el proyecto.',
      ERROR_FILE_FORMAT: 'El formato del fichero no es válido.',
      ERROR_TAX_CERO_LEGAL_TEXT: 'Una operación con tipo 0 debe incluir texto legal.',
      ERROR_CORRECTIVE_INVOICE_ORDER_OR_CONTRACT: 'La factura rectificativa debe informar pedido o contrato.',
      ERROR_CORRECTIVE_REQUIRED: 'Falta el bloque correctivo obligatorio en la factura rectificativa.',
      ERROR_PARTY_BUYER_ADDRESS_VALUE: 'El valor de la dirección del comprador no es válido.',
      ERROR_SPECIFIC_CANARY: 'La factura no cumple las validaciones específicas de Canarias.',
      ERROR_SPECIFIC_CEUTA: 'La factura no cumple las validaciones específicas de Ceuta.',
      ERROR_PHYSICAL_GLN_REQUIRED: 'Falta el GLN físico obligatorio.',
      ERROR_NO_IGIC_IVA: 'No se puede informar IGIC e IVA a la vez.',
      ERROR_EXITS_PAYMENT_DETAILS: 'Falta información de medios de pago.',
      ERROR_LINE_FROM_RECADV_PRICE_QUANTITITY_POSITIVE: 'En facturas desde recepción, cantidad y precio deben ser positivos.',
      ERROR_INVOICE_LINES_NO_NEGATIVE: 'En facturas manuales, cantidad y precio no pueden ser negativos.',
      ERROR_LINE_CORRECTIVE_PRICE_NEGATIVE: 'En facturas rectificativas, el precio debe ser negativo.',
      ERROR_LINE_NO_SAME_TAX: 'Una misma línea no puede repetir el mismo impuesto.',
      ERROR_INVOICE_FROM_RECADV: 'No existe una recepción coincidente para la factura.',
      ERROR_INVOICE_ADDITIONAL_INFO_FROM_RECADV: 'La factura no coincide con la información adicional de la recepción.',
      ERROR_INVOICE_DOCUMENT_VALUES_FROM_RECADV: 'La factura no coincide con los valores de documento de la recepción.',
      ERROR_INVOICE_LINE_DATA_FROM_RECADV: 'La factura no coincide con los datos de línea de la recepción.',
      ERROR_INVOICE_ISSUE_DATE_REJECTED: 'La factura ya existe con otra fecha de emisión.',
      ERROR_GENERIC: 'Error genérico'
    },
    invoice_detail_edit_form: {
      status: 'Estado de la factura',
      internalStatus: 'Estado interno de la factura',
      invoice_number: 'Número de la factura',
      buyer: 'Comprador',
      issue_date: 'Fecha de emisión',
      communication_send_method: 'Método de envío',
      change_state: {
        label: 'Cambio de estado',
        placeholder: 'Elige un estado de factura'
      },
      change_internal_state: {
        label: 'Cambio de estado interno',
        placeholder: 'Elige un estado interno de factura'
      },
      change_sent_flag: {
        label: 'Estado del envío',
        placeholder: 'Elige un estado de envío'
      },
      total_executable_amount: 'Importe',
      seller: 'Vendedor',
      creation_date_time: 'Fecha de registro',
      communication_reception_method: 'Método de entrada',
      observations: 'Motivo cambio de estado',
      internal_observations: 'Motivo cambio de estado interno',
      pending_task: 'Tarea pendiente',
      internal_notes: 'Notas internas',
      registerNumber: 'Número de registro'
    },
    error: {
      validation: {
        id_invoice_empty: 'Identificador de factura no puede ser nulo',
        field_category_empty: 'Categoría no puede estar vacía',
        field_category_incorrect: 'Categoría indicada incorrecta'
      }
    },
    attachment: 'Adjuntos',
    no_attachment: 'No tiene archivos adjuntos asociados',
    attachments_table: {
      filename: 'Nombre',
      category: 'Categoría',
      size: 'Tamaño',
      compressed_size: 'T. Comp.',
      creation_date: 'Creación',
      author: 'Creador'
    },
    payment_table: {
      remasa: 'Remesa',
      invoice_number: 'N. factura',
      banco: 'Banco',
      desBanco: 'Descripción banco',
      viaPago: 'Vía pago',
      desViaPago: 'Descripción vía de pago',
      fechaAcept: 'F. aceptación',
      fechaVenc: 'F. vencimiento',
      fechaValor: 'F. valor',
      moneda: 'Moneda',
      importeDivisa: 'Importe',
      importeComDivi: 'Importe compensado',
      situacion: 'Estado',
      codigoFianza: 'Código fianza',
      numeroDocumento: 'Documento',
      importe: 'Importe EUR',
      receptorAlternativo: 'Receptor alternativo',
      detalleCompensacion: 'Detalle de compensación',
      detalleCompensacionPago: 'Documento/s pago',
      detalleCompensacionCobro: 'Documento/s cobro'
    },
    dialog_add_invoice_attachment: {
      title: 'Cargar adjunto',
      load_document: 'Cargar',
      file_selected: 'Seleccionar adjunto'
    },
    events: {
      title: 'Eventos',
      code: {
        SIGNED: 'Firmada',
        description: {
          SIGNED: 'Firmada electrónicamente'
        },
        REJECTED: 'Rechazada',
        VALIDATE_SIGNATURE: 'Verificación de firma',
        reject: 'Rechazada',
        DISAGREEMENT: 'No conforme',
        PENDING_OF_SIGNING: 'Pendiente de firma',
        UPDATE_STATUS: 'Actualización del estado',
        UPDATE_INTERNAL_STATUS: 'Actualización del estado interno',
        ADD_ATTACHMENT: 'Adjuntar archivo',
        DELETE_ATTACHMENT: 'Eliminación adjunto',
        RECEIVED: 'Recibido',
        SEND_INVOICE: 'Envío de factura',
        SEND_INVOICE_ORIGIN: 'Envío de factura al emisor',
        SEND_STATE: 'Envío del estado',
        SEND_CANCELINVOICE: 'Solicitud de anulación',
        PENDING_OF_VERIFYING: 'Pendiente de verificación',
        PENDING_OF_GENERATE: 'Pendiente de generación',
        PENDING_OF_VALIDATION: 'Pendiente de validación',
        FORWARD_INVOICE: 'Reenvío de factura',
        CHECK_STATUS_ONLINE: 'Consulta de estado online',
        NOTIFICATION: 'Notificación',
        RECEPTION_INVOICE: 'Recepción de factura',
        RECEPTION_ORIGINAL_INVOICE: 'Recepción de factura original',
        PENDING_OF_SEND: 'Pendiente de envío',
        YIELDED: 'Cedida',
        COMPENSATED: 'Compensada',
        PENDING_OF_COMPENSATION: 'Pendiente de compensación',
        PENDING_OF_CONFIRM: 'Pendiente de confirmar',
        COLLECTED: 'Cobrada',
        PENDING: 'Pendiente',
        RETAINED_PAYMENT: 'Pago retenido'
      },
      property: {
        FILE_NAME: 'Nombre del fichero',
        REASON: 'Razón',
        ORIGINAL_STATUS: 'Estado original',
        FINAL_STATUS: 'Estado final',
        SIGNATURE_DATE: 'Fecha de firma',
        DATE: 'Fecha de pendiente de validación',
        DISAGREEMENT: 'No conforme',
        PENDING_OF_SIGNING_DATE: 'Fecha pendiente de firma',
        PENDING_OF_VERIFYING_DATE: 'Fecha pendiente de verificación',
        RECEPTION_DATE: 'Fecha de recepción',
        REJECT_DATE: 'Fecha de rechazo',
        MOTIVE: 'Motivo',
        STATUS_BEFORE: 'Estado inicial',
        LAST_STATUS: 'Estado final',
        INTERNAL_MOTIVE: 'Motivo interno',
        INTERNAL_STATUS_BEFORE: 'Estado interno inicial',
        LAST_INTERNAL_STATUS: 'Estado interno final',
        MESSAGE_RESULT: 'Mensaje de respuesta',
        ERROR_CODE: 'Código de error',
        ERROR_DESCRIPTION: 'Descripción del error',
        ENDPOINT_STATUS: 'Estado cliente',
        EDICOM_CDR_POSITIVE: 'CDR positivo',
        EDICOM_CDR_NEGATIVE: 'CDR negativo',
        DOCUMENT_INTEGRATED: 'Documento integrado',
        INVOICE_ACCEPTED: 'Factura aceptada',
        INVOICE_OPENED: 'Factura abierta',
        REJECT_CODE: 'Código de rechazo',
        REJECT_DESCRIPTION: 'Descripción de rechazo',
        REGISTRATION_CODE_PROPERTY: 'Código de registro',
        REGISTRATION_DATE_PROPERTY: 'Fecha de registro',
        ERROR_DOWNLOAD_PROPERTY: 'Motivo del error',
        DOWNLOAD_PROPERTY: 'Descarga',
        DELETE_DIR: 'Borrado',
        REJECT: 'Rechazo',
        reject: 'Rechazo',
        USER: 'Usuario',
        USER_NAME: 'Usuario',
        signature: {
          no: {
            such: {
              algorithm: {
                exception: {
                  creating: {
                    signature: 'Error en la firma'
                  }
                }
              }
            }
          }
        },
        PROPERTY_REJECT_CODE: 'Código de rechazo',
        PROPERTY_ERROR_CODE: 'Código de error',
        PROPERTY_REJECT_DESCRIPTION: 'Descripción de rechazo',
        PROPERTY_ERROR_DESCRIPTION: 'Descripción del error',
        SIGNATURE_ERROR: 'Error de firma',
        MESSAGE: 'Mensaje',
        RECEPTION_DATE_PLATFORM: 'Fecha de recepción en plataforma',
        RECEPTION_ORIGINAL_DATE_PLATFORM: 'Fecha de recepción del original',
        SEND_DATE: 'Factura enviada. Fecha de envío'
      },
      no_events: 'No tiene eventos asociados'
    },
    eventsbpm: {
      title: 'Eventos del flujo de aprobación'
    },
    load: {
      update_invoice: 'Actualizando datos de la factura ...',
      resend_invoice: 'Reenviando esta factura ...',
      collecting_buyer_center: 'Recopilando centros ...',
      add_buyer_center: 'Añadiendo centros ...',
      download_attachment: 'Descargando adjunto ...',
      delete_attachment: 'Eliminando adjunto ...',
      checking: 'Consultando ...'
    },
    notification: {
      resend_invoice_ok: 'La factura se reenvió correctamente',
      resend_invoice_warn_suffix: ' pero se ha recibido un error.',
      resend_invoice_retry_suffix: ' Inténtelo de nuevo más tarde.',
      add_buyer_center_ok: 'Centro de comprador añadido correctamente',
      cancel_invoice_ok: 'La factura se cancelo correctamente',
      submit_edit_invoice_ok: 'La factura se editó correctamente',
      resend_invoice_ko_retained: 'La factura no se envió por estar en estado retenida',
      check_status_invoice_ok: 'El estado de la factura se ha consultado correctamente',
      resend_same_project: 'Todas las facturas deben pertenecer al mismo servicio',
      resend_same_country: 'Las facturas deben tener el mismo país receptor',
      resend_same_emission: 'Todas las facturas deben ser o de emisión o recepción',
      resend_invoices_ok: 'Las facturas se reenviaron correctamente',
      resend_not_all: 'Alguna de las factuas no cumplen las condiciones para su reenvio',
      resend_any: 'Ninguna de las facturas seleccionadas cumplen las condiciones de reenvio',
      submit_edit_invoices_ok: 'Estados de las facturas actualizados correctamente',
      no_results_payment: 'No se han encontrado datos para esta factura'
    }
  },

  // Documentos OCR
  ocr: {
    filters: {
      creation_date: {
        value: 'Fecha de registro',
        placeholder: ''
      },
      ocr_process_date: {
        value: 'Fecha de procesamiento OCR',
        placeholder: ''
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      seller: {
        value: 'Proveedor',
        placeholder: 'Proveedor'
      },
      document_name: {
        value: 'Nombre documento',
        placeholder: 'Documento'
      },
      document_number: {
        value: 'Nº documento',
        placeholder: 'Nº documento'
      },
      email: {
        value: 'Email emisor',
        placeholder: 'Email emisor'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      documenttype: {
        value: 'Tipo documento',
        placeholder: 'Tipo documento'
      },
      mail_server: {
        value: 'Email receptor',
        placeholder: 'Email receptor'
      }
    },
    documents_entity_table: {
      locked_icon: 'Bloqueado',
      document_name: 'Nombre documento',
      document_number: 'Nº documento',
      email_from: 'Email emisor',
      status_document: 'Estado',
      project: 'Servicio',
      seller: 'Proveedor',
      mail_server: 'Email receptor',
      document_type: 'Tipo documento',
      message_status: 'Mensaje estado',
      creation_date: 'F. registro',
      ocr_process_date: 'F. procesamiento OCR',
      locked_at: 'F. bloqueo',
      locked_by: 'Bloqueado por',
      attachments: 'Adjuntos'
    },
    attachments_table: {
      filename: 'Nombre',
      size: 'Tamaño',
      compressed_size: 'T. Comp.',
      creation_date: 'F. Creación'
    },
    select_placeholder: 'Seleccione...',
    title_ocr_document_validation_page: 'Validación de documentos',
    document_block_label_info: 'Está en modo consulta. Documento bloqueado por otro usuario.',
    block_tooltip: 'Bloqueado',
    no_ocr_attachment_data: 'No existen archivos adjuntos asociados',
    ocr_attachment: 'Documentos adjuntos',
    no_ocr_lines_data: 'No existen líneas asociadas al documento',
    ocr_lines: 'Líneas del documento',
    buttons: {
      reject: 'Rechazar',
      approve: 'Aprobar',
      permanent_lock: 'Bloquear',
      permanent_unlock: 'Desbloquear'
    },
    permanent_lock: {
      confirm_lock: '¿Está seguro que desea activar el bloqueo permanente de este documento?',
      confirm_unlock: '¿Está seguro que desea desactivar el bloqueo permanente de este documento?',
      locking: 'Bloqueando documento...',
      unlocking: 'Desbloqueando documento...',
      locked_success: 'Documento bloqueado permanentemente',
      unlocked_success: 'Documento desbloqueado correctamente'
    },
    // Formulario de pantalla de validación de documentos
    detail_form: {
      // Información de bloques
      general_data: 'Información de cabecera',
      supplier_data: 'Información del proveedor',
      receiver_data: 'Información del cliente',
      total_data: 'Totales',
      taxes: 'Impuestos',
      // Campos información de cabecera
      invoiceNumber: 'Número factura',
      invoiceSeriesCode: 'Nº serie',
      invoiceDate: 'Fecha factura',
      invoiceType: 'Tipo factura',
      invoiceType_ocrValue: 'Valor reconocido: ',
      correctiveInvoiceId: 'Factura que rectifica',
      deliveryDate: 'F. operación/entrega',
      purchaseOrder: 'Pedido',
      // Campos información del proveedor
      nif_tooltip: 'El NIF está normalizado, puede no coincidir con el formato indicado en el PDF',
      supplierTaxId: 'NIF',
      supplierName: 'Nombre',
      supplierAddress: 'Dirección',
      supplierIban: 'IBAN',
      supplierEmail: 'Email',
      // Campos información del cliente
      receiverTaxId: 'NIF',
      receiverName: 'Nombre',
      receiverAddress: 'Dirección',
      buyerCentreCode: 'Código centro comprador',
      // Campos totales
      netAmount: 'Base imponible',
      totalTaxAmount: 'Total impuestos',
      totalAmount: 'Total factura',
      totalDisbursements: 'Total suplidos',
      currency: 'Divisa'
    },
    taxes_table: {
      // Campos impuestos
      amount: 'Base imponible',
      taxRate: 'Tasa(%)',
      taxAmount: 'Impuesto',
      categoryCode: 'Tipo de impuesto'
    },
    lines_table: {
      // Campos líneas
      productCode: 'Código',
      amount: 'Importe',
      description: 'Descripción',
      quantity: 'Cantidad',
      unit: 'Unidad',
      unitPrice: 'Precio unitario',
      purchaseOrder: 'Pedido'
    },
    document_class: {
      ORIGINAL: 'Original',
      RECTIFICATIVA: 'Rectificativa'
    },
    send_ocr_document: {
      confirm: {
        params_required: 'Faltan parámetros obligatorios',
        title_approve: '¿Desea aprobar la factura?',
        title_reject: '¿Desea rechazar la factura?',
        confirm_button_send_document: 'Confirmar',
        approving: 'Aprobando factura ...',
        rejecting: 'Rechazando factura ...',
        nextDocumentInfo: 'Se ha cargado el siguiente documento para su validación',
        approve_notification: 'Documento aprobado correctamente',
        form_notification_error: 'Valide los campos incorrectos del formulario',
        reject_notification: 'Documento rechazado correctamente'
      }
    }
  },

  // Borradores
  drafts: {
    filters: {
      creation_date: {
        value: 'Fecha de registro',
        placeholder: ''
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Escriba 3 caracteres'
      },
      buyer_centre: {
        value: 'Centro comprador',
        placeholder: 'Centro'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Escriba 3 caracteres'
      },
      seller_centre: {
        value: 'Centro vendedor',
        placeholder: 'Centro'
      },
      invoice_number: {
        value: 'Nº factura',
        placeholder: 'Nº factura'
      },
      invoice_series_code: {
        value: 'Nº serie',
        placeholder: 'Código'
      },
      currency: {
        value: 'Divisa',
        placeholder: 'Divisa'
      },
      issue_date: {
        value: 'Rango fechas emisión',
        placeholder: 'Fecha incidencias'
      },
      operation_date: {
        value: 'Rango fechas operación',
        placeholder: 'Fecha operación'
      }
    },
    drafts_entity_table: {
      project: 'Servicio',
      buyer: 'Comprador',
      seller: 'Vendedor',
      issue_date: 'F. emisión',
      invoice_number: 'Nº factura',
      operation_date: 'F. operación',
      creation_date: 'F. registro',
      total_outstanding_amount: 'Total a pagar',
      total_executable_amount: 'Total ejecutable',
      currency: 'Divisa'
    },
    buttons: {
      create_invoice: 'Crear factura'
    }
  },

  draft_detail: {
    info_draft: 'Información',
    info_message: 'Algunos de los campos de la información de la factura son editables. Recuerda pulsar en el botón \'Guardar\' para que se apliquen las modificaciones',
    copy_draft: 'Copiar',
    copy_draft_tooltip: 'Copiar borrador de la factura',
    edit_draft: 'Editar',
    edit_draft_tooltip: 'Editar borrador de la factura',
    delete_draft: 'Eliminar',
    delete_draft_tooltip: 'Eliminar borrador de la factura',
    csv_title: 'Exportar a CSV. Información',
    csv_message: 'No se pueden exportar más de {argumento} registros, por favor acote la búsqueda',
    draft_detail_edit_form: {
      invoice_number: 'Número de la factura: ',
      buyer: 'Comprador: ',
      issue_date: 'Fecha de emisión: ',
      total_executable_amount: 'Importe ({code}): ',
      seller: 'Vendedor: ',
      creation_date_time: 'Fecha de registro: ',
      invoice_additional_information: 'Observaciones: ',
      other_additional_information: 'Otras observaciones: '
    },
    attachment: 'Adjuntos',
    no_attachment: 'No tiene archivos adjuntos asociados',
    add_attachment: 'Cargar',
    add_attachment_tooltip: 'Cargar documento adjunto',

    attachments_table: {
      filename: 'Nombre',
      category: 'Categoría',
      size: 'Tamaño',
      compressedSize: 'T. Comp.',
      creationDate: 'Creación',
      author: 'Creador'
    },
    dialog_copy_draft: {
      title: 'Copiar factura',
      invoice_number: 'Número de la factura',
      issue_date: 'Fecha de emisión',
      copy_documents: 'Copiar adjuntos',
      button_copy: 'Copiar factura'
    },
    dialog_add_attachment: {
      title: 'Cargar adjunto',
      form_dialog_add_attachment: {
        select_file: 'Seleccionar adjunto'
      },
      button_upload: 'Cargar',
      button_upload_tooltip: 'Cargar adjunto'
    },
    confirm: {
      title_delete_draft: '¿Estás seguro de querer eliminar este borrador?',
      confirm_button_delete_draft: 'Eliminar',
      title_delete_attachment: '¿Estás seguro de querer eliminar este adjunto?',
      confirm_button_delete_attachment: 'Eliminar',
      delete_draft: 'Eliminando borrador ...'
    },
    load: {
      init_draft_data: 'Cargando los datos del borrador ...',
      cancel_edit_draft_data: 'Restaurando datos del borrador ...',
      copy_draft: 'Copiando borrador ...',
      delete_draft: 'Eliminando borrador ...',
      delete_attachment: 'Eliminando adjunto ...',
      download_attachment: 'Descargando adjunto ...'
    },
    notify: {
      copy_draft_ok: 'Se ha copiado el borrador correctamente.',
      copy_draft_partial_one: 'El borrador se ha copiado, pero 1 adjunto no se ha podido copiar.',
      copy_draft_partial_many: 'El borrador se ha copiado, pero {count} adjuntos no se han podido copiar.',
      delete_draft_ok: 'Se ha eliminado el borrador correctamente.',
      download_attachment_ok: 'La descarga del archivo: "{filename}" fue correcta.',
      download_attachment_error: 'No se ha podido descargar el adjunto.',
      delete_attachment_ok: 'Adjunto eliminado correctamente.',
      create_cmr_ok: 'El documento de transporte se ha creado correctamente.',
      create_draft_ok: 'El borrador se ha creado correctamente.'
    }
  },

  new_invoice: {
    title: 'Nueva factura',
    steps: {
      header: 'Cabecera',
      extension: 'Extensión',
      lines: 'Líneas',
      totals: 'Totales'
    },
    new_invoice_form: {
      select_placeholder: 'Escriba 3 caracteres',
      format: 'Formato',
      document_class: {
        title: 'Clase de documento',
        COPY: 'Copia',
        ORIGINAL: 'Original',
        DUPLICATE: 'Duplicado',
        ADDITIONAL_TRANSMISSION: 'Adicional',
        REPLACE: 'Rectificativa',
        ADDITION: 'Adición'
      },
      seller: 'Vendedor',
      table_centre: {
        code: 'Código',
        role: 'Rol'
      },
      invoice_number: 'Número de la factura',
      issue_date: 'Fecha de emisión',
      invoicing_date_from: 'Fecha inicial periodo de facturación',
      invoicing_date_from_pickerAll: 'Fecha periodo de facturación',
      currency: 'Divisa',
      exchange_rate: 'Tipo de cambio a divisa del comprador',
      exchange_rate_date: 'Fecha Tipo de cambio',
      extension_type: 'Añadir extensión',

      document_type: 'Tipo de documento',
      service: 'Servicio',
      buyer: 'Comprador',
      invoice_series_code: 'Número de serie',
      operation_date: 'Fecha de operación',
      invoicing_date_to: 'Fecha final periodo de facturación',
      communication_method: {
        title: 'Método de envío',
        placeholder: ''
      },

      additional_data: 'Observaciones',
      other_additional_data: 'Datos del documento previo',

      place_issue_description: 'Descripción lugar expedición',
      pc_issue: 'CP Lugar Expedición',

      corrective_number: 'Número de factura rectificada',
      corrective_tax_period_from: 'Fecha inicial periodo impositivo',
      corrective_tax_period_from_pickerAll: 'Fecha de periodo impositivo',
      corrective_method: {
        title: 'Método de rectificación',
        '01': 'Rectificación íntegra',
        '02': 'Rectificación por diferencias',
        '03': 'Rectificación por descuento por volumen de operaciones durante un periodo',
        '04': 'Autorizadas por la Agencia Tributaria'
      },

      corrective_series_code: 'Número de serie',
      corrective_tax_period_to: 'Fecha final periodo impositivo',
      corrective_reason: {
        title: 'Motivo de rectificación',
        '01': 'Número de la factura',
        '02': 'Serie de la factura',
        '03': 'Fecha expedición',
        '04': 'Nombre y apellidos/Razón Social-Emisor',
        '05': 'Nombre y apellidos/Razón Social-Receptor',
        '06': 'Identificación fiscal Emisor/obligado',
        '07': 'Identificación fiscal Receptor',
        '08': 'Domicilio Emisor/Obligado',
        '09': 'Domicilio Receptor',
        '10': 'Detalle Operación',
        '11': 'Porcentaje impositivo a aplicar',
        '12': 'Cuota tributaria a aplicar',
        '13': 'Fecha/Periodo a aplicar',
        '14': 'Clase de factura',
        '15': 'Literales legales',
        '16': 'Base imponible',
        '80': 'Cálculo de cuotas repercutidas',
        '81': 'Cálculo de cuotas retenidas',
        '82': 'Base imponible modificada por devolución de envases / embalajes',
        '83': 'Base imponible modificada por descuentos y bonificaciones',
        '84': 'Base imponible modificada por resolución firme, judicial o administrativa',
        '85': 'Base imponible modificada cuotas repercutidas no satisfechas. Auto de declaración de concurso'
      },
      corrective_invoice: 'Factura rectificativa',
      dialog_add_centre: {
        title: 'Añadir centro',
        form_add_centre: {
          centre: {
            label: 'Centro',
            placeholder: 'Seleccione centro'
          },
          role: {
            label: 'Rol',
            placeholder: 'Seleccione rol'
          }
        },
        button_add_centre: 'Añadir centro'
      },
      detail_centre: {
        name: 'Nombre',
        country: 'País',
        province: 'Provincia',
        town: 'Ciudad',
        address: 'Dirección',
        postcode: 'C.Postal'
      },
      rules_form: {
        select_project_first: 'Debes seleccionar un servicio primero',
        select_seller_first: 'Debes seleccionar un vendedor primero',
        issue_date: 'La fecha de emisión no puede ser posterior a la fecha actual',
        operation_date_vs_actual_date: 'La fecha de operacion no puede ser posterior a la fecha actual',
        operation_date_lower_issue_date: 'La fecha de operacion debe ser inferior a la fecha de emisión',
        field_required_corrective_invoice: 'Campo obligatorio para facturas rectificativas',
        select_cp_first: 'Debes insertar un CP para insertar una descripción del lugar de expedición',
        select_cpDescription: 'Debes insertar una descripción de CP si has introducido un CP',
        cp_error: 'El campo "CP lugar expedición" no es válido. Debe ser un valor de 5 dígitos'
      },
      load: {
        text_load_data: 'Cargando datos ...',
        text_load_parties: 'Cargando empresas vendedoras y compradoras ...',
        text_load_communications_method: 'Cargando métodos de envío ...',
        text_save_invoice_data: 'Guardando la información de la factura',
        text_load_init_data: 'Cargando datos iniciales ...'
      },
      error: {
        validation: {
          iban: 'El IBAN no es válido',
          swift: 'El código SWIFT no es válido'
        },
        required: {
          formatDocumentId: 'El parámetro ID del formato es obligatorio',
          invoiceId: 'El ID de la factura es obligatorio',
          swift_code: 'El coódigo SWIFT es obligatorio.',
          country: 'El país es obligatorio.'
        },
        not_found: {
          invoice: 'No existe la factura',
          invoiceExtension: 'No existe la extension asociada a esta factura'
        },
        recadv_rejected: 'No se puede facturar la recepcion porque esta rechazada',
        duplicated_invoice_error_recadv: 'Ya existe una factura para la recepcion seleccionada',
        duplicated_line_invoice_status_error: 'Una de las lineas ya esta facturada o no se puede facturar'
      }
    },
    extension: {
      title: 'Añadir extensión',
      faceb2b: {
        general_data: 'Datos generales',
        public_sector_information: {
          public_organism_code: 'Código de organismo público - DIR3',
          contract_reference: 'Referencia contrato de la Administración Pública'
        },
        buyer_data: 'Datos del comprador',
        receiver_administrative_centre: {
          code: 'Código del centro receptor - DIRe',
          name: 'Nombre del centro receptor'
        },
        seller_data: 'Datos del vendedor',
        dialog_add_centre: {
          buyer_title: 'Añadir centro comprador',
          seller_title: 'Añadir centro vendedor',
          code: {
            label: 'Código',
            placeholder: 'Código'
          },
          name: {
            label: 'Nombre',
            placeholder: 'Nombre'
          },
          role: {
            label: 'Rol',
            placeholder: 'Seleccione rol'
          },
          address: {
            label: 'Dirección'
          }
        },
        roles: {
          FISCAL: 'Fiscal',
          PAYER: 'Pagador',
          BUYER: 'Comprador',
          COLLECTOR: 'Cobrador',
          SELLER: 'Vendedor',
          PAYMENT_RECEIVER: 'Receptor de pago',
          COLLECTION_RECEIVER: 'Receptor de cobro',
          ISSUER: 'Emisor'
        },
        validations: {
          public_organism_code_required: 'Este campo es obligatorio si se indica la referencia del contrato.'
        },
        add_centre_button: 'Añadir centro',
        load: {
          saving_data: 'Guardando datos de la extensión'
        }
      }
    },
    new_line_invoice: {
      title: 'Nueva línea de factura',
      delivery_title: 'Nueva línea de albarán',
      buttons: {
        add_line: 'Cargar',
        update_line: 'Actualizar',
        add_line_tooltip: 'Añadir línea',
        update_line_tooltip: 'Actualizar línea'
      },
      new_line_invoice_table: {
        concept: 'Descripción concepto',
        article_code: 'Código artículo',
        article_code_seller: 'Código vendedor',
        article_code_buyer: 'Código comprador',
        quantity: 'Cantidad',
        quantityTradeUnit: 'Cantidad embalaje',
        unitOfMeasure: 'Unidad de medida',
        measureTradeUnit: 'Unidad de medida embalaje',
        net_price: 'Precio neto',
        total_cost: 'Coste total',
        batch: 'Lote',
        serial: 'Número serie',
        bestbefore: 'F. caducidad',
        gtin14: 'Código GTIN14',
        grossAmount: 'Importe bruto',
        grossAmount_tooltip: 'Coste total con descuentos y cargos'
      },
      new_line_invoice_form: {
        description: 'Descripción',
        article_code: 'Código artículo',
        quantity: 'Cantidad',
        quantityShipped: 'Cantidad expedida',
        quantityPending: 'Cantidad pendiente',
        net_price: 'Precio neto',
        unit_of_measure: {
          title: 'Unidad de medida',
          '01': 'Unidades',
          UND: 'Unidades',
          '02': 'Horas',
          '03': 'Kilogramos',
          '04': 'Litros',
          '05': 'Otros',
          '06': 'Cajas',
          '07': 'Bandejas',
          '08': 'Barriles',
          '09': 'Bidones',
          '10': 'Bolsas',
          '11': 'Bombonas',
          '12': 'Botellas',
          '13': 'Botes',
          '14': 'Tetra Briks',
          '15': 'Centilitros',
          '16': 'Centimetros',
          '17': 'Cubos',
          '18': 'Docenas',
          '19': 'Estuches',
          '20': 'Garrafas',
          '21': 'Gramos',
          '22': 'Kilómetros',
          '23': 'Latas',
          '24': 'Manojos',
          '25': 'Metros',
          '26': 'Milimetros',
          '27': '6-Packs',
          '28': 'Paquetes',
          '29': 'Raciones',
          '30': 'Rollos',
          '31': 'Sobres',
          '32': 'Tarrinas',
          '33': 'Metro cúbico',
          '34': 'Segundo',
          '35': 'Vatio',
          PCE: 'Piezas',
          KGM: 'Kilogramos',
          MTR: 'Metro lineal',
          TNE: 'Tonelada',
          LTR: 'Litro',
          MTQ: 'Metro cubico',
          DMQ: 'Dcm. cubico',
          CENT: 'Centenas',
          MILL: 'Millares',
          MTK: 'M. cuadrados',
          BOX: 'Caja',
          BOTL: 'Botella',
          NTBK: 'Cuaderno',
          GRM: 'Gramo',
          GRSA: 'Gruesa',
          SHEE: 'Hoja',
          GAME: 'Juego',
          PAR: 'Par',
          OVLL: 'Ovillo',
          CARR: 'Carrete',
          PACK: 'Paquete',
          DOCE: 'Docena',
          K: 'K',
          R: 'R',
          B: 'B',
          C62: 'Pieza'
        },
        additional_data: 'Observaciones',
        goods_code: 'Código de mercancía',
        goods_code_placeholder: 'Escriba 3 caracteres',
        weight: 'Peso'
      },
      documents: {
        title: 'Documentos',
        no_documents: 'No tiene documentos asociados',
        button_add_document: 'Cargar',
        button_add_document_tooltip: 'Cargar documento relacionado'
      },
      documents_table: {
        name: 'Documentos',
        seller_receiver: 'Emisor/Receptor',
        value: 'Valor',
        date: 'Fecha',
        line_number: 'Nº línea'
      },
      dialog_add_document: {
        title: 'Cargar documento',
        form_add: {
          invoice_document: {
            label: 'Documento',
            CONTRACT: 'Contrato / recepción',
            TRANSACTION: 'Pedido',
            DELIVERY_NOTE: 'Albarán',
            FILE: 'Expediente',
            ORDER_LINE: 'Nº secuencia / línea',
            DESADV_LINE: 'Línea de albarán'
          },
          seller: 'Emisor/Receptor',
          value: 'Valor',
          date: 'Fecha'
        },
        notify: {
          error_type_document_uniqueER: 'El tipo de documento seleccionado debe ser único para emisor/receptor',
          error_type_document_unique: 'El tipo de documento seleccionado debe ser único'
        },
        button_add: 'Cargar',
        button_add_tooltip: 'Cargar documento'
      },
      taxes: {
        title: 'Impuestos',
        no_taxes: 'No tiene impuestos asociados. Debe añadir al menos uno.',
        button_add_tax: 'Cargar',
        button_add_tax_tooltip: 'Cargar impuesto',
        no_rate: 'No se ha podido añadir la tasa'
      },
      chargeDiscount: {
        title: 'Añadir cargos y descuentos',
        table: {
          bi: 'Base imponible',
          type: 'Tipo',
          description: 'Descripción',
          rate: 'Tasa (en %)',
          amount: 'Importe'
        },
        form_add: {
          base_amount: 'Base imponible',
          indicator: 'Indicador de descuento o cargo',
          type: 'Tipo',
          rate: 'Tasa %',
          amount: 'Importe'
        },
        no_chargeDiscount: 'No tiene cargos o descuentos asociados.',
        button_add_chargeDiscount: 'Cargar',
        button_add_chargeDiscount_tooltip: 'Cargar cargo o descuento',
        types: {
          TD: "Descuento comercial",
          DPPROPAGO: "Descuento por pronto pago",
          DRAPPEL: "Descuento por volumen o rappel",
          CCANSGAE: "Canon sociedad de autores (SGAE)"
        },
        indicator: {
          charge: "Cargo",
          discount: "Descuento"
        }

      },
      taxes_table: {
        tax_type: 'Impuesto',
        rate: 'Tasa (en %)',
        bi: 'Base imponible',
        amount: 'Importe impuesto',
        type_exemption: {
          title: 'Hecho imponible',
          SUBJECT_AND_EXEMPT: 'Sujeto y exento',
          NOT_SUBJECT: 'No sujeto',
          SUBJECT_AND_NOT_EXEMPT: 'Sujeto y no exento'
        },
        legal_text: 'Motivo'
      },
      dialog_add_tax: {
        title: 'Carga impuesto',
        response: 'Las líneas se han actualizado correctamente',
        responsewithtax: 'Las líneas se han actualizado correctamente. Algunas líneas ya tenían el impuesto seleccionado.',
        form_add: {
          tax: 'Impuesto',
          rate: 'Tasa (en %)',
          bi: 'Base imponible',
          amount: 'Importe impuesto',
          type_exemption: 'Hecho imponible',
          legal_text: 'Motivo',
          motive: 'Motivo',
          legaltextlong: 'Motivo o texto legal (Campo opcional, seleccione sólo para operaciones exentas, no sujetas o regímenes especiales)'
        },
        validations: {
          no_quantity_no_net_price: 'Debe introducir primero cantidad y precio',
          quantity_net_price_incorrect: 'Debe introducir cantidad y precio correctos'
        },
        notify: {
          invoice_line_tax_already_added: 'El impuesto seleccionado ya se ha incluido'
        },
        button_add: 'Cargar',
        button_add_tooltip: 'Cargar impuesto'
      },
      load: {
        text_go_detail: 'Cargando datos de línea de factura ...',
        text_go_deliveryNote_detail: 'Cargando datos de línea ...',
        text_add_invoice_line: 'Guardando la nueva línea ...',
        text_update_invoice_line: 'Actualizando la línea de factura ...',
        text_add_deliveryNote_line: 'Guardando la nueva línea ...',
        text_update_deliveryNote_line: 'Actualizando la línea ...',
        text_invoice_lines: 'Cargando líneas de factura ...',
        text_deliveryNote_lines: 'Cargando líneas ...',
        text_delete_invoice_line: 'Borrando línea de factura ...',
        text_delete_deliveryNote_line: 'Borrando línea de albarán ...',
        text_add_article: 'Buscando artículo ...',
      },
      notify: {
        no_lines_added: 'La factura debe tener al menos una línea',
        update_deliveryNote_line: 'La cantidad de la línea se ha actualizado'
      },
      lines: {
        button_delete_tooltip: 'Eliminar lineas seleccionadas',
        button_delete: 'Eliminar'
      },
      confirm: {
        title_delete_invoice_line: '¿Desea eliminar esta/s línea/s de factura?',
        confirm_button_delete_invoice_line: 'Confirmar',
        title_delete_deliveryNote_line: '¿Desea eliminar esta línea de albarán?',
        confirm_button_delete_deliveryNote_line: 'Confirmar',
        pending_changes_title: 'Confirmación',
        pending_changes_message: 'Tenemos cambios pendientes de guardar. ¿Deseas continuar sin actualizar?',
        pending_changes_confirm: 'Sí',
        pending_changes_cancel: 'No'
      }
    },
    invoice_totals: {
      title: 'Totales de factura',
      invoice_totals_form: {
        total_gross_amount: 'Importe bruto',
        total_gross_amount_invoice: 'Importe bruto total de la factura',
        total_general_discounts: 'Total descuentos globales',
        total_general_surcharges: 'Total cargos globales',
        total_gross_amount_before_taxes: 'Importe bruto A.I.',
        total_tax_outputs: 'Total impuestos repercutidos',
        total_taxes_withheld: 'Total impuestos retenidos',
        invoice_total: 'Total factura',
        total_payments_on_account: 'Total anticipos',
        irpf: '% IRPF',
        total_irpf: 'Total IRPF',
        payments_on_account_date: 'Fecha del anticipo',
        subsidies_total: 'Total subvenciones',
        total_outstanding_amount: 'Total a pagar',
        withholding_amount: 'Retención',
        withholding_amount_tooltip: 'Cantidades que retiene el pagador hasta el buen fin de la operación.',
        withholding_reason: 'Motivo',
        total_reimbursable_expenses: 'Total suplidos',
        total_financial_expenses: 'Gastos financieros',
        total_executable_amount: 'Total a ejecutar',
        currency: 'Divisa'
      },
      dialog_global_discounts: {
        title: 'Total descuentos globales',
        add_title: 'Añadir descuento global',
        button_add: 'Añadir',
        load: {
          text_add_discount: 'Guardando descuento global ...'
        }
      },
      dialog_global_surcharges: {
        title: 'Total cargos globales',
        add_title: 'Añadir cargo global',
        button_add: 'Añadir',
        text_add_surcharge: 'Guardando cargo global ...'
      },
      dialog_tax_outputs: {
        title: 'Impuestos repercutidos',
        title_with_held: 'Impuestos retenidos',
        bi: 'Base imponible',
        tax_type: 'Tipo de impuesto',
        tax_rate: 'Impuesto(%)',
        tax_output: 'Impuesto repercutido',
        tax_with_held: 'Impuesto retenido'
      },
      installments: {
        title: 'Datos de vencimiento',
        no_installments: 'No tiene datos de vencimiento asociados.',
        button_add_tax: 'Cargar',
        button_add_tax_tooltip: 'Cargar vencimiento'
      },
      table_installments: {
        due_date: 'Fecha',
        amount: 'Importe',
        payment_means: 'Métodos de pago',
        iban: 'IBAN',
        bic: 'SWIFT'
      },
      dialog_add_installment: {
        title: 'Cargar los datos de vencimiento',
        form_add_installment: {
          due_date: 'Fecha',
          amount: 'Importe',
          payment_means: {
            title: 'Métodos de pago',
            '01': 'Al contado',
            '02': 'Recibo Domiciliado',
            '03': 'Recibo',
            '04': 'Transferencia',
            '05': 'Letra Aceptada',
            '06': 'Crédito Documentario',
            '07': 'Contrato Adjudicación',
            '08': 'Letra de cambio',
            '09': 'Pagaré a la Orden',
            '10': 'Pagaré No a la Orden',
            '11': 'Cheque',
            '12': 'Reposición',
            '13': 'Especiales',
            '14': 'Compensación',
            '15': 'Giro postal',
            '16': 'Cheque conformado',
            '17': 'Cheque bancario',
            '18': 'Pago contra reembolso',
            '19': 'Pago mediante tarjeta',
            '20': 'Pagaré',
            '21': 'Pago a cuenta bancaria',
            '22': 'Efectivo',
            '23': 'Confirming'
          },
          iban: 'IBAN',
          bic: 'SWIFT'
        },
        load: {
          text_add_installment: 'Guardando dato de vencimiento ...',
          text_delete_installment: 'Eliminando vencimiento ...'
        },
        notify: {
          error_add_installment: 'El importe seleccionado no puede ser mayor que el total a ejecutar',
          error_add_installment_0: 'El importe seleccionado no puede ser 0',
          error_add_installment_sepa_no_swift: 'El país del código IBAN no es un país de tipo SEPA, debe introducir el código SWIFT',
          error_add_installment_sepa_no_correct_lenght: 'El pais con codigo "{code}" no es un pais SEPA cuyo codigo ' +
            'SWIFT debe tener una longitud de 8 o de 11',
          error_add_installment_no_correct_country: 'El código de país del IBAN introducido no es correcto',
          error_add_installment_incorrect_iban: 'El IBAN introducido no es correcto',
          error_character_incorrect_iban: 'El IBAN introducido no es correcto. No se permiten guiones, espacios ni caracteres especiales'
        },
        button_add: 'Cargar',
        button_add_tooltip: 'Cargar vencimiento'
      },
      button_finish: 'Enviar',
      button_finish_tooltip: 'Enviar borrador',
      button_recalculate: 'Recalcular',
      button_recalculate_tooltip: 'Recalcular totales',
      send_invoice: {
        confirm: {
          title_send_invoice: '¿Desea enviar la factura?',
          confirm_button_send_invoice: 'Confirmar'
        },
        add_attachments: {
          tittle_add_attachments: 'Antes de enviar la factura, ¿desea añadirle adjuntos?',
          confirm_button_add_attachments: 'Adjuntar'
        },
        error_no_taxes: 'No puede continuar si no ha añadido al menos 1 impuesto repercutido a cada una de las líneas de factura',
        load: {
          sending_invoice: 'Enviando factura ...'
        },
        sendOK: 'El envio se ha realizado correctamente'
      },
      send_delivery: {
        confirm: {
          title_send_delivery: '¿Desea enviar el albarán?',
          confirm_button_send_delivery: 'Confirmar'
        },
        load: {
          sending_delivery: 'Enviando albarán ...'
        },
        sendOK: 'El envio se ha realizado correctamente'
      },
      tooltip: {
        tax_output: 'Ver tabla de impuestos repercutidos',
        tax_with_held: 'Ver tabla de impuestos retenidos',
        preview_pdf_title: 'Previsualización de PDF',
        preview_xsl_title: 'Previsualización de XSL',
        preview_xml_title: 'Fichero de metadatos',
        preview_label_title: 'Previsualización de etiqueta',
        global_discounts: 'Detalle de los descuentos globales aplicados',
        global_surcharges: 'Detalle de los cargos globales aplicados'
      },
      dialog_general_discounts: {
        title: 'Descuentos globales',
        description: 'Descripción',
        amount: 'Importe'
      },
      dialog_general_surcharges: {
        title: 'Cargos globales',
        description: 'Descripción',
        amount: 'Importe'
      },
      load: {
        text_invoice_totals: 'Cargando totales de la factura ...',
        text_recalculate_totals: 'Recalculando totales'
      },
      notify: {
        recalculate_totals_ok: 'Se han recalculado correctamente'
      },
      error_no_withholding_amount_when_withholding_reason: 'Este campo es obligatorio si se aplica retención',
      error_no_payments_on_account_date: 'Este campo es obligatorio si se aplica anticipo'
    }
  },
  new_deliveryNote: {
    title: 'Nuevo albarán',
    generate_line: 'Editar / Generar línea',
    delete_line: 'Eliminar línea',
    steps: {
      header: 'Cabecera',
      extension: 'Extensión',
      lines: 'Líneas'
    },
    new_deliveryNote_form: {
      select_placeholder: 'Escriba 3 caracteres',
      format: 'Formato',
      document_class: {
        title: 'Clase de documento',
        COPY: 'Copia',
        ORIGINAL: 'Original',
        DUPLICATE: 'Duplicado',
        ADDITIONAL_TRANSMISSION: 'Adicional',
        REPLACE: 'Rectificativa',
        ADDITION: 'Adición'
      },
      seller: 'Vendedor',
      table_centre: {
        code: 'Código',
        role: 'Rol'
      },
      deliveryNote_number: 'Número de albarán',
      issue_date: 'Fecha de emisión',
      delivery_date: 'Fecha de entrega',
      invoicing_date_from: 'Fecha inicial periodo de facturación',
      invoicing_date_from_pickerAll: 'Fecha periodo de facturación',
      currency: 'Divisa',
      exchange_rate: 'Tipo de cambio a divisa del comprador',
      exchange_rate_date: 'Fecha Tipo de cambio',
      extension_type: 'Añadir extensión',

      document_type: 'Tipo de documento',
      deliveryNote_type: 'Tipo de albarán',
      service: 'Servicio',
      buyer: 'Comprador',
      deliveryNote_series_code: 'Número de serie',
      operation_date: 'Fecha de operación',
      invoicing_date_to: 'Fecha final periodo de facturación',
      communication_method: {
        title: 'Método de envío',
        placeholder: ''
      },

      additional_data: 'Observaciones',
      other_additional_data: 'Datos del documento previo',
      place_issue_description: 'Descripción lugar expedición',
      pc_issue: 'CP Lugar Expedición',
      buttons: {
        add_package_tooltip: 'Añadir nuevo embalaje',
        delete_package_tooltip: 'Eliminar embalaje',
        show_package_lines_tooltip: 'Mostrar líneas asociadas al embalaje',
        show_all_lines: {
          label: 'Mostrar líneas',
          tooltip: 'Mostrar todas las líneas del albarán'
        }
      },
      dialog_add_package: {
        title: 'Añadir embalaje',
        load_registration: 'Generando código SSCC',
        form_add_package: {
          package_type: {
            label: 'Tipo de embalaje',
            placeholder: 'Seleccione tipo'
          },
          sscc: {
            label: {
              seller: 'Código SSCC generado por el proveedor. Opcional',
              auto: 'Código SSCC generado por la plataforma'
            },
            placeholder: 'SSCC',
            noexist: 'No se puede añadir un nuevo embalaje porque no se ha configurado el código de empresa y el número de embalaje inicial. Consulte con su administrador.'
          }
        }
      },

      dialog_add_centre: {
        title: 'Añadir centro',
        form_add_centre: {
          centre: {
            label: 'Centro',
            placeholder: 'Seleccione centro'
          },
          role: {
            label: 'Rol',
            placeholder: 'Seleccione rol'
          }
        },
        button_add_centre: 'Añadir centro'
      },
      detail_centre: {
        name: 'Nombre',
        country: 'País',
        province: 'Provincia',
        town: 'Ciudad',
        address: 'Dirección',
        postcode: 'C.Postal'
      },
      rules_form: {
        select_project_first: 'Debes seleccionar un servicio primero',
        select_seller_first: 'Debes seleccionar un vendedor primero',
        issue_date: 'La fecha de emisión no puede ser posterior a la fecha actual',
        operation_date_vs_actual_date: 'La fecha de operacion no puede ser posterior a la fecha actual',
        operation_date_lower_issue_date: 'La fecha de operacion debe ser inferior a la fecha de emisión',
        select_cp_first: 'Debes insertar un CP para insertar una descripción del lugar de expedición',
        select_cpDescription: 'Debes insertar una descripción de CP si has introducido un CP',
        cp_error: 'El campo "CP lugar expedición" no es válido. Debe ser un valor de 5 dígitos',
        select_centre_delivery_point: 'Debe seleccionar un lugar de entrega para visualizar las líneas'
      },
      load: {
        text_load_data: 'Cargando datos ...',
        text_load_parties: 'Cargando empresas vendedoras y compradoras ...',
        text_load_communications_method: 'Cargando métodos de envío ...',
        text_save_deliveryNote_data: 'Guardando la información del albarán',
        text_load_init_data: 'Cargando datos iniciales ...',
        delete_load_deliveryNote: 'Eliminando albarán ...'
      },
      notify: {
        deliverynote_data_saved: 'Los datos del albarán se han guardado correctamente',
        delete_deliveryNote: '¿Eliminar albarán?',
        delete_tooltip: 'Eliminar albarán',
        confirm_delete_deliveryNote: 'Eliminar',
        delete_deliveryNote_ok: 'Se ha eliminado el borrador correctamente.'
      },
      error: {
        validation: {
          iban: 'El IBAN no es válido',
          swift: 'El código SWIFT no es válido'
        },
        required: {
          formatDocumentId: 'El parámetro ID del formato es obligatorio',
          deliveryNoteId: 'El ID del albarán es obligatorio',
          swift_code: 'El coódigo SWIFT es obligatorio.',
          country: 'El país es obligatorio.'
        },
        not_found: {
          deliveryNote: 'No existe el albarán',
          deliveryNoteExtension: 'No existe la extension asociada a este albarán'
        },
        recadv_rejected: 'No se puede facturar la recepcion porque esta rechazada',
        duplicated_deliveryNote_error_recadv: 'Ya existe un albarán para la recepcion seleccionada',
        duplicated_line_deliveryNote_error_recadv: 'Una de las lineas ya esta facturada o no se puede facturar'
      }
    },
    deliveryNote_package: {
      title: 'Embalajes',
      form_package: 'Embalaje',
      popover: {
        all_packages_has_subpackages: 'Todos los embalajes de segundo nivel deben tener un subnivel',
        all_packages_has_lines: 'Todos los embalajes de último nivel deben tener al menos una línea asociada',
        all_lines_has_package: 'Todas las líneas deben tener un embalaje asignado'
      },
      dialog_move_line_package: {
        title: 'Asignar embalaje a las líneas',
        buttons: {
          move_line_package: {
            label: 'Asignar embalaje',
            tooltip: 'Asignar embalaje a las líneas'
          }
        }
      },
      load: {
        get_all_lines: 'Cargando todas las líneas ...',
        remove_package: 'Eliminando embalajes ...',
        get_package_lines: 'Cargando las líneas del embalaje ...',
        new_package: 'Añadiendo embalaje ...',
        move_line_package: 'Asignando embalaje a la líneas ...'
      },
      notify: {
        remove_package: '¿Desea eliminar el embalaje?'
      }
    }
  },

  // Cierres contables y borradores de cierres contables
  accounting_closes: {
    filters: {
      close_date: {
        value: 'Fecha de cierre'
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Escriba 3 caracteres'
      },
      invoice_number: {
        value: 'Nº factura',
        placeholder: 'Nº factura'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      name: {
        value: 'Nombre',
        placeholder: 'Nombre'
      },
      accounting_close_name: {
        value: 'Nombre cierre dependiente',
        placeholder: 'Nombre cierre'
      },
      start_date: {
        value: 'Fecha de inicio',
        placeholder: 'Fecha'
      },
      end_date: {
        value: 'Fecha de fin',
        placeholder: 'Fecha'
      }
    },
    entity_table: {
      project: 'Servicio',
      buyer: 'Comprador',
      name: 'Nombre',
      close_date_time: 'Fecha cierre',
      status: 'Estado',
      start_date: 'Fecha inicio',
      end_date: 'Fecha fin',
      child_accounting_close_name: 'Cierre dependiente',
      date_info: 'F. informativa',
      description: 'Descripción',
      add: 'Añadir cierre',
      close_accounting: 'Cerrar cierre contable'
    },
    notify: {
      save_changes: 'El cierre contable se ha creado correctamente',
      update_changes: 'El cierre contable se ha actualizado correctamente',
      invoices_added: 'Facturas añadidas correctamente',
      verification_ok: 'La firma del cierre es correcta',
      verification_ko: 'La firma del cierre no es correcta',
      result_exceded: 'No permitidio. Debe acotar la búsqueda al menos a 1000 resultados'
    },
    add_invoices: 'Añadir facturas',
    add_selected: 'Añadir selección',
    add_all_invoices: 'Añadir todas las facturas',
    new_accounting: 'Nuevo cierre',
    new_accounting_tooltip: 'Crear nuevo cierre contable',
    validate_signature: 'Verificación de firma'
  },
  accounting_closes_detail: {
    invoices: {
      title: 'Listado de facturas',
      no_data: 'No existen facturas asociadas a este cierre contable',
      buyer: 'Comprador',
      seller: 'Vendedor',
      invoice_number: 'Nº factura',
      issue_date: 'F. emisión',
      creation_date_time: 'F. registro',
      total_executable_amount: 'Importe',
      currency: 'Divisa',
      status: 'Estado',
      project: 'Servicio',
      reception_method: 'Método recepción'
    },
    confirm: {
      title_delete_draft: '¿Estás seguro de eliminar este borrador de cierre contable?',
      title_close_draft: '¿Estás seguro de cerrar este cierre contable?',
      close_ok: 'Se ha cerrado el borrador correctamente.',
      close_ko: 'No se ha podido cerrar el borrador. Contacte con su administrador'
    },
    notify: {
      delete_draft_ok: 'Borrador eliminado'
    }
  },
  // incidencias
  issue: {
    type: {
      ERROR_PORTAL: 'Error en el portal',
      PRICE_ERROR: 'Error en el precio',
      QUANTITY_ERROR: 'Error en la cantidad'
    },
    status: {
      OPEN: 'Abierta',
      IN_PROGRESS: 'En proceso',
      RESOLVED: 'Resuelta'
    },
    priority: {
      value_0: 'Ninguna',
      value_1: 'Baja',
      value_2: 'Media',
      value_3: 'Alta'
    }
  },
  // Tareas pendientes
  pendingtask: {
    error: {
      reject_action: 'No es posible rechazar la factura al proveedor si no está rechazada previamente en el sistema de gestión.'
    },
    filters: {
      creation_date: {
        value: 'Fecha-hora de registro'
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Escriba 3 caracteres'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Escriba 3 caracteres'
      },
      invoice_number: {
        value: 'Nº factura',
        placeholder: 'Nº factura'
      },
      invoice_series_code: {
        value: 'Nº de serie',
        placeholder: 'Código'
      },
      corrective_invoice_number: {
        value: 'Nº factura rectificada',
        placeholder: 'Nº factura rectificada'
      },
      total_executable_amount_from: {
        value: 'Importe desde',
        placeholder: 'Importe'
      },
      total_executable_amount_to: {
        value: 'Importe hasta',
        placeholder: 'Importe'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      document_class: {
        value: 'Clase de factura',
        placeholder: 'Clase de factura'
      },
      registration_number: {
        value: 'Nº registro',
        placeholder: 'Registro'
      },
      reception_method: {
        value: 'Mét. entrada',
        placeholder: 'Método'
      },
      attachments: {
        value: 'Adjuntos',
        placeholder: 'Escoge...'
      },
      internal_status: {
        value: 'Estado interno',
        placeholder: 'Estado'
      },
      pending_task: {
        value: 'Tarea pendiente',
        placeholder: 'Escoge...'
      },
      invoice_type: {
        value: 'Tipo de factura',
        placeholder: 'Tipo'
      },
      tax_type: {
        value: 'Tipo de impuesto',
        placeholder: 'Impuesto'
      },
      rate: {
        value: 'Tasa',
        placeholder: 'Tasa'
      },
      currency_type: {
        value: 'Divisa',
        placeholder: 'Divisa'
      },
      order_number: {
        value: 'Nº pedido',
        placeholder: 'Pedido'
      },
      contract_number: {
        value: 'Nº contrato/recepción',
        placeholder: 'Contrato/recepción'
      },
      delivery_note: {
        value: 'Nº albarán',
        placeholder: 'Albarán'
      },
      file_number: {
        value: 'Nº expediente',
        placeholder: 'Expediente'
      },
      issue_date: {
        value: 'Rango fechas emisión',
        placeholder: 'Rango fechas'
      },
      operation_date: {
        value: 'Rango fechas operación',
        placeholder: 'Rango fechas'
      }
    },

    buttons: {
      btnDownloadPdf: 'PDF',
      btnDownloadPdf_tooltip: 'Descargar visualización en formato PDF',
      btnDownloadOriginal: 'Custodiado',
      btnDownloadOriginal_tooltip: 'Descargar custodiado',
      btnDownloadMetadata: 'Metadatos',
      btnDownloadMetadata_tooltip: 'Descargar metadatos',
      btnSendInvoice: 'Enviar factura',
      btnSendInvoice_tooltip: 'Enviar factura',
      btnPaymentProposal: 'Enviar propuesta',
      btnPaymentProposal_tooltip: 'Envío de estado de propuesta de pago',
      btnApprove: 'Aprobar',
      btnSend: 'Enviar',
      btnCreate: 'Crear/Reiniciar',
      btnRejected: 'Rechazar'
    },

    createcover: {
      noCoverPP: 'No existe carátula de propuesta de pago de la factura ',
      noSendCoverPP: '. No se puede enviar el estado de la propuesta de pago.',
      createcover_multiple_ko: 'Las siguientes facturas deben tener indicador de tarea pendiente Sí: ',
      title: 'Flujo de aprobación de documentos',
      rbInvoice: 'Carátula Factura',
      rbPaymentProposal: 'Carátula propuesta pago',
      cover: {
        steps: {
          creation: 'Creación',
          send: 'Envío'
        },
        titleaux: '1. Seleccione Documento: ',
        title: '1. Documento: ',
        create_ok: 'La/s carátula/s se han creado correctamente',
        create: 'Creando carátula',
        btnCover: 'Crear carátula',
        send_ok: 'La/s factura/s se han enviado correctamente',
        send_multiple_ko: 'Se ha enviado correctamente el estado de la propuesta de pago ',
        send_multiple_ko_all: 'No se ha enviado el estado de las propuesta de pago. Revise los errores',

        aprroval: {
          btnAprroval: 'Enviar a visto bueno',
          notify: 'Enviando a visto bueno'
        },

        signature: {
          btnSignature: 'Enviar a firma',
          notify: 'Enviando a firma'
        },
        user: {
          title: '2. Usuario: ',
          placeholder: 'Introduce un usuario',
          user_required: 'Seleccione usuario'
        }
      }
    },

    pendingtask_entity_table: {
      buyer: 'Comprador',
      buyer_centres: 'Centros comprador',
      seller: 'Vendedor',
      num_pendingtask: 'N. factura',
      issue_date: 'F. emisión',
      creation_date: 'F. registro',
      import: 'Importe',
      divisa: 'Divisa',
      status: 'Estado',
      reception_method: 'Mét. recepción',
      pendingtask: 'Tarea pendiente',
      internal_status: 'Estado interno',
      internal_notes: 'Notas Internas',
      register_number: 'Nº registro',
      level_approval: 'Nivel de aprobación'
    },

    pendingtask_entity_table_detail: {
      code: 'Código artículo',
      description: 'Descripción',
      order: 'Pedido',
      despatch_quantity: 'Cantidad anunciada',
      received_quantity: 'Cantidad recibida',
      accepted_quantity: 'Cantidad aceptada',
      measure: 'Unidad de medida',
      price: 'Precio unitario',
      currency: 'Divisa',
      status: 'Estado'
    },
    pendingtask_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Descargar PDF',
      download_pdfmultiple_buttons: 'PDF/S',
      download_originalmultiple_buttons: 'Custodiado/s',
      download_createrestar_buttons: 'Crear/Reiniciar',
      download_sendinvoice_buttons: 'Enviar factura',
      download_sendstatus_buttons: 'Enviar propuesta',

      event_table: {
        events: 'Eventos',
        action: 'Acci\u00F3n',
        date: 'Fecha evento',
        category: 'Categoría',
        user_origin: 'Usuario origen',
        user_destiny: 'Usuario destino',
        observations: 'Observaciones',
        no_date: 'Esta factura no tiene eventos'
      },

      attachments_table: {
        attachments: 'Adjuntos',
        fiename: 'Nombre',
        category: 'Categoría',
        size: 'Tamaño',
        compressedSize: 'T.comprimido',
        hidden: 'Oculto',
        creationDate: 'F.Creación',
        author: 'Creador',
        no_date: 'Esta factura no tiene ningún documento adjunto',
        load: 'Cargar',
        load_tooltip: 'Cargar adjunto',
        download: 'Descargando Documento Adjunto de la Factura ...',
        delete: 'Eliminando documento adjunto de la factura ...',
        delete_ok: 'El archivo se ha eliminado correctamente.',
        fileselected: 'Seleccione fichero.'
      },

      sap: {
        send: 'Enviando factura',
        send_ok: 'Factura enviada',
        send_multiple_ko: 'La factura {fact} debe estar en estado pendiente y no haber sido enviada previamente.',
        send_multiple_ko_all: 'No se han enviado las facturas. Revise los errores',
        maxselected: 'No puede realizar el envío de más de 10 facturas a la vez.'
      },

      paymentproposal: {
        send: 'Enviando estado propuesta de pago',
        send_ok: 'Estado de propuesta de pago enviado',
        name: 'Nombre propuesta pago',
        invoicenumber: 'Número de factura',
        status: 'Estado',
        description: 'Descripción',
        title: 'Propuesta de pago',
        btnsend: 'Enviar'
      },

      rejectedinvoice: {
        title: 'Rechazar factura',
        status: 'Estado actual',
        statusnext: 'Estado siguiente',
        category: 'Categoría',
        motive: 'Motivo del rechazo',
        motive_required: 'Motivo obligatorio',
        categoryselected: 'Seleccione .',
        rejected: 'Rechazando la factura',
        rejected_ok: 'La factura se ha rechazado correctamente ',
        statusrejected: 'Rechazada'
      },

      approveinvoice: {
        title1: 'Aprobar factura',
        title2: 'Enviar factura',
        status: 'Nivel actual',
        statusnext: 'Nivel siguiente',
        category: 'Categoría',
        motive: 'Comentario',
        motive_required: 'Comentario obligatorio',
        categoryselected: 'Seleccione',
        approved: 'Aprobando la factura',
        approved_ok: 'La factura se ha aprobado correctamente',
        send: 'Enviando la factura',
        send_ok: 'La factura se ha enviado correctamente',
        field: 'Campo',
        value: 'Valor'
      },

      internal_notes: {
        title: 'Notas internas'
      },

      notify: {
        save: 'Actualizando datos de la factura',
        download: 'La descarga del fichero {file} fue correcta.',
        download_multiple: 'La descarga se a realizado correctamente.',
        selected_service: 'Seleccione un servicio',
        save_field: 'Guardando campos...',
        save_field_ok: 'Campos guardados correctamente.',
        delete_fields: 'Eliminando campos...',
        delete_fields_ok: 'Los campos se han eliminado correctamente.'
      }
    }
  },

  auditory: {
    filters: {
      input_date: {
        value: 'Fecha-hora de entrada'
      },
      sender: {
        value: 'Emisor',
        placeholder: 'Emisor'
      },
      receiver: {
        value: 'Receptor',
        placeholder: 'Receptor'
      },
      filename: {
        value: 'Nombre de fichero',
        placeholder: 'Fichero'
      },
      document_number: {
        value: 'Nº documento',
        placeholder: 'Documento'
      },
      document_type: {
        value: 'Tipo de documento',
        placeholder: 'Tipo'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      batch: {
        value: 'Lote',
        placeholder: 'Escoge...'
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      inFormat: {
        value: 'Formato Entrada',
        placeholder: 'Formato Entrada'
      },
      outFormat: {
        value: 'Formato Salida',
        placeholder: 'Formato Salida'
      },
      visible: {
        value: 'Visible',
        placeholder: 'Escoge...'
      },
      sonFrom: {
        value: 'N. docs. hijos desde',
        placeholder: 'N. docs. hijos desde'
      },
      sonTo: {
        value: 'N. docs. hijos hasta',
        placeholder: 'N. docs. hijos hasta'
      },
      processingTimeFrom: {
        value: 'Tiempo de procesamiento desde',
        placeholder: 'Tiempo de procesamiento desde'
      },
      processingTimeTo: {
        value: 'Tiempo de procesamiento hasta',
        placeholder: 'Tiempo de procesamiento hasta'
      },
      communication_protocol: {
        value: 'Protocolo de comunicación',
        placeholder: 'Protocolo'
      },
      audit_document_module: {
        value: 'Módulo',
        placeholder: 'Módulo'
      },
      user: {
        value: 'Usuario',
        placeholder: 'Usuario'
      },
      action: {
        value: 'Acción',
        placeholder: 'Acción'
      },
      group: {
        value: 'Grupo funcional',
        placeholder: 'Grupo funcional'
      },
      value: {
        value: 'Valor',
        placeholder: 'Valor'
      }
    },
    parent: 'Acceder al fichero padre',
    son: 'Acceder a ficheros generados',
    auditory_entity_table: {
      project: 'Servicio',
      sender: 'Emisor',
      receiver: 'Receptor',
      date: 'Fecha',
      filename: 'Nombre fichero',
      document_number: 'Nº documento',
      document_type: 'T. documento',
      status: 'Estado',
      communication_protocol: 'Comunicación',
      audit_document_module: 'Módulo',
      batch: 'Lote',
      processingTime: 'Tiempo procesamiento',
      group: 'Grupo',
      user: 'Usuario',
      action: 'Acción',
      value: 'Valor',
      csv_title: 'Exportar a CSV. Información',
      csv_message: 'No se pueden exportar más de {argumento} registros, por favor acote la búsqueda'
    },
    download_multiple: {
      multiple_ko: 'Las siguientes auditorias no se pueden descargar'
    },

    load: {
      download_request_file: 'Descargando ficheros de entrada ...',
      download_response_file: 'Descargando ficheros de salida ...',
      download_incoming_file: 'Descargando ficheros de entrada ...',
      download_integrated_file: 'Descargando ficheros integrados ...'
    },

    buttons: {
      btn_request: 'Petición/es',
      btn_response: 'Respuesta/s',
      btn_incoming_file: 'Fichero/s de entrada',
      btn_integrated_file: 'Fichero/s intregado/s',
      btn_request_tooltip: 'Descargar petición/es',
      btn_response_tooltip: 'Descargar respuesta/s',
      btn_incoming_file_tooltip: 'Descargar fichero/s de entrada',
      btn_integrated_file_tooltip: 'Descargar fichero/s intregado/s'
    }
  },

  auditory_detail: {
    info_auditory: 'Eventos',

    buttons: {
      request: 'Petición',
      response: 'Respuesta',
      incoming_file: 'Fichero de entrada',
      integrated_file: 'Fichero integrado',
      request_tooltip: 'Descargar petición',
      response_tooltip: 'Descargar  respuesta',
      incoming_file_tooltip: 'Descargar fichero de entrada',
      integrated_file_tooltip: 'Descargar fichero integrado'
    },

    load: {
      download_request_file: 'Descargando peticion de entrada ...',
      download_response_file: 'Descargando petición de salida ...',
      download_original_file: 'Descargando fichero custodiado ...',
      download_incoming_file: 'Descargando ficheros de entrada ...',
      download_integrated_file: 'Descargando ficheros integrados ...'
    },

    notify: {
      error_download_not_found: 'Error en la descarga. No se ha encontrado el fichero'
    },

    events: {
      code: {
        RECEPTION_INVOICE: 'Recepción de factura',
        RECEPTION_ORIGINAL_INVOICE: 'Recepción de factura original',
        SUMMARY_ALTCLI: 'Resumen alta clientes',
        SUMMARY_ALTPRO: 'Resumen alta proveedores',
        ERROR_LINE_LENGTH: 'Línea mal formada',
        DELETE_DIR: 'Borrado',
        invalidFormat: 'La factura no sigue el formato Facturae seleccionado',
        FILE_BASE64_ERROR: 'Error inesperado en el formato de la factura',
        'VALIDATION.DUPLICATION': 'No ha pasado la validación de factura duplicada',
        'VALIDATION.DUPLICATION.ISSUEYEAR': 'No ha pasado la validación de factura duplicada en año en curso',
        SIGNED: 'Firmada',
        EDICOM_CDR_NEGATIVE: 'CDR negativo',
        EDICOM_CDR_POSITIVE: 'CDR positivo',
        DISAGREEMENT: 'No conforme',
        PENDING_OF_SIGNING: 'Pendiente de firma',
        PENDING_OF_SEND: 'Pendiente de envío',
        UPDATE_STATUS: 'Actualización estado',
        UPDATE_INTERNAL_STATUS: 'Actualización estado interno',
        CHECK_STATUS_ONLINE: 'Consulta de estado online',
        DOCUMENT_INTEGRATED: 'Documento integrado',
        INVOICE_INTEGRATED: 'Factura integrada correctamente',
        INVOICE_INTEGRATED_WS: 'Factura integrada por servicio web',
        INVOICE_INTEGRATED_REST: 'Factura integrada por Rest',
        VALIDATION_INVOICE_DIGITIZED_WS: 'Factura digitalizada validada por servicio web',
        RECOGNITION: 'Reconocimiento',
        VALIDATE_SIGNATURE: 'Verificación de firma',
        TRANSFORMATION: 'Transformación',
        SIGNATURE: 'Firma',
        DELIVERY: 'Entrega',
        CHANGE_STATUS_RECADV_WS: 'Cambio de estado de recepciones por servicio web',
        CHECK_STATUS_RECADV_WS: 'Verificar estado de recepciones por servicio web',
        INTEGRATION_RECADV_WS: 'Integración de recepciones por servicio web',
        ERROR: 'Error',
        FACTURAE_INVALID: 'Factura mal formada',
        PARTY_SENDER_NOTFOUND: 'Empresa emisora no encontrada',
        CENTRE_SELLER_NOTFOUND: 'Centro de la empresa proveedora no encontrado',
        PARTY_RECEIVER_NOTFOUND: 'Empresa receptora no encontrada',
        CENTRE_BUYER_NOTFOUND: 'Centro de la empresa cliente no encontrado',
        CURRENCY_NOTFOUND: 'Divisa no encontrada',
        TAXTYPE_NOTFOUND: 'Tipo de impuesto no encontrado',
        COUNTRY_BUYER_NOTFOUND: 'País de la empresa cliente no encontrado',
        COUNTRY_BUYER_CIFPREFIX_NOTFOUND: 'EL país indicado en el prefijo del nif no existe',
        COUNTRY_SELLER_CIFPREFIX_NOTFOUND: 'Prefijo de nif proveedor no encontrado',
        COUNTRY_CENTRE_NOTFOUND: 'Pais del centro no encontrado',
        MEDIA_TYPE_NOTFOUND: 'Media type no encontrado',
        CONTRACT_BUYER_ERROR: 'Error inesperado en la contratacion de la empresa cliente',
        CONTRACT_PARTYMEDIA_ERROR: 'Error en la contratacion de party_media',
        DB_ERROR: 'Error inesperado en conexion a bbdd',
        REPOSITORY_FENIX_INVOICE_ERROR: 'Error al copiar fichero al repositorio fenix',
        REPOSITORY_FENIX_ATTACHMENT_ERROR: 'Error al descomprimir adjuntos en temporales',
        REPOSITORY_FENIX_RECEIVED_INVOICE_ERROR: 'Error al copiar el fichero recibido en el repositorio fenix',
        REPOSITORY_UNZIP_FILE_ERROR: 'Error ocurrido al obtener o descomprimir el fichero del repositorio de editrack',
        NOTE_INVOICE_ERROR: 'Error inesperado al crear el apunte de la factura',
        AUDIT_DOCUMENT_ERROR: 'Error inesperado al insertar informacion en auditoria',
        GETFORMAT_ERROR: 'Error inesperado al determinar el formato del documento a integrar',
        SEND_MAIL_ERROR: 'Error ocurrido en el envio de correo',
        RETRY_MAIL_ERROR: 'Error al guardar informacion para reintento de envío de email',
        UNEXPECTED_ERROR: 'Error inesperado',
        REQUEST_EMPTY: 'Petición vacía',
        DOCUMENT_CLASS_NOTFOUND: 'Clase de documento no encontrado',
        STATUS_DOCUMENT_NOTFOUND: 'Estado de documento no encontrado',
        INVOICE_DOCUMENT_TYPE_NOTFOUND: 'Tipo de documento defactura no encontrado',
        INVOICE_TYPE_NOTFOUND: 'Tipo de factura no encontrado',
        INSTANCES_REQUEST_EMPTY: 'Las instancias de documento no pueden ser vacías',
        DOCUMENT_FORMAT_EMPTY: 'El elemento Documentformat no puede ser vacío o nulo',
        DOCUMENT_FORMAT_UNRECOGNIZED: 'Formato de documento no reconocido',
        REPOSITORYLOCATOR_ATTACHMENT_EMPTY: 'El elemento Repositorylocator de la instancia ATTACHMENT no puede ser nulo o vacio',
        ORIGINALFILENAME_ATTACHMENT_EMPTY: 'El elemento originalfilename de la instancia ATTACHMENT no puede ser nulo o vacio',
        DOCUMENT_FORMAT_ERROR: 'El formato del documento a integrar (contenido en la petición) no es correcto',
        PROJECT_PARTY_SPONSOR_NOTFOUND: 'Propietaria no encontrado entre las empresas de la factura',
        PROJECT_PARTY_SPONSOR_ERROR: 'Error inesperado al buscar la propietaria entre las empresas proveedor/cliente de la factura',
        VALIDITY_DOCUMENT_NOTFOUND: 'No existe vigencia de documento para el tipo de documento y pais de la factura',
        STATUS_AUDIT_NOTFOUND: 'Estado de auditoria no encontrado',
        SEMANTICDOCUMENTID_EMPTY: 'El elemento semanticdocumentid no puede ser nulo o vacío',
        REPOSITORYLOCATOR_RECEIVED_EMPTY: 'El elemento Repositorylocator de la instancia RECEIVED no puede ser nulo o vacio',
        INCOMINGDATETIME_EMPTY: 'El elemento incomingdatetime no puede ser nulo o vacio',
        RECEIVERID_NOTFOUND: 'Empresa cuyo nif esta indicado en el elemento receiverid no existe',
        SENDERID_NOTFOUND: 'Empresa cuyo nif esta indicado en el elemento senderid no existe',
        DOCUMENT_TYPE_NOTFOUND: 'Tipo de documento no encontrado',
        DOCUMENT_PARENT_NOTFOUND: 'Documento padre no encontrado',
        COMMUNICATION_PROTOCOL_EMPTY: 'Protocolo de comunicación no puede ser nulo o vacio',
        COMMUNICATION_PROTOCOL_NOTFOUND: 'Protocolo de comunicación no encontrado',
        REPOSITORY_ERROR: 'Error al obtener el fichero del repositorio',
        CONNECTION_ERROR: 'Error de conexion a bbdd inesperado',
        PROJECT_COMMUNITYID_NOTFOUND: ' Servicio con codigo communityid no encontrado',
        DOCUMENT_FORMAT_NOTFOUND: ' Formato de documento no encontrado',
        INPUTDATETIME_EMPTY: ' El elemento inputdatetime no puede ser nulo ni vacío',
        DELIVERYCHECK: ' Confirmación de entrega',
        DUPLICATED_INVOICE_ERROR: ' Error de factura duplicada',
        CORRECTIVE_NUMBER_REQUIRED: ' El número de factura rectificativa es obligatorio para método de rectificación 01 ó 02',
        DIR_ATTACHMENT_NOTFOUND: ' No existe el directorio de adjuntos de la factura a integrar',
        996: '996',
        CIF_REQUIRED: 'El nif es un campo obligatorio',
        ACTION_REQUIRED: 'La acción es un campo obligatorio',
        DESCRIPTION_REQUIRED: 'La descripción es un campo obligatorio',
        CANAL_REQUIRED: 'El canal es un campo obligatorio',
        EMAIL_REQUIRED: 'El email es un campo obligatorio',
        PARTY_BUYER_NOTFOUND: 'La empresa cliente no existe',
        PROJECT_PARTY_DISABLED: 'La empresa esta deshabilitada para el servicio indicado',
        PROJECT_PARTY_BUYER_NOTFOUND: 'La empresa cliente no esta asociada o esta deshabilitada para el servicio indicado',
        PROJECT_PARTY_SELLER_NOTFOUND: 'La empresa vendedora no esta asociada o esta deshabilitada para el servicio indicado',
        COMMUNICATION_METHOD_NOTFOUND: 'El método de comunicación no existe',
        EMAIL_INVALID: 'El email es incorrecto',
        ACTION_UNEXPECTED: 'La accion es incorrecta',
        READ_FILE_BUYERS_ERROR: 'Error inesperado al leer el fichero de contratación de empresas clientes',
        UPDATE_PARTY_ERROR: 'Error al actualizar los datos de la empresa',
        CREATE_COMMUNICATIONMETHOD_PARTY_ERROR: 'Error al crear el metodo de entrega asociado a la empresa',
        CREATE_PARTY_MEDIA_ERROR: 'Error al crear el email asociado a la empresa cliente',
        CREATE_USER_PARTY_ERROR: 'Error al crear el usuario asociado a la empresa cliente',
        CREATE_USER_ERROR: 'Error al crear el usuario',
        CREATE_PARTY_ERROR: 'Error al crear la empresa',
        CREATE_PROJECT_PARTY_ERROR: 'Error al crear la relación entre el proyecto y la empresa',
        CREATE_PARTY_COMMERCIALRELATION_ERROR: ' Error al crear la relación comercial entre la empresa propietaria y la empresa cliente',
        CREATION_PARTY_WS: 'Creación de empresas',
        UPDATE_PARTY_WS: 'Actualización de empresas',
        CREATION_USER_WS: 'Creación de usuarios',
        REMOVE_USER_WS: 'Borrado de usuarios',
        UPDATE_USER_WS: 'Actualización de usuarios',
        UNLOCK_USER_WS: 'Desbloqueo de usuarios',
        RESET_USER_WS: 'Reseteo de usuarios',
        PROJECT_NOSENDER: 'Método de envío incorrecto. El proyecto no es de emisión',
        SELLER_NOSPONSOR: 'Método de envío incorrecto. La empresa no es propietaria.',
        PROJECT_NO_DELIVERY_METHOD: 'Método de envío no encontrado para el proyecto.',
        NO_LINES: 'Recepción sin líneas',
        ITEM_PRICE_NOTFOUND: 'La línea no contiene precio',
        ITEM_NOTFOUND: 'Falta el artículo',
        INVALID_MEASURE: 'Unidad de medida errónea',
        RECADV_ERROR: 'Error',
        DUPLICATED_RECADV: 'Recepción duplicada',
        INVOICE_VALIDATION: 'Error en la validación de la factura',
        UPDATE_PARTY: 'Actualización de empresa',
        SIGN: 'Firma',
        hermes: {
          integration: {
            invoice: 'Factura integrada con éxito'
          },
          download: {
            invoice: 'Descarga de factura'
          }
        },

        // Categorías

        CARATULA_FACTURA: 'Carátula de factura',
        CARATULA_PROPUESTA_PAGO: 'Carátula de propuesta de pago',
        PROPUESTA_PAGO: 'Propuesta de pago',
        DISPLAY_INVOICE: 'PDF de la factura',
        APPROVAL_FLOW: 'Flujo de aprobación',

        // Acciones

        SEND_SIGNED: 'Envío a Firma',
        SEND_APPROVAL: 'Envío a visto bueno',
        CREATE_COVER: 'Creación de carátula',
        RESTART_CREATE_COVER: 'Reinicio de carátula',
        ACCEPTED: 'Aceptada',
        REJECTED: 'Rechazada',
        SEND_INVOICE: 'Envío de factura',
        SEND_INVOICE_ORIGIN: 'Envío de factura al emisor',
        SEND_STATE: 'Envío del estado',
        SEND_PROPOSED_STATE: 'Enviado estado propuesta',
        INVOICE_SIGNATURE: 'Factura en firmas',
        PROPOSALS_SIGNATURE: 'Propuesta en firmas',

        // Códigos para eventos de auditorías de servicio web
        unexpected: {
          error: 'Error inesperado al procesar la petición o su documento'
        },
        document: {
          integration: {
            error: 'Error de integración del documento de la petición'
          }
        },
        repository: {
          error: 'Error al buscar o guardar el documento de la petición en un repositorio'
        },
        validation: {
          error: 'Error al validar el documento de la petición',
          retry: 'Reintento de validación'
        },
        invoice: {
          integrated: {
            b2bintegration: 'Factura B2B integrada con éxito',
            ws: 'Factura por servicio web integrada con éxito',
            upload: 'Factura integrada con éxito'
          },
          format: {
            error: 'Error en el formato de la factura'
          },
          schema: {
            error: 'Error en el esquema XML de la factura'
          }
        },
        recadv: {
          integrated: {
            b2bintegration: 'Recepción B2B integrada con éxito'
          },
          format: {
            error: 'Error en el formato de la recepción'
          },
          schema: {
            error: 'Error en el esquema XML de la recepción'
          }
        },
        csvparties: {
          integrated: {
            b2bintegration: 'CSV de empresas integrado con éxito'
          },
          format: {
            error: 'Error en el formato del CSVde empresas'
          },
          schema: {
            error: 'Error en el contenido del CSV de empresas'
          }
        }
      },

      property: {
        NUMLINES_TOTAL: 'Número de líneas contenidas',
        NUMLINES_ERROR: 'Número de líneas con error',
        NUMLINES_OK: 'Número de líneas correctas',
        UPDATE_PARTY: 'Actualización de empresa',
        UPDATED_PARTY: 'Actualizada',
        SEND_FILE: 'Envío de fichero',
        ERROR_LINE_LENGTH: 'Línea mal formada',
        DELETE_DIR: 'Borrado',
        REASON: 'Razón',
        ORIGINAL_STATUS: 'Estado original',
        FINAL_STATUS: 'Estado final',
        SEND_MAIL_ERROR: 'Error ocurrido en el envio de correo',
        NOTE_INVOICE_ERROR: 'Error inesperado al crear el apunte de la factura',
        DOCUMENT_INTEGRATED: 'Número de documento integrado',
        DIGITIZEDINVOICE_VALIDATED: 'Factura validada',
        ATTACHMENT_INTEGRATED: 'Nombre de fichero de adjuntos',
        INVOICE_INTEGRATED_WS: 'Número de factura integrada',
        INVOICE_INTEGRATED: 'Número de factura integrada',
        VALIDATION_INVOICE_DIGITIZED_WS: 'Número de factura digitalizada validada',
        documentinstance: {
          filename: 'Nombre del fichero'
        },
        MOTIVE: 'Motivo',
        STATUS_BEFORE: 'Estado inicial',
        LAST_STATUS: 'Estado final',
        USER_NAME: 'Usuario',
        INTERNAL_MOTIVE: 'Motivo interno',
        INTERNAL_STATUS_BEFORE: 'Estado interno inicial',
        LAST_INTERNAL_STATUS: 'Estado interno final',
        MESSAGE_RESULT: 'Mensaje de respuesta',
        CHANGE_STATUS_RECADV_WS: 'Cambio de estado',
        FACTURAE_INVALID: 'Factura mal formada',
        PARTY_SENDER_NOTFOUND: 'Empresa emisora no encontrada',
        CENTRE_SELLER_NOTFOUND: 'Centro de la empresa proveedora no encontrado',
        PARTY_RECEIVER_NOTFOUND: 'Empresa receptora no encontrada',
        CENTRE_BUYER_NOTFOUND: 'Centro de la empresa cliente no encontrado',
        CURRENCY_NOTFOUND: 'Divisa no encontrada',
        TAXTYPE_NOTFOUND: 'Tipo de impuesto no encontrado',
        COUNTRY_BUYER_NOTFOUND: 'País de la empresa cliente no encontrado',
        COUNTRY_BUYER_CIFPREFIX_NOTFOUND: 'Prefijo de nif cliente no encontrado',
        COUNTRY_SELLER_CIFPREFIX_NOTFOUND: 'Prefijo de nif proveedor no encontrado',
        COUNTRY_CENTRE_NOTFOUND: 'Pais del centro no encontrado',
        MEDIA_TYPE_NOTFOUND: 'Media type no encontrado',
        CONTRACT_BUYER_ERROR: 'Error inesperado en la contratacion de la empresa cliente',
        CONTRACT_PARTYMEDIA_ERROR: 'Error en la contratacion de party_media',
        DB_ERROR: 'Error inesperado en conexion a bbdd',
        REPOSITORY_FENIX_INVOICE_ERROR: 'Error al copiar fichero al repositorio fenix',
        REPOSITORY_FENIX_ATTACHMENT_ERROR: 'Error al descomprimir adjuntos en temporales',
        REPOSITORY_FENIX_RECEIVED_INVOICE_ERROR: 'Error al copiar el fichero recibido en el repositorio fenix',
        REPOSITORY_UNZIP_FILE_ERROR: 'Error ocurrido al obtener o descomprimir el fichero del repositorio de editrack',
        AUDIT_DOCUMENT_ERROR: 'Error inesperado al insertar informacion en auditoria',
        RETRY_MAIL_ERROR: 'Error al guardar informacion para reintento de envío de email',
        UNEXPECTED_ERROR: 'Error inesperado',
        REQUEST_EMPTY: 'Petición vacía',
        CORRECTIVE_NUMBER_REQUIRED: 'El número de factura rectificativa es obligatorio para método de rectificación 01 ó 02',
        DOCUMENT_CLASS_NOTFOUND: 'Clase de documento no encontrado',
        STATUS_DOCUMENT_NOTFOUND: 'Estado de documento no encontrado',
        INVOICE_DOCUMENT_TYPE_NOTFOUND: 'Tipo de documento defactura no encontrado',
        INVOICE_TYPE_NOTFOUND: 'Tipo de factura no encontrado',
        INSTANCES_REQUEST_EMPTY: 'Las instancias de documento no pueden ser vacías',
        DOCUMENT_FORMAT_EMPTY: 'El elemento Documentformat no puede ser vacío o nulo',
        REPOSITORYLOCATOR_ATTACHMENT_EMPTY: 'El elemento Repositorylocator de la instancia ATTACHMENT no puede ser nulo o vacio',
        ORIGINALFILENAME_ATTACHMENT_EMPTY: 'El elemento originalfilename de la instancia ATTACHMENT no puede ser nulo o vacio',
        DOCUMENT_FORMAT_ERROR: 'Formato de documento no reconocido',
        PROJECT_PARTY_SPONSOR_NOTFOUND: 'Propietaria no encontrado entre las empresas de la factura',
        PROJECT_PARTY_SPONSOR_ERROR: 'Error inesperado al buscar la propietaria entre las empresas proveedor/cliente de la factura',
        VALIDITY_DOCUMENT_NOTFOUND: 'No existe vigencia de documento para el tipo de documento y pais de la factura',
        STATUS_AUDIT_NOTFOUND: 'Estado de auditoria no encontrado',
        SEMANTICDOCUMENTID_EMPTY: 'El elemento semanticdocumentid no puede ser nulo o vacío',
        REPOSITORYLOCATOR_RECEIVED_EMPTY: 'El elemento Repositorylocator de la instancia RECEIVED no puede ser nulo o vacio',
        INCOMINGDATETIME_EMPTY: 'El elemento incomingdatetime no puede ser nulo o vacio',
        RECEIVERID_NOTFOUND: 'Empresa cuyo nif esta indicado en el elemento receiverid no existe',
        SENDERID_NOTFOUND: 'Empresa cuyo nif esta indicado en el elemento senderid no existe',
        DOCUMENT_TYPE_NOTFOUND: 'Tipo de documento no encontrado',
        DOCUMENT_PARENT_NOTFOUND: 'Documento padre no encontrado',
        COMMUNICATION_PROTOCOL_EMPTY: 'Protocolo de comunicación no puede ser nulo o vacio',
        COMMUNICATION_PROTOCOL_NOTFOUND: 'Protocolo de comunicación no encontrado',
        REPOSITORY_ERROR: 'Error al obtener el fichero del repositorio',
        CONNECTION_ERROR: 'Error de conexion a bbdd inesperado',
        PROJECT_COMMUNITYID_NOTFOUND: 'Servicio con codigo communityid no encontrado',
        DOCUMENT_FORMAT_NOTFOUND: 'Formato de documento no encontrado',
        INPUTDATETIME_EMPTY: 'El elemento inputdatetime no puede ser nulo ni vacío',
        TRANSFORMATION: 'Etapa de transformacion de la factura',
        EXTRACTION: 'Etapa de extracción de la factura',
        ATTACHMENT: 'Etapa de extracción de los adjuntos de la factura',
        DELIVERY: 'Etapa de entrega del fichero',
        DIR_ATTACHMENT_NOTFOUND: 'No existe el directorio de adjuntos de la factura a integrar',
        VALIDATION_ERROR: 'Error de validación',
        translation: {
          instances: {
            added: 'Añadida traducción de instancias'
          },
          processingtime: 'Duración en completar la traducción'
        },
        error: {
          document: {
            entrieszip: {
              '': 'Error al descomprimir el zip',
              format: {
                invalid: 'Estructura/Formato del fichero de entrada incorrecta'
              }
            },
            attachments: {
              directory: {
                name: {
                  invalid: 'El nombre del directorio de adjuntos es inválido'
                }
              }
            },
            file: {
              name: {
                invalid: 'El nombre de alguno de los ficheros de entrada es inválido'
              },
              format: 'Error en el formato del fichero de entrada'
            },
            read: {
              country: 'Error en la lectura del fichero, no se puede determinar el pais'
            }
          },
          ai: {
            translationfail: 'Error en la traducción AI del fichero'
          },
          ruleinformation: {
            notfound: 'Regla no encontrada'
          }
        },
        EXTRACTION_INVOICE: {
          ERROR: 'Error ocurrido al extraer la factura del fichero comprimido'
        },
        EXTRACTION_ATTACHMENT: {
          ERROR: 'Error ocurrido al extraer los adjuntos del fichero comprimido'
        },
        TRANSLATION_MAP: {
          ERROR: 'Error ocurrido al aplicar el mapa a la factura'
        },
        SIGNATURE: {
          '': 'Etapa de firma del fichero',
          ERROR: 'Error en la etapa de firma'
        },
        signature: {
          sax: {
            exception: {
              parsing: {
                document: 'Error ocurrido al firmar la factura, formato incorrecto'
              }
            }
          },
          signature: {
            exception: {
              signing: 'Error al firmar la factura'
            }
          }
        },
        RECOGNITION: {
          '': 'Etapa de reconocimiento del fichero de entrada',
          ERROR: 'Error ocurrido en el reconocimiento del fichero'
        },
        vltrader: {
          senddt: 'Fecha envío',
          sender: {
            host: 'Host',
            mailbox: 'Buzón'
          },
          sendid: 'Identificador envío',
          totalattempts: 'Número de intentos',
          transfer: {
            enddt: 'Fecha fin envío',
            resulttext: 'Resultado de envío',
            startdt: 'Fecha inicio envío',
            status: 'Estado resultado de envío',
            transferid: 'Identificador de entrega'
          }
        },
        wsserver: {
          profile: 'Perfil',
          requestid: 'Identificador de la petición'
        },
        DUPLICATED_INVOICE_ERROR: 'Error por factura duplicada',
        EDICOM_CDR_NEGATIVE: 'CDR negativo',
        996: '996',
        CIF_REQUIRED: 'El nif es un campo obligatorio',
        ACTION_REQUIRED: 'La acción es un campo obligatorio',
        DESCRIPTION_REQUIRED: 'La descripción es un campo obligatorio',
        CANAL_REQUIRED: 'El canal es un campo obligatorio',
        EMAIL_REQUIRED: 'El email es un campo obligatorio',
        PARTY_BUYER_NOTFOUND: 'La empresa cliente no existe',
        PROJECT_PARTY_DISABLED: 'La empresa esta deshabilitada para el servicio indicado',
        PARTY_DISABLED: 'La empresa esta deshabilitada',
        COMMUNICATION_METHOD_NOTFOUND: 'El método de comunicación no existe',
        EMAIL_INVALID: 'El email es incorrecto',
        ACTION_UNEXPECTED: 'La accion es incorrecta',
        READ_FILE_BUYERS_ERROR: 'Error inesperado al leer el fichero de contratación de empresas clientes',
        UPDATE_PARTY_ERROR: 'Error al actualizar los datos de la empresa',
        CREATE_COMMUNICATIONMETHOD_PARTY_ERROR: 'Error al crear el metodo de entrega asociado a la empresa',
        CREATE_PARTY_MEDIA_ERROR: 'Error al crear el email asociado a la empresa cliente',
        CREATE_USER_PARTY_ERROR: 'Error al crear el usuario asociado a la empresa cliente',
        CREATE_PARTY_ERROR: 'Error al crear la empresa cliente',
        CREATE_USER_ERROR: 'Error al crear el usuario',
        CREATE_PROJECT_PARTY_ERROR: 'Error al crear la relación entre el proyecto y la empresa',
        CREATE_PARTY_COMMERCIALRELATION_ERROR: 'Error al crear la relación comercial entre la empresa propietaria y la empresa cliente',
        EDICOM_ACK_NEGATIVE: 'ACK negativo',
        NO_PERSON_CODE_VALID: 'Código de persona no válido',
        PARTY_NIF_EXIST: 'El NIF de empresa ya existe',
        PARTY_GLN_EXIST: 'El GLN de empresa ya existe',
        WITHOUT_DATA_REQUIRED: 'Faltan datos obligatorios',
        LOGO_ERROR: 'Error con el logo',
        MIME_TYPE_LOGO_ERROR: 'Error de formato de logo',
        FILE_BASE64_ERROR: 'Error de archivo en Base64',
        NO_COUNTRY_CODE_VALID: 'Código de pais no válido',
        CENTRE_ERROR: 'Error de centro',
        COMMUNICATION_METHOD_ERROR: 'Error de método de comunicación',
        EMAIL_ERROR: 'Error de Email',
        PARTY_USER_ERROR: 'Error al asignar al usuario la entidad',
        PROJECT_PARTY_NIF_NOT_EXIST: 'No existe empresa con ese NIF',
        CREATED: 'Creado',
        DELETED: 'Eliminado',
        UPDATED: 'Actualizado',
        EDICOM_CDR_POSITIVE: 'CDR positivo',
        CENTRE_NOT_EXIST: 'No existe el centro',
        USER_EXIST: 'El usuario ya existe',
        USER_NOT_EXIST: 'El usuario no existe',
        USER_NOT_LOCKED: 'Usuario no bloqueado',
        USER_NOT_REMOVED: 'Usuario no eliminado',
        USER_NOT_PROJECT: 'El usuario no es del servicio',
        USER_NIF_EXIST: 'Ya existe un usuario con ese NIF',
        PROJECT_NOSENDER: 'Método de envío incorrecto. El proyecto no es de emisión',
        SELLER_NOSPONSOR: 'Método de envío incorrecto. La empresa no es propietaria.',
        PROJECT_NO_DELIVERY_METHOD: 'Método de envío no encontrado para el proyecto.',
        REGISTRATION_CODE_PROPERTY: 'Código de registro',
        REGISTRATION_DATE_PROPERTY: 'Fecha de registro',
        CHANGE_STATUS: 'Cambio de estado',
        CHANGE_STATUS_PROPERTY: 'Cambio de estado',
        DOWNLOAD_PROPERTY: 'Descarga',

        // Códigos para propiedades de auditorías
        invoice: {
          integrated: {
            b2bintegration: 'Número de factura B2B integrada con éxito',
            ws: 'Número de factura por servicio web integrada con éxito',
            upload: 'Número de factura integrada con éxtito'
          },
          note: {
            media: {
              type: {
                not: {
                  found: 'No se encontró el canal de comunicación especificado para el dato de contacto de apunte de factura'
                }
              },
              invalid: {
                email: {
                  format: 'La dirección de email del dato de contacto de apunte de factura no es válida'
                }
              }
            },
            document: {
              not: {
                found: 'No se encontró el documento de factura indicado. No existe o sus datos son errados'
              }
            },
            recadv: {
              not: {
                found: 'No se encontró el recibo indicado para el apunte de factura. No existe o sus datos son incorrectos'
              }
            },
            attachment: {
              category: {
                not: {
                  found: 'No se encontró la categoría indicada del adjunto del apunte de factura'
                }
              },
              user: {
                not: {
                  found: 'No se encontró el usuario indicado del adjunto del apunte de factura'
                }
              }
            }
          },
          project: {
            not: {
              found: 'No se encontró el proyecto indicado para la factura. No existe o es erróneo'
            },
            category: {
              not: {
                found: 'No se encontró la categoría de proyecto indicada para la factura. No existe o es errónea'
              }
            }
          },
          sender: {
            not: {
              found: 'No se encontró la empresa emisora indicada para la factura. No existe o sus datos son incorrectos'
            }
          },
          receiver: {
            not: {
              found: 'No se encontró la empresa receptora indicada para la factura. No existe o sus datos son incorrectos'
            }
          },
          thirdparty: {
            not: {
              found: 'No se encontró la tercera empresa indicada para la factura. No existe, está desactivada para el proyecto o sus datos son incorrectos'
            }
          },
          status: {
            not: {
              found: 'No se encontró el estado indicado para la factura. No existe o es erróneo'
            }
          },
          currency: {
            not: {
              found: 'No se encontró la divisa indicada para la factura. No existe o es errónea'
            }
          },
          document: {
            format: {
              not: {
                found: 'No se encontró el formato de documento indicado para la factura. No existe o es erróneo'
              }
            },
            class: {
              not: {
                found: 'No se encontró la clase de documento indicada para la factura. No existe o es errónea'
              }
            },
            type: {
              not: {
                found: 'No se encontró el tipo de documento para la factura indicado. No existe o es erróneo'
              }
            }
          },
          type: {
            not: {
              found: 'No se encontró el tipo de factura indicado. No existe o es erróneo'
            }
          },
          validity: {
            document: {
              not: {
                found: 'No se encontró el documento de vigencia indicado para la factura. No existe o es erróneo'
              }
            }
          },
          communication: {
            method: {
              not: {
                found: 'No se encontró el método de comunicación indicado para la factura. No existe o es erróneo'
              }
            }
          },
          auditdocument: {
            not: {
              found: 'No se encontró el documento de auditoría indicado para la factura. No existe o es erróneo'
            }
          },
          accounting: {
            close: {
              not: {
                found: 'No se encontró el cierre contable indicado para la factura. No existe o es erróneo'
              }
            }
          },
          recept: {
            comm: {
              method: {
                not: {
                  found: 'No se encontró el método de comunicación de recepción indicado para la factura. No existe o es erróneo'
                }
              }
            }
          },
          internal: {
            status: {
              not: {
                found: 'No se encontró el estado interno indicado para la factura. No existe o es erróneo'
              }
            }
          },
          batch: {
            not: {
              found: 'No se encontró el lote indicado para la factura. No existe o es erróneo'
            }
          },
          channel: {
            not: {
              found: 'No se encontró el canal indicado para la factura. No existe o es erróneo'
            }
          },
          seller: {
            centre: {
              not: {
                found: 'No se encontró uno de los centros vendedores de la factura. No existe o sus datos son incorrectos'
              },
              roletype: {
                not: {
                  found: 'No se encontró el tipo de rol específico del centro vendedor de la factura. No existe o sus datos son incorrectos'
                }
              }
            }
          },
          buyer: {
            centre: {
              not: {
                found: 'No se encontró uno de los centros compradores de la factura. No existe o sus datos son incorrectos'
              },
              roletype: {
                not: {
                  found: 'No se encontró el tipo de rol específico del centro comprador de la factura. No existe o sus datos son incorrectos'
                }
              }
            }
          },
          tax: {
            type: {
              not: {
                found: 'No se encontró el tipo de impuesto indicado para la factura. No existe o sus datos son incorrectos'
              }
            },
            currency: {
              not: {
                found: ' la divisa indicada para el impuesto de la factura. No existe o sus datos son incorrectos'
              }
            }
          },
          user: {
            does: {
              not: {
                belong: {
                  to: {
                    party: 'El usuario no pertenece a la empresa emisora especificada'
                  }
                }
              }
            }
          }
        },
        recadv: {
          integrated: {
            b2bintegration: 'Número de recepción B2B integrada con éxito'
          },
          status: {
            not: {
              found: 'No se encontró el estado indicado para la recepción. No existe o es erróneo'
            }
          },
          validity: {
            document: {
              not: {
                found: 'No se encontró el documento de vigencia indicado para la recepción. No existe o es erróneo'
              }
            }
          },
          document: {
            format: {
              not: {
                found: 'No se encontró el formato de documento indicado para la recepción. No existe o es erróneo'
              }
            }
          },
          centre: {
            not: {
              found: 'No se encontró el centro del comprador del documento de recepción'
            }
          }
        },
        unexpected: {
          error: 'Error inesperado al procesar la petición o su documento'
        },
        validation: {
          noDocumentType: 'No se ha incluido ningún tipo de documento',
          retry: 'Las validaciones se deben reintentar',
          invoicePeriodDates: 'La fecha de inicio del periodo de facturación  debe ser anterior a la fecha de fin',
          invoiceCorrectivePeriodDates: 'La fecha de inicio del periodo de rectificación  debe ser anterior a la fecha de fin',
          signature: 'La factura no viene firmada',
          nif: 'El número NIF no es válido',
          attachmentformat: 'Tipo de adjunto no permitido, solo se admiten las extensiones: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx, .zip, .msg',
          attachmentformat321: 'Tipo de adjunto no permitido, solo se admiten las extensiones: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx',
          error: 'Formato de fichero incorrecto',
          party: {
            noTaxId: 'No se ha incluido ningún identificador fiscal',
            noProject: 'No se ha incluido ningún proyecto',
            buyer: {
              notInProject: 'La empresa compradora no existe para el proyecto o está deshabilitada'
            },
            seller: {
              notInProject: 'La empresa vendedora no existe para el proyecto o está deshabilitada'
            },
            noSeller: 'No se ha incluido ningún identificador fiscal del vendedor',
            noBuyer: 'No se ha incluido ningún identificador fiscal del comprador',
            noRelation: 'No existe una relación comercial entre la empresa compradora  y vendedora  para este servicio',
            noSponsor: 'La empresa  no es propietaria para el proyecto',
            disabled: 'La empresa  está desactivada',
            disabledInProject: 'La empresa  está desactivada para el proyecto'
          },
          parties: {
            noSponsor: 'Ninguna de las empresas son propietaria del proyecto'
          },
          centre: {
            role: {
              type: 'El rol del centro no es válido para el formato de la factura'
            },
            noCentreCode: 'No se ha incluido ningún código de centro',
            noParty: 'No se ha incluido ninguna empresa',
            buyer: {
              notInParty: 'Uno o más de los centros compradores no existen para la empresa  o están deshabilitados'
            },
            seller: {
              notInParty: 'Uno o más de los centros vendedores no existen para la empresa  o están deshabilitados'
            },
            noCentreUnique: 'Los centros deben ser únicos'
          },
          document: {
            noDocument: 'No se ha incluido ningún documento'
          },
          invoice: {
            currency: 'No se ha incluido la divisa',
            currencyExchange: 'Tipo de cambio incorrecto o no informado',
            currencyExchangeDate: 'Fecha tipo de cambio incorrecta o no informada',
            iban: 'El formato del IBAN es incorrecto',
            ibanNull: 'IBAN no informado',
            registrationData: 'Los datos del registro mercantil del vendedor incluidos en la factura no coinciden con los datos registrados en B2B',
            sequenceNumber: 'La línea del pedido es obligatoria para el pedido indicado',
            correctiveSign01pos: 'Factura rectificativa de tipo Rectificación Integra deben ser positivas',
            correctiveSign02pos: 'Factura rectificativa de tipo Rectificación por diferencias deben ser positivas',
            correctiveSign03pos: 'Factura rectificativa de tipo Rectificación parcial por descuento por volumen de operaciones deben ser positivas',
            correctiveSign04pos: 'Factura rectificativa de tipo Rectificación autorizada por la Agencia Tributaria deben ser positivas',
            correctiveSign01neg: 'Factura rectificativa de tipo Rectificación Integra deben ser negativas',
            correctiveSign02neg: 'Factura rectificativa de tipo Rectificación por diferencias deben ser negativas',
            correctiveSign03neg: 'Factura rectificativa de tipo Rectificación parcial por descuento por volumen de operaciones deben ser negativas',
            correctiveSign04neg: 'Factura rectificativa de tipo Rectificación autorizada por la Agencia Tributaria deben ser negativas',
            noInvoice: 'Solo aplica a facturas',
            noInvoiceLine: 'No se ha incluido ninguna línea de factura o una o más de ellas son nulas',
            noInvoiceNumber: 'No se ha incluido ningún número de factura',
            noParty: 'No se ha incluido ninguna empresa',
            noProject: 'No se ha incluido ningún proyecto',
            duplicate: 'Ya existe una factura con el número de factura en estado correcto',
            issuedate: 'la fecha de la factura no coincide con la factura anterior recibida con la fecha de emisión {argumento}',
            dates: 'La fecha de operación debe ser menor o igual a la fecha de emisión',
            noIssueDate: 'No se ha incluido ninguna fecha de emisión',
            noOperationDate: 'No se ha incluido ninguna fecha de operación',
            noIssuerType: 'No se ha incluido ningún tipo de emisor',
            issuerType: 'El tipo emisor factura no es válido',
            issuerTypeError: 'No se incluyen datos necesarios para realizar la validación',
            noModalityType: 'La modalidad de la factura no se corresponde con uno de los valores admitidos',
            modalityType: 'El tipo de factura debe ser individual',
            modalityTypeError: 'No se incluyen datos necesarios para realizar la validación',
            project: {
              notSender: 'El proyecto no tiene activado el rol de emisión indicado para la factura',
              notReceiver: 'El proyecto no tiene activado el rol de recepción indicado para la factura'
            },
            noRole: 'El rol de la factura (emisora o receptora) debe ser establecido',
            communication: {
              method: 'El método de comunicación de la factura no está contratado para su proyecto'
            },
            lines: {
              total: {
                error: 'El total de línea sin impuestos no cuadra con el producto de la cantidad por precio unitario',
                discountscharges: {
                  error: 'El total de línea con cargos y descuentos no cuadra con el importe bruto de la línea'
                }
              }
            },
            total: {
              error: 'El total de la factura sin cargos ni descuentos generales no cuadra con la suma del total de las líneas con descuentos y cargos',
              discountscharges: {
                error: 'El total de la factura con cargos y descuentos generales no cuadra con el total de la factura antes de impuestos',
                taxes: {
                  error: 'El total de la factura no cuadra con el total de la factura antes de impuestos más total de impuestos repercutidos y menos total de impuestos retenidos'
                }
              }
            },
            totalexecutable: {
              error: 'El total ejecutable de la factura no cuadra con el total a pagar menos subvenciones, anticipos y retenciones y más suplidos y gastos financieros'
            },
            accounting: {
              error: 'La factura no cumple alguna de las validaciones contables'
            },
             messae:{
              ko: 'Se ha producido un error en el env\u00EDo. Consulte con el administrador'
            }
          },
          recadv: {
            noRecadv: 'No se ha incluido ninguna recepción',
            noRecadvNumber: 'No se ha incluido ningún número de recepción',
            noSeller: 'No se ha incluido ninguna empresa vendedora',
            noBuyer: 'No se ha incluido ninguna empresa compradora',
            duplicate: 'Ya existe una recepción con número en estado correcto'
          },
          cmr: {
            noCmr: 'No se ha incluido ningún documento de transporte',
            noCmrNumber: 'No se ha incluido ningún número de documento de transporte',
            noSeller: 'No se ha incluido ninguna empresa vendedora',
            noBuyer: 'No se ha incluido ninguna empresa compradora',
            noshipfrom: 'No se ha incluido el lugar de origen',
            noshipto: 'No se ha incluido el lugar de destino',
            duplicate: {
              '': 'Ya existe un documento de transporte con el mismo número en estado correcto',
              issueyear: 'Ya existe un documento de transporte con el mismo número en estado correcto en el año en curso'
            },
          },
          sign: {
            noParty: 'No se ha incluido ninguna empresa',
            noSign: 'La empresa emisora  no dispone de firma delegada'
          },
          order: {
            noOrder: 'El número de pedido es obligatorio',
            noUnique: 'El número de pedido debe ser único en la factura',
            noOrderIssuer: 'El número de emisor del pedido es obligatorio',
            noUniqueIssuer: 'El número de pedido del emisor debe ser único en la factura',
            invalidPatternIssuer: 'El formato del número de pedido del emisor no es válido',
            noPattern: 'Falta configurar el patrón a comprobar',
            invalidPattern: 'El número de pedido incluido no cumple con el formato requerido por el receptor',
            error: 'No se incluyen datos necesarios para realizar la validación del número de pedido'
          },
          expediente: {
            noExp: 'El número de expediente es obligatorio',
            noUnique: 'El número de expediente debe ser único en la factura',
            noPattern: 'Falta configurar el patrón a comprobar',
            invalidPattern: 'El número de expediente incluido no cumple con el formato requerido por el receptor',
            error: 'No se incluyen datos necesarios para realizar la validación del número de expediente'
          },
          contract: {
            noContract: 'El número de contrato/recepción es obligatorio',
            invalidPattern: 'El número de contrato/recepción incluido no cumple con el formato requerido por el receptor',
            noUnique: 'El número de contrato/recepción debe ser único en la factura',
            noPattern: 'Falta configurar el patrón a comprobar',
            error: 'No se incluyen datos necesarios para realizar la validación del número de contrato/recepción'
          },
          transaction: {
            noTransaction: 'El número de pedido del receptor es obligatorio'
          },
          invoiceCorrective: {
            dates: 'Fecha inicial y final del periodo impositivo no son válidos',
            number: 'El número de factura es obligatorio para las facturas de tipo Rectificación íntegra y Rectificación por diferencias',
            noNumber: 'El número de factura es obligatorio para las facturas de tipo rectificativas',
            invalidPattern: 'El formato del número de factura rectificada no es válido',
            noValue: 'No se ha adjuntado ningún documento con valor',
            noOrderValue: 'Debe indicar el pedido del receptor',
            required: 'El bloque de rectificación es obligatorio para una factura rectificativa'
          },
          project: {
            disabled: 'El proyecto no existe o está deshabilitado',
            noProject: 'No se ha incluido ningún proyecto',
            attachment: {
              notfound: 'No existe el directorio 1 de adjuntos del proyecto de la factura a integrar'
            }
          },
          issue: {
            date: {
              future: 'La fecha de emisión es posterior a su fecha de registro',
              past: 'La fecha de emisión es anterior a su fecha de registro'
            }
          },
          commercial: {
            relation: {
              channel: 'No existe la relación comercial entre el vendedor, comprador y el canal'
            }
          },
          channel: {
            not: {
              found: 'No existe el canal'
            }
          },
          invoiceNumber: {
            error: 'No se ha podido validar el formato del número de la factura al no determinarse si la factura es de emisión o de recepción',
            noPattern: 'Falta configurar el patrón de Número de Factura',
            invalidPattern: 'El formato del número de factura no es válido. Revise el tamaño, caracteres y requisitos del número de factura.'
          },
          b2bvalidationws: {
            nourl: 'No existe una URL asociada al servicio web o no es válida',
            metadataerror: 'Se produjo un error al intentar obtener el archivo de metadatos.',
            connectionerror: 'Se produjo un error durante la conexión con el servicio del cliente.',
            wrongresponse: 'El servicio web cliente devolvió una respesta incorrecta.',
            errorresponse: 'El servicio web cliente devolvió una respuesta de ERROR.'
          }
        },
        invalid: {
          validation: {
            code: {
              exception: 'Uno o más códigos de validación no tienen un método de validación'
            }
          },
          persontypecode: 'El código de tipo de persona especificado no es válido. Solo puede ser jurídica (j) o física (f)',
          name: {
            format: 'El nombre o apellido tiene caracteres no permitidos en el formato utf-8'
          },
          facturae32: {
            xml: {
              format: 'El formato del fichero de la Facturae 3.2 es incorrecto o no es .xml'
            },
            schema: 'La factura de tipo Facturae 3.2 tiene campos que no superan la validación de su esquema: '
          },
          facturae321: {
            xml: {
              format: 'El formato del fichero de la Facturae 3.2.1 es incorrecto o no es .xml'
            },
            schema: 'La factura de tipo Facturae 3.2.1 tiene campos que no superan la validación de su esquema: '
          },
          facturae322: {
            xml: {
              format: 'El formato del fichero de la Facturae 3.2.2 es incorrecto o no es .xml'
            },
            schema: 'La factura de tipo Facturae 3.2.2 tiene campos que no superan la validación de su esquema: '
          },
          facturapdf: {
            xml: {
              format: 'El formato de la factura PDF es incorrecto o no es .xml'
            },
            schema: 'La factura de tipo factura PDF tiene campos que no superan la validación de su esquema: '
          },
          cii: {
            xml: {
              format: 'El formato del fichero de la factura CII es incorrecto o no es .xml'
            },
            schema: 'El CII tiene campos que no superan la validación de su esquema: {0}'
          },
          ubl21: {
            xml: {
              format: 'El formato del fichero de la factura UBL 2.1 es incorrecto o no es una factura UBL'
            },
            schema: 'La factura de tipo UBL 2.1 tiene campos que no superan la validación de su esquema: {0}'
          },
          edi: {
            date: {
              format: 'El formato de la fecha no es correcto'
            }
          },
          facturad01b: {
            edi: {
              format: 'El formato del fichero de la facturad01b es incorrecto o .edi'
            }
          },
          facturad93a: {
            edi: {
              format: 'El formato del fichero de la facturad93a es incorrecto o .edi'
            }
          },
          facturad96a: {
            edi: {
              format: 'El formato del fichero de la facturad96a es incorrecto o .edi'
            }
          },
          facturad97a: {
            edi: {
              format: 'El formato del fichero de la facturad97a es incorrecto o .edi'
            }
          },
          fatturapa12: {
            xml: {
              format: 'El formato del fichero del fatturapa12 es incorrecto o no es .xml'
            },
            schema: 'La factura de tipo fatturapa12 tiene campos que no superan la validación de su esquema: '
          },
          recadv: {
            xml: {
              format: 'El formato del fichero del documento de recepción es incorrecto o no es .xml'
            },
            schema: 'La factura de la recepción tiene campos que no superan la validación de su esquema: {0}'
          },
          fatturapaSemplificata1: {
            xml: {
              format: 'El formato del fichero del fatturapa simplificada es incorrecto o no es .xml'
            },
            schema: 'La factura de tipo fatturapa simplificada tiene campos que no superan la validación de su esquema: {0}'
          },
          fatturapa12cades: {
            xml: {
              format: 'El formato del fichero del fatturapa 1.2 cades es incorrecto o no es .xml'
            },
            schema: 'La factura de tipo fatturapa 1.2 cades tiene campos que no superan la validación de su esquema: {0}'
          },
          fatturapaSemplificatacades: {
            xml: {
              format: 'El formato del fichero del fatturapa simplificada cades es incorrecto o no es .xml'
            },
            schema: 'La factura de tipo fatturapa simplificada cades tiene campos que no superan la validación de su esquema: {0}'
          }
        },
        unable: {
          to: {
            save: {
              file: {
                in: {
                  repository: 'No se pudo guardar el fichero en la dirección del repositorio. El mismo es erróneo o existe algún problema con el fichero'
                }
              }
            },
            get: {
              repository: {
                file: ' No se pudo recuperar el fichero con la dirección de repositorio indicada. La misma es errónea o existe algún problema con el fichero'
              }
            },
            delete: {
              repository: {
                file: 'No se pudo borrar el fichero de la dirección de repositorio indicada. La misma es errónea o el fichero está bloqueado'
              }
            }
          }
        },
        no: {
          repository: {
            date: 'No se ha incluido ninguna fecha. Es requerida para el tipo de fichero',
            project: {
              name: 'No se ha incluido ningún nombre de proyecto requerido para el tipo de fichero a guardar'
            },
            file: 'No se ha incluido ningún fichero a guardar',
            subpath: 'No se ha incluido la ruta secundaria del fichero'
          },
          file: {
            to: {
              save: {
                extension: 'No se ha indicado la extensión del fichero a guardar'
              }
            }
          },
          pathcomplete: {
            flag: 'No se ha indicado si la ruta incluida en el objeto es completa o parcial'
          }
        },
        repository: {
          path: {
            not: {
              found: 'No se encontró una ruta de repositorio en la base de datos para el tipo del fichero a guardar. El mismo no existe o es inválido'
            }
          }
        },
        missing: {
          required: {
            party: {
              data: 'No se ha incluido uno o más de los datos obligatorios (nif, nombres, país y estado de activación) de la empresa',
              commercial: {
                relation: {
                  data: 'No se ha incluido uno o más datos obligatorios (empresa emisora/vendedora y empresa receptora/compradora) de la relación comercial de la empresa'
                }
              },
              media: {
                value: 'debe especificar un valor para el medio de contacto de la empresa',
                type: 'No se ha indicado el canal del dato de contacto',
                to: {
                  delete: 'No se ha indicado el dato de contacto de empresa a borrar'
                }
              }
            },
            partyproject: 'Es necesario indicar un proyecto de la empresa para poder crear los datos de contacto y las relaciones comerciales',
            projectparty: {
              data: 'No se ha incluido uno o más datos obligatorios (proyecto, empresa y fecha de creación de relación) de la relación proyecto-empresa',
              role: 'No se han indicado roles (vendedor, comprador o tercero) para la empresa en su proyecto',
              role_required: 'Es obligatorio indicar un rol (vendedor, comprador o tercero) para la empresa en su proyecto',
              enable: 'No se ha indicado el estado de activación de la empresa con el proyecto'
            },
            communicationmethod: {
              data: 'No se ha incluido uno o más datos obligatorios (empresa y método de comunicación) del método de comunicación de la empresa'
            },
            partycentre: {
              roletype: {
                data: 'No se ha incluido uno o más datos obligatorios del tipo de rol del centro'
              }
            },
            centre: {
              role: 'No se han indicado roles (vendedor o comprador) para el centro',
              data: 'No se ha incluido uno o más de los datos obligatorios (nif o id de empresa, código y estado de activación) del centro',
              media: {
                value: 'debe especificar un valor para el medio de contacto del centro',
                type: 'No se ha indicado el canal del dato de contacto de centro',
                to: {
                  delete: 'No se ha indicado el dato de contacto de centro a borrar'
                }
              }
            },
            invoice: {
              note: {
                media: {
                  value: 'debe especificar un valor para el medio de contacto de apunte de factura',
                  type: 'No se ha indicado el canal del dato de contacto de apunte de factura',
                  default: {
                    flag: 'No se ha indicado el flag de contacto por defecto del dato de contacto de apunte de factura'
                  },
                  role: 'No se ha indicado el rol (vendedor o comprador) del dato de contacto de la factura'
                },
                issue: {
                  date: 'No se ha indicado una fecha de emisión para el apunte de factura'
                },
                document: {
                  name: 'No se ha indicado un nombre de documento de apunte de factura o su id',
                  format: 'No se ha indicado un formato para el documento de apunte de factura',
                  type: 'No se ha indicado un tipo de documento para el apunte de factura'
                },
                recadv: {
                  data: 'No se ha indicado el recibo (por su id o número) asociado al apunte de factura'
                }
              },
              integration: {
                file: {
                  '': 'No se ha incluido el fichero de la factura',
                  extension: 'No se ha indicado la extensión del fichero de la factura',
                  size: 'No se ha indicado el tamaño original del fichero de factura'
                }
              },
              project: 'No se ha indicado el proyecto de la factura',
              seller: {
                '': 'No se ha indicado la empresa vendedora de la factura',
                centre: {
                  code: 'No se ha incluido el código de uno o más centros vendedores de la factura'
                }
              },
              buyer: {
                '': 'No se ha indicado la empresa compradora de la factura',
                centre: {
                  code: 'No se ha incluido el código de uno o más centros compradores de la factura'
                }
              },
              number: 'No se ha indicado el número de la factura',
              sender: 'No se ha indicado la empresa emisora del apunte de factura',
              receiver: 'No se ha indicado la empresa receptora del apunte de factura',
              status: 'No se ha indicado un estado para la factura',
              document: {
                format: 'No se ha indicado un formato de documento para la factura',
                class: 'No se ha indicado una clase de documento para la factura',
                type: 'No se ha indicado un tipo de documento para la factura'
              },
              validity: {
                document: 'No se ha indicado el documento de vigencia de la factura'
              },
              correctedflag: 'No se ha indicado el flag de factura correctiva (true: la factura es correctiva, false: no lo es)',
              metadata: {
                file: {
                  extension: 'No se ha indicado la extensión del fichero de metadatos de la factura'
                }
              },
              attachment: {
                extension: 'No se ha indicado la extensión de uno o más adjuntos de la factura'
              },
              tax: {
                type: 'No se ha indicado el tipo de uno o más impuestos del apunte de factura',
                baseamount: 'No se ha indicado el monto base de uno o más impuestos del apunte de factura',
                currency: 'No se ha indicado la divisa de uno o más impuestos del apunte de factura'
              },
              event: 'No se ha indicado un nombre para el evento de la factura',
              property: {
                '': 'No se ha indicado un nombre para la propiedad del evento de la factura',
                value: 'No se ha indicado el valor para la propiedad del evento de la factura'
              },
              outstanding: {
                amount: 'No se ha indicado el importe pendiente de la factura'
              },
              executable: {
                amount: 'No se ha indicado el importe ejecutable de la factura'
              },
              communication: {
                reception: {
                  name: 'No se ha indicado el nombre de la comunicación de recepción usada para la integración de la factura'
                }
              }
            },
            media: {
              type: 'No se ha indicado el canal del dato de contacto de empresa'
            },
            centremedia: {
              project: 'es necesario indicar un proyecto del centro para poder crear los datos de contacto',
              role: 'No se han indicado roles (vendedor o comprador) para el dato de contacto del centro'
            },
            partymedia: {
              role: 'No se han indicado roles (vendedor o comprador) para el dato de contacto de la empresa'
            },
            request: {
              compressed: {
                invoice: {
                  flag: 'No se ha indicado si el fichero de la factura de la petición está comprimido o no'
                }
              },
              invoice: {
                file: 'No se ha incluido un fichero de factura en la petición'
              }
            }
          },
          update: {
            party: {
              taxid: 'No se ha especificado el identificador fiscal de la empresa a actualizar o modificar'
            }
          },
          search: {
            party: {
              taxid: 'No se ha especificado uno o más identificadores fiscales de empresas a buscar'
            }
          },
          commercial: {
            relation: {
              partytaxid: 'No se ha incluido el identificador fiscal de la empresa de la relación comercial',
              role: 'No se ha indicado el rol de la empresa creada/actualizada en la relación comercial'
            }
          },
          recadv: {
            integration: {
              file: {
                '': 'No se ha incluido el fichero de la recepción',
                extension: 'No se ha indicado la extensión del fichero de la recepción'
              }
            },
            status: 'No se ha indicado un estado para la recepción',
            number: {
              exception: 'No se ha indicado el número de la recepción'
            },
            receiving: {
              date: {
                time: {
                  extension: 'No se ha indicado la fecha de la última recepción del recibo'
                }
              }
            },
            validity: {
              document: 'No se ha indicado el documento de vigencia de la factura'
            },
            document: {
              format: 'No se ha indicado un formato de documento para la recepción'
            },
            centre: 'No se ha indicado el centro del comprador del documento de recepción'
          }
        },
        party: {
          not: {
            found: 'No se ha encontrado una empresa con el número de identificación fiscal indicado'
          },
          project: {
            not: {
              found: 'No se encontró el proyecto especificado para la empresa. No existe o está desactivado'
            }
          },
          to: {
            delete: {
              not: {
                found: 'No se encontró la empresa a borrar. No se ha indicado su identificador fiscal o el mismo no existe'
              }
            }
          },
          commercial: {
            relation: {
              channel: {
                not: {
                  found: 'No se ha encontrado el canal para la relación comercial. No existe o es erróneo'
                }
              }
            }
          },
          deletion: 'Error al borrar la empresa',
          country: {
            not: {
              found: 'No se encontró el país indicado para la empresa. No existe o sus datos son erróneos'
            }
          },
          media: {
            type: {
              not: {
                found: 'No se encontró el canal de comunicación especificado para el dato de contacto de empresa'
              }
            },
            deletion: 'Error al borrar el dato de contacto de la empresa',
            to: {
              delete: {
                not: {
                  found: 'No se encontró el dato de contacto a borrar de la empresa. No se ha indicado o no existe'
                }
              }
            },
            invalid: {
              email: {
                format: 'La dirección de email del dato de contacto de empresa no es válida'
              }
            }
          }
        },
        commercial: {
          relation: {
            party: {
              not: {
                found: 'No se encontró la empresa indicada para la relación comercial dentro del rol especificado. También es posible que no exista o esté desactivada'
              }
            }
          }
        },
        incompatible: {
          integrated: {
            party: {
              for: {
                commercial: {
                  relation: 'La empresa integrada no tiene activado el rol (vendedor o comprador) establecido para su relación comercial o está desactivada'
                }
              }
            }
          },
          centre: {
            role: 'El centro no tiene un rol compatible con el de su empresa dentro de su relación de proyecto',
            media: {
              data: {
                role: 'El centro no tiene el rol asignado (vendedor o comprador) para el dato de contacto, o dicho rol es incompatible con los asignados para su empresa en el proyecto determinado'
              }
            }
          },
          party: {
            media: {
              data: {
                role: 'La empresa no tiene el rol asignado (vendedor o comprador) para el dato de contacto dentro de su proyecto'
              }
            }
          }
        },
        communication: {
          method: {
            not: {
              found: 'No se encontró el método de comunicación especificado para la empresa'
            }
          }
        },
        centre: {
          role: {
            type: {
              not: {
                found: 'No se encontró el tipo de rol especificado para el centro'
              }
            }
          },
          to: {
            delete: {
              not: {
                found: 'No se encontró el centro a borrar. No se ha indicado alguno de sus datos obligatorios (empresa y código de centro) o el centro no existe'
              }
            }
          },
          deletion: 'Error al borrar el centro',
          party: {
            not: {
              found: 'No se ha encontrado la empresa del centro con los datos establecidos'
            }
          },
          not: {
            found: 'No se ha encontrado un centro que coincida con la empresa y código indicados'
          },
          country: {
            not: {
              found: 'No se encontró el país indicado para el centro. No existe o sus datos son erróneos'
            }
          },
          media: {
            type: {
              not: {
                found: 'No se encontró el canal de comunicación especificado para el dato de contacto de centro'
              }
            },
            deletion: 'Error al borrar el dato de contacto del centro',
            to: {
              delete: {
                not: {
                  found: 'No se encontró el dato de cntacto a borrar del centro. No se ha indicado o no existe'
                }
              }
            },
            invalid: {
              email: {
                format: 'La dirección de email del dato de contacto de centro no es válida'
              }
            }
          }
        },
        media: {
          type: {
            not: {
              found: 'No se encontró el canal de contacto especificado'
            }
          }
        },
        centremedia: {
          project: {
            not: {
              found: 'No se encontró el proyecto para el dato de contacto del centro. No existe o sus datos son errados'
            }
          }
        },
        duplicate: {
          partymedia: {
            value: 'ya existe un dato de contacto de la empresa con el mismo valor para el proyecto al que está asignado'
          },
          centremedia: {
            value: 'ya existe un dato de contacto del centro con el mismo valor para el proyecto al que está asignado'
          }
        },
        recadvLine: {
          currency: {
            not: {
              found: 'No se encontró la divisa indicada para la recepción. No existe o es errónea'
            }
          },
          unitOfMeasure: {
            notFound: 'No se encontró la unidad de medida indicada para la línea de recepción'
          }
        },
        document: {
          generation: {
            format: {
              class: {
                not: {
                  found: 'No se encontró la clase de mapeo del formato del documento. No existe o es errónea'
                }
              }
            }
          }
        },
        unzipped: {
          request: {
            invoice: {
              file: 'La petición de la factura está configurada para llevar ficheros de factura comprimidos, pero su fichero está sin comprimir'
            },
            attachments: 'La petición de la factura está configurada para llevar adjuntos comprimidos, pero tiene uno solo sin comprimir'
          }
        },
        zipped: {
          request: {
            invoice: {
              file: 'La petición de la factura está configurada para llevar ficheros de factura sin comprimir, pero su fichero está comprimido'
            },
            attachments: 'La petición de la factura está configurada para llevar un solo adjunto sin comprimir, pero tiene un fichero comprimido con uno o más'
          }
        },
        different: {
          invoice: {
            number: 'El número de factura de la petición es distinto al extraído del fichero de factura adjuntado'
          },
          seller: {
            tax: {
              identification: {
                number: 'La identificación fiscal del vendedor de la solicitud es diferente de la extraída del archivo de factura adjunto'
              }
            }
          }
        }
      }
    }
  },
  // Errores/mensajes en Integración de factura

  translation: {
    instances: {
      added: 'Añadida traducción de instancias'
    },
    processingtime: 'Duración en completar la traducción'
  },
  error_code: {
    document: {
      entrieszip: {
        '': 'Error al descomprimir el zip',
        format: {
          invalid: 'Estructura/Formato del fichero de entrada incorrecta'
        }
      },
      attachments: {
        directory: {
          name: {
            invalid: 'El nombre del directorio de adjuntos es inválido'
          }
        }
      },
      file: {
        name: {
          invalid: 'El nombre de alguno de los ficheros de entrada es inválido'
        },
        format: 'Error en el formato del fichero de entrada'
      },
      read: {
        country: 'Error en la lectura del fichero, no se puede determinar el pais'
      }
    },
    ai: {
      translationfail: 'Error en la traducción AI del fichero'
    },
    ruleinformation: {
      notfound: 'Regla no encontrada'
    }
  },
  EXTRACTION_INVOICE: {
    ERROR: 'Error ocurrido al extraer la factura del fichero comprimido'
  },
  EXTRACTION_ATTACHMENT: {
    ERROR: 'Error ocurrido al extraer los adjuntos del fichero comprimido'
  },
  TRANSLATION_MAP: {
    ERROR: 'Error ocurrido al aplicar el mapa a la factura'
  },
  SIGNATURE: {
    '': 'Etapa de firma del fichero',
    ERROR: 'Error ocurrido al firmar la factura'
  },
  signature: {
    sax: {
      exception: {
        parsing: {
          document: 'Error ocurrido al firmar la factura, formato incorrecto'
        }
      }
    },
    signature: {
      exception: {
        signing: 'Error al firmar la factura'
      }
    }
  },
  RECOGNITION: {
    '': 'Etapa de reconocimiento del fichero de entrada',
    ERROR: 'Error ocurrido en el reconocimiento del fichero'
  },
  vltrader: {
    senddt: 'Fecha envío',
    sender: {
      host: 'Host',
      mailbox: 'Buzón'
    },
    sendid: 'Identificador envío',
    totalattempts: 'Número de intentos',
    transfer: {
      enddt: 'Fecha fin envío',
      resulttext: 'Resultado de envío',
      startdt: 'Fecha inicio envío',
      status: 'Estado resultado de envío',
      transferid: 'Identificador de entrega'
    }
  },
  wsserver: {
    profile: 'Perfil',
    requestid: 'Identificador de la petición'
  },
  DUPLICATED_INVOICE_ERROR: 'Error por factura duplicada',
  EDICOM_CDR_NEGATIVE: 'CDR negativo',
  996: '996',
  CIF_REQUIRED: 'El nif es un campo obligatorio',
  ACTION_REQUIRED: 'La acción es un campo obligatorio',
  DESCRIPTION_REQUIRED: 'La descripción es un campo obligatorio',
  CANAL_REQUIRED: 'El canal es un campo obligatorio',
  EMAIL_REQUIRED: 'El email es un campo obligatorio',
  PARTY_BUYER_NOTFOUND: 'La empresa cliente no existe',
  PROJECT_PARTY_DISABLED: 'La empresa esta deshabilitada para el servicio indicado',
  PARTY_DISABLED: 'La empresa esta deshabilitada',
  COMMUNICATION_METHOD_NOTFOUND: 'El método de comunicación no existe',
  EMAIL_INVALID: 'El email es incorrecto',
  ACTION_UNEXPECTED: 'La accion es incorrecta',
  READ_FILE_BUYERS_ERROR: 'Error inesperado al leer el fichero de contratación de empresas clientes',
  UPDATE_PARTY_ERROR: 'Error al actualizar los datos de la empresa',
  CREATE_COMMUNICATIONMETHOD_PARTY_ERROR: 'Error al crear el metodo de entrega asociado a la empresa',
  CREATE_PARTY_MEDIA_ERROR: 'Error al crear el email asociado a la empresa cliente',
  CREATE_USER_PARTY_ERROR: 'Error al crear el usuario asociado a la empresa cliente',
  CREATE_PARTY_ERROR: 'Error al crear la empresa cliente',
  CREATE_USER_ERROR: 'Error al crear el usuario',
  CREATE_PROJECT_PARTY_ERROR: 'Error al crear la relación entre el proyecto y la empresa',
  CREATE_PARTY_COMMERCIALRELATION_ERROR: 'Error al crear la relación comercial entre la empresa propietaria y la empresa cliente',
  EDICOM_ACK_NEGATIVE: 'ACK negativo',
  NO_PERSON_CODE_VALID: 'Código de persona no válido',
  PARTY_NIF_EXIST: 'El NIF de empresa ya existe',
  PARTY_GLN_EXIST: 'El GLN de empresa ya existe',
  WITHOUT_DATA_REQUIRED: 'Faltan datos obligatorios',
  WITHOUT_DATA_REQUIRED_INVALID: 'Faltan datos obligatorios o son inválidos',
  LOGO_ERROR: 'Error con el logo',
  MIME_TYPE_LOGO_ERROR: 'Error de formato de logo',
  FILE_BASE64_ERROR: 'Error de archivo en Base64',
  NO_COUNTRY_CODE_VALID: 'Código de pais no válido',
  CENTRE_ERROR: 'Error de centro',
  COMMUNICATION_METHOD_ERROR: 'Error de método de comunicación',
  EMAIL_ERROR: 'Error de Email',
  PARTY_USER_ERROR: 'Error al asignar al usuario la entidad',
  PROJECT_PARTY_NIF_NOT_EXIST: 'No existe empresa con ese NIF',
  CREATED: 'Creado',
  DELETED: 'Eliminado',
  UPDATED: 'Actualizado',
  EDICOM_CDR_POSITIVE: 'CDR positivo',
  CENTRE_NOT_EXIST: 'No existe el centro',
  USER_EXIST: 'El usuario ya existe',
  USER_NOT_EXIST: 'El usuario no existe',
  USER_NOT_LOCKED: 'Usuario no bloqueado',
  USER_NOT_REMOVED: 'Usuario no eliminado',
  USER_NOT_PROJECT: 'El usuario no es del servicio',
  USER_NIF_EXIST: 'Ya existe un usuario con ese NIF',
  PROJECT_NOSENDER: 'Método de envío incorrecto. El proyecto no es de emisión',
  SELLER_NOSPONSOR: 'Método de envío incorrecto. La empresa no es propietaria.',
  PROJECT_NO_DELIVERY_METHOD: 'Método de envío no encontrado para el proyecto.',

  // Códigos para propiedades de auditorías
  invoice: {
    integrated: {
      b2bintegration: 'Número de factura B2B integrada con éxito',
      ws: 'Número de factura por servicio web integrada con éxito',
      upload: 'Número de factura integrada con éxtito'
    },
    note: {
      media: {
        type: {
          not: {
            found: 'No se encontró el canal de comunicación especificado para el dato de contacto de apunte de factura'
          }
        },
        invalid: {
          email: {
            format: 'La dirección de email del dato de contacto de apunte de factura no es válida'
          }
        }
      },
      document: {
        not: {
          found: 'No se encontró el documento de factura indicado. No existe o sus datos son errados'
        }
      },
      recadv: {
        not: {
          found: 'No se encontró el recibo indicado para el apunte de factura. No existe o sus datos son incorrectos'
        }
      },
      order: {
        not: {
          found: 'No se encontró el pedido indicado para el apunte de factura. No existe o sus datos son incorrectos'
        }
      },
      delivery: {
        not: {
          found: 'No se encontró el albarán indicado para el apunte de factura. No existe o sus datos son incorrectos'
        }
      },
      attachment: {
        category: {
          not: {
            found: 'No se encontró la categoría indicada del adjunto del apunte de factura'
          }
        },
        user: {
          not: {
            found: 'No se encontró el usuario indicado del adjunto del apunte de factura'
          }
        }
      }
    },
    project: {
      not: {
        found: 'No se encontró el proyecto indicado para la factura. No existe o es erróneo'
      },
      category: {
        not: {
          found: 'No se encontró la categoría de proyecto indicada para la factura. No existe o es errónea'
        }
      }
    },
    sender: {
      not: {
        found: 'No se encontró la empresa emisora indicada para la factura. No existe o sus datos son incorrectos'
      }
    },
    receiver: {
      not: {
        found: 'No se encontró la empresa receptora indicada para la factura. No existe o sus datos son incorrectos'
      }
    },
    thirdparty: {
      not: {
        found: 'No se encontró la tercera empresa indicada para la factura. No existe, está desactivada para el proyecto o sus datos son incorrectos'
      }
    },
    status: {
      not: {
        found: 'No se encontró el estado indicado para la factura. No existe o es erróneo'
      }
    },
    currency: {
      not: {
        found: 'No se encontró la divisa indicada para la factura. No existe o es errónea'
      }
    },
    document: {
      format: {
        not: {
          found: 'No se encontró el formato de documento indicado para la factura. No existe o es erróneo'
        }
      },
      class: {
        not: {
          found: 'No se encontró la clase de documento indicada para la factura. No existe o es errónea'
        }
      },
      type: {
        not: {
          found: 'No se encontró el tipo de documento para la factura indicado. No existe o es erróneo'
        }
      }
    },
    type: {
      not: {
        found: 'No se encontró el tipo de factura indicado. No existe o es erróneo'
      }
    },
    validity: {
      document: {
        not: {
          found: 'No se encontró el documento de vigencia indicado para la factura. No existe o es erróneo'
        }
      }
    },
    communication: {
      method: {
        not: {
          found: 'No se encontró el método de comunicación indicado para la factura. No existe o es erróneo'
        }
      }
    },
    auditdocument: {
      not: {
        found: 'No se encontró el documento de auditoría indicado para la factura. No existe o es erróneo'
      }
    },
    accounting: {
      close: {
        not: {
          found: 'No se encontró el cierre contable indicado para la factura. No existe o es erróneo'
        }
      }
    },
    recept: {
      comm: {
        method: {
          not: {
            found: 'No se encontró el método de comunicación de recepción indicado para la factura. No existe o es erróneo'
          }
        }
      }
    },
    internal: {
      status: {
        not: {
          found: 'No se encontró el estado interno indicado para la factura. No existe o es erróneo'
        }
      }
    },
    batch: {
      not: {
        found: 'No se encontró el lote indicado para la factura. No existe o es erróneo'
      }
    },
    channel: {
      not: {
        found: 'No se encontró el canal indicado para la factura. No existe o es erróneo'
      }
    },
    seller: {
      centre: {
        not: {
          found: 'No se encontró uno de los centros vendedores de la factura. No existe o sus datos son incorrectos'
        },
        roletype: {
          not: {
            found: 'No se encontró el tipo de rol específico del centro vendedor de la factura. No existe o sus datos son incorrectos'
          }
        }
      }
    },
    buyer: {
      centre: {
        not: {
          found: 'No se encontró uno de los centros compradores de la factura. No existe o sus datos son incorrectos'
        },
        roletype: {
          not: {
            found: 'No se encontró el tipo de rol específico del centro comprador de la factura. No existe o sus datos son incorrectos'
          }
        }
      }
    },
    tax: {
      type: {
        not: {
          found: 'No se encontró el tipo de impuesto indicado para la factura. No existe o sus datos son incorrectos'
        }
      },
      currency: {
        not: {
          found: 'No se ha encontrado la divisa indicada para el impuesto de la factura. No existe o sus datos son incorrectos'
        }
      }
    },
    user: {
      does: {
        not: {
          belong: {
            to: {
              party: 'El usuario no pertenece a la empresa emisora especificada'
            }
          }
        }
      }
    }
  },
  recadv_code: {
    integrated: {
      b2bintegration: 'Número de recepción B2B integrada con éxito'
    },
    status: {
      not: {
        found: 'No se encontró el estado indicado para la recepción. No existe o es erróneo'
      }
    },
    validity: {
      document: {
        not: {
          found: 'No se encontró el documento de vigencia indicado para la recepción. No existe o es erróneo'
        }
      }
    },
    document: {
      format: {
        not: {
          found: 'No se encontró el formato de documento indicado para la recepción. No existe o es erróneo'
        }
      }
    },
    centre: {
      not: {
        found: 'No se encontró el centro del comprador del documento de recepción'
      }
    }
  },
  unexpected: {
    error: 'Error inesperado al procesar la petición o su documento'
  },
  FACTURAE_INVALID: 'Factura mal formada',
  validation: {
    noDocumentType: 'No se ha incluido ningún tipo de documento',
    retry: 'Las validaciones se deben reintentar',
    invoicePeriodDates: 'La fecha de inicio del periodo de facturación  debe ser anterior a la fecha de fin',
    invoiceCorrectivePeriodDates: 'La fecha de inicio del periodo de rectificación  debe ser anterior a la fecha de fin',
    signature: 'La factura no viene firmada',
    nif: 'El número NIF no es válido',
    attachmentformat: 'Tipo de adjunto no permitido, solo se admiten las extensiones: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx, .zip, .msg',
    attachmentformat321: 'Tipo de adjunto no permitido, solo se admiten las extensiones: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx',
    error: 'Formato de fichero incorrecto',
    invoicedocument: 'El campo "valor" del tipo de documento "Nº secuencia / línea" debe ser de tipo numérico',
    ep: {
      errorclientnoepcanarias: 'Para facturar servicios en Canarias marque ambos indicadores de establecimiento permanente en Canarias.',
      errorclientnoepceuta: 'Para facturar servicios en Ceuta marque ambos indicadores de establecimiento permanente en Ceuta.',
      clientepproveedorpen: 'Para facturar servicios en Península, desmarque el indicador de su establecimiento permanente.',
      clientepproveedornocanarias: 'Para facturar servicios en Canarias, marque el indicador de su establecimiento permanente en Canaria.',
      errorclientnoepceutacanarias: 'Para facturar servicios en Ceuta, desmarque el indicador de su establecimiento permanente en Canarias',
      clientepproveedornoceuta: 'Para facturar servicios en Ceuta, marque el indicador de su establecimiento permanente en Ceuta.',
      clientecanariasceuta: 'Para facturar servicios en Canarias, desmarque el indicador de su establecimiento permanente en Ceuta'
    },
    buyer: {
      address: 'La identificación del tipo de residencia no es correcta para la empresa compradora.',
      noAddress: 'La empresa compradora no tiene la dirección asignada',
      noCountry: 'La empresa compradora no tiene el país asignado',
      noPostCode: 'La empresa compradora no tiene el código postal asignado',
      invalidPostCode: 'El código postal asignado a la empresa compradora no debe tener menos de 5 dígitos',
      noProvince: 'La empresa compradora no tiene la provincia asignada',
      noTown: 'La empresa compradora no tiene la población asignada',
      centres: {
        rol: 'No se ha incluido ningún centro de la empresa compradora para el tipo de rol obligatorio: {argumento}.',
        rolbyvalues: 'No se ha incluido ningún centro de la empresa compradora para el tipo de rol obligatorio: {argumento}.',
        roletype: {
          notfound: 'El tipo de rol de centro a validar para la empresa compradora no existe: {argumento}'
        }
      }
    },
    buyerCentre: {
      noAddress: 'El centro comprador no tiene la dirección asignada',
      noCountry: 'El centro comprador no tiene el país asignado',
      noPostCode: 'El centro comprador no tiene el código postal asignado',
      invalidPostCode: 'El código postal asignado al centro comprador no debe tener menos de 5 dígitos',
      noProvince: 'El centro comprador no tiene la provincia asignada',
      noTown: 'El centro comprador no tiene la población asignada'
    },
    seller: {
      address: 'La identificación del tipo de residencia no es correcta para la empresa vendedora.',
      noAddress: 'La empresa vendedora no tiene la dirección asignada',
      noCountry: 'La empresa vendedora no tiene el país asignado',
      noPostCode: 'La empresa vendedora no tiene el código postal asignado',
      invalidPostCode: 'El código postal asignado a la empresa vendedora no debe tener menos de 5 dígitos',
      noProvince: 'La empresa vendedora no tiene la provincia asignada',
      noTown: 'La empresa vendedora no tiene la población asignada',
      centres: {
        rol: 'No se ha incluido ningún centro de la empresa vendedora para el tipo de rol obligatorio: {argumento}.',
        rolbyvalues: 'No se ha incluido ningún centro de la empresa vendedora para el tipo de rol obligatorio: {argumento}.',
        roletype: {
          notfound: 'El tipo de rol de centro a validar para la empresa vendedora no existe: {argumento}'
        }
      }
    },
    sellerCentre: {
      noAddress: 'El centro vendedor no tiene la dirección asignada',
      noCountry: 'El centro vendedor no tiene el país asignado',
      noPostCode: 'El centro vendedor no tiene el código postal asignado',
      invalidPostCode: 'El código postal asignado al centro vendedor no debe tener menos de 5 dígitos',
      noProvince: 'El centro vendedor no tiene la provincia asignada',
      noTown: 'El centro vendedor no tiene la población asignada'
    },
    party: {
      noTaxId: 'No se ha incluido ningún identificador fiscal',
      noProject: 'No se ha incluido ningún proyecto',
      buyer: {
        notInProject: 'La empresa compradora no existe para el proyecto o está deshabilitada',
        invalidName: 'El nombre de la empresa compradora no es correcto, debe ser {argumento1},\n debe cumplir la expresión regular {argumento}',
        addressvalue: 'La dirección del receptor de la factura no es válida, debe ser Paseo Conde de los Gaitanes n 177 para facturas de la península,  o calle Juan de Quesada n 9 para facturas de Canarias.'
      },
      seller: {
        notInProject: 'La empresa vendedora no existe para el proyecto o está deshabilitada',
        invalidName: 'El nombre de la empresa compradora no es correcto, debe ser {argumento1},\n debe cumplir la expresión regular {argumento}'
      },
      noSeller: 'No se ha incluido ningún identificador fiscal del vendedor',
      noBuyer: 'No se ha incluido ningún identificador fiscal del comprador',
      noRelation: 'No existe una relación comercial entre la empresa compradora  y vendedora  para este servicio',
      noSponsor: 'La empresa no es propietaria para el proyecto',
      disabled: 'La empresa está desactivada',
      disabledInProject: 'La empresa está desactivada para el proyecto',
      invalidExpresion: 'La expresión regular para validar el nombre de la empresa con NIF {argumento} no es correcta'
    },
    parties: {
      noSponsor: 'Ninguna de las empresas son propietarias del proyecto'
    },
    centre: {
      role: {
        type: 'El rol del centro no es válido para el formato'
      },
      roletype: {
        notfound: 'No existe el tipo de rol de centro indicado'
      },
      noCentreCode: 'No se ha incluido ningún código de centro',
      noParty: 'No se ha incluido ninguna empresa',
      buyer: {
        notInParty: 'Uno o más de los centros compradores no existen para la empresa  o están deshabilitados'
      },
      seller: {
        notInParty: 'Uno o más de los centros vendedores no existen para la empresa  o están deshabilitados'
      },
      noCentreUnique: 'Los centros deben ser únicos'
    },
    document: {
      noDocument: 'No se ha incluido ningún documento'
    },
    phisical: {
      gln: 'Buzón físico obligatorio'
    },
    schematron: {
      error: 'Error en la validación de la factura: {argumento}'
    },
    kosit: {
      error: 'Error en la validación de la factura: {argumento}'
    },
    invoice: {
      currency: 'No se ha incluido la divisa',
      currencyExchange: 'Tipo de cambio incorrecto o no informado',
      currencyExchangeDate: 'Fecha tipo de cambio incorrecta o no informada',
      iban: 'El formato del IBAN es incorrecto',
      ibanNull: 'IBAN no informado',
      registrationData: 'Los datos del registro mercantil del vendedor incluidos en la factura no coinciden con los datos registrados en B2B',
      sequenceNumber: 'La línea del pedido es obligatoria para el pedido indicado{argumento}',
      correctiveSign01pos: 'Factura rectificativa de tipo Rectificación Integra deben ser positivas',
      correctiveSign02pos: 'Factura rectificativa de tipo Rectificación por diferencias deben ser positivas',
      correctiveSign03pos: 'Factura rectificativa de tipo Rectificación parcial por descuento por volumen de operaciones deben ser positivas',
      correctiveSign04pos: 'Factura rectificativa de tipo Rectificación autorizada por la Agencia Tributaria deben ser positivas',
      correctiveSign01neg: 'Factura rectificativa de tipo Rectificación Integra deben ser negativas',
      correctiveSign02neg: 'Factura rectificativa de tipo Rectificación por diferencias deben ser negativas',
      correctiveSign03neg: 'Factura rectificativa de tipo Rectificación parcial por descuento por volumen de operaciones deben ser negativas',
      correctiveSign04neg: 'Factura rectificativa de tipo Rectificación autorizada por la Agencia Tributaria deben ser negativas',
      noInvoice: 'No se ha incluido ninguna factura',
      noInvoiceLine: 'No se ha incluido ninguna línea de factura o una o más de ellas son nulas',
      noInvoiceNumber: 'No se ha incluido ningún número de factura',
      noParty: 'No se ha incluido ninguna empresa',
      noProject: 'No se ha incluido ningún proyecto',
      duplicate: 'Ya existe una factura con el número de factura en estado correcto {argumento}',
      issuedate: 'la fecha de la factura no coincide con la factura anterior recibida con la fecha de emisión {argumento}',
      dates: 'La fecha de operación debe ser menor o igual a la fecha de emisión',
      invalidOperationDate: 'La fecha de operación no puede ser posterior al día {argumento} ({argumento1} días y {argumento2} meses desde la fecha de emisión)',
      invalidOperationDateEnd: 'La fecha de operación no puede ser posterior al día {argumento} (último día del mes {argumento2} desde la fecha de emisión)',
      invalidInvoicingPeriod: 'La fecha final del período de facturación no puede ser posterior al {argumento} ({argumento1} días y {argumento2} meses desde la fecha de emisión)',
      invalidInvoicingPeriodEnd: 'La fecha final del período de facturación no puede ser posterior al {argumento} (último día del mes {argumento2} desde la fecha de emisión)',
      invalidWithholdingAmount: 'La retención en garantía debería ser {argumento}',
      invalidNegativeWithholdingAmount: 'La retencion en garantia debe ser positiva',
      simultaneousTransactionAndContract: 'La factura no puede indicar contrato y pedido a la vez, debe indicar exactamente uno de los dos',
      contractNotFoundRecadv: 'No se ha encontrado ninguna recepción con nº {argumento} y estado Recibida para el proveedor y cliente especificados en la factura',
      recadvNotFound: 'La recepción {argumento} de la línea {argumento1} no está publicada por el comprador, o no está en un estado facturable',
      contractNotFound: 'Debe indicar recepción/certificación, línea  {argumento}',
      duplicateContractFoundRecadv: 'Se ha encontrado más de una recepción',
      orderNotFound: 'Debe indicar pedido, línea  {argumento}',
      orderContractNotFound: 'Debe indicar pedido y recepción/certificación, línea  {argumento}',
      differentOrder: 'El pedido indicado en el archivo ({argumento}) no corresponde con el registrado ({argumento1})',
      currencyNotEur: 'Solo se aceptan facturas en euros',
      igicNotInCanary: 'La factura tiene impuesto IGIC: \n {argumento} \n {argumento1}',
      ipsiNotInCeuta: 'La factura tiene impuesto IPSI: \n {argumento} \n {argumento1}',
      tooMuchAttachments: 'La factura supera el máximo de archivos aduntos configurados ({argumento} archivo/s)',
      notAllowedAttachedExtension: 'La extension para el adjunto no está permitida. Se permiten {argumento}',
      taxesNotInProject: 'Los siguientes impuestos no se incluyen en el proyecto: {argumento}',
      taxRateNotRegistered: 'Para el impuesto {argumento} sólo se admiten las tasas (%): {argumento1}',
      notAllowedFileFormat: 'El formato del fichero ({argumento}) no está permitido. Se permiten: {argumento1}',
      noIssueDate: 'No se ha incluido ninguna fecha de emisión',
      noOperationDate: 'No se ha incluido ninguna fecha de operación',
      noIssuerType: 'No se ha incluido ningún tipo de emisor',
      issuerType: 'El tipo emisor factura no es válido',
      issuerTypeError: 'No se incluyen datos necesarios para realizar la validación',
      noModalityType: 'La modalidad de la factura no se corresponde con uno de los valores admitidos',
      modalityType: 'El tipo de factura debe ser individual',
      modalityTypeError: 'No se incluyen datos necesarios para realizar la validación',
      taxCeroLegalText: 'Una factura con tasa de impuesto 0 debe tener texto legal',
      specificCanary: 'Validación especifica de Canarias, IVA positivo',
      specificCeuta: 'Validación especifica de Ceuta, IVA positivo',
      noIgicIva: 'La factura no puede tener impuestos repercutidos diferentes (IVA, IPSI, IGIC)',
      exitsPaymentDetails: 'La factura no contiene método de pago',
      receiverTransactionReferenceNotFound: 'La factura {argumento} no contiene número de pedido ni en la cabecera ni en las líneas',
      documentValuesRecadv: 'Línea {argumento}. El {argumento1} \'{argumento2}\' no coincide con el indicado en la recepción',
      documentValuesRecadvDeliveryNote: 'Línea {argumento}. El {argumento1} \'{argumento2}\'  de la recepción no coincide con alguno de los indicados en la línea correspondiente de la factura',
      lineDataFromRecadv: 'Línea {argumento}. La línea de pedido: {argumento1} no coincide con ninguna línea de la recepción',
      lineDataFromRecadvValue: 'Línea {argumento}. {argumento1} : {argumento2}, no corresponde con la línea de la recepción',
      lineDataFromRecadvTax: 'Línea {argumento}. El impuesto con tipo {argumento1} y con porcentaje {argumento2} no corresponde con la línea de la recepción',
      project: {
        notSender: 'El proyecto no tiene activado el rol de emisión indicado para la factura',
        notReceiver: 'El proyecto no tiene activado el rol de recepción indicado para la factura'
      },
      noRole: 'El rol de la factura (emisora o receptora) debe ser establecido',
      communication: {
        method: 'El método de comunicación de la factura no está contratado para su proyecto'
      },
      lines: {
        invalidOperationDate: 'La línea número {argumento3}. La fecha de operación no puede ser posterior al día {argumento} ({argumento1} días y {argumento2} meses desde la fecha de emisión)',
        invalidOperationDateEnd: 'La línea número {argumento3}. La fecha de operación no puede ser posterior al día {argumento} (último día del mes {argumento2} desde la fecha de emisión)',
        invalidInvoicingPeriod: 'La línea número {argumento3}. La fecha final del período de facturación no puede ser posterior al {argumento} ({argumento1} días y {argumento2} meses desde la fecha de emisión)',
        invalidInvoicingPeriodEnd: 'La línea número {argumento3}. La fecha final del período de facturación no puede ser posterior al {argumento} (último día del mes {argumento2} desde la fecha de emisión)',
        total: {
          error: 'El total de línea sin impuestos no cuadra con el producto de la cantidad por precio unitario',
          discountscharges: {
            error: 'El total de línea con cargos y descuentos no cuadra con el importe bruto de la línea'
          }
        },
        positive: 'Los precios y cantidades deben de ser positivos',
        negative: 'Todos los precios deben ser negativos y las cantidades positivas',
        sametax: 'La factura no puede contener el mismo impuesto en la misma linea',
        totalPositive: 'El importe total de la factura debe ser positivo'
      },
      total: {
        error: 'El total de la factura sin cargos ni descuentos generales no cuadra con la suma del total de las líneas con descuentos y cargos',
        discountscharges: {
          error: 'El total de la factura con cargos y descuentos generales no cuadra con el total de la factura antes de impuestos',
          taxes: {
            error: 'El total de la factura no cuadra con el total de la factura antes de impuestos más total de impuestos repercutidos y menos total de impuestos retenidos'
          }
        },
        taxes: {
          error: 'El total de impuestos informado no coincide con la suma de los impuestos'
        }
      },
      totalexecutable: {
        error: 'El total ejecutable de la factura no cuadra con el total a pagar menos subvenciones, anticipos y retenciones y más suplidos y gastos financieros'
      },
      accounting: {
        error: 'La factura no cumple alguna de las validaciones contables'
      },
      centre: {
        mask: 'Máscara de centro no válida',
        rol: 'Rol de centro no válido'
      },
      corrective: {
        method: 'Método de corrección {argumento} no admitido por el receptor de la factura rectificativa'
      },
      buyer: {
        centre: 'Centro comprador no informado'
      },
      noOrder: 'No se ha incluido ningún pedido en la línea de la recepción',
      order: {
        noLine: 'El pedido {argumento} incluido en la línea de la recepción no se encuentra',
        missingData: 'Faltan datos obligatorios en una o más líneas del pedido {argumento}'
      },
      recadv: {
        additionalInfo: 'El valor {argumento} de la propiedad {argumento1} no se encuentra en la información adicional de la factura.',
        noAdditionalInfo: 'La factura no contiene la información adicional de la recepción {argumento}',
        additionalInfoNoProperty: 'No se ha incluido la propiedad {argumento1} en la información adicional de la recepción {argumento}',
        noData: 'No se ha incluido informacion en la recepción {argumento}'
      }
    },
    recadv: {
      noRecadv: 'No se ha incluido ninguna recepción',
      noRecadvNumber: 'No se ha incluido ningún número de recepción',
      noSeller: 'No se ha incluido ninguna empresa vendedora',
      noBuyer: 'No se ha incluido ninguna empresa compradora',
      duplicate: 'Ya existe una recepción con número en estado correcto'
    },
    sign: {
      noParty: 'No se ha incluido ninguna empresa',
      noSign: 'La empresa emisora  no dispone de firma delegada'
    },
    order: {
      noOrder: 'El número de pedido es obligatorio',
      noUnique: 'El número de pedido debe ser único en la factura',
      noOrderIssuer: 'El número de emisor del pedido es obligatorio',
      noUniqueIssuer: 'El número de pedido del emisor debe ser único en la factura',
      invalidPatternIssuer: 'El formato del número de pedido del emisor no es válido',
      noPattern: 'Falta configurar el patrón a comprobar',
      invalidPattern: 'El número de pedido incluido no cumple con el formato requerido por el receptor',
      error: 'No se incluyen datos necesarios para realizar la validación del número de pedido'
    },
    documentCycle: {
      noOrder: 'No se ha incluído información suficiente del pedido',
      orderResponseRequired: 'No puede generar el albarán si el pedido no está aceptado previamente',
      order: {
        type: {
          noParams: 'La clase del ciclo es incorrecta, debe indicar parámetros adicionales indicando el tipo y subtipo a validar'
        },
        invalid: {
          type: 'No se puede crear una factura de este pedido, debe tener el tipo "{argumento}"',
          subtype: 'No se puede crear una factura de este pedido, debe tener el subtipo "{argumento}"'
        }
      }
    },
    expediente: {
      noExp: 'El número de expediente es obligatorio',
      noUnique: 'El número de expediente debe ser único en la factura',
      noPattern: 'Falta configurar el patrón a comprobar',
      invalidPattern: 'El número de expediente incluido no cumple con el formato requerido por el receptor',
      error: 'No se incluyen datos necesarios para realizar la validación del número de expediente'
    },
    contract: {
      noContract: 'El número de contrato/recepción es obligatorio',
      invalidPattern: 'El número de contrato/recepción incluido no cumple con el formato requerido por el receptor',
      noUnique: 'El número de contrato/recepción debe ser único en la factura',
      noPattern: 'Falta configurar el patrón a comprobar',
      error: 'No se incluyen datos necesarios para realizar la validación del número de contrato/recepción'
    },
    transaction: {
      noTransaction: 'El número de pedido del receptor es obligatorio'
    },
    invoiceCorrective: {
      dates: 'Fecha inicial y final del periodo impositivo no son válidos',
      number: 'El número de factura es obligatorio para las facturas de tipo Rectificación íntegra y Rectificación por diferencias',
      noNumber: 'El número de factura es obligatorio para las facturas de tipo rectificativas',
      invalidPattern: 'El formato del número de factura rectificada no es válido',
      noValue: 'No se ha adjuntado ningún documento con valor',
      noOrderValue: 'Debe indicar el pedido del receptor',
	  required: 'El bloque de rectificación es obligatorio para una factura rectificativa'
    },

    project: {
      disabled: 'El proyecto no existe o está deshabilitado',
      noProject: 'No se ha incluido ningún proyecto',
      attachment: {
        notfound: 'No existe el directorio de adjuntos del proyecto de la factura a integrar'
      }
    },
    issue: {
      date: {
        future: 'La fecha de emisión es posterior a su fecha de registro en {argumento} días. La fecha de emisión máxima permitida es: {argumento1}',
        past: 'La fecha de emisión es anterior a su fecha de registro en {argumento} días. Sólo se permite que la fecha de emisión sea {argumento2} días anterior a la fecha de registro. La fecha de emisión mínima permitida es: {argumento1}'
      }
    },
    commercial: {
      relation: {
        channel: 'No existe la relación comercial entre el vendedor, comprador y el canal'
      }
    },
    channel: {
      not: {
        found: 'No existe el canal'
      }
    },
    invoiceNumber: {
      error: 'No se ha podido validar el formato del número de la factura al no determinarse si la factura es de emisión o de recepción',
      noPattern: 'Falta configurar el patrón de Número de Factura',
      invalidPattern: 'El formato del número de factura no es válido. Revise el tamaño, caracteres y requisitos del número de factura.'
    },
    b2bvalidationws: {
      nourl: 'No existe una URL asociada al servicio web o no es válida',
      metadataerror: 'Se produjo un error al intentar obtener el archivo de metadatos.',
      connectionerror: 'Se produjo un error durante la conexión con el servicio del cliente.',
      wrongresponse: 'El servicio web cliente devolvió una respesta incorrecta.',
      errorresponse: 'El servicio web cliente devolvió una respuesta de ERROR.'
    },
    valid: {
      iban: 'Error de validación del IBAN.'
    },
    payment: {
      mean: 'Error: la factura no contiene métodos de pago admitidos.'
    },
    file: {
      size: 'Error: factura y adjuntos superan el tamaño máximo permitido.'
    },
    nif: {
      codpais: 'Error en la validación del código de país en NIF {argumento}. Se debe indicar el país delante del NIF.'
    },
    line: {
      noDescription: 'Alguna de las líneas no tiene descripción',
      transactionReference: 'Todas las líneas deben contener IssuerTransactionReference y/o ReceiverTransactionReference',
      sequence: {
        number: 'Todas las líneas deben tener el mismo número de secuencia/línea'
      }
    },
    noPublicOrganismCode: 'No se ha informado el Órgano Público Proponente – DIR3',
    delivery: {
      noDeliveryDate: 'La fecha de entrega del albarán es obligatoria',
      duplicate: {
        '': 'Ya existe un albarán con el número de albarán en estado correcto',
        issueyear: 'Ya existe un albarán con el número de albarán en estado correcto en el año en curso'
      },
      lines: {
        noBatch: 'Todas las líneas deben tener número de lote',
        noSerialNumber: 'Todas las líneas deben tener número de serie',
        noExpirationDate: 'Todas las líneas deben tener fecha de caducidad',
        invalidDate: 'Todas las líneas deben tener una fecha de caducidad que no sea posterior a la fecha de entrega del albarán',
        noQuantity: 'La suma de las cantidades de las sublíneas no son iguales a la cantidad de la línea padre',
        noSubline: 'Todas las líneas del albarán deben tener al menos una sublinea',
        package: {
          invalidGtin14: 'No se pueden asociar líneas con diferentes códigos GTIN14 a un mismo embalaje. Las líneas asociadas al embalaje con SSCC {argumento} tienen distinto código GTIN14.'
        }
      }
    }
  },
  invalid: {
    validation: {
      code: {
        exception: 'Uno o más códigos de validación no tienen un método de validación'
      }
    },
    persontypecode: 'El código de tipo de persona especificado no es válido. Solo puede ser jurídica (j) o física (f)',
    name: {
      format: 'El nombre o apellido tiene caracteres no permitidos en el formato utf-8'
    },
    facturae32: {
      xml: {
        format: 'El formato del fichero de la Facturae 3.2 es incorrecto o no es .xml'
      },
      schema: 'La factura de tipo Facturae 3.2 tiene campos que no superan la validación de su esquema: '
    },
    facturae321: {
      xml: {
        format: 'El formato del fichero de la Facturae 3.2.1 es incorrecto o no es .xml'
      },
      schema: 'La factura de tipo Facturae 3.2.1 tiene campos que no superan la validación de su esquema: '
    },
    facturae322: {
      xml: {
        format: 'El formato del fichero de la Facturae 3.2.2 es incorrecto o no es .xml'
      },
      schema: 'La factura de tipo Facturae 3.2.2 tiene campos que no superan la validación de su esquema: '
    },
    facturapdf: {
      xml: {
        format: 'El formato de la factura PDF es incorrecto o no es .xml'
      },
      schema: 'La factura de tipo factura PDF tiene campos que no superan la validación de su esquema: '
    },
    edi: {
      date: {
        format: 'El formato de la fecha no es correcto'
      }
    },
    facturad01b: {
      edi: {
        format: 'El formato del fichero de la facturad01b es incorrecto o .edi'
      }
    },
    facturad93a: {
      edi: {
        format: 'El formato del fichero de la facturad93a es incorrecto o .edi'
      }
    },
    facturad96a: {
      edi: {
        format: 'El formato del fichero de la facturad96a es incorrecto o .edi'
      }
    },
    facturad97a: {
      edi: {
        format: 'El formato del fichero de la facturad97a es incorrecto o .edi'
      }
    },
    fatturapa12: {
      xml: {
        format: 'El formato del fichero del fatturapa12 es incorrecto o no es .xml'
      },
      schema: 'La factura de tipo fatturapa12 tiene campos que no superan la validación de su esquema: '
    },
    recadv: {
      xml: {
        format: 'El formato del fichero del documento de recepción es incorrecto o no es .xml'
      },
      schema: 'La factura de la recepción tiene campos que no superan la validación de su esquema: {argumento}'
    },
    fatturapaSemplificata1: {
      xml: {
        format: 'El formato del fichero del fatturapa simplificada es incorrecto o no es .xml'
      },
      schema: 'La factura de tipo fatturapa simplificada tiene campos que no superan la validación de su esquema: {argumento}'
    },
    fatturapa12cades: {
      xml: {
        format: 'El formato del fichero del fatturapa 1.2 cades es incorrecto o no es .xml'
      },
      schema: 'La factura de tipo fatturapa 1.2 cades tiene campos que no superan la validación de su esquema: {argumento}'
    },
    fatturapaSemplificatacades: {
      xml: {
        format: 'El formato del fichero del fatturapa simplificada cades es incorrecto o no es .xml'
      },
      schema: 'La factura de tipo fatturapa simplificada cades tiene campos que no superan la validación de su esquema: {argumento}'
    },
    cii: {
      xml: {
        format: 'El formato del fichero de la factura CII es incorrecto o no es .xml'
      },
      schema: 'El CII tiene campos que no superan la validación de su esquema: {0}'
    },
    ubl21: {
      xml: {
        format: 'El formato del fichero de la factura UBL 2.1 es incorrecto o no es una factura UBL'
      },
      schema: 'La factura de tipo UBL 2.1 tiene campos que no superan la validación de su esquema: {0}'
    }
  },
  unable: {
    to: {
      save: {
        file: {
          in: {
            repository: 'No se pudo guardar el fichero en la dirección del repositorio. El mismo es erróneo o existe algún problema con el fichero'
          }
        }
      },
      get: {
        repository: {
          file: ' No se pudo recuperar el fichero con la dirección de repositorio indicada. La misma es errónea o existe algún problema con el fichero'
        }
      },
      delete: {
        repository: {
          file: 'No se pudo borrar el fichero de la dirección de repositorio indicada. La misma es errónea o el fichero está bloqueado'
        }
      }
    }
  },
  no: {
    repository: {
      date: 'No se ha incluido ninguna fecha. Es requerida para el tipo de fichero',
      project: {
        name: 'No se ha incluido ningún nombre de proyecto requerido para el tipo de fichero a guardar'
      },
      file: 'No se ha incluido ningún fichero a guardar',
      subpath: 'No se ha incluido la ruta secundaria del fichero'
    },
    file: {
      to: {
        save: {
          extension: 'No se ha indicado la extensión del fichero a guardar'
        }
      }
    },
    pathcomplete: {
      flag: 'No se ha indicado si la ruta incluida en el objeto es completa o parcial'
    }
  },
  repository: {
    path: {
      not: {
        found: 'No se encontró una ruta de repositorio en la base de datos para el tipo del fichero a guardar. El mismo no existe o es inválido'
      }
    }
  },
  missing: {
    required: {
      party: {
        data: 'No se ha incluido uno o más de los datos obligatorios (nif, nombres, país y estado de activación) de la empresa',
        commercial: {
          relation: {
            data: 'No se ha incluido uno o más datos obligatorios (empresa emisora/vendedora y empresa receptora/compradora) de la relación comercial de la empresa'
          }
        },
        media: {
          value: 'debe especificar un valor para el medio de contacto de la empresa',
          type: 'No se ha indicado el canal del dato de contacto',
          to: {
            delete: 'No se ha indicado el dato de contacto de empresa a borrar'
          }
        },
        documentcycle: {
          buyer: 'No se ha indicado la empresa compradora del ciclo del documento',
          sourcetype: 'No se ha indicado el tipo de documento origen del ciclo del documento',
          destinationtype: 'No se ha indicado el tipo de documento de destino del ciclo del documento',
          class: {
            source: 'No se ha indicado el sentido de la clase del ciclo de documento'
          }
        }
      },
      partyproject: 'Es necesario indicar un proyecto de la empresa para poder crear los datos de contacto y las relaciones comerciales',
      projectparty: {
        data: 'No se ha incluido uno o más datos obligatorios (proyecto, empresa y fecha de creación de relación) de la relación proyecto-empresa',
        role: 'No se han indicado roles (vendedor o comprador) para la empresa en su proyecto',
        enable: 'No se ha indicado el estado de activación de la empresa con el proyecto'
      },
      communicationmethod: {
        data: 'No se ha incluido uno o más datos obligatorios (empresa y método de comunicación) del método de comunicación de la empresa'
      },
      partycentre: {
        roletype: {
          data: 'No se ha incluido uno o más datos obligatorios del tipo de rol del centro'
        }
      },
      centre: {
        role: 'No se han indicado roles (vendedor o comprador) para el centro',
        data: 'No se ha incluido uno o más de los datos obligatorios (nif o id de empresa, código y estado de activación) del centro',
        media: {
          value: 'debe especificar un valor para el medio de contacto del centro',
          type: 'No se ha indicado el canal del dato de contacto de centro',
          to: {
            delete: 'No se ha indicado el dato de contacto de centro a borrar'
          }
        }
      },
      invoice: {
        note: {
          media: {
            value: 'debe especificar un valor para el medio de contacto de apunte de factura',
            type: 'No se ha indicado el canal del dato de contacto de apunte de factura',
            default: {
              flag: 'No se ha indicado el flag de contacto por defecto del dato de contacto de apunte de factura'
            },
            role: 'No se ha indicado el rol (vendedor o comprador) del dato de contacto de la factura'
          },
          issue: {
            date: 'No se ha indicado una fecha de emisión para el apunte de factura'
          },
          document: {
            name: 'No se ha indicado un nombre de documento de apunte de factura o su id',
            format: 'No se ha indicado un formato para el documento de apunte de factura',
            type: 'No se ha indicado un tipo de documento para el apunte de factura'
          },
          recadv: {
            data: 'No se ha indicado el recibo (por su id o número) asociado al apunte de factura'
          }
        },
        integration: {
          file: {
            '': 'No se ha incluido el fichero de la factura',
            extension: 'No se ha indicado la extensión del fichero de la factura',
            size: 'No se ha indicado el tamaño original del fichero de factura'
          }
        },
        project: 'No se ha indicado el proyecto de la factura',
        seller: {
          '': 'No se ha indicado la empresa vendedora de la factura',
          centre: {
            code: 'No se ha incluido el código de uno o más centros vendedores de la factura'
          }
        },
        buyer: {
          '': 'No se ha indicado la empresa compradora de la factura',
          centre: {
            code: 'No se ha incluido el código de uno o más centros compradores de la factura'
          }
        },
        number: 'No se ha indicado el número de la factura',
        sender: 'No se ha indicado la empresa emisora del apunte de factura',
        receiver: 'No se ha indicado la empresa receptora del apunte de factura',
        status: 'No se ha indicado un estado para la factura',
        document: {
          format: 'No se ha indicado un formato de documento para la factura',
          class: 'No se ha indicado una clase de documento para la factura',
          type: 'No se ha indicado un tipo de documento para la factura'
        },
        validity: {
          document: 'No se ha indicado el documento de vigencia de la factura'
        },
        correctedflag: 'No se ha indicado el flag de factura correctiva (true: la factura es correctiva, false: no lo es)',
        metadata: {
          file: {
            extension: 'No se ha indicado la extensión del fichero de metadatos de la factura'
          }
        },
        attachment: {
          extension: 'No se ha indicado la extensión de uno o más adjuntos de la factura'
        },
        tax: {
          type: 'No se ha indicado el tipo de uno o más impuestos del apunte de factura',
          baseamount: 'No se ha indicado el monto base de uno o más impuestos del apunte de factura',
          currency: 'No se ha indicado la divisa de uno o más impuestos del apunte de factura'
        },
        event: 'No se ha indicado un nombre para el evento de la factura',
        property: {
          '': 'No se ha indicado un nombre para la propiedad del evento de la factura',
          value: 'No se ha indicado el valor para la propiedad del evento de la factura'
        },
        outstanding: {
          amount: 'No se ha indicado el importe pendiente de la factura'
        },
        executable: {
          amount: 'No se ha indicado el importe ejecutable de la factura'
        },
        communication: {
          reception: {
            name: 'No se ha indicado el nombre de la comunicación de recepción usada para la integración de la factura'
          }
        }
      },
      media: {
        type: 'No se ha indicado el canal del dato de contacto de empresa'
      },
      centremedia: {
        project: 'es necesario indicar un proyecto del centro para poder crear los datos de contacto',
        role: 'No se han indicado roles (vendedor o comprador) para el dato de contacto del centro'
      },
      partymedia: {
        role: 'No se han indicado roles (vendedor o comprador) para el dato de contacto de la empresa'
      },
      request: {
        compressed: {
          invoice: {
            flag: 'No se ha indicado si el fichero de la factura de la petición está comprimido o no'
          }
        },
        invoice: {
          file: 'No se ha incluido un fichero de factura en la petición'
        }
      }
    },
    update: {
      party: {
        taxid: 'No se ha especificado el identificador fiscal de la empresa a actualizar o modificar'
      }
    },
    search: {
      party: {
        taxid: 'No se ha especificado uno o más identificadores fiscales de empresas a buscar'
      }
    },
    commercial: {
      relation: {
        partytaxid: 'No se ha incluido el identificador fiscal de la empresa de la relación comercial',
        role: 'No se ha indicado el rol de la empresa creada/actualizada en la relación comercial'
      }
    },
    recadv: {
      integration: {
        file: {
          '': 'No se ha incluido el fichero de la recepción',
          extension: 'No se ha indicado la extensión del fichero de la recepción'
        }
      },
      status: 'No se ha indicado un estado para la recepción',
      number: {
        exception: 'No se ha indicado el número de la recepción'
      },
      receiving: {
        date: {
          time: {
            extension: 'No se ha indicado la fecha de la última recepción del recibo'
          }
        }
      },
      validity: {
        document: 'No se ha indicado el documento de vigencia de la factura'
      },
      document: {
        format: 'No se ha indicado un formato de documento para la recepción'
      },
      centre: 'No se ha indicado el centro del comprador del documento de recepción'
    }
  },
  party: {
    not: {
      found: 'No se ha encontrado una empresa con el número de identificación fiscal indicado'
    },
    project: {
      not: {
        found: 'No se encontró el proyecto especificado para la empresa. No existe o está desactivado'
      }
    },
    to: {
      delete: {
        not: {
          found: 'No se encontró la empresa a borrar. No se ha indicado su identificador fiscal o el mismo no existe'
        }
      }
    },
    commercial: {
      relation: {
        channel: {
          not: {
            found: 'No se ha encontrado el canal para la relación comercial. No existe o es erróneo'
          }
        }
      }
    },
    deletion: 'Error al borrar la empresa',
    country: {
      not: {
        found: 'No se encontró el país indicado para la empresa. No existe o sus datos son erróneos'
      }
    },
    media: {
      type: {
        not: {
          found: 'No se encontró el canal de comunicación especificado para el dato de contacto de empresa'
        }
      },
      deletion: 'Error al borrar el dato de contacto de la empresa',
      to: {
        delete: {
          not: {
            found: 'No se encontró el dato de contacto a borrar de la empresa. No se ha indicado o no existe'
          }
        }
      },
      invalid: {
        email: {
          format: 'La dirección de email del dato de contacto de empresa no es válida'
        }
      }
    }
  },
  commercial: {
    relation: {
      party: {
        not: {
          found: 'No se encontró la empresa indicada para la relación comercial dentro del rol especificado. También es posible que no exista o esté desactivada'
        }
      }
    }
  },
  incompatible: {
    integrated: {
      party: {
        for: {
          commercial: {
            relation: 'La empresa integrada no tiene activado el rol (vendedor o comprador) establecido para su relación comercial o está desactivada'
          }
        }
      }
    },
    centre: {
      role: 'El centro no tiene un rol compatible con el de su empresa dentro de su relación de proyecto',
      media: {
        data: {
          role: 'El centro no tiene el rol asignado (vendedor o comprador) para el dato de contacto, o dicho rol es incompatible con los asignados para su empresa en el proyecto determinado'
        }
      }
    },
    party: {
      media: {
        data: {
          role: 'La empresa no tiene el rol asignado (vendedor o comprador) para el dato de contacto dentro de su proyecto'
        }
      }
    }
  },
  communication: {
    method: {
      not: {
        found: 'No se encontró el método de comunicación especificado para la empresa'
      }
    }
  },
  centre: {
    role: {
      type: {
        not: {
          found: 'No se encontró el tipo de rol especificado para el centro'
        }
      }
    },
    to: {
      delete: {
        not: {
          found: 'No se encontró el centro a borrar. No se ha indicado alguno de sus datos obligatorios (empresa y código de centro) o el centro no existe'
        }
      }
    },
    deletion: 'Error al borrar el centro',
    party: {
      not: {
        found: 'No se ha encontrado la empresa del centro con los datos establecidos'
      }
    },
    not: {
      found: 'No se ha encontrado un centro que coincida con la empresa y código indicados'
    },
    country: {
      not: {
        found: 'No se encontró el país indicado para el centro. No existe o sus datos son erróneos'
      }
    },
    media: {
      type: {
        not: {
          found: 'No se encontró el canal de comunicación especificado para el dato de contacto de centro'
        }
      },
      deletion: 'Error al borrar el dato de contacto del centro',
      to: {
        delete: {
          not: {
            found: 'No se encontró el dato de cntacto a borrar del centro. No se ha indicado o no existe'
          }
        }
      },
      invalid: {
        email: {
          format: 'La dirección de email del dato de contacto de centro no es válida'
        }
      }
    }
  },
  media: {
    type: {
      not: {
        found: 'No se encontró el canal de contacto especificado'
      }
    }
  },
  centremedia: {
    project: {
      not: {
        found: 'No se encontró el proyecto para el dato de contacto del centro. No existe o sus datos son errados'
      }
    }
  },
  duplicate: {
    partymedia: {
      value: 'ya existe un dato de contacto de la empresa con el mismo valor para el proyecto al que está asignado'
    },
    centremedia: {
      value: 'ya existe un dato de contacto del centro con el mismo valor para el proyecto al que está asignado'
    }
  },
  recadvLine: {
    currency: {
      not: {
        found: 'No se encontró la divisa indicada para la recepción. No existe o es errónea'
      }
    },
    unitOfMeasure: {
      notFound: 'No se encontró la unidad de medida indicada para la línea de recepción'
    }
  },
  document_code: {
    generation: {
      format: {
        class: {
          not: {
            found: 'No se encontró la clase de mapeo del formato del documento. No existe o es errónea'
          }
        }
      }
    }
  },
  unzipped: {
    request: {
      invoice: {
        file: 'La petición de la factura está configurada para llevar ficheros de factura comprimidos, pero su fichero está sin comprimir'
      },
      attachments: 'La petición de la factura está configurada para llevar adjuntos comprimidos, pero tiene uno solo sin comprimir'
    }
  },
  zipped: {
    request: {
      invoice: {
        file: 'La petición de la factura está configurada para llevar ficheros de factura sin comprimir, pero su fichero está comprimido'
      },
      attachments: 'La petición de la factura está configurada para llevar un solo adjunto sin comprimir, pero tiene un fichero comprimido con uno o más'
    }
  },
  different: {
    invoice: {
      number: 'El número de factura de la petición es distinto al extraído del fichero de factura adjuntado'
    },
    seller: {
      tax: {
        identification: {
          number: 'La identificación fiscal del vendedor de la solicitud es diferente de la extraída del archivo de factura adjunto'
        }
      }
    }
  },
  // Fin errores/mensajes en Integración de factura
  projects: {
    filters: {
      creation_date: {
        value: 'Fecha de creación'
      },
      name: {
        value: 'Nombre del servicio',
        placeholder: 'Nombre'
      },
      code: {
        value: 'Código del servicio',
        placeholder: 'Código'
      },
      security_code: {
        value: 'Código de seguridad',
        placeholder: 'Código'
      },
      enabled: {
        value: 'Activo',
        placeholder: 'Escoge...'
      },
      issuing: {
        value: 'Emisión',
        placeholder: 'Escoge...'
      },
      reception: {
        value: 'Recepción',
        placeholder: 'Escoge...'
      },
      party_nif: {
        value: 'NIF empresa',
        placeholder: 'NIF'
      },
      party_name: {
        value: 'Nombre empresa',
        placeholder: 'Nombre'
      }
    },
    entity_table: {
      name: 'Servicio',
      code: 'Código',
      security_code: 'Código de seguridad',
      issuing: 'Emisión',
      reception: 'Recepción',
      creation_date: 'Fecha',
      enabled: 'Activo'
    },
    buttons: {
      new_project: 'Nuevo servicio'
    },
    error: {
      tamanomaximo: {
        code: "Tamaño máximo del campo 'Código de Servicio': 50 caracteres",
        name: "Tamaño máximo del campo 'Nombre de Servicio': 40 caracteres",
        security_code: "Tamaño máximo del campo 'Código de Seguridad': 64 caracteres",
        new_name: "Tamaño máximo del campo 'Nombre': 40 caracteres"
      },
      required: {
        name: 'Campo obligatorio: Nombre',
        code: 'Campo obligatorio: Código',
        enable: 'Campo obligatorio: Activo',
        isSender: 'Campo obligatorio: Emisión',
        isReceiver: 'Campo obligatorio: Recepción'
      },
      exist: 'El método de entrega elegido ya está insertado',
      validityexist: 'Ya existen datos de vigencia en el servicio para ese tipo y ese rol. Deberá borrar la vigencia existente si desea añadir otra.',
      validationexist: 'Ya existen datos de validación en el servicio para ese tipo, formato y rol. Deberá borrar la validación existente si desea añadir otra.',
      statusexist: 'Ya existe el estado para visualizar en tareas pendiente asociado el servicio',
      statuschangeexist: 'Ya existe el estado para el cambio de estado asociado al servicio',
      categoryexist: 'Ya existe la categoría asociada al servicio',
      mimeexist: 'Ya existe la configuración mime asociada al servicio',
      mime: {
        invalidMimeFrom: 'El email mime de procedencia no es válido',
        invalidMimeSender: 'El email mime remitente no es válido',
        invalidMimeReplyTo: 'El email mime al que responder no es válido'
      },
      wrongLogoSize: 'El tamaño de la imagen supera el máximo permitido: 256 KBs',
      wrongLogoExtension: 'Sólo se admiten imágenes en formato JPG/JPEG y PNG',
      adminParties_name_exist: 'Se ha producido un error. Ya existe un servicio con ese nombre o código',
      format_email: 'El formato del correo electrónico no es correcto.',
      format_phone: 'El formato del teléfono no es correcto.',
      partyTypeAndProject: 'El tipo de empresa no corresponde con el rol del servicio',
      signDocument_fileNull: 'Se debe adjuntar un fichero',
      signDocument_wrongExtension: 'La extension del adjunto debe ser PDF',
      signDocument_invalidPdf: 'El contenido del documento no es un Pdf válido',
      roleOfParte_isEmpty: 'Debe haber al menos un rol para la empresa',
      commercialrelation_insert: 'Indique únicamente el comprador o el vendedor.',
      existRelation: 'Operación no completada. La relación ya existe.',
      partyCountryNotEqual: 'El identificador ya existe en la plataforma para otro país',
      partydisabled: 'No puede añadir la empresa, existe pero está desactivada',
      partyAlreadyAdded: 'La empresa ya está asignada, por favor revise los datos',
      noMediaCorrect: 'Los datos de contacto no son correctos, revise el tipo de empresa de los datos.',
      email_empty: 'Debe introducirse un dato de contacto',
      contact_duplicado: 'Ya existe ese valor de "correo electrónico"',
      contact_noMore: 'No se pueden añadir mas contactos con este tipo',
      adminparties: {
        required: {
          userType: 'El campo "Tipo persona" es obligatorio',
          name: 'El campo "Nombre" es obligatorio',
          firstSurname: 'El campo "Primer apellido" es obligatorio',
          corporateName: 'El campo "Razón social" es obligatorio',
          country: 'El campo "País" es obligatorio',
          postcode: 'El campo "Código postal" es obligatorio',
          address: 'El campo "Dirección" es obligatorio',
          town: 'El campo "Población" es obligatorio',
          province: 'El campo "Provincia" es obligatorio',
          nif: 'El campo "ID fiscal" es obligatorio'
        },
        invalid: {
          name: 'El campo "Nombre" no es válido',
          firstSurname: 'El campo "Primer apellido" no es válido',
          secondSurname: 'El campo "Segundo apellido" no es válido',
          postcode: 'El campo "Código postal" no es válido',
          postcode_max: 'La longitud del campo "Código postal" no es correcta',
          nif: 'El campo "ID fiscal" no tiene un formato válido',
          nif_max: 'La longitud del campo "ID fiscal" no es correcta',
          email: 'El correo electrónico introducido no es válido',
          phoneNumber: 'El número de teléfono del contacto no es válido'
        }
      }
    },
    validations: {
      name: 'Validación',
      value: 'Valor',
      role: 'Sentido del documento',
      document_type: 'Tipo de documento',
      comm_method: 'Método de comunicación',
      emission: 'Emisión',
      reception: 'Recepción',
      country: 'País',
      document_format: 'Formato documento'
    },
    validities: {
      validity: 'Vigencia (días)',
      country: 'País',
      role: 'Sentido del documento',
      document_type: 'Tipo de documento',
      emission: 'Emisión',
      reception: 'Recepción'
    },
    pendingtasks: {
      status: 'Estado',
      module: 'Módulo'
    },
    rejectionCategories: {
      name: 'Nombre',
      visible: 'Visible'
    },
    emailType: {
      type: 'Tipología email',
      value: 'Email'
    },
    visualization: {
      name: 'Visualización'
    }
  },

  new_project: {
    title: 'Creación de servicio',
    new_project_form: {
      name: {
        label: 'Nombre',
        placeholder: ''
      },
      code: {
        label: 'Código',
        placeholder: ''
      },
      issuing: {
        label: 'Emisión',
        placeholder: 'Escoge...'
      },
      enable: {
        label: 'Activo',
        placeholder: 'Escoge...'
      },
      reception: {
        label: 'Recepción',
        placeholder: 'Escoge...'
      },
      indra_project: {
        label: 'Contratista',
        placeholder: 'Escoge...'
      }
    },
    load: {
      upload_logo: 'Subiendo Logo',
      save_changes: 'Guardando los datos del proyecto'
    },
    notify: {
      upload_logo: 'Se ha cargado el logo correctamente. Recuerde pulsar en "Guardar cambios"',
      save_changes: 'Proyecto creado correctamente'
    }
  },

  project_detail: {
    info_message: 'Algunos de los campos de la información del servicio son editables. Recuerda pulsar en el botón \'Guardar\' para que se apliquen las modificaciones',
    title_delete_communication: 'Alguna empresa del servicio tiene credenciales para ese método, revise si debe borrarlas antes de continuar, ¿desea continuar de todos modos?',
    expand_all_accordion: 'Expandir todo',
    collapse_all_accordion: 'Contraer todo',
    buttons: {
      management_services_parties: 'Ver empresas asociadas',
      add_logo: 'Cargar',
      add_configuration_data: 'Cargar',
      add_delivery_methods: 'Cargar',
      add_logo_tooltip: 'Cargar logo',
      add_configuration_data_tooltip: 'Cargar dato de configuración',
      add_mime_configuration: 'Cargar',
      add_mime_configuration_tooltip: 'Cargar configuración mime',
      add_delivery_methods_tooltip: 'Cargar método de entrega',
      add_validation_tooltip: 'Cargar validación',
      add_validity_document: 'Cargar',
      add_validity_document_tooltip: 'Cargar vigencia',
      add_visualization_tooltip: 'Cargar visualización',
      add_pendingtask: 'Cargar',
      add_pendingtask_tooltip: 'Cargar estado tarea pendiente',
      add_rejectionCategory: 'Cargar',
      add_rejectionCategory_tooltip: 'Cargar categoría',
      add_emailype_tooltip: 'Cargar tipología de correo',
      add_documentFormat_data_tooltip: 'Cargar un formato de documento',
      add_charge_or_discount_tooltip: 'Cargar cargos y descuentos',
      add_charge_or_discount: 'Cargar'
    },
    project_detail_edit_form: {
      name: 'Nombre de servicio',
      code: 'Código de servicio',
      enable: 'Activo/Inactivo',
      security_code: 'Código de seguridad',
      issuing: 'Emisión',
      reception: 'Recepción',
      is_indra_project: 'Contratista'
    },
    facturar: 'Facturar',
    configuration_data: 'Datos de configuración',
    no_configuration_data: 'Este servicio no tiene datos de configuración',
    configuration_data_table: {
      code: 'Configuración',
      project_type: 'Tipo proyecto'
    },
    mime_required: 'Debe introducir al menos uno de los valores',
    mime_configuration: 'Datos configuración mime',
    no_mime_configuration: 'Este servicio no tiene datos de configuración mime',
    mime_configuration_table: {
      mime_from: 'De',
      mime_sender: 'Remitente',
      mime_reply_to: 'Responder a'
    },

    validation: {
      error_code: 'El código no cumple con el formato requerido {0}'
    },
    delivery_methods: 'Métodos de entrega',
    delivery_methods_credentials: 'Credenciales de métodos de entrega',
    no_delivery_methods: 'Este servicio no tiene métodos de entrega',
    validations: 'Validaciones',
    addCharge_or_discount: 'Cargos y descuentos',
    no_chargeDiscount: 'El servicio no tiene cargos ni descuentos',
    visualize_pdf: 'Visualización PDF',
    no_active_validations: 'El servicio no tiene validaciones activas',
    no_active_PDF: 'El servicio no tiene visualizaciones de PDF activas',
    validity_document: 'Vigencia de documentos',
    no_validity_document: 'Este servicio no tiene datos de vigencia',
    rejectionCategories: 'Categoría de rechazos',
    no_rejectionCategories: 'Este servicio no tiene categorías de rechazo',
    rejectionCategory_table: {
      category: 'Categoría',
      visible: 'Visible'
    },
    emailType: 'Tipología correos',
    no_emailType: 'Este servicio no tiene tipologías de correo configuradas',
    pendingtasks: 'Configuración de estados',
    no_pendingtasks: 'Este servicio no tiene estados configurados',
    pendingtask_table: {
      status: 'Estado a visualizar en tareas pendientes',
      statuschange: 'Cambio de estado',
      statusplaceholder: 'Estado'
    },
    emailTypePlaceholder: 'Tipo email',
    validity_document_table: {
      days: 'Vigencia (días)',
      country: 'País',
      document_type: 'Tipo documento',
      role: 'Rol'
    },

    charges: 'Cargo',
    discounts: 'Descuento',

    dialog_add_logo: {
      title: 'Carga un logo'
    },
    dialog_add_configuration_data: {
      title: 'Añade los datos de configuración',
      configuration: {
        label: 'Configuración',
        placeholder: 'Elige una configuración'
      },
      type: {
        label: 'Tipo',
        placeholder: 'Elige un tipo'
      }
    },
    dialog_add_mime_configuration: {
      title: 'Añade los datos de configuración mime',
      mime_from: {
        label: 'De',
        placeholder: 'Quien envía el correo'
      },
      mime_sender: {
        label: 'Remitente',
        placeholder: 'Remitente del correo'
      },
      mime_reply_to: {
        label: 'Responder a',
        placeholder: 'Aquien reponde el correo'
      }
    },

    // Documentos y formatos
    document_format: 'Documentos y formatos',
    no_document_format: 'Este servicio no tiene documentos y formatos',
    dialog_add_document_format: {
      title: 'Elige un nuevo documento y formato',
      format: {
        labelType: 'Tipo de documento',
        labelFormat: 'Formato de documento',
        placeholder: 'Escoge...'
      }
    },
    document_format_table: {
      name: 'Nombre',
      sender: 'Emisión/Recepción',
      priority: 'Prioridad',
      user: 'Usuario',
      password: 'Contraseña',
      party: 'Entidad',
      format: 'Formato',
      documentType: 'Tipo documento'
    },

    dialog_add_delivery_method: {
      title: 'Elige un nuevo método de entrega',
      method: {
        label: 'Método',
        placeholder: 'Elige un método'
      }
    },
    dialog_add_validations: {
      title: 'Elige una nueva validación',
      validation: {
        title: 'Validación',
        placeholder: 'Elige una validación'
      }
    },
    dialog_add_visualization: {
      title: 'Elige una nueva visualización PDF',
      visualization: {
        title: 'Visualización PDF',
        placeholder: 'Elige una visualización'
      }
    },
    dialog_add_validities: {
      title: 'Elige una nueva vigencia',
      validity: {
        title: 'Vigencia',
        placeholder: 'Elige una vigencia'
      }
    },
    dialog_add_pendingtask: {
      title: 'Configuración de estados',
      pendingtask: {
        title: 'Tarea pendiente',
        placeholder: 'Elige tarea pendiente'
      }
    },
    dialog_add_emailType: {
      title: 'Elige un tipo de email',
      emailType: {
        title: 'Tipo de email',
        placeholder: 'Elige tipo de email'
      }
    },
    dialog_add_rejectionCategory: {
      title: 'Elige una categoría',
      rejectionCategory: {
        title: 'Categoría de rechazo',
        placeholder: 'Elige categoría'
      }
    },
    dialog_add_charge_or_discount: {
      title: 'Añadir cargo o descuento',
      type: 'Tipo',
      description: 'Descripción'
    },
    load: {
      upload_logo: 'Subiendo Logo',
      delete_logo: 'Eliminando logo de la empresa',
      download_logo: 'Descargando Logo del proyecto',
      save_changes: 'Guardando los datos del servicio',
      cancel: 'Cancelando',
      add_configuration: 'Añadiendo configuración',
      delete_configuration: 'Eliminando configuración',
      add_delivery_method: 'Añadiendo método de entrega',
      delete_delivery_method: 'Eliminando método de entrega',
      delete_validation: 'Eliminando validación',
      add_validation: 'Añadiendo validación',
      delete_validity: 'Eliminando vigencia',
      add_validity: 'Añadiendo vigencia',
      delete_PDFVisualization: 'Eliminando visualización PDF',
      add_visualization: 'Añadiendo visualización PDF',
      delete_pendingtask: 'Eliminando estado de tarea pendiente',
      add_pendingtask: 'Añadiendo estado de tarea pendiente',
      delete_rejectionCategory: 'Eliminando categoría de rechazo',
      add_rejectionCategory: 'Añadiendo categoría de rechazo',
      delete_emailType: 'Eliminando tipología de correo',
      add_emailType: 'Añadiendo tipología de correo',
      delete_project_document_format: 'Eliminando documento y formato',
      add_document_format: 'Añadiendo documento y formato',
      add_delivery_note_config: 'Añadiendo matrícula para albaranes emitidos',
      add_project_delivery_note_type: 'Añadiendo tipo de albarán',
      delete_project_delivery_note_type: 'Eliminando tipo de albarán'
    },
    notify: {
      delete_logo: 'Se ha eliminado el logo correctamente',
      save_changes: 'El servicio se ha actualizado correctamente',
      add_configuration: 'Los datos de configuración se añadieron correctamente',
      delete_configuration: 'Se ha eliminado la configuración correctamente',
      add_delivery_method: 'El método de entrega se añadio correctamente',
      delete_delivery_method: 'Datos eliminados correctamente',
      delete_validation: 'Se ha eliminado la validación correctamente',
      add_validation: 'La validación se ha añadido correctamente',
      delete_validity: 'Se ha eliminado la vigencia correctamente',
      add_validity: 'La vigencia se ha añadido correctamente',
      delete_PDFVisualization: 'Se ha eliminado la visualización correctamente',
      add_PDFVisualization: 'La visualización se ha añadido correctamente',
      noDisplayDocuments: 'No existen visualizaciones para ese tipo de documento',
      delete_pendingtask: 'Se ha eliminado el estado correctamente',
      add_pendingtask: 'El estado se ha añadido correctamente',
      delete_rejectionCategory: 'Se ha eliminado la categoría de rechazo correctamente',
      add_rejectionCategory: 'La categoría de rechazo se ha añadido correctamente',
      delete_emailType: 'Se ha eliminado la tipología de correo correctamente',
      add_emailType: 'La tipología de correo se ha añadido correctamente',
      delete_project_document_format: 'Se ha eliminado el documento y formato correctamente',
      add_document_format: 'El documento y formato se han añadido correctamente',
      add_delivery_note_config: 'La matrícula se ha añadido correctamente',
      document_format_duplicate: 'No se ha podido insertar el documento y formato, documento y formato repetido.',
      add_project_delivery_note_exist: 'Ya existe la relación entre el proyecto y el tipo de albarán',
      add_project_delivery_note_type: 'El tipo de albarán se ha añadido correctamente',
      delete_project_delivery_note_type: 'El tipo de albarán se ha eliminado correctamente'
    },
    error: {
      duplicated: 'La validación ya ha sido insertada',
      document_type: {
        required: 'No se ha indicado un tipo de documento'
      },
      validation_id: {
        required: 'No se ha indicado una validación',
        duplicated: 'Validación duplicada'
      },
      validity: {
        required: 'No se han indicado los días de vigencia'
      },
      sender: {
        required: 'No se ha indicado el rol'
      },
      visualization_id: {
        required: 'No se ha indicado una visualización',
        duplicated: 'Visualización duplicada'
      },
      statusconfig: {
        required: 'No se ha indicado ningún estado'
      },
      emailType: {
        required: 'No se ha indicado tipo de email'
      },
      emailValue: {
        required: 'Debe indicarse al menos un email',
        duplicated: 'Ya existe el email para ese poyecto y tipología',
        invalid: 'El email no tiene un formato válido'
      },
      category: {
        required: 'No se ha indicado categoria'
      },
      visible: {
        required: 'Nessuna visibilità indicata'
      }
    }
  },

  parties: {
    filters: {
      party_name: {
        value: 'Nombre de empresa',
        placeholder: 'Nombre'
      },
      identification_tax_number: {
        value: 'ID fiscal',
        placeholder: 'ID fiscal'
      },
      gln: {
        value: 'GLN',
        placeholder: 'GLN'
      },
      registerDate: {
        value: 'Fecha de registro',
        placeholder: 'Fecha de registro'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Comprador'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Vendedor'
      },
      propietary: {
        value: 'Propietaria',
        placeholder: 'Propietaria'
      },
      active: {
        value: 'Activo',
        placeholder: 'Activo'
      },
      country: {
        value: 'País',
        placeholder: 'País'
      }
    },
    notify: {
      not_buyer_sponsor: 'Todas los empresas deben ser compradoras y propietaria/no propietaria',
      modify_all: 'Se modificarán todas las empresas seleccionadas, ¿Desea continuar?',
      parties_updated: 'Empresas actualizadas',
      loadmassive_timeout: 'La carga de empresas se está procesando, una vez finalizada puede ver el resultado en la auditoría de documentos',
      loadmassive_numlinesOK: 'Número de líneas procesadas correctamente:'
    },
    entity_table: {
      name: 'Nombre',
      identification_tax_number: 'ID fiscal',
      country: 'País',
      province: 'Provincia',
      creation_date: 'F. asignación',
      creation_date_party: 'F. registro',
      seller: 'Vendedor',
      buyer: 'Comprador',
      third: 'Tercero',
      sponsor: 'Propietaria',
      register_location_company: 'R. Mercantil',
      enable: 'Activo',
      permanentEstablishment: 'Establecimiento permanente'
    },
    buttons: {
      add_party: 'Cargar',
      add_party_tooltip: 'Cargar empresa',
      mass_partycharge_tooltip: 'Carga masiva de empresas',
      mass_partycharge: 'Carga empresas',
      mass_partyupdate_tooltip: 'Actualización masiva de razones sociales de empresas',
      mass_upload: 'Carga masiva',
      mass_partyupdate: 'Actualización masiva'
    },
    mass_party_chargemsg: 'El fichero debe contener la extension CSV.'
  },

  new_party: {
    country_nif: {
      title: 'Añadir empresa',
      info: 'Añade el ID Fiscal y el país de la empresa para proceder a rellenar el formulario de creación de Empresa',
      form: {
        country: {
          label: 'País',
          placeholder: 'Elige...'
        },
        identification_number: {
          label: 'ID fiscal'
        }
      }
    }
  },

  party_detail: {
    confirm_clean: 'Recuerde: si modifica los datos deberá volver a generar el modelo de solicitud de cambio de datos',
    title: 'Información de la empresa',
    info_message: 'Algunos de los campos de la información de la empresa son editables. Recuerda pulsar en el botón \'Guardar\' para que se apliquen las modificaciones',
    info_address: 'Para guardar la información de dirección fiscal es necesario rellenar todos los campos del apartado',
    buttons: {
      admin_channels: 'Administrar relaciones comerciales',
      admin_centres: 'Administrar centros',
      upload_centre: 'Actualizar centro',
      upload_centre_ok: 'Centro actualizado correctamente',
      add_contact_data: 'Cargar',
      add_contact_data_tooltip: 'Cargar datos de contacto',
      add_gln_data: 'Cargar',
      add_gln_data_tooltip: 'Cargar buzón GLN',
      add_delivery_method: 'Cargar',
      add_sign_document: 'Cargar',
      add_delivery_method_tooltip: 'Cargar método de entrega',
      add_document_format_tooltip: 'Cargar formato de documento',
      add_delivery_note_type_tooltip: 'Cargar tipo de albarán',
      add_label_tooltip: 'Cargar etiqueta',
      add_registration_tooltip: 'Cargar matrícula',
      add_sign_document_tooltip: 'Cargar documento de firma delegada',
      add_validations_tooltip: 'Cargar validación',
      mass_partyupdate: 'Actualizar razón social',
      add_shipping_configuration: 'Cargar',
      add_shipping_configuration_tooltip: 'Cargar configuración de envío',
      add_paymentMeans_tooltip: 'Cargar datos de pago',
      add_document_cycle_tooltip: 'Cargar ciclo de documentos'
    },

    dialog_add_payments: {
      title: 'Añade los datos de pago'
    },

    party_detail_edit_form: {
      confirm_clean: 'Recuerde: si modifica los datos deberá volver a generar el modelo de solicitud de cambio de datos',
      person_type: {
        label: 'Tipo de persona',
        placeholder: 'Elige un tipo'
      },
      corporate_name: 'Razón social',
      name: 'Nombre',
      gln: 'GLN',
      identification_tax_number: 'ID fiscal',
      enable: 'Activo/Inactivo',
      first_surname: 'Primer apellido',
      second_surname: 'Segundo apellido',

      // Registro mercantil
      book: 'Libro',
      folio: 'Folio',
      volume: 'Volumen',
      sheet: 'Hoja',
      section: 'Sección',
      additional_data: 'Datos adicionales',
      registerOrCompaniesLocation: 'Registro mercantil',
      taxDataCertificate: 'Cargar certificado de datos fiscales de la agencia tributaria',

      // Direccion
      address: 'Dirección',
      province: 'Provincia',
      postcode: 'Código postal',
      town: 'Población',
      country: {
        label: 'País',
        placeholder: 'País'
      },

      // Datos Bancarios
      iban: 'IBAN',
      bic: 'BIC Swift',
      accountTitular: 'Titular de la cuenta',
      email: 'Email de comunicación de pagos',
      ficheroCertificado: 'Carga certificado de titularidad de la cuenta bancaria',
      donwloadModelo: 'Descarga modelo solicitud cambio datos',
      ficheroDatos: 'Carga de solicitud de cambio de datos (Debe firmarse digitalmente)',
      sendProject: {
        label: 'Proyectos a enviar documentación',
        placeholder: 'Elige Proyecto/s'
      },
      legalNif: 'Nif del representante legal/apoderado',
      legalName: 'Apellidos y nombre del representante legal/apoderado',
      legalCountry: {
        label: 'País',
        placeholder: 'País'
      },
      contactName: 'Apellidos y nombre de la persona de contacto',
      contactRole: 'Cargo que desempeña en la entidad la persona de contacto',
      contactEmail: 'Correo electrónico de la persona de contacto',
      contactEmailEmi: 'Correo electrónico para emitir comunicaciones relacionadas con la facturación electrónica',
      contactPhones: 'Teléfono/s de la persona de contacto',

      // Rol por servicio
      buyer: 'Comprador',
      seller: 'Vendedor',
      sponsor: 'Propietaria'
    },
    subtitle: {
      commercial_register: 'Registro mercantil',
      address: 'Dirección Fiscal',
      project_role: 'Rol por servicio',
      bank: 'Datos bancarios',
      bank_legal_data: 'Datos del representante legal/apoderado',
      bank_contact_data: 'Datos de la persona de contacto en relación con el presente formulario'
    },

    // Carga de logo
    dialog_add_logo: {
      title: 'Carga un logo'
    },

    no_active_validations: 'Esta empresa no tiene validaciones activas',
    // Proyectos relacionados
    project_related: 'Servicios relacionados',
    no_project_data: 'Esta empresa no está asociada a ningún servicio',
    // Datos de contacto
    contact_data: 'Datos de contacto',
    no_contact_data: 'Esta empresa no tiene datos de contacto',
    party_media_table: {
      project: 'Servicio',
      media_type: 'Tipo de contacto',
      contact_data: 'Dato de contacto',
      party_type: 'Tipo de empresa',
      profile_info: '>>  Si desea modificar los datos de contacto debe contactar con su cliente.'
    },
    dialog_add_contact_data: {
      title: 'Añadir dato de contacto',
      media_type: {
        label: 'Medio de contacto',
        placeholder: 'Tipo de contacto'
      },
      party_type: {
        label: 'Tipo de empresa',
        placeholder: 'Tipo de empresa'
      },
      contact_data: {
        label: 'Dato de contacto'
      }
    },
    // Buzones
    gln_data: 'Identificadores',
    no_gln_data: 'Esta empresa no tiene identificadores',
    party_gln_table: {
      physical_gln: 'Identificador',
	  physical_gln_type: 'Tipo',
    },
    dialog_add_gln_data: {
      title: 'Añadir identificador',
      physical_gln: {
        label: 'Identificador',
		type: 'Tipo'
      }
    },

    // Metodos de entrega
    delivery_methods: 'Métodos de entrega',
    no_delivery_methods: 'Esta empresa no tiene métodos de entrega',
    delivery_methods_table: {
      name: 'Nombre',
      sender: 'Emisión/Recepción',
      priority: 'Prioridad',
      user: 'Usuario',
      password: 'Contraseña',
      party: 'Entidad',
      countryEmission: 'País emisor',
      countryReception: 'País receptor',
    },
    dialog_add_delivery_methods: {
      title: 'Elige un nuevo método de entrega',
      method: {
        label: 'Método de entrega',
        placeholder: 'Escoge...'
      }
    },
    dialog_add_delivery_methods_credentials: {
      title: 'Credenciales del método de envío'
    },

    // Formato de documento
    document_format: 'Formatos de documentos',
    no_document_format: 'Este servicio no tiene formatos de documentos',
    dialog_add_document_format: {
      title: 'Elige un nuevo formato de documento',
      method: {
        labelType: 'Tipo de documento',
        labelFormat: 'Formato de documento',
        placeholder: 'Escoge...'
      }
    },
    document_format_table: {
      name: 'Nombre',
      sender: 'Emisión/Recepción',
      priority: 'Prioridad',
      user: 'Usuario',
      password: 'Contraseña',
      party: 'Entidad',
      format: 'Formato',
      documentType: 'Tipo documento'
    },

    // Documento de firma delegada
    sign_document: 'Documento de firma delegada',
    no_sign_document: 'Esta empresa no tiene documentos de firma delegada',
    sign_document_table: {
      project: 'Tipo/Servicio',
      filename: 'Nombre fichero',
      creation_date: 'Fecha creación'
    },
    dialog_add_sign_document: {
      title: 'Cargar fichero de delegación de firma'
    },
    dialog_add_party_label: {
      title: 'Elige una nueva etiqueta'
    },
    // Documento de datos fiscales
    aeat_document: 'Documento de datos fiscales',
    no_aeat_document: 'Esta empresa no tiene documentos de datos fiscales',
    aeat_document_table: {
      documentname: 'Documento',
      user: 'Usuario',
      creation_date: 'Fecha de carga'
    },
    // Datos de pago
    paymentMeans: 'Datos de pago',
    no_payment_data: 'Esta empresa no tiene datos de pago',
    payments_table: {
      paymentMeans: 'Método de pago',
      iban: 'IBAN',
      swift: 'SWIFT'
    },
    // Ciclos de documentos
    no_party_document_cycle: 'No hay ciclos de documentos',
    document_cycle_table: {
      title: 'Ciclos de documentos',
      sourceDocumentType: 'Tipo de documento origen',
      destinationDocumentType: 'Tipo de documento destino',
      buyer_centre: 'Centro de la empresa compradora',
      seller: 'Empresa vendedora',
      class: 'Clase de documento origen',
      additional: 'Parámetro adicional de la clase de documento origen'
    },
    document_cycle_class_source_options: {
      source: 'Documento origen',
      destination: 'Documento destino'
    },
    dialog_add_document_cycle: {
      title: 'Añade un nuevo ciclo de documentos',
      source_document_type: {
        label: 'Tipo de documento origen',
        placeholder: 'Escoge...'
      },
      destination_document_type: {
        label: 'Tipo de documento destino',
        placeholder: 'Escoge...'
      },
      seller: {
        label: 'Empresa vendedora',
        placeholder: 'Escriba 3 caracteres'
      },
      centre_buyer: {
        label: 'Centro de la empresa compradora',
        placeholder: 'Escoge...'
      },
      document_cycle: {
        label: 'Clase de documento',
        placeholder: 'Escoge...'
      },
      document_cycle_class_source: {
        label: 'Sentido del documento',
        placeholder: 'Escoge el documento al que añadir la clase...'
      },
      additional_class_value: {
        title: 'Parámetro adicional de la clase de documento'
      }
    },
    load: {
      upload_logo: 'Subiendo Logo',
      delete_logo: 'Eliminando logo de la empresa',
      download_logo: 'Descargando Logo de la empresa',
      save_changes: 'Guardando los datos de la empresa',
      cancel: 'Cancelando',
      add_contact_data: 'Añadiendo dato de contacto',
      delete_contact_data: 'Eliminando dato de contacto',
      add_approval_amount: 'Creando flujo de aprobación',
      modify_approval_amount: 'Actualizando flujo de aprobación',
      delete_approval_amount: 'Eliminando flujo de aprobación',
      add_approval_level: 'Creando nivel de aprobación',
      delete_approval_level: 'Eliminando nivel de aprobación',
      add_party_label: 'Añadiendo etiqueta',
      delete_party_label: 'Eliminando etiqueta',
      add_gln_data: 'Añadiendo buzón GLN',
      add_document_format: 'Añadiendo formato de documento',
      delete_gln_data: 'Eliminando buzón GLN',
      add_delivery_method: 'Añadiendo método de entrega',
      delete_delivery_method: 'Eliminando método de entrega',
      delete_party_document_format: 'Eliminando formato de documento',
      delete_party_emission_deliverynote_config: 'Eliminando matrícula para albaranes emitidos',
      upload_sign_document: 'Subiendo documento de firma delegada',
      download_sign_document: 'Descargando Documento de firma delegada',
      delete_sign_document: 'Eliminando Documento de firma delegada',
      download_aeat_document: 'Descargando Documento de datos fiscales',
      add_shipping_configuration: 'Añadiendo configuración de envío',
      delete_shipping_configuration: 'Eliminando configuración de envío',
      add_party_delivery_note_type: 'Añadiendo tipo de albarán',
      delete_party_delivery_note_type: 'Eliminando tipo de albarán',
      delete_paymentMeans: 'Eliminando datos de pago',
      add_paymentMeans: 'Añadiendo datos de pago',
      delete_document_cycle: 'Eliminando ciclo de documentos',
      add_party_document_cycle: 'Añadiendo ciclo de documentos'
    },
    notify: {
      upload_logo: 'Se ha cargado el logo correctamente. Recuerde pulsar en "Guardar cambios"',
      delete_logo: 'Se ha eliminado el logo correctamente',
      save_changes: 'La empresa se ha actualizado correctamente',
      created: 'La empresa se ha creado correctamente',
      save_changes_to_service: 'Se han informado los datos al servicio ',
      add_contact_data: 'Los datos de contacto se añadieron correctamente',
      delete_contact_data: 'Se ha eliminado el dato de contacto correctamente',
      add_approval_amount_data: 'Datos del flujo de aprobación añadidos correctamente',
      modify_approval_amount_data: 'Datos del flujo de aprobación modificados correctamente',
      delete_approval_amount_data: 'Eliminado el flujo de aprobación del centro',
      add_approval_level_data: 'Nivel de aprobación añadido correctamente',
      delete_approval_level_data: 'Nivel de aprobación eliminado',
      add_gln_data: 'El identificador se ha añadido correctamente',
      add_document_format: 'El formato de documento se ha añadido correctamente',
      noLabels: 'No existen etiquetas para ese tipo de documento',
      existLabels: 'La etiqueta ya está asociada a la empresa',
      add_party_label: 'La etiqueta se ha añadido correctamente',
      delete_party_label: 'La etiqueta se ha eliminado correctamente',
      delete_gln_data: 'Se ha eliminado el identificador correctamente',
      add_delivery_method: 'El método de entrega se añadio correctamente',
      delete_delivery_method: 'Se ha eliminado el método de entrega correctamente',
      delete_party_document_format: 'Se ha eliminado el formato del documento correctamente',
      delete_party_emission_deliverynote_config: 'Se ha eliminado la matrícula correctamente',
      add_party_delivery_note_type: 'El tipo de albarán se ha añadido correctamente',
      add_party_delivery_note_exist: 'Ya existe la relación entre la empresa y el tipo de albarán',
      delete_party_delivery_note_type: 'Se ha eliminado el tipo de albarán correctamente',
      delete_sign_document: 'Se ha eliminado el documento de firma correctamente',
      typePersonTaxIden: 'El tipo de persona debe de coincidir con un id fiscal correcto en España',
      document_format_duplicate: 'No se ha podido insertar el formato de documento, formato repetido.',
      add_shipping_configuration: 'La configuración de envío se añadió correctamente',
      delete_shipping_configuration: 'Se ha eliminado la configuración de envío correctamente',
      add_shipping_configuration_duplicate: 'No se ha podido insertar la configuración de envío, formato para ese GLN repetido',
      add_paymentMeans: 'Los datos de pago se añadieron correctamente',
      delete_paymentMeans: 'Los datos de pago se eliminaron correctamente',
      payment_means_duplicate: 'Ya existen datos de pago para el mismo método, elimine primero el dato de pago existente',
      document_cycle_duplicate: 'Ya existe el ciclo de documento para la empresa, elimine primero el ciclo de documento existente',
      delete_document_cycle: 'Se ha eliminado el ciclo de documento correctamente',
      add_document_cycle: 'Se ha añadido el ciclo de documento correctamente'
    },

    // Administrar canales
    channels: {
      filters: {
        name: {
          value: 'Nombre de la empresa',
          placeholder: 'Nombre'
        },
        buyer: {
          value: 'Comprador',
          placeholder: 'Escoge...'
        },
        seller: {
          value: 'Vendedor',
          placeholder: 'Escoge...'
        }
      },
      entity_table: {
        sellers: 'Empresas vendedoras',
        buyers: 'Empresas compradoras',
        channels: 'Canales',
        seller: 'Empresa vendedora',
        buyer: 'Empresa compradora',
        communicationsMethod: 'Métodos de comunicación'
      },
      buttons: {
        add_commercial_relation: 'Añadir relación comercial'
      },
      dialog_add_commercial_relation: {
        title: 'Nueva relación comercial',
        party: 'Empresa',
        buyer: {
          label: 'Comprador',
          placeholder: 'Elige...',
          write_placeholder: 'Escriba 3 caracteres'
        },
        seller: {
          label: 'Vendedor',
          placeholder: 'Elige...',
          write_placeholder: 'Escriba 3 caracteres'
        }
      },
      dialog_users: {
        title: 'Usuarios',
        userName: 'Nombre del usuario'
      },
      notify: {
        add_commercial_relation: 'Se ha añadido la relación comercial correctamente',
        delete_commercial_relation: 'Relación comercial eliminada correctamente.'
      },
      confirm: {
        delete_commercial_relation: '¿Estás seguro de eliminar la relación comercial?'
      },
      load: {
        add_commercial_relation: 'Añadiendo relación comercial ...',
        delete_commercial_relation: 'Eliminando relación comercial ...'
      },
      channels_data: 'Canales de la empresa',
      no_channels_data: 'La empresa no tiene canales'
    },

    commercial_relation: {
      filters: {
        party_name: {
          value: 'Nombre de la empresa',
          placeholder: 'Empresa'
        },
        buyer: {
          value: 'Comprador',
          placeholder: 'Elige...'
        },
        seller: {
          value: 'Vendedor',
          placeholder: 'Elige...'
        }
      }
    },

    // Configuración de emisión de albaranes
    emission_delivery_note_config: 'Configuración de matrículas de albaranes emitidos',
    no_emission_delivery_note_config: 'Esta empresa no tiene configuración de matrículas de albaranes emitidos',
    emission_delivery_note_config_table: {
      platformCode: 'Código de plataforma',
      partyPrefix: 'Código de empresa',
      packSequenceNumber: 'Número de secuencia'
    },

    // Configuración de tipos de albaranes recibidos
    reception_delivery_note_config: 'Configuración de tipos de albaranes recibidos',
    no_party_reception_delivery_note_config: 'Esta empresa no tiene configuración de tipos de albaranes recibidos',
    no_project_reception_delivery_note_config: 'Este servicio no tiene configuración de tipos de albaranes recibidos',
    reception_delivery_note_config_table: {
      delivery_note_type: 'Tipo de albarán'
    },

    dialog_add_party_delivery_note_config: {
      title: 'Nueva matrícula',
      method: {
        platformCode: 'Código de plataforma',
        partyPrefix: {
          title: 'Código de empresa',
          tooltip: 'Introduzca código pais (2 digitos) + código organismo oficial (de 5 a 9 dígitos)'
        },
        packSequenceNumber: {
          title: 'Número de secuencia',
          tooltip: 'Introduzca número de secuencia inicial para numerar embalajes'
        },
        rules: {
          partyPrefix_pattern: 'El código de empresa sólo admite entre 7 y 11 dígitos',
          packSequenceNumber_pattern: 'El número de secuencia sólo admite dígitos'
        }
      }
    },

    dialog_add_party_delivery_note_type: {
      title: 'Elige un nuevo tipo de albarán',
      method: {
        deliveyNoteType: 'Tipo de albarán'
      }
    },

    // Configuración de etiquetas para empresa compradora
    party_label_config: 'Configuración de etiquetas de albaranes recibidos',
    no_party_label_config: 'Esta empresa no tiene etiquetas configuradas para albaranes recibidos',
    party_label_config_table: {
      name: 'Nombre',
      description: 'Descripción',
      document_type: 'Tipo de documento',
      class: 'Clase de implementación'
    },

    dialog_add_party_label_config: {
      title: 'Nueva etiqueta',
      method: {
        label: {
          title: 'Etiqueta',
          placeholder: 'Selecciona una etiqueta'
        },
        description: 'Descripción',
        document_type: 'Tipo de documento',
        class: 'Clase de implementación'
      }
    },

    // CONFIGURACIÓN DE ENVÍO DE LA EMPRESA
    shipping_configuration: 'Configuración de envío',
    no_shipping_configuration: 'Esta empresa no tiene configuraciones de envío',
    shipping_configuration_table: {
      documentType: 'Tipo documento',
      documentFormat: 'Formato',
      partySeller: 'Vendedor',
      deliveryPoint: 'Lugar de entrega',
      sellerGLN: 'Buzón vendedor',
      buyerGLN: 'Buzón comprador'
    },

    dialog_add_shipping_configuration: {
      title: 'Nueva configuración de envío',
      document_type: {
        label: 'Tipo de documento',
        placeholder: 'Elige...'
      },
      document_format: {
        label: 'Formato de documento',
        placeholder: 'Elige...'
      },
      gln_buyer: {
        label: 'Buzón físico comprador',
        placeholder: 'Escriba 3 caracteres'
      },
      gln_seller: {
        label: 'Buzón físico vendedor',
        placeholder: 'Escriba 3 caracteres'
      },
      seller: {
        label: 'Vendedor',
        placeholder: 'Escriba 3 caracteres'
      },
      delivery_centre: {
        label: 'Lugar de entrega',
        placeholder: 'Escriba 3 caracteres'
      }
    }
  },

  centres: {
    filters: {
      name: {
        value: 'Nombre',
        placeholder: 'Nombre'
      },
      gln: {
        value: 'Gln',
        placeholder: 'Gln'
      },
      province: {
        value: 'Provincia',
        placeholder: 'Provincia'
      },
      code: {
        value: 'Código',
        placeholder: 'Código'
      },
      mailbox: {
        value: 'Buzón',
        placeholder: 'Buzón'
      },
      centre_type: {
        value: 'Tipo de centro',
        placeholder: 'Tipo',
        buyer: 'Comprador',
        seller: 'Vendedor',
        both: 'Ambos'
      }
    },
    entity_table: {
      name: 'Nombre',
      dateCreationTime: 'Fecha de creación',
      code: 'Código',
      gln: 'GLN',
      town: 'Ciudad',
      province: 'Provincia',
      country: 'País',
      nameCentre: 'Nombre del centro',
      mailbox: 'Buzon',
      siret: 'Identificador internacional',
      siret_tooltip: 'Para Francia hay que introducir el SIRET (14 caracteres)',
      address: 'Dirección',
      postcode: 'C.P',
      centreType: 'Tipo Centro'
    },
    save_changes_notify: 'El centro se ha actualizado correctamente',
    save_changes_load: 'Guardando los datos del centro',
    no_contact_data: 'Este centro no tiene datos de contacto',
    no_aproval_flow_data: 'No existen niveles para este flujo de aprobación',
    save_changes_insert_notify: 'El centro se ha añadido correctamente',
    data_contact_ko: 'No se pueden añadir más contactos de este tipo',
    data_contact_repeat: 'El dato de contacto introducido no es válido,está repetido',
    data_approval_level_repeat: 'El nivel de aprobación introducido ya existe para el usuario',
    data_approval_level_not_valid: 'Existe un nivel de aprobación inferior sin asignar',
    data_approval_level_empty: 'Revisar campos obligatorios del formulario',
    approval_level_delete_not_allowed: 'Existen niveles superiores. Si desea borrar el elemento, registre uno nuevo para este nivel previamente.',
    approval_amount_empty: 'El importe mínimo es obligatorio y debe ser mayor o igual a 0',
    delete_centre: 'Eliminar centro',
    title_delete_user: '¿Desea eliminar el centro?',
    delete_user_ok: 'El centro se ha eliminado correctamente',
    approval_flow: 'Niveles de aprobación',
    title_admin_approval_flow: 'Flujo de aprobación',
    title_admin_approval_flows: 'Flujos de aprobación',
    delete_approval_flow: 'Eliminar flujo',
    confirm_delete_approval_flow: '¿Está seguro de eliminar el flujo de aprobación?',
    cannot_delete_flow_has_levels: 'No puede eliminar el flujo. Primero deberá eliminar los niveles asociados',
    confirm_delete_approval_level: '¿Está seguro de eliminar este nivel de aprobación?',
    centre_approval_level_table: {
      level: 'Nivel',
      user: 'Usuario aprobador',
      notification: 'Notificación al usuario aprobador'
    },

    // Role Centro
    centre_roles: 'Rol de centro',
    no_centre_role: 'Este centro no tiene ningún rol asignado',
    centre_roles_table: {
      name: 'Rol'
    },

    buttons: {
      mass_upload: 'Carga masiva',
      add_centre_role: {
        label: 'Cargar',
        content: 'Añadir rol al centro'
      },
      download_csv_approval_flow_tooltip: 'Exportación CSV de flujos y niveles de aprobación',
      download_csv_approval_flow: 'CSV flujos',
      massive_upload_tooltip: 'Carga masiva de flujos de aprobación',
      massive_upload_button: 'Carga flujos',
      centre_massive_charge: 'Carga masiva',
      centre_massive_tooltip: 'Carga masiva de centros'
    },

    dialog_add_centre_role: {
      title: 'Añadir rol al centro',
      role_type: {
        label: 'Rol de centro',
        placeholder: 'Tipo de rol'
      }
    },

    approval_flow_data: {
      amount: 'Importe mínimo',
      code: 'Código centro',
      description: 'Descripción del flujo de aprobación',
      purchase_order: 'Tener en cuenta campo pedido',
      amountTo: 'Importe máximo'
    },
    centre_massive_charge: {
      title: 'Carga masiva de centros',
      message: 'El fichero debe contener la extensión CSV.'
    },
    approval_flow_massive_charge: {
      title: 'Carga masiva de flujos de aprobación, niveles y usuarios',
      message: 'El fichero debe contener la extensión CSV.'
    },
    dialog_add_approval_level: {
      title: 'Añadir nivel de aprobación',
      level: {
        label: 'Nivel de aprobación',
        placeholder: 'Nivel de aprobación'
      },
      user: {
        label: 'Usuario aprobador',
        placeholder: 'Usuario'
      },
      notification: {
        label: '¿Enviar nofificación pendiente de aprobación?',
        placeholder: 'Sí / No'
      }
    },

    load: {
      add_centre_role: 'Añadiendo rol de centro ...',
      delete_centre_role: 'Eliminando el rol de centro ...',
      text_load_data: 'Cargando datos ...',
      text_load_init_data: 'Cargando datos iniciales ...'
    },

    notify: {
      loadmassive_numlinesOK: 'Número de líneas procesadas correctamente:',
      add_centre_role: 'El rol de centro fue añadido correctamente.',
      delete_centre_role: 'El rol de centro fue eliminado correctamente.',
      error_duplicate_role: 'El rol seleccionado ya está asignado a ese centro'
    }
  },

  users: {
    filters: {
      registration_date: {
        value: 'F-h.registro'
      },
      username: {
        value: 'Usuario',
        placeholder: 'Nombre de usuario'
      },
      complete_name: {
        value: 'Nombre/Apellidos',
        placeholder: 'Nombre',
        placeholder_first_surname: 'Apellido 1',
        placeholder_second_surname: 'Apellido 2'
      },
      trial: {
        value: 'Intentos',
        placeholder: 'N. intentos'
      },
      active: {
        value: 'Activo',
        placeholder: 'Escoge...'
      },
      service_account: {
        value: 'Acceso por servicio',
        placeholder: 'Escoge...'
      },
      last_connection_date: {
        value: 'Fecha ultima conexion',
        placeholder: ''
      },
      identification_number: {
        value: 'N. identificación',
        placeholder: 'N. identificación'
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      party: {
        value: 'Empresa',
        placeholder: 'Empresa'
      },
      party_type: {
        value: 'Tipo de empresa',
        placeholder: 'Tipo'
      },
      is_party_sponsor: {
        value: 'Propietaria de empresa',
        placeholder: 'Escoge...'
      },
      email: {
        value: 'Email',
        placeholder: 'Email'
      }
    },
    error: {
      usuarioKo: 'El usuario {argumento} no existe'
    },
    // - CREATE USER
    createuser: {
      steps: {
        user: 'Usuario',
        data: 'Datos',
        entity: 'Entidades',
        profile: 'Perfiles'
      },
      newuser: {
        title: 'Nuevo Usuario',
        username: 'Usuario',
        email: 'Email',
        success: 'Usuario creado con éxito'
      },
      datauser: {
        title: 'Datos generales del usuario {username}',
        name: 'Nombre',
        firstSurname: 'Primer apellido',
        secondSurname: 'Segundo apellido',
        taxIdentificationNumber: 'Núm.identificación fiscal'
      },
      party: {
        partyTaxIdentificationNumber: 'Núm.identificación fiscal empresa '
      },
      entitiesuser: {
        title: 'Asignación de entidades al usuario {username}'
      },
      profilesuser: {
        title: 'Perfiles del usuario {username}'
      },
      error: {
        userExistsWithDifferentMail: 'El usuario ya existe y está asociado a otra dirección de correo electrónico. Revise la dirección de correo electrónico o solicite otro usuario.',
        usernameExists: 'El nombre de usuario ya existe en el sistema.',
        validation: {
          required: {
            username: "El campo 'Usuario' es obligatorio",
            mail: "El campo 'Email' es obligatorio",
            name: "El campo 'Nombre' es obligatorio",
            first_surname: "El campo 'Primer apellido' es obligatorio",
            partyId: 'El parámetro partyId es obligatorio',
            projectId: 'El parámetro projectId es obligatorio',
            userId: 'El parámetro userId es obligatorio',
            userMediaId: 'El parámetro userMediaId es obligatorio',
            userentities: 'Es obligatorio asignar alguna entidad',
            rolesAuthorities: 'Es obligatorio asignar algún perfil/permiso'
          },
          maxLength_username: 'Longitud máxima del campo "Usuario": 64 caracteres',
          minLength_username: 'Longitud mínima del campo "Usuario": 3 caracteres',
          forbidden_word: "Cambie el 'Usuario'. No puede usar ese valor como usuario",
          format_mail: "'Email' no tiene un formato válido",
          maxLength_mail: 'Longitud máxima del campo "Email": 255 caracteres',
          maxLength_name: 'Longitud máxima del campo "Nombre": 50 caracteres',
          invalid_name: 'El campo "Nombre" no es válido',
          maxLength_first_surname: 'Longitud máxima del campo "Primero apellido": 50 caracteres',
          invalid_first_surname: 'El campo "Primer apellido" no es válido',
          maxLength_TaxID: 'Longitud máxima del campo "Número de identificación fiscal": 20 caracteres',
          exist_TaxID: 'Ya existe un usuario con ese NIF',
          maxLength_second_surname: 'Longitud máxima del campo "Segundo apellido": 50 caracteres',
          invalid_second_surname: 'El campo "Segundo apellido" no es válido',
          not_asociated_project: 'El Proyecto no existe o no está asociado al usuario.',
          not_asociated_user: 'El Usuario no existe o no está asociada al usuario',
          not_asociated_rol: 'El Rol no existe o no está asociado al usuario',
          not_asociated_permission: 'El Permiso no existe o no está asociado al usuario.',
          not_asociated_party: 'La Empresa no existe o no está asociada al usuario.',
          not_exist: 'No existe relacion entre el proyecto y la empresa',
          userEntity_notfound: 'No existe el usuario o no tiene privilegios para ver sus entitades.'
        }
      },
      created: 'El usuario ha sido creado correctamente'
    },

    users_entity_table: {
      username: 'Usuario',
      complete_name: 'Nombre/Apellidos',
      creation_datetime: 'Fecha de alta',
      trail: 'Intentos',
      last_connection_date: 'Última conexión',
      password_expiration_date: 'Fecha caducidad',
      id_number: 'Núm. identificación',
      enable: 'Activo',
      service_account: 'Acceso por servicio',
      email: 'Email',
      what_show: '¿Qué quieres visualizar en la tabla?',
	  service_account_tooltip: 'Marcado: Este usuario es de integración.<br>Desmarcado: Este usuario es de portal',
      enable_tooltip: 'Marcado: Este usuario está activo.<br>Desmarcado: Este usuario está inactivo'
    },
    users_pagination: {
      csv: 'CSV',
      showing: 'Mostrando'
    },
    users_multiple_selection: {
      csv: 'CSV',
      massive_reset: 'Reseteo masivo',
      confirm_massive_reset_title: 'Reseteo masivo de usuarios',
      confirm_massive_reset_message: 'Se van a resetear todos los usuarios seleccionados, ¿Está seguro?'
    },
    users_filters: {
      button_new_user: 'Crear',
      button_reset_users: 'Reseteo masivo',
      button_reset_users_tt: 'Resetear',
      button_mass_usercharge: 'Carga masiva',
      username_placeholder: 'Nombre de usuario',
      filter_form: {
        no_match: 'No hay resultados',
        placeholder_first_value: 'Elige un filtro',
        button_add_filter: 'Cargar'
      }
    },
    user_reset_tooltip: 'Separe los nombres de usuario con punto y coma (;)',
    user_mass_userchargemsg: 'Carga masiva de usuarios. El fichero debe contener la extension CSV.',
    user_upload: 'Seleccionar archivo',
    no_date: 'No hay fecha',
    load: {
      reset_password: 'Reseteando contraseñas ...'
    },
    notify: {
      reset_ok: 'El reseteo se ha producido de forma correcta.'
    },
    massive_upload: {
      username: {
        required: 'El campo usuario es obligatorio',
        maxLength: 'El nombre de usuario excede la longitud máxima permitida',
        forbidden_word: 'No puede usar ese valor para usuario'
      },
      mail: {
        required: 'El campo email es obligatorio',
        novalid: 'Formato de correo electrónico no válido',
        maxLength: 'El email excede la longitud máxima permitida',
        emailKO: 'El email del usuario no se puede modificar. El usuario existe en otros proyectos'
      },
      firstSurname: {
        maxLength: 'El primer apellido excede la longitud máxima permitida',
        invalid: 'El campo Primer apellido no es válido',
        required: 'El campo Primer apellido es obligatorio'
      },
      name: {
        maxLength: 'El nombre excede la longitud máxima permitida',
        invalid: 'El campo Nombre no es válido',
        required: 'El campo Nombre es obligatorio'
      },
      nif: {
        maxLength: 'El NIF excede la longitud máxima permitida',
        exist: 'Ya existe un usuario con el mismo NIF'
      },
      entities: {
        invalid: 'El formato del campo entidades es incorrecto'
      },
      enabled: {
        invalid: 'El campo Activo no es válido'
      },
      parties: {
        required: 'El campo Empresas es obligatorio',
        noexist: 'La empresa no existe'
      },
      error: {
        projectParty: 'La empresa no pertenece al servicio',
        centreParty: 'El centro no pertenece a la empresa'
      },
      centre: {
        noexist: 'El centro no existe'
      },
      rol: {
        required: 'El campo Perfiles es obligatorio',
        noexist: 'El Rol no existe'
      }
    }
  },
  plannedProcesses: {
    filters: {
      group: {
        value: 'Grupo',
        placeholder: 'Grupo'
      },
      name: {
        value: 'Nombre',
        placeholder: 'Nombre'
      },
      description: {
        value: 'Descripción',
        placeholder: 'Descripción'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      jobclass: {
        value: 'Clase ejecución',
        placeholder: 'Clase ejecución'
      }
    },
    plannedProcesses_table: {
      group: 'Grupo',
      name: 'Nombre',
      description: 'Descripción',
      status: 'Estado',
      jobclass: 'Clase ejecución',
      triggerCron: 'Planificación'
    },
    plannedProcesses_button: {
      pause: 'Detiene una tarea',
      resume: 'Arranca una tarea',
      interrupt: 'Interrumpe una tarea',
      pauseAll: 'Pausar',
      resumeAll: 'Reanudar',
      standby: 'En espera',
      shutdown: 'Detener',
      start: 'Iniciar',
      pauseAll_tooltip: 'Detiene todas las tareas',
      resumeAll_tooltip: 'Arranca todas las tareas',
      standby_tooltip: 'Detiene el quartz entero',
      shutdown_tooltip: 'Apaga el quartz, no se puede arrancar luego, solo reiniciando',
      start_tooltip: 'Arranca el quart, después de un STANDBY'
    },
    text1: 'Significado de cada campo: [Segundos] [Minutos] [Horas] [Dia del mes Mes] [Día de la semana] [Año (campo opcional)]',
    text2: 'Las subexpresiones individuales pueden contener rangos (-)  y/o listas (,).',
    text3: 'El carácter "*": "todos" los valores posibles de este campo.',
    text4: 'El carácter "/": especificar incrementos en los valores. Por ejemplo, si coloca "0/15" en el campo Minutos, significa "cada 15 minutos de la hora".',
    text5: 'La "?": para los campos de día del mes y día de la semana, indica "ningún valor específico".'
  },
  mailTemplates: {
    editor: {
      toolbar: {
        bold_tooltip: 'Negrita',
        italic_tooltip: 'Cursiva',
        underline_tooltip: 'Subrayado',
        orderedList_tooltip: 'Lista numerada',
        bulletList_tooltip: 'Lista con viñetas',
        link_tooltip: 'Insertar enlace',
        image_tooltip: 'Insertar imagen',
        showHtml_tooltip: 'Ver/editar HTML',
        undo_tooltip: 'Deshacer',
        redo_tooltip: 'Rehacer',
        alignLeft_tooltip: 'Alinear a la izquierda',
        alignCenter_tooltip: 'Centrar',
        alignRight_tooltip: 'Alinear a la derecha',
        justify_tooltip: 'Justificar',
        outdent_tooltip: 'Reducir sangría',
        indent_tooltip: 'Aumentar sangría',
        sourceCode_tooltip: 'Código fuente',
        preview_tooltip: 'Vista previa',
        table_tooltip: 'Tabla',
        removeFormat_tooltip: 'Borrar formato',
        fontFamily_tooltip: 'Tipo de fuente',
        fontSize_tooltip: 'Tamaño de fuente'
      },
      source: {
        code: 'Código',
        preview: 'Vista previa'
      }
    },
    filters: {
      mailType: {
        value: 'Tipo de correo',
        placeholder: 'Tipo de correo'
      },
      language: {
        value: 'Idioma',
        placeholder: 'Idioma'
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      userHostServer: {
        value: 'Servidor de correo (usuario/from/host)',
        placeholder: 'Servidor de correo (usuario/from/host)'
      }
    },
    mailTemplates_table: {
      userHostServer: 'Servidor de correo (usuario/from/host)',
      mailType: 'Tipo de correo',
      language: 'Idioma',
      project: 'Servicio'
    },
    detail: {
      subject: 'Asunto',
      body: 'Cuerpo del mensaje',
      delete_template: 'Eliminar plantilla',
      delete_template_ok: 'Plantilla eliminada correctamente',
      save_changes: 'Plantilla actualizada correctamente',
      create_template_ok: 'Plantilla creada correctamente',
      confirm: {
        title_delete_template: '¿Estás seguro de querer eliminar esta plantilla?'
      }
    },
    new_template: 'Nueva plantilla',
    create_template: 'Crear plantilla',
    add_template: 'Guardando plantilla',
    clone: {
      title: 'Clonar plantilla',
      label: 'Clonar'
    },
    error: {
      duplicated: 'Ya existe una plantilla para ese tipo de correo, proyecto e idioma',
      notFound: 'Falta rellenar algún campo necesario para realizar la actualización'
    }
  },
  communicationm: {
    filters: {
      id: {
        value: 'Id',
        placeholder: 'Id'
      },
      name: {
        value: 'Nombre',
        placeholder: 'Nombre'
      },
      docTypeName: {
        value: 'Tipo de documento',
        placeholder: 'Tipo de documento'
      },
      enabled: {
        value: 'Activo',
        placeholder: 'Elige...',
        enabled: 'Habilitado',
        disabled: 'Deshabilitado'
      },
      description: {
        value: 'Descripción',
        placeholder: 'Descripción'
      },
      creationDateTimeFrom: {
        value: 'Fecha de creación desde',
        placeholder: 'Fecha de creación desde'
      },
      creationDateTimeTo: {
        value: 'Fecha de creación hasta',
        placeholder: 'Fecha de creación hasta'
      }

    },
    communicationm_table: {
      id: 'Id',
      name: 'Nombre',
      countryReception: 'País de recepción',
      docTypeName: 'Tipo de documento',
      description: 'Descripción',
      creationDateTime: 'Fecha de creación',
      enable: 'Activo',
      disabled: 'Inactivo',
      byCountryEmission: 'Por país de emisión',
    },
    msg_generics: {
      saving: 'Guardando los datos de la comunicación',
      enable: 'Habilitado',
      disable: 'Deshabilitado',
      no_match: 'No se han encontrado coincidencias',
      advanced_search: 'Búsqueda avanzada',
      search: 'Buscar',
      popover_clean_filters: 'Limpiar filtros'
    },
    notify: {
      save_changes: 'El método de comunicación ha sido actualizado',
      error_save_changes: 'El método de comunicación no ha sido actualizado'
    }
  },
  articles: {
    filters: {
      id: {
        value: 'Id artículo',
        placeholder: 'Introduce el id del artículo'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Selecciona vendedores'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Selecciona compradores'
      },
      itemCode: {
        value: 'Código artículo',
        placeholder: 'Introduce el código exacto'
      },
      itemDescription: {
        value: 'Descripción',
        placeholder: 'Introduce la descripción'
      },
      creationDateTimeFrom: {
        value: 'Fecha creación desde',
        placeholder: 'Selecciona fecha inicial'
      },
      creationDateTimeTo: {
        value: 'Fecha creación hasta',
        placeholder: 'Selecciona fecha final'
      },
      futureGrossPriceDate: {
        value: 'Rango fecha cambio de precio',
        placeholder: 'Selecciona rango fecha'
      },
      pendingUpdate: {
        value: 'Pendientes de actualizar',
        placeholder: 'Selecciona una opción'
      },
      enabled: {
        value: 'Activo',
        placeholder: 'Selecciona estado'
      }
    },
    table: {
      seller: 'Vendedor',
      buyer: 'Comprador',
      itemCode: 'Código de artículo',
      itemDescription: 'Descripción',
      grossPrice: 'Precio bruto',
      futureGrossPriceDate: 'F. cambio de precio',
      futureGrossPrice: 'Nuevo precio',
      creationDateTime: 'Fecha de creación',
      enable: 'Activo'
    },
    msg_generics: {
      enabled: 'Habilitado',
      filter_table_menu: 'Menú de columnas',
      popover_clean_filters: 'Limpiar filtros',
      load_init: 'Cargando resultados…',
      order_table: 'Ordenando tabla…',
      size_table: 'Actualizando tamaño de página…',
      pagination_table: 'Cambiando página…',
      saving: 'Guardando cambios…',
      filter_date: 'Filtrando por fecha…',
      filter_delete: 'Eliminando filtro…',
      filter_delete_all: 'Eliminando todos los filtros…',
      no_match: 'Sin coincidencias',
      advanced_search: 'Búsqueda avanzada',
      disabled: 'Deshabilitado'
    },
    notify: {
      save_changes: 'Los cambios se han guardado correctamente',
      error_save_changes: 'Error al guardar cambios',
      no_articles: 'No existen artículos para los criterios de búsqueda indicados',
      updating: 'Actualizando estado...',
      updated: 'El estado se ha actualizado correctamente',
      error_updating: 'Error al actualizar el estado'
    },
    buttons: {
      add_article: 'Añadir',
      article_created: 'Artículo creado correctamente',
      cancel_new_article: 'Cancelar'
    }
  },
  profiles: {
    new: 'Nuevo perfil',
    filters: {
      name: {
        value: 'Perfil',
        placeholder: 'Nombre perfil'
      },
      description: {
        value: 'Descripción',
        placeholder: 'Descripción'
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      }
    },
    notify: {
      add_profile: 'Se ha añadido el perfil',
      delete_profile: 'Perfil eliminado correctamente.',
      save_changes: 'El perfil se ha actualizado correctamente'
    },
    confirm: {
      delete_profile: '¿Estás seguro de eliminar el perfil?'
    },
    load: {
      add_profile: 'Añadiendo perfil ...',
      delete_profile: 'Eliminando perfil ...'
    },
    profiles_table: {
      name: 'Perfil',
      description: 'Descripción',
      project: 'Servicio'
    },
    profiles_auth: {
      name: 'Nombre',
      description: 'Descripción',
      module: 'Módulo'
    }
  },
  form_new_role: {
    new_role: 'Crear nuevo perfil',
    service: 'Servicio',
    role: 'Perfil',
    delete: 'Borrable',
    description: 'Descripción',
    submit: 'Aceptar',
    permisos: 'Permisos',
    dialog: {
      delete: '¿Es borrable?',
      service: 'Elige el servicio',
      permisos: 'Elige los permisos'
    }
  },
  taxes: {
    new: 'Nuevo impuesto',
    filters: {
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      type: {
        value: 'Tipo de impuesto',
        placeholder: 'Tipo impuesto'
      },
      rate: {
        value: 'Tasa',
        placeholder: 'Tasa'
      },
      enabled: {
        value: 'Activo',
        placeholder: 'Escoge...'
      },
      country: {
        value: 'País',
        placeholder: 'País'
      },
      validity_date_from: {
        value: 'Fecha de validez desde',
        placeholder: 'Fecha de validez desde'
      },
      validity_date_to: {
        value: 'Fecha de validez hasta',
        placeholder: 'Fecha de validez hasta'
      },
      legal_text: {
        value: 'Motivo',
        placeholder: 'Motivo'
      },
      taxable_event: {
        value: 'Hecho imponible'
      }
    },
    notify: {
      add_tax: 'Impuesto creado correctamente',
      delete_tax: 'El impuesto ha sido eliminado.',
      save_changes: 'El impuesto ha sido actualizado'
    },
    confirm: {
      delete_tax: '¿Está seguro de eliminar el impuesto?'
    },
    load: {
      add_tax: 'Añadiendo impuesto ...',
      delete_tax: 'Eliminando impuesto ...'
    },
    taxes_table: {
      type: 'Tipo impuesto',
      rate: 'Tasa',
      country: 'País',
      validity_date_from: 'Fecha validez desde',
      validity_date_to: 'Fecha validez hasta',
      enable: 'Activo',
      project: 'Servicio'
    },
    rules_form: {
      validity_date_msg: 'La fecha de validez desde no puede ser posterior a la fecha de validez hasta',
      duplicated_text: 'Valor duplicado. Ya existe el texto legal asociado al impuesto.'
    },
    validity_date: 'Fecha de validez',
    delete_tax: 'Eliminar',
    delete_tax_tooltip: 'Eliminar impuesto',
    no_legalTex: 'Impuesto sin textos legales',
    add_legalText_tooltip: 'Cargar texto legal'
  },
  userInformation: {
    title: 'Información',
    validity_date: 'Periodo de validez',
    message: 'Mensaje',
    message_placeholder: 'Escribe el mensaje a mostrar',
    close: 'Cerrar',
    dont_show_again: 'No volver a mostrar este mensaje',
    rules: {
      message_required: 'Debe introducir un mensaje',
      date_range: 'La fecha de inicio no puede ser posterior a la fecha de fin'
    },
    notify: {
      warning: 'Aviso',
      error: 'Error',
      saved_title: 'Guardado',
      deleted_title: 'Eliminado',
      created: 'Mensaje creado correctamente',
      updated: 'Mensaje actualizado correctamente',
      deleted: 'Mensaje eliminado correctamente',
      load_error: 'No se pudo cargar el mensaje informativo',
      save_error: 'No se pudo guardar el mensaje informativo',
      delete_error: 'No se pudo eliminar el mensaje informativo'
    }
  },
  mailServer: {
    new: 'Nuevo servidor de correo',
    notify: {
      add_mailServer: 'Servidor de correo creado correctamente',
      delete_mailServer: 'Servidor de correo eliminado correctamente.',
      save_changes: 'Servidor de correo actualizado correctamente'
    },
    confirm: {
      delete_mailServer: '¿Está seguro de eliminar el servidor de correo?'
    },
    load: {
      add_mailServer: 'Añadiendo servidor de correo ...',
      delete_mailServer: 'Eliminando el servidor de correo ...'
    },
    mailServer_table: {
      host: 'Host',
      user: 'Usuario',
      password: 'Contraseña',
      mailfrom: 'Dirección de correo origen',
      port: 'Puerto',
      auth: 'Auth',
      idClient: 'Id cliente',
      idTenant: 'Id de la organización',
      clientSecret: 'Secreto del cliente',
      validityDateTo: 'Fecha validez de acceso',
      saveToSentItems: 'Guardar mails enviados',
      protocol: 'Protocolo'
    },
    test_error: 'No fue posible establecer la conexión con el servidor de correo',
    duplicate_error: 'Ya existe un servidor de correo con estos datos',
    test_ok: 'La conexión con el servidor de correo se realizó correctamente',
    auth_error: 'Se produjo un error de autenticación',
    delete_mailServer: 'Eliminar',
    delete_mailServer_tooltip: 'Eliminar servidor de correo',
    test_tooltip: 'Comprobar conexión',
    test: 'Test'
  },
  user_detail: {
    info_user: 'Información usuario',
    new_role: 'Crear perfil',
    user_detail_edit_form: {
      name: 'Nombre',
      first_surname: 'Primer apellido',
      second_surname: 'Segundo apellido',
      id_number: 'Identificador fiscal',
      department: 'Departamento',
      enable: 'Estado inactivo/activo',
      service_account: 'Acceso por servicio',
      reset_otp: 'Resetear OTP'
    },
    delete_user: 'Eliminar',
    delete_user_tooltip: 'Eliminar usuario',
    duplicate_user: 'Duplicar',
    duplicate_user_tooltip: 'Duplicar usuario',
    reset_pass_user: 'Resetear contraseña',
    user_media: 'Datos de contacto',
    no_user_media: 'Este usuario no tiene ningún dato de contacto',
    add_user_media: 'Cargar',
    add_user_media_tooltip: 'Cargar datos de contacto',
    user_media_table: {
      media_type_name: 'Tipo de contacto',
      value: 'Contacto'
    },
    dialog_add_user_media: {
      title: 'Datos de contacto',
      media_type_name: 'Tipo de contacto',
      value: 'Contacto',
      button_add: 'Cargar'
    },
    dialog_change_user_email: {
      title: 'Nuevo correo electrónico',
      old_email: 'Correo electrónico actual',
      new_email: 'Correo electrónico nuevo',
      button_add: 'Actualizar'
    },
    user_entity: 'Entidades de usuario',
    no_user_entity: 'Este usuario no tiene ninguna entidad de usuario',
    add_user_entity: 'Cargar',
    add_user_entity_tooltip: 'Cargar entidad de usuario',
    user_entity_table: {
      project_name: 'Nombre de servicio',
      party_tax_identification_number: 'Empresa/Id fiscal',
      centre_code: 'Código/centro'
    },
    dialog_add_user_entity: {
      title: 'Entidades de usuario',
      project_name: 'Nombre de servicio',
      option_all_project: 'Todos',
      party_tax_identification_number: 'Empresa/Id fiscal',
      option_all_party: 'Todas',
      centre_code: 'Código/centro',
      option_all_centre: 'Todos',
      button_add: 'Cargar'
    },
    roles_authorities: 'Perfiles/Permisos',
    no_user_authorities: 'Este usuario no tiene permisos',
	no_user_authorities_sign: 'Este usuario no tiene permiso sobre esta empresa',
    option_all_project_roles_authorities: 'Todas',
    roles: 'Perfiles',
    authorities: 'Permisos',
    add_new_role: 'Crear',
    save_roles_authorities: 'Guardar',
    add_new_role_tooltip: 'Crear nuevo perfil',
    save_roles_authorities_tooltip: 'Guardar cambios',
    cancel_roles_authorities: 'Cancelar',
    cancel_roles_authorities_tooltip: 'Cancelar cambios',
    load: {
      delete_user_media: 'Eliminando datos de contacto ...',
      add_user_media: 'Añadiendo datos de contacto ...',
      add_user_entity: 'Añadiendo entidad de usuario ...',
      delete_user_entity: 'Eliminando entidad de usuario ...',
      change_roles_user: 'Cambiando permisos del usuario ...',
      init_user_data: 'Cargando los datos del usuario ...',
      change_user_email: 'Actualizando correo electrónico del usuario ...'
    },
    notify: {
      reset_password_ok: 'La nueva contraseña ha sido enviada al email',
      delete_user_media: 'Dato de contacto eliminado correctamente.',
      add_user_media: 'Dato de contacto añadido correctamente.',
      add_role: 'El perfil se ha creado correctamente.',
      add_user_entity: 'Entidad de usuario añadida correctamente.',
      add_user_entity_repeat: 'El usuario ya tiene asignada dicha entidad',
      add_user_entity_validateko: 'La entidad que se va a añadir ya ha sido contemplada previamente',
      delete_user_entity: 'Entidad de usuario eliminada correctamente.',
      delete_user_entityko: 'No se puede eliminar, el usuario debe tener al menos una entidad',
      delete_user_ok: 'Usuario eliminado con éxito',
      save_user_entityko: 'No se pueden guardar los cambios,el usuario debe tener al menos una entidad',
      change_user_email: 'Correo electrónico del usuario actualizado correctamente.',
      reset_otp_ok: 'OTP reseteado correctamente. El usuario deberá configurar su autenticación de doble factor en el próximo acceso.'
    },
    confirm: {
      title_delete_user: '¿Estás seguro de querer eliminar este usuario?',
      message_delete_user: 'Esta acción eliminará toda la información relacionada con el usuario. Se recomienda desactivar al usuario.',
      confirm_button_delete_user: 'Eliminar',
      title_reset_password: '¿Estás seguro de querer cambiar la contraseña de este usuario?',
      confirm_button_reset_password: 'Cambiar',
      title_delete_user_media: '¿Estás seguro de querer eliminar este dato de contacto?',
      confirm_button_delete_user_media: 'Eliminar',
      title_delete_user_entity: '¿Estás seguro de querer eliminar esta entidad de usuario?',
      confirm_button_delete_user_entity: 'Eliminar',
      change_user_email: 'El usuario debe tener un correo electrónico como dato de contacto. Para eliminar el correo actual debe introducir un nuevo correo electrónico.',
      reset_otp_title: '¿Estás seguro de querer resetear el OTP de este usuario?',
      reset_otp_message: 'Esta acción obligará al usuario a volver a configurar su autenticación de doble factor la próxima vez que inicie sesión.',
      confirm_button_reset_otp: 'Resetear OTP',
	  service_account_title: 'Acceso por servicio',
	  service_account_ok_message: 'Este usuario sólo puede acceder por canales de integración.',
  	  service_account_ko_message: 'Este usuario sólo puede acceder por el portal.',
	  service_account_ok: 'Acceso por servicio actualizado'
    }
  },

  // Recepciones emitidas y recibidas
  recadv: {
    number: {
      max: 'El número de recepción no puede superar los 20 caracteres'
    },
    filters: {
      creation_date: {
        value: 'Fecha-hora de registro'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Escriba 3 caracteres'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Escriba 3 caracteres'
      },
      delivery_date: {
        value: 'Rango fechas de entrega',
        placeholder: 'Fechas de entrega'
      },
      reception_date: {
        value: 'Rango fechas de recepción',
        placeholder: 'Fechas de recepción'
      },
      recadv_number: {
        value: 'Nº recepción',
        placeholder: 'Recepción'
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      order_number: {
        value: 'Nº pedido',
        placeholder: 'Pedido'
      },
      delivery_number: {
        value: 'Nº albarán',
        placeholder: 'Albarán'
      },
      invoice_recadv: {
        value: 'Nº factura',
        placeholder: 'Factura'
      }
    },
    recadv_entity_table: {
      buyer: 'Comprador',
      seller: 'Vendedor',
      num_recadv: 'N. recepción',
      date_receiving: 'F. recepción',
      date_creation: 'F. registro',
      status: 'Estado',
      services: 'Servicio',
      invoice_recadv: 'N. factura',
      buyer_centre: 'Centro comprador',
      delivery_centre: 'Lugar de entrega',
      seller_centre: 'Centro vendedor',
      csv_title: 'Exportar a CSV. Información',
      csv_message: 'No se pueden exportar más de {argumento} registros, por favor acote la búsqueda',
      csv_details_message: 'No se pueden exportar líneas de más de 200 documentos, por favor acote la búsqueda',
	  total_amount: 'Importe total',
    },
    recadv_entity_table_detail: {
      code: 'Código artículo',
      lineNumber: 'Nº lin',
      itemCodeSeller: 'Cód. artículo vendedor',
      itemCodeBuyer: 'Cód. artículo comprador',
      description: 'Descripción',
      order: 'Pedido',
      deliveryNoteNumber: 'Albarán',
      deliveryNoteLine: 'Línea albarán',
      despatch_quantity: 'Cantidad anunciada',
      received_quantity: 'Cantidad recibida',
      accepted_quantity: 'Cantidad aceptada',
      measure: 'Unidad de medida',
      price: 'Precio unitario',
      currency: 'Divisa',
      status: 'Estado',
      options: 'Opciones',
      subtype: 'Subtipo'
    },
    recadv_related_documents_table: {
      date: 'Fecha de relación',
      destinationDocument: 'Nº documento',
      destinationDocumentType: 'Tipo documento'
    },
    recadv_detail: {
      create_invoice_buttons: 'Crear',
      activate_recadv_buttons: 'Activar',
      rejected_recadv_buttons: 'Rechazar',
      recadv_line_no_date: 'Esta recepción no tiene líneas',
      related_documents_no_data: 'Esta recepción no tiene documentos relacionados',
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Descargar PDF recepción',
      create_invoice_buttons_tooltip: 'Crear factura',
      activate_recadv_buttons_tooltip: 'Activar recepción',
      rejected_recadv_buttons_tooltip: 'Rechazar recepción',
      rejected_recadv_lineError: 'Linea de descuadre',
      download_pdfmultiple_buttons: 'Descargar',
      download_pdfmultiple_buttons_tooltip: 'Descargar PDF recepción\\s',
      create_line_buttons_tooltip: 'Crear linea de descuadre',
      edit_line_buttons_tooltip: 'Editar linea de descuadre',
      recadv_line_no_data: 'Este pedido no tiene líneas',
      related_documents: 'Documentos relacionados',
      reception_lines: 'Líneas de recepción',
      edit: 'Editar',

      change_state: {
        label: 'Cambio de estado',
        placeholder: 'Elige un estado de recepción',
        load: 'Actualizando datos de la recepción ...'
      },

      dialog_rejected_recadv: {
        title: 'Rechazo de recepción',
        value: 'Motivo',
        placeholder: 'Motivo de rechazo',
        motive_required: 'Motivo obligatorio'
      },

      dialog_new_check_line_recadv: {
        title: 'Nueva linea de recepción',
        title_edit: 'Editar linea de recepción',
        description: 'Descripción artículo',
        quantity: 'Cantidad',
        priceUnit: 'Precio Und.',
        date_required: 'Campo obligatorio',
        measure: 'Medida',
        measureUnit: {
          PCE: 'Piezas',
          KGM: 'Kilogramos',
          MTR: 'Metro lineal',
          TNE: 'Tonelada',
          LTR: 'Litro',
          MTQ: 'Metro cubico',
          DMQ: 'Dcm. cubico',
          CENT: 'Centenas',
          MILL: 'Millares',
          MTK: 'M. cuadrados',
          BOX: 'Caja',
          BOTL: 'Botella',
          NTBK: 'Cuaderno',
          GRM: 'Gramo',
          GRSA: 'Gruesa',
          SHEE: 'Hoja',
          GAME: 'Juego',
          PAR: 'Par',
          OVLL: 'Ovillo',
          CARR: 'Carrete',
          PACK: 'Paquete',
          DOCE: 'Docena',
          K: 'K',
          R: 'R',
          B: 'B',
          UN: 'Unidades'

        },
        search_measure: 'Elija unidad de medida'
      },

      notify: {
        submit_edit_recadv_ok: 'El estado de la recepción se ha modificado correctamente',
        recadv_rejected: 'La recepción se ha rechazado correctamente',
        recadv_activate: 'La recepción se ha activado',
        download_pdf: 'La descarga del fichero {file} fue correcta.',
        recadv_new_line: 'Se ha dado de alta correctamente una nueva linea de descuadre',
        recadv_edit_line: 'Se ha modificado correctamente la linea de descuadre'
      },
      load: {
        recadv_rejected: 'Rechazando recepción',
        recadv_activate: 'Activando recepción'
      },
      confirm: {
        title_recadv_activate: 'La recepción {recadvID}, del proveedor {sellerName}, se va a activar. ¿Desea continuar?',
        confirm_button_recadv_activate: 'Aceptar'
      }
    }
  },
  // Albaranes
  delivery: {
    number: {
      max: 'El número de albarán no puede superar los 30 caracteres'
    }
  },
  // Pedidos emitidas y recibidas
  order: {
    number: {
      max: 'El número de pedido no puede superar los 20 caracteres'
    },
    filters: {
      creation_date: {
        value: 'Fecha de registro'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Escriba 3 caracteres'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Escriba 3 caracteres'
      },
      delivery_date: {
        value: 'Rango fechas de entrega',
        placeholder: 'Fechas de entrega'
      },
      order_date: {
        value: 'Rango fechas de pedido',
        placeholder: 'Fechas de pedido'
      },
      issue_date: {
        value: 'Rango fechas emisión',
        placeholder: 'Fecha emisión'
      },
      order_number: {
        value: 'Nº pedido',
        placeholder: 'Pedido'
      },
      deliveryNote_number: {
        value: 'Nº albarán',
        placeholder: 'Albarán'
      },
      invoice_number: {
        value: 'Nº factura',
        placeholder: 'Factura'
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      invoice_order: {
        value: 'Nº factura',
        placeholder: 'Factura'
      },
      orderType: {
        value: 'Tipo',
        placeholder: 'Tipo de pedido'
      },
      orderSubType: {
        value: 'Subtipo',
        placeholder: 'Subtipo de pedido'
      },
      deliveryDateFrom: {
        value: 'Fecha entrega desde',
        placeholder: 'Fecha entrega desde'
      },
      deliveryDateTo: {
        value: 'Fecha entrega hasta',
        placeholder: 'Fecha entrega hasta'
      },
      no_error_status: {
        value: 'Estados excluidos',
        placeholder: 'Estados excluidos',
        rejected: 'Estados rechazados'
      }
    },
    order_entity_table: {
      buyer: 'Comprador',
      seller: 'Vendedor',
      num_order: 'N. pedido',
      date_creation: 'F. registro',
      date_issue: 'F. emisión',
      status: 'Estado',
      services: 'Servicio',
      invoice_order: 'N. factura',
      buyer_centre: 'Centro comprador',
      seller_centre: 'Centro vendedor',
      delivery_centre: 'Lugar de entrega',
      order_type: 'Tipo',
      delivery_date_from: 'F. entrega desde',
      delivery_date_to: 'F. entrega hasta',
      csv_title: 'Exportar a CSV. Información',
      csv_message: 'No se pueden exportar más de {argumento} registros, por favor acote la búsqueda',
      csv_details_message: 'No se pueden exportar líneas de más de 100 documentos, por favor acote la búsqueda'
    },
    order_entity_table_detail: {
      lineNumber: 'Nº lin',
      itemCode: 'Cód. artículo',
      itemCodeSeller: 'Cód. artículo vendedor',
      itemCodeBuyer: 'Cód. artículo comprador',
      gtin14Code: 'Cód. GTIN14',
      delivery_centre: 'Lugar de entrega',
      quantity: 'Cantidad',
      description: 'Descripción',
      order: 'Pedido',
      despatch_quantity: 'Cantidad anunciada',
      received_quantity: 'Cantidad recibida',
      accepted_quantity: 'Cantidad aceptada',
      measure: 'Unidad de medida',
      unitPrice: 'Precio unitario',
      totalAmount: 'Precio total linea',
      deliveryDate: 'Fecha de entrega',
      documentStatus: 'Estado de la linea',
      currency: 'Divisa',
      status: 'Estado',
      options: 'Opciones',
      notes: 'Notas',
      quantityTradeUnit: 'Cantidad embalaje',
      measureTradeUnit: 'Unidad de medida embalaje',
      netPrice: 'Precio neto',
      grossPrice: 'Precio bruto',
      quantityRemaining: 'Cantidad pendiente',
      change_state: {
        title: 'Cambio de estado de línea pedido',
        label: 'Cambio de estado de línea',
        placeholder: 'Elige un estado de línea',
        load: 'Actualizando líneas del pedido ...'
      }
    },
    order_related_documents_table: {
      date: 'Fecha de relación',
      destinationDocument: 'Nº documento',
      destinationDocumentType: 'Tipo documento'
    },
    order_charges_discounts_table: {
      chargeDiscountTypeCode: 'Descripción',
      charge: 'Tipo',
      charge_code: {
        TD: 'Descuento comercial',
        EAB: 'Descuentos por pronto pago',
        ABH: 'Descuentos por volumen o rappel',
        ACQ: 'Canon sociedad de autores (SGAE)',
        MC: 'Tasa harinas cárnicas',
        VEJ: 'Punto verde',
        AA: 'Cargo por publicidad CTV'
      },
      rate: 'Tasa (en %)',
      baseAmount: 'Base imponible',
      amount: 'Importe',
      currencyCode: 'Divisa',
      sequence: 'Secuencia'
    },
    order_detail: {
      create_invoice_buttons: 'Crear',
      activate_order_buttons: 'Aceptar',
      rejected_order_buttons: 'Rechazar',
      order_line_no_data: 'Este pedido no tiene líneas',
      related_documents_no_data: 'Este pedido no tiene documentos relacionados',
      charge_discounts_no_data: 'Este pedido no tiene cargos ni descuentos',
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Descargar PDF pedido',
      create_invoice_buttons_tooltip: 'Crear factura',
      create_deliveryNote_buttons_tooltip: 'Crear albarán',
      activate_order_buttons_tooltip: 'Aceptar pedido',
      rejected_order_buttons_tooltip: 'Rechazar pedido',
      rejected_order_lineError: 'Linea de descuadre',
      download_pdfmultiple_buttons: 'Descargar',
      download_pdfmultiple_buttons_tooltip: 'Descargar PDF pedido\\s',
      create_line_buttons_tooltip: 'Crear linea de descuadre',
      edit_line_buttons_tooltip: 'Editar linea de descuadre',
      change_line_status_buttons_tooltip: 'Cambiar estado de línea de pedido',
      change_line_status_buttons: 'Cambiar estado',

      order_lines: 'Líneas de pedido',
      related_documents: 'Documentos relacionados',
      charge_discount: 'Cargos y descuentos',
      edit: 'Editar',
      order_reponse: 'Respuestas de pedido',
      order_reponse_download_tooltip: 'Descargar respuesta',
      order_reponse_number: 'Nº Respuesta',
      order_reponse_name: 'Nombre',
      order_reponse_date: 'F. Registro',
      order_response_no_data: 'Este pedido no tiene respuestas',

      dialog_rejected_order: {
        title: 'Rechazo del pedido',
        value: 'Motivo',
        placeholder: 'Motivo de rechazo',
        motive_required: 'Motivo obligatorio'
      },

      dialog_new_check_line_order: {
        title: 'Nueva linea de pedido',
        title_edit: 'Editar linea de pedido',
        description: 'Descripción artículo*',
        quantity: 'Cantidad*',
        priceUnit: 'Precio Und.*',
        date_required: 'Campo obligatorio'
      },

      dialog_accept_order: {
        title: 'Aceptar pedido y generar respuesta',
        orderResponseNumberLabel: 'Número respuesta de pedido'
      },

      change_state: {
        label: 'Cambio de estado',
        placeholder: 'Elige un estado de pedido',
        load: 'Actualizando datos del pedido ...'
      },
      notify: {
        submit_edit_order_ok: 'El estado de pedido se ha modificado correctamente',
        order_rejected: 'El pedido se ha rechazado correctamente',
        order_activate: 'El pedido se ha activado',
        download_pdf: 'La descarga del fichero {file} fue correcta.',
        order_new_line: 'Se ha dado de alta correctamente una nueva linea de descuadre',
        order_edit_line: 'El estado de las líneas de pedido se ha modificado correctamente',
        line_error: 'No pueden seleccionar líneas inválidas para crear la factura'
      },
      load: {
        order_rejected: 'Rechazando pedido',
        order_activate: 'Activando pedido'
      },
      confirm: {
        title_order_activate: 'El pedido {orderID}, del proveedor {sellerName}, se va a activar. ¿Desea continuar?',
        title_order_reject: 'El pedido {orderID}, del proveedor {sellerName}, se va a rechazar. ¿Desea continuar?',
        confirm_button_order_activate: 'Aceptar'
      }
    }
  },
  // reporte de ventas.
  sales_report: {
    number: {
      max: 'El número de reporte no puede superar los 35 caracteres'
    },
    filters: {
      service: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Selecciona un vendedor'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Selecciona un comprador'
      },
      store: {
        value: 'Punto de venta',
        placeholder: 'Selecciona un punto de venta'
      },
      document_number: {
        value: 'Nº reporte',
        placeholder: 'Número de reporte'
      },
      sale_date: {
        value: 'Rango fecha de venta',
        placeholder: 'Selecciona un rango de fecha de venta'
      },
      article_code: {
        value: 'Código de artículo',
        placeholder: 'Código de artículo'
      },
      creation_date: {
        value: 'Fecha de registro'
      }
    },
    sales_report_entity_table: {
      slsrpt_number: 'Nº reporte',
      service: 'Servicio',
      seller: 'Vendedor',
      buyer: 'Comprador',
      centre_buyer: 'Punto de venta',
      issue_date: 'F. emisión',
      creation_date_time: 'F. registro',
      status: 'Estado',
      expiration_date_time: 'F. expiración',
      csv_title: 'Exportar a CSV. Información',
      csv_message: 'No se pueden exportar más de {argumento} registros, por favor acote la búsqueda'
    },
    sales_report_entity_table_detail: {
      lineNumber: 'Nº línea',
      itemCode: 'Código artículo',
      itemDescription: 'Descripción artículo',
      quantitySales: 'Cantidad vendida',
      quantityReturn: 'Cantidad devuelta',
      salesDate: 'F. venta',
      centre_buyer: 'Punto de venta'
    },
    sales_report_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Descargar PDF reporte de ventas',
      sales_report_lines: 'Líneas de reporte de ventas',
      edit: 'Editar',
      related_documents: 'Documentos relacionados',
      related_documents_no_data: 'Este reporte no tiene documentos relacionados',
      sales_report_line_no_data: 'Este reporte no tiene líneas',
      notify: {
        download_pdf: 'La descarga del fichero {file} fue correcta.'
      },
      load: {
        download_pdf: 'Descargando PDF reporte de ventas ...'
      }
    },
    buttons: {
      download_csv_tooltip: 'Descargar CSV',
      download_original_tooltip: 'Descargar custodiado'
    }
  },
  // reporte de inventario.
  inventory_report: {
    number: {
      max: 'El número de reporte no puede superar los 35 caracteres'
    },
    filters: {
      service: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Selecciona un vendedor'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Selecciona un comprador'
      },
      store: {
        value: 'Punto de inventario',
        placeholder: 'Selecciona un punto de inventario'
      },
      document_number: {
        value: 'Nº reporte',
        placeholder: 'Número de reporte'
      },
      quantity_incoming_date: {
        value: 'Rango fecha de inventario',
        placeholder: 'Selecciona un rango de fecha de inventario'
      },
      article_code: {
        value: 'Código de artículo',
        placeholder: 'Código de artículo'
      },
      creation_date: {
        value: 'Fecha de registro'
      }
    },
    inventory_report_entity_table: {
      invrpt_number: 'Nº reporte',
      service: 'Servicio',
      seller: 'Vendedor',
      buyer: 'Comprador',
      centre_buyer: 'Punto de inventario',
      issue_date: 'F. emisión',
      creation_date_time: 'F. registro',
      status: 'Estado',
      expiration_date_time: 'F. expiración',
      csv_title: 'Exportar a CSV. Información',
      csv_message: 'No se pueden exportar más de {argumento} registros, por favor acote la búsqueda'
    },
    inventory_report_entity_table_detail: {
      lineNumber: 'Nº línea',
      itemCode: 'Código artículo',
      itemDescription: 'Descripción artículo',
      quantityTarget: 'Cantidad objetivo',
      quantityIncoming: 'Cantidad devuelta',
      quantityStock: 'Cantidad en stock',
      quantityIncomingDate: 'F. inventario',
      centre_buyer: 'Punto de venta'
    },
    inventory_report_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Descargar PDF reporte de inventario',
      inventory_report_lines: 'Líneas de reporte de inventario',
      edit: 'Editar',
      related_documents: 'Documentos relacionados',
      related_documents_no_data: 'Este reporte no tiene documentos relacionados',
      inventory_report_line_no_data: 'Este reporte no tiene líneas',
      notify: {
        download_pdf: 'La descarga del fichero {file} fue correcta.'
      },
      load: {
        download_pdf: 'Descargando PDF reporte de inventario ...'
      }
    },
    buttons: {
      download_csv_tooltip: 'Descargar CSV',
      download_original_tooltip: 'Descargar custodiado'
    }
  },
  // Traducciones REMADV
  remadv: {
    buttons: {
      download_csv_tooltip: 'Descargar CSV remadv',
      download_original_tooltip: 'Descargar original'
    },
    remadv_entity_table: {
      service: 'Servicio',
      seller: 'Vendedor',
      buyer: 'Comprador',
      invoicee_centre: 'Centro facturado',
      remadv_number: 'Nº aviso de liquidación',
      invoice_number: 'Nº factura',
      issue_date: 'F. emisión',
      document_date: 'F. documento',
      total_amount: 'Importe liquidación',
      currency: 'Divisa',
      creation_date_time: 'F. creación',
      status: 'Estado',
      payment_date: 'F. pago',
      notes: 'Notas'
    },
    lines_remadv_entity_table: {
      line_number: 'Nº línea',
      document_number: 'Nª documento',
      document_date: 'F. emisión',
      description: 'Descripción',
      centre_code: 'Facturador',
      document_amount: 'Total',
      currency: 'Divisa',
      payment_date: 'F. pago',
    },
    remadv_detail: {
      remadv_lines: 'Líneas de aviso de liquidación',
      remadv_line_no_data: 'Este aviso de liquidación no tiene líneas'
    },
    csv_title: 'Exportar a CSV. Información',
    csv_message: 'No se pueden exportar más de {argumento} registros, por favor acote la búsqueda',
    csv_details_message: 'No se pueden exportar líneas de más de 100 documentos, por favor acote la búsqueda',
    filters: {
      service: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Selecciona un vendedor'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Selecciona un comprador'
      },
      centre_payer: {
        value: 'Centro facturado',
        placeholder: 'Selecciona un centro facturado'
      },
      remadv_number: {
        value: 'Nº aviso de liquidación',
        placeholder: 'Nº aviso de liquidación'
      },
      invoice_number: {
        value: 'Número factura',
        placeholder: 'Número factura'
      },
      issue_date: {
        value: 'Rango fecha emisión ',
        placeholder: 'Selecciona un rango de seleccione fecha emisión'
      },
      document_date: {
        value: 'Rango fecha documento ',
        placeholder: 'Selecciona un rango de seleccione fecha documento'
      },
      total_amount_from: {
        value: 'Importe liquidación desde',
        placeholder: 'Importe liquidación desde'
      },
      total_amount_to: {
        value: 'Importe liquidación hasta',
        placeholder: 'Importe liquidación hasta'
      },
      validation: {
        amount_range: 'El importe desde no puede ser mayor que el importe hasta'
      },
      creation_date: {
        value: 'Fecha-hora de registro',
      },
    }

  },
  //Traducciones Coacsu
  coacsu: {
    // Etiquetas de columnas de la tabla
    coacsu_entity_table: {
      service: 'Servicio',
      seller: 'Vendedor',
      buyer: 'Comprador',
      centre_buyer: 'Centro pagador',
      coacsu_number: 'Nº res. cuenta comercial',
      issue_date: 'F. de emisión',
      creation_date_time: 'F. registro',
      total_amount: 'Importe total',
      actions: "Acciones"
    },

    filters: {
      service: { value: 'Servicio', placeholder: 'Servicio' },
      buyer: { value: 'Comprador', placeholder: 'Escriba 3 caracteres' },
      seller: { value: 'Vendedor', placeholder: 'Escriba 3 caracteres' },
      coacsu_number: { value: 'Nº res. cuenta comercial', placeholder: 'Número' },
      invoice_number: { value: 'Nº factura', placeholder: 'Número' },
      issue_date: { value: 'F. emisión', placeholder: '' },
      total_amount_from: {
        value: 'Importe',
        placeholder: 'Importe liquidación desde'
      },
      total_amount_to: {
        value: 'Importe hasta',
        placeholder: 'Importe liquidación hasta'
      },
      creation_date: { value: 'Fecha-hora de registro', placeholder: '' },
    },
    buttons: {
      download_csv_tooltip: 'Descargar CSV',
      download_original_tooltip: 'Descargar original',
      download_csv_details_tooltip: 'Descargar CSV con detalle',
      download_csv_details: 'CSV detalle'
    },
    tooltip: {
      detail: "Ver detalle"
    },
    breadcrumb: {
      coacsu_lines_view: "Resumen de cuenta comercial"
    },
    detail: {
      information: "Información",
      seller: "Vendedor",
      buyer: "Comprador",
      summary_number: "Número de resumen comercial",
      issue_date: "Fecha de emisión",
      delivery_date: "Fecha de entrega",
      additional_data: "Datos adicionales",
      code: "Código",
      name: "Nombre",
      role: "Rol",
      address: "Dirección",
      summary: "Resumen",
      coacsuNumber: "Nº res. cuenta comercial",
      status: "Estado",
      issueDate: "Fecha emisión",
      paymentDate: "Fecha vencimiento",
      lineNumber: "Nº línea",
      invoiceNumber: "Nº documento",
      total: "Total",
      currency: "Moneda",
      no_lines: "Sin líneas",
      lines_title: "Lineas Resumen de cuenta comercial",
      title_emitidos: "Resumen de cuenta comercial emitidos"
      ,
      new_coacsu: {
        seller: "Vendedor",
        buyer: "Comprador",
        summary_number: "Número de resumen comercial",
        issue_date: "Fecha de emisión",
        delivery_date: "Fecha de entrega",
        additional_data: "Datos adicionales"
      }
    },
    dialog_exists: {
      title: 'Ya existe un resumen comercial',
      text: 'La factura {invoice} ya pertenece al resumen comercial {coacsu}. ¿Desea continuar?',
      confirm: 'Continuar'
    }
  },
  cmr: {
    cmr_entity_table_detail: {
      cargo_general_data: 'Mercancía',
      cargo_general_data_tooltip: 'Datos generales de la mercancía',
      sent: 'Enviado',
      deleteAttach: 'Eliminar adjunto',
      general_data: 'Datos generales',
      document_control: 'Documento de Control',
      cmr: 'CMR',
      cmrNumber: 'Nº documento de transporte',
      group: 'Agrupación',
      order: 'Pedido',
      loadparty: 'Cargador',
      shipper: 'Cargador',
      buyer: 'Destinatario',
      seller_centre: 'Lugar de origen',
      buyer_centre: 'Lugar de destino',
      load: 'Lugar de origen',
      loadcode: 'Código de Lugar de origen',
      loaddirection: 'Dirección lugar de origen',
      deliveryparty: 'Destinatario',
      delivery: 'Lugar de destino',
      deliverycode: 'Código de lugar de destino',
      deliverydirection: 'Dirección lugar de destino',
      dateCreation: 'F. registro',
      numpackages: 'Cantidad',
      status: 'Estado',
      service: 'Servicio',
      weight: 'Peso',
      cmrlines: 'Líneas de documento de transporte',
      cmrObservation: 'Observaciones/Incidencias de documento de transporte',
      addObservationTitle: 'Añadir observación/incidencia',
      addObservationOk: 'Añadida correctamente la observación/incidencia al documento de transporte',
      observation: 'Observación/incidencia',
      deleteObservation: 'Eliminar observación/incidencia',
      addLineTitle: 'Añadir línea',
      deleteLineTitle: 'Eliminar línea',
      deleteLine: 'Eliminar línea',
      deleteLineOk: 'Eliminada línea correctamente',
      cannot_delete_last_line: 'No se puede eliminar la última línea',
      must_keep_one_line: 'Debe existir al menos una línea, si desea eliminar esta línea deberá añadir una nueva línea previamente',
      addLineOk: 'Añadida línea correctamente',
      sendlink: 'Enviar',
      sendlink_tooltip: 'Aceptar/Enviar enlace',
      sendlink_ok: 'Enlace enviado correctamente',
      sendlink_confirm: '¿Desea confirmar y enviar el enlace?',
      changeplates: 'Datos de transporte',
      changeplates_tooltip: 'Cambio de Conductor, matrículas y datos de transportista',
      changeplates_confirm: '¿Desea realizar el cambio de matrículas?',
      changeplates_ok: 'Datos actualizados correctamente',
      changeobservations: 'Observaciones/Incidencias',
      changeobservations_tooltip: 'Añadir observación/incidencia',
      changegeneralobservations: 'Observaciones',
      changegeneralobservations_tooltip: 'Cambio de observaciones generales',
      changeobservations_confirm: '¿Desea realizar el cambio de observaciones?',
      changeobservations_ok: 'Observaciones/incidencias actualizadas correctamente',
      updatestatus: 'Estado',
      updatestatus_tooltip: 'Cambio de estado',
      updatestatus_ok: 'Estado actualizado correctamente',
      plate: 'Matrícula vehículo tractor',
      trailerplate: 'Matrícula semirremolque',
      secondTrailerplate: 'Matrícula remolque',
	  id_cmr: 'Id interno',
      cmrnolines: 'Este documento de transporte no tiene líneas',
      cmrnoObservations: 'Este documento de transporte no tiene observaciones/incidencias',
      events: 'Eventos',
      download_attach: 'Descargando adjunto',
      linecode: 'Código',
      linecodeseller: 'Código vendedor',
      download_pdf: 'Descargar PDF',
      download_original: 'Original',
      download_metadata: 'Metadatos',
      download_metadata_tooltip: 'Descargar metadatos',
      line: 'Línea',
      history: 'Histórico de cambios',
      no_history: 'No hay histórico de cambios',
      creation_date: 'Fecha del cambio',
      description: 'Descripción/Naturaleza',
      csv_title: 'Exportar a CSV. Información',
      csv_message: 'No se pueden exportar más de {argumento} registros, por favor acote la búsqueda',
      csv_details_message: 'No se pueden exportar líneas de más de 100 documentos, por favor acote la búsqueda',
      transportist_data: 'Datos del transportista',
      transportist_search: {
        title: 'Buscar transportista',
        col_name: 'Nombre',
        col_nif: 'NIF',
        col_email: 'Email'
      },
      warn_required_fields: 'Datos opcionales en borradores que deben cumplimentarse obligatoriamente antes de enviar el documento al transportista',
      warn_required_fields_stop: 'Esta información es obligatoria si no se incluyen paradas por tratarse de una única entrega',
      charger_observations: 'Observaciones del cargador',
      transportist_observations: 'Observaciones del transportista',
      observation_type: 'Tipo de observación/incidencia',
      transportist_name: 'Transportista',
      transportist_nif: 'NIF del transportista',
      transportist_email: 'Email del transportista/conductor',
      emailTransportist: 'Email del transportista/conductor',
      email_conductor: 'Email transportista/conductor',
      conductor: 'Conductor',
      email_link_note: 'Este es el email al que se enviará el link del pdf',
      observation_type_values: {
        INCIDENCE: 'Incidencia',
        UNPLANNEDSTOP: 'Parada no planificada',
        DELIVERYNOTES: 'Albaranes',
        DELAY: 'Retraso',
        MERCHANDISESTATUS: 'Estado de mercancía',
        OTHER: 'Sin determinar'
      },
      transportist_default: 'Transportista',
      send_date: 'F. envío',
      send_date_long: 'Fecha de envío',
      update_cmr: 'Actualizando datos...',
      submit_edit_ok: 'Datos actualizados correctamente',
      confirm_update_status: '¿Estás seguro de querer cambiar el estado del documento de transporte?',
      confirm_sign_pdf: '¿Está seguro de firmar el PDF?',
      confirm_sign_pdf_ok: 'PDF firmado correctamente',
      confirm_draft: '¿Está seguro de enviar el documento de transporte a borrador?',
      load_signing: 'Firmando PDF ...',
      biometric_signature: {
        title: 'Firma biométrica del documento',
        no_pdf: 'No hay documento PDF para firmar',
        init_error: 'Error al inicializar el sistema de firma',
        error: 'Error durante el proceso de firma',
        saving: 'Guardando documento firmado...',
        success: 'Documento firmado y guardado correctamente'
      },
      send_tosign_tooltip: 'Enviar a firma',
      send_tosign: 'Enviar a firma',
      modify_tooltip: 'Modificar documento de transporte',
      modify: 'Modificar',
      create_ecmr: 'Crear documento de transporte',
      change_state: {
        label: 'Cambio de estado',
        placeholder: 'Elige un estado de documento de transporte',
        load: 'Actualizando datos del documento de transporte ...'
      }
    },
    cmr_event_type: {
      CHANGE_STATUS: 'Cambio de estado',
      CHANGE_STATUS_INI: 'Estado inicial',
      CHANGE_STATUS_END: 'Estado final',
      CHANGE_STATUS_MOTIVE: 'Motivo del cambio de estado',
      CHANGE_STATUS_USER: 'Cambio de estado',
      SEND_MAIL: 'Enviado por correo',
      RECEIVED: 'Recepcionado',
      ISSUED: 'Emitido',
      ASSIGNED_ORDER: 'Pedido asignado',
      DO_NOT_DOWNLOAD: 'No descarga',
      NO_LOAD: 'No carga',
      LOADED_PACKAGE: 'Bulto cargado',
      UNLOADED_PACKAGE: 'Bulto descargado',
      CHANGE_DRIVER: 'Cambio de conductor',
      SEND_PDF: 'Envío de PDF',
      COMMENTS: 'Observaciones',
      INTEGRATION: 'Integración',
      CHANGE_PLATE: 'Cambio de matrículas',
      CHANGE_CARGO: 'Modificación datos generales de mercancía',
      CHANGE_AUTHORIZATION: 'Cambio de autorización',
      CHANGE_SEND_DATE: 'Cambio de fecha de envío',
      CHANGE_OBSERVATIONS: 'Cambio de observaciones/incidencias'
    },
    filters: {
      num_cmr: {
        value: 'Nº documento de transporte',
        placeholder: 'Nº documento de transporte'
      },
      order: {
        value: 'Pedido',
        placeholder: 'Pedido'
      },
      group: {
        value: 'Agrupación',
        placeholder: 'Agrupación'
      },
      date_creation: {
        value: 'F. registro',
        placeholder: 'F. registro'
      },
      vehicle_plate: {
        value: 'Matrícula vehículo tractor',
        placeholder: 'Matrícula vehículo tractor'
      },
      trailer_plate: {
        value: 'Matrícula semirremolque',
        placeholder: 'Matrícula semirremolque'
      },
      second_trailer_plate: {
        value: 'Matrícula remolque',
        placeholder: 'Matrícula remolque'
      },
	  id_cmr: {
        value: 'Id interno',
        placeholder: 'Id interno'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      service: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      sender_party: {
        value: 'Cargador',
        placeholder: 'Escriba 3 caracteres'
      },
      receiver_party: {
        value: 'Destinatario',
        placeholder: 'Escriba 3 caracteres'
      },
      sender_centre: {
        value: 'Lugar de origen',
        placeholder: 'Lugar de origen'
      },
      receiver_centre: {
        value: 'Lugar de destino',
        placeholder: 'Lugar de destino'
      },
      transportist: {
        value: 'Transportista',
        placeholder: 'Transportista'
      },
      send_date: {
        value: 'F. envío',
        placeholder: 'F. envío'
      }
    }
  },
  deliverynote: {
    filters: {
      buyer: {
        value: 'Comprador',
        placeholder: 'Comprador'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Vendedor'
      },
      num_deliverynote: {
        value: 'Nº albarán',
        placeholder: 'Nº albarán'
      },
      date_creation: {
        value: 'F. registro',
        placeholder: 'F. registro'
      },
      date_issue: {
        value: 'Rango fechas emisión',
        placeholder: 'Rango fechas emisión'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      services: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      buyer_centre: {
        value: 'Centro comprador',
        placeholder: 'Centro comprador'
      },
      seller_centre: {
        value: 'Centro vendedor',
        placeholder: 'Centro vendedor'
      },
      delivery_centre: {
        value: 'Lugar de entrega',
        placeholder: 'Lugar de entrega'
      },
      delivery_date: {
        value: 'Rango fechas entrega',
        placeholder: 'Fecha entrega'
      },
      invoice_number: {
        value: 'Nº factura',
        placeholder: 'Factura'
      }
    },
    delivery_entity_table: {
      buyer: 'Comprador',
      seller: 'Vendedor',
      num_deliverynote: 'Nº albarán',
      date_creation: 'F. registro',
      date_issue: 'F. emisión',
      status: 'Estado',
      delivery_type: 'Tipo albarán',
      services: 'Servicio',
      buyer_centre: 'Centro comprador',
      seller_centre: 'Centro vendedor',
      delivery_centre: 'Lugar de entrega',
      delivery_date: 'F. entrega',
      order_number: 'Nº pedido',
      csv_title: 'Exportar a CSV. Información',
      csv_message: 'No se pueden exportar más de {argumento} registros, por favor acote la búsqueda',
      csv_details_message: 'No se pueden exportar líneas de más de 100 documentos, por favor acote la búsqueda'
    },
    delivery_entity_table_detail: {
      lineNumber: 'Nº lin',
      itemCode: 'Cód. artículo',
      itemCodeSeller: 'Cód. artículo vendedor',
      itemCodeBuyer: 'Cód. artículo comprador',
      codeCentreDeliveryPoint: 'Lugar de entrega',
      quantity: 'Cantidad pendiente',
      description: 'Descripción',
      order: 'Número de pedido',
      despatch_quantity: 'Cantidad anunciada',
      received_quantity: 'Cantidad recibida',
      accepted_quantity: 'Cantidad aceptada',
      measure: 'Unidad de medida',
      unitPrice: 'Precio unitario',
      totalAmount: 'Precio total linea',
      documentStatus: 'Estado de la linea',
      serialNumber: 'Número de serie',
      batch: 'Número de lote',
      expirationDate: 'F. caducidad',
      currency: 'Divisa',
      status: 'Estado',
      options: 'Opciones',
      notes: 'Notas',
      quantityTradeUnit: 'Cantidad embalaje',
      measureTradeUnit: 'Unidad de medida embalaje',
      assignedQuantity: 'Cantidad asignada',
      assignedMeasureUnit: 'Unidad de medida asignada',
      netPrice: 'Precio neto',
      grossPrice: 'Precio bruto',
      gtin14Code: 'Cód. GTIN14'
    },
    delivery_related_documents_table: {
      date: 'Fecha de relación',
      destinationDocument: 'Nº documento',
      destinationDocumentType: 'Tipo documento'
    },
    deliverynote_detail: {
      activate_deliverynote_buttons: 'Aceptar',
      rejected_deliverynote_buttons: 'Rechazar',
      deliverynote_line_no_date: 'Este albarán no tiene líneas',
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Descargar PDF albarán',
      activate_deliverynote_buttons_tooltip: 'Aceptar albarán',
      rejected_deliverynote_buttons_tooltip: 'Rechazar albarán',
      rejected_deliverynote_lineError: 'Linea de descuadre',
      related_documents_no_data: 'Este albarán no tiene documentos relacionados',
      source_related_documents: 'Documentos relacionados de origen',
      destination_related_documents: 'Documentos relacionados de destino',
      deliverynote_lines: 'Líneas de albarán',
      edit: 'Editar',
      send_to_draft: 'Borrador',
      send_to_draft_tooltip: 'Enviar a borrador',

      dialog_rejected_deliverynote: {
        title: 'Rechazo del albarán',
        value: 'Motivo',
        placeholder: 'Motivo de rechazo',
        motive_required: 'Motivo obligatorio'
      },

      dialog_new_check_line_deliverynote: {
        title: 'Nueva linea de albarán',
        title_edit: 'Editar linea de albarán',
        description: 'Descripción artículo*',
        quantity: 'Cantidad*',
        priceUnit: 'Precio Und.*',
        date_required: 'Campo obligatorio'
      },
      change_state: {
        label: 'Cambio de estado',
        placeholder: 'Elige un estado de albarán',
        load: 'Actualizando datos del albarán ...'
      },
      notify: {
        submit_edit_deliverynote_ok: 'El estado de albarán se ha modificado correctamente',
        deliverynote_rejected: 'El albarán se ha rechazado correctamente',
        deliverynote_activate: 'El albarán se ha activado',
        deliverynote_new_line: 'Se ha dado de alta correctamente una nueva linea de descuadre',
        deliverynote_edit_line: 'Se ha modificado correctamente la linea de descuadre',
        delivery_point_centre_not_found: 'No se encontró el centro de lugar de entrega indicado'
      },
      load: {
        deliverynote_rejected: 'Rechazando albarán',
        deliverynote_activate: 'Activando albarán'
      },
      confirm: {
        title_deliverynote_activate: 'El albarán {deliveryId}, del proveedor {sellerName}, se va a activar. ¿Desea continuar?',
        title_deliverynote_reject: 'El albarán {deliveryId}, del proveedor {sellerName}, se va a rechazar. ¿Desea continuar?',
        confirm_button_deliverynote_activate: 'Aceptar'
      }
    },
    package_type: {
      TRANSPORT: 'Transporte',
      PALLET: 'Palet',
      HALF_PALLET: 'Medio palet',
      BOX: 'Caja'
    },
    package: {
      invalid: {
        sscc: 'El código SSCC indicado para el embalaje no es válido. Debe estar formado por 18 dígitos.',
        ssccExist: 'El código SSCC indicado para el embalaje no es válido. Ya existe un albarán que contiene ese código SSCC',
        delete: 'No se puede eliminar el embalaje del albarán, porque tiene embalajes o líneas asociadas',
        noLogistic: 'No se puede añadir un embalaje a un albarán de tipo no logístico',
        lineCentreDeliveryPoint: 'No se pueden asociar líneas con diferentes lugares de entrega a un mismo embalaje',
        typeLevel: 'No se puede añadir un embalaje de tipo {argumento} dentro de un embalaje de tipo {argumento1}'
      },
      max: {
        levels: 'El embalaje que se quiere añadir supera el número de máximo de niveles para el albarán'
      },
      all: {
        hasLines: 'Todos los embalajes de último nivel del albarán deben tener al menos una línea asociada',
        linesHasPackage: 'Todas las líneas del albarán deben tener un embalaje asingado'
      },
      line: {
        notFound: {
          package: 'No se encontró el embalaje indicado para la línea del albarán',
          parent: 'No se encontró el embalaje padre indicado para el embalaje de la línea del albarán'
        }
      }
    }
  },
  // Genrals emitidas y recibidas
  genral: {
    filters: {
      creation_date: {
        value: 'Fecha-hora de registro'
      },
      seller: {
        value: 'Receptor',
        placeholder: 'Escriba 3 caracteres'
      },
      buyer: {
        value: 'Emisor',
        placeholder: 'Escriba 3 caracteres'
      },
      delivery_date: {
        value: 'Rango fechas de entrega',
        placeholder: 'Fechas de entrega'
      },
      genral_date: {
        value: 'Rango fechas de genral',
        placeholder: 'Fechas de genral'
      },
      issue_date: {
        value: 'Rango fechas emisión',
        placeholder: 'Fecha emisión'
      },
      description: {
        value: 'Texto',
        placeholder: 'Texto'
      },
      genral_number: {
        value: 'Nº genral',
        placeholder: 'Nº Genral'
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      }
    },
    genral_entity_table: {
      seller: 'Receptor',
      buyer: 'Emisor',
      description: 'Texto',
      num_genral: 'N. genral',
      date_creation: 'F. registro',
      date_issue: 'F. emisión',
      status: 'Estado',
      services: 'Servicio',
      csv_title: 'Exportar a CSV. Información',
      csv_message: 'No se pueden exportar más de {argumento} registros, por favor acote la búsqueda'
    },
    genral_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Descargar PDF genral',
      activate_genral_buttons_tooltip: 'Activar genral',
      rejected_genral_buttons_tooltip: 'Rechazar genral',
      download_pdfmultiple_buttons: 'Descargar',
      download_pdfmultiple_buttons_tooltip: 'Descargar PDF genral\\s',

      edit: 'Editar',
      dialog_rejected_genral: {
        title: 'Rechazo del genral',
        value: 'Motivo',
        placeholder: 'Motivo de rechazo',
        motive_required: 'Motivo obligatorio'
      },

      notify: {
        genral_rejected: 'El genral se ha rechazado correctamente',
        genral_activate: 'El genral se ha activado',
        download_pdf: 'La descarga del fichero {file} fue correcta.'
      },
      load: {
        genral_rejected: 'Rechazando genral',
        genral_activate: 'Activando genral'
      },
      confirm: {
        title_genral_activate: 'El genral {genralID}, del proveedor {sellerName}, se va a activar. ¿Desea continuar?',
        title_genral_reject: 'El genral {genralID}, del proveedor {sellerName}, se va a rechazar. ¿Desea continuar?',
        confirm_button_genral_activate: 'Aceptar'
      }
    }
  },
  document_type: {
    INVOICE: 'Factura',
    PURCHASEORDER: 'Pedido',
    DELIVERYNOTE: 'Albarán',
    RECEIVEADVICE: 'Recepción',
    SALES_REPORT: 'Informe de ventas',
    INVENTORY_REPORT: 'Informe de inventario'
  },
  charge_type: {
    CHARGE: 'Cargo',
    DISCOUNT: 'Descuento'
  },
  // Validaciones genericas
  validations: {
    maxlenght: 'Máximo "{maxlenght}" caracteres',
    minlenght: 'Mínimo "{minlenght}" caracteres',
    required: 'El campo  "{field}" es obligatorio',
    data: {
      VALIDATION_ATTACHMENT_RENFE: 'Adjuntos de Renfe',
      VALIDATION_B2BINVOICEVALIDATION_WS: 'Servicio SOAP del cliente',
      VALIDATION_BUYER: 'Empresa cliente en el proyecto y habilitada',
      VALIDATION_BUYER_CENTRES: 'Centro cliente en la empresa y habilitado',
      VALIDATION_COMMERCIAL_RELATION_CHANNEL: 'Relacion comercial con canal',
      VALIDATION_COMMERCIAL_RELATION: 'Existencia de relación comercial',
      VALIDATION_DOCUMENT_SIGN: 'Firma delegada',
      VALIDATION_DUPLICATION: 'Duplicados',
      VALIDATION_DUPLICATION_ISSUEYEAR: 'Duplicados por año de la emisión',
      VALIDATION_EIFFAGEINVOICEVALIDATION_WS: 'Utilizar servicio web de Eiffage',
      VALIDATION_INTRASTAT_REQUIRED: 'Intracomunidad obligatoria',
      VALIDATION_INVOICE_ACCOUNTING: 'Todas las validaciones contables de la factura',
      VALIDATION_INVOICE_CORRECTIVE: 'Existencia de los datos obligatorios de factura rectificada',
      VALIDATION_INVOICE_CORRECTIVE_MANDATORY: 'Número de factura a la que rectifica obligatorio',
      VALIDATION_INVOICE_TOTAL: 'Total de la factura sin descuentos y sin cargos generales',
      VALIDATION_INVOICE_TOTAL_DISCOUNTS_CHARGES: 'Total de la factura con descuentos y cargos generales',
      VALIDATION_INVOICE_TOTAL_TAXES: 'Impuestos totales igual a la suma de los impuestos',
      VALIDATION_INVOICE_TOTAL_DISCOUNTS_CHARGES_TAXES: 'Total de la factura',
      VALIDATION_INVOICE_TOTALEXECUTABLE: 'Total ejecutable de la factura',
      VALIDATION_INVOICENUMBER_FORMAT: 'Formato de número de factura',
      VALIDATION_ISSUEDATE_FUTURE: 'Fecha de emision no mayor',
      VALIDATION_ISSUEDATE_PAST: 'Fecha de emision no anterior',
      VALIDATION_ISSUER_TYPE: 'Tipo emisor Factura',
      VALIDATION_ISSUER_TYPE_RENFE: 'Tipo emisor Factura para proyecto Renfe',
      VALIDATION_LINE_DESCRIPTION: 'Descripción obligatoria de líneas de factura',
      VALIDATION_LINES_TOTAL: 'Total línea sin impuestos',
      VALIDATION_LINES_TOTAL_DISCOUNTS_CHARGES: 'Total de línea con descuentos y cargos de línea',
      VALIDATION_MODALITY: 'Tipo de factura individual',
      VALIDATION_OPERATION_AND_ISSUE_DATE: 'Fecha de devengo',
      VALIDATION_RECEIVER_CONTRACT: 'Contrato receptor obligatorio',
      VALIDATION_RECEIVER_CONTRACT_FIRSTLINE: 'Contrato receptor obligatorio solo en primera linea o cabecera',
      VALIDATION_RECEIVER_TRANSACTION_FIRSTLINE: 'Receptor del pedido obligatorio solo en primera linea o cabecera',
      VALIDATION_RECEIVER_CONTRACT_FORMAT: 'Formato contrato receptor',
      VALIDATION_RECEIVER_CONTRACT_UNIQUE: 'Contrato receptor unico',
      VALIDATION_RECEIVER_EXP: 'Expediente fileReference obligatorio',
      VALIDATION_RECEIVER_EXP_FIRSTLINE: 'Expediente fileReference obligatorio solo en primera linea o cabecera',
      VALIDATION_RECEIVER_EXP_FORMAT: 'Formato expediente fileReference',
      VALIDATION_RECEIVER_EXP_UNIQUE: 'Expediente fileReference unico',
      VALIDATION_RECEIVER_ORDER: 'Pedido receptor obligatorio',
      VALIDATION_RECEIVER_ORDER_FORMAT: 'Formato del pedido receptor',
      VALIDATION_RECEIVER_ORDER_UNIQUE: 'Pedido receptor único',
      VALIDATION_ISSUER_ORDER: 'Emisor del pedido obligatorio',
      VALIDATION_ISSUER_ORDER_FORMAT: 'Formato del emisor del pedido',
      VALIDATION_ISSUER_ORDER_UNIQUE: 'Emisor del pedido único',
      VALIDATION_RENFE_WS: 'Utilizar servicio web de Renfe',
      VALIDATION_SELLER: 'Existencia empresa proveedora, como proveedora en el proyecto y habilitada',
      VALIDATION_SELLER_BUYER_NOSPONSOR: 'Existencia de una propietaria en el cliente o el proveedor',
      VALIDATION_SELLER_CENTRES: 'Existencia centro proveedor en la empresa, con rol proveedor y habilitado',
      VALIDATION_UNIQUE_CENTRES_BUYER: 'Centros iguales para el comprador. Centro unico',
      VALIDATION_UNIQUE_CENTRES_SELLER: 'Centros iguales para el vendedor. Centro único.',
      VALIDATION_INVOICE_PUBLICORGANISM: 'Órgano Público Proponente – DIR3',
      VALIDATION_LINE_CODE: 'Existencia de código por cada línea',
      VALIDATION_LINE_ORDER_EXIST: 'Existencia en BBDD del pedido registrado',
      VALIDATION_LINE_TRANSACTIONREFERENCE: 'Emisor o receptor del pedido obligatorio',
      VALIDATION_LINE_EXIST: 'Existencia de líneas',
      VALIDATION_CURRENCY_EXCHANGE: 'Tipo de cambio y fecha de tipo de cambio obligatorio si divisa distinta al parámetro',
      VALIDATION_IBAN: 'IBAN obligatorio para Transferencias y Recibos domiciliados',
      VALIDATION_REGISTRATION_DATA: 'Coincidencia de datos del registro mercantil del vendedor con los registrados en B2B',
      VALIDATION_SEQUENCE_NUMBER_BY_ORDER_FORMAT: 'Línea de pedido obligatoria si pedido cumple máscara',
      VALIDATION_CORRECTIVE_SIGN: 'Signo positivo en las facturas con CorrectionMethod igual al parámetro',
      VALIDATION_INVOICE_BUYER_CENTRE: 'Centro receptor obligatorio',
      VALIDATION_INVOICE_CENTRE_MASK: 'Formato máscara de centro',
      VALIDATION_INVOICE_CENTRE_ROL: 'Tipo de rol de centro de la factura',
      VALIDATION_NO_INTEGRATE_REJECTED_INVOICE: 'No integrar factura rechazada',
      VALIDATION_REGISTRATION_DATA_INDRAFE: 'Coincidencia de datos del registro mercantil del vendedor con los registrados en B2B Indrafe',
      VALIDATION_BUYER_CENTRES_ROL: 'Tipo de rol obligatorio en centro comprador',
      VALIDATION_SELLER_CENTRES_ROL: 'Tipo de rol obligatorio en centro vendedor',
      VALIDATION_BUYER_CENTRES_ROL_BYVALUES: 'Centro comprador contiene el rol',
      VALIDATION_SELLER_CENTRES_ROL_BYVALUES: 'Centro vendedor contiene el rol',
      VALIDATION_CENTRE_VOCENTO_WS: 'Personalizada Vocento: validación de centro por servicio web',
      VALIDATION_LINE_DELIVERY_BATCH: 'Existencia de lote por cada línea de albarán',
      VALIDATION_LINE_DELIVERY_SERIAL: 'Existencia de número de serie por cada línea de albarán',
      VALIDATION_LINE_DELIVERY_EXPIRATION: 'Existencia de fecha de caducidad por cada línea de albarán',
      VALIDATION_LINE_DELIVERY_DATES: 'Fecha de caducidad de línea de albarán posterior a la fecha de entrega',
      VALIDATION_SENDATE_FUTURE: 'Fecha de envío debe ser actual o futura',
      VALIDATION_LINE_DELIVERY_QUANTITY: 'La suma de las cantidades de las sublíneas debe ser igual a la cantidad de la línea padre',
      VALIDATION_LINE_DELIVERY_SUBLINE_REQUIRED: 'Existencia de una sublínea por línea de albarán',
      VALIDATION_LINE_DOCUMENT_CANAL: 'Documentos de factura de CYII',
      VALIDATION_VALID_IBAN: 'IBAN de factura',
      VALIDATION_PAYMENT_MEAN: 'Métodos de pago admitidos',
      VALIDATION_FILE_SIZE: 'Tamaño máximo de fichero de entrada',
      VALIDATION_INVOICE_CORRECTIVE_METHOD: 'Métodos de corrección en facturas rectificativas',
      VALIDATION_NIF_CODPAIS: 'Código de país en NIF',
      VALIDATION_LINE_SEQUENCE_NUMBER: 'Número de secuencia/línea único',
      VALIDATION_PARTY_NAME: 'Nombre de la empresa en factura',
      VALIDATION_INVOICE_OPERATIONDATE: 'Fecha de operación sobre la fecha de emisión',
      VALIDATION_INVOICE_INVOICINGPERIOD: 'Fecha final del período de facturacíon sobre la fecha de emisión',
      VALIDATION_INVOICE_WITHHOLDINGAMOUNT: 'Retención en garantía',
      VALIDATION_INVOICE_TRANSACTIONXORCONTRACT: 'Contrato y pedido no se pueden indicar a la vez',
      VALIDATION_INVOICE_CORRECTCONTRACTANDTRANSACTION: 'Recepción y su pedido de la factura exista en el sistema',
      VALIDATION_INVOICE_EURCURRENCY: 'Divisa en euros',
      VALIDATION_INVOICE_IGICINCANARY: 'Impuesto IGIC y dirección en Islas Canarias obligatoria',
      VALIDATION_INVOICE_IPSIINCEUTA: 'Impuesto IPSI y dirección en Ceuta obligatoria',
      VALIDATION_LINE_DELIVERY_PACKAGE_GTIN14: 'Mismo código GTIN14 para todas las líneas asociadas a un embalaje del albarán',
      VALIDATION_INVOICE_ATTACHEDFILESNUMBER: 'Número de adjuntos',
      VALIDATION_INVOICE_ATTACHEDFILESEXTENSION: 'Extensión de archivos adjuntos',
      VALIDATION_INVOICE_TAXESINPROJECT: 'Impuesto y tasa activos en el servicio',
      VALIDATION_INVOICE_FILEFORMAT: 'Formato del fichero de entrada',
      VALIDATION_LINE_TAX0_LEGALTEXT: 'Para impuesto 0 debe informarse un texto legal',
      VALIDATION_CORRECTIVE_ORDERORCONTRACT: 'Pedido o contrato necesario en factura rectificativa',
      VALIDATION_CORRECTIVE_REQUIRED: 'El bloque de rectificación es obligatorio para una factura rectificativa',
      VALIDATION_PARTY_BUYER_ADDRESS_VALUE: 'Dirección del comprador sea igual a lo configurado',
      VALIDATION_SPECIFIC_CANARY: 'Validaciones específicas para facturas de proveedores canarios puros (100% canarios)',
      VALIDATION_SPECIFIC_CEUTA: 'Validaciones específicas para facturas de proveedores de Ceuta puros (100% Ceuta)',
      VALIDATION_PHYSICAL_GLN_REQUIRED: 'Buzón obligatorio para el envío de formatos edi',
      VALIDATION_INVOICE_NOIGICIVA: 'Una factura no puede tener dos impuestos repercutidos diferentes (IVA, IPSI, IGIC)',
      VALIDATION_INVOICE_EXITSPAYMENTDETAILS: 'Que una factura contenga método de pago',
      VALIDATION_LINE_RECADVPRICEQUANTITYPOSITIVE: 'Todas las lineas de un borrador a partir de una recepcion tengan importe y cantidad positiva',
      VALIDATION_LINE_CORRECTIVEPRICENEGATIVE: 'Todas las lineas de un borrador rectificativo tengan precio negativo',
      VALIDATION_INVOICELINES_SAMETAX: 'Que una factura no contenga el mismo impuesto en la misma línea',
      VALIDATION_INVOICELINES_NONEGATIVE: 'Todas las lineas de un borrador tengan importe y cantidad positiva',
      VALIDATION_INVOICE_RECEIVERTRANSACTIONREFERENCE: 'Si existe pedido receptor que venga informado en todas las líneas o en la cabecera',
      VALIDATION_INVOICE_FROMRECADV: 'Existencia de la recepción indicada en la factura',
      VALIDATION_INVOICE_DOCUMENTVALUESFROMRECADV: 'Los documentos de la factura coinciden con los de la recepción',
      VALIDATION_INVOICE_ADDITIONALINFOFROMRECADV: 'Personalizada red.es: validar que la información adicional de la factura contiene propiedades de la recepción',
      VALIDATION_INVOICE_LINEDATAFROMRECADV: 'Información de la línea de la factura en la recepción',
      VALIDATION_CENTRE_PERMANET_ESTABLISHMENT: 'Establecimiento permanente según comprador y vendedor para borradores',
      VALIDATION_INVOICE_ISSUEDATE_REJECTED: 'La fecha de emisión sea la misma que la de otra factura existente negativa',
      VALIDATION_RULES_KOSIT: 'Factura válida mediante KoSIT',
      VALIDATION_RULES_SCHEMATRON: 'Factura válida mediante Schematron'
    }
  },

  error: {
    e400: 'Se produjeron errores de validación sobre la petición.',
    e400_create_invoice: 'Se ha producido un error durante la creación de la factura, contacte con el administrador.',
    e401_login: 'Usuario y/o contraseña incorrectos.',
    e401: 'La sesión ha expirado o el usuario no tiene permisos.',
    e403: 'El usuario no tiene el permiso necesario para realizar esta acción',
    e403_service: 'El usuario no tiene permiso para acceder al servicio',
    e404: 'Archivo no encontrado.',
    e409: 'El medio seleccionado ya existe para el usuario',
    e409_create_invoice: 'Ya existe una factura con este numero de factura para el mismo proveedor',
    e428_login: 'El usuario tiene el doble fator de autenticación activo, introduzca el código',
    e401_two_factor_auth: 'El código ha expirado o es incorrecto',
    e500: 'Se ha producido un error. Contacte con su administrador.',
    e500_user: 'Error creando usuario. Consulte con el administrador.',
    default: 'Error de conexión con el servidor. Inténtelo de nuevo más tarde',
    recadv_rejected: 'No se puede facturar, alguna recepción esta rechazada',
    validation_intrastat_required: 'El campo "C\u00F3digo de mercancia" y "Peso" son obligatorios',
    password_expired: 'Su contraseña ha caducado, debe cambiar su contraseña.',
    file_size: {
      exceeded: 'Tamaño no permitido. El tamaño máximo es de {argumento}'
    },
    invalid_image: 'La imagen está corrupta o es inválida',
    retry: 'Se ha producido un error. Por favor, inténtelo de nuevo más tarde.',
    user: 'No puede eliminar al usuario por estar asociado a procesos en el sistema relacionados con las facturas, deberá deshabilitar al usuario'
  },

  global_error: 'Se ha producido un error. Contacte con su administrador.',
  user_not_found: 'Usuario no encontrado',

  // Paises
  countries: {
    country_AFG: 'Afganist\u00E1n',
    country_ALA: 'Islas Åland',
    country_ALB: 'Albania',
    country_DEU: 'Alemania',
    country_AND: 'Andorra',
    country_AGO: 'Angola',
    country_AIA: 'Anguila',
    country_ATA: 'Ant\u00E1rtida',
    country_ATG: 'Antigua y Barbuda',
    country_SAU: 'Arabia Saudita',
    country_DZA: 'Argelia',
    country_ARG: 'Argentina',
    country_ARM: 'Armenia',
    country_ABW: 'Aruba',
    country_AUS: 'Australia',
    country_AUT: 'Austria',
    country_AZE: 'Azerbaiy\u00E1n',
    country_BHS: 'Bahamas (las)',
    country_BGD: 'Banglad\u00E9s',
    country_BRB: 'Barbados',
    country_BHR: 'Bar\u00E9in',
    country_BEL: 'B\u00E9lgica',
    country_BLZ: 'Belice',
    country_BEN: 'Ben\u00EDn',
    country_BMU: 'Bermudas',
    country_BLR: 'Bielorrusia',
    country_MMR: 'Myanmar',
    country_BOL: 'Bolivia, Estado Plurinacional de',
    country_BIH: 'Bosnia y Herzegovina',
    country_BWA: 'Botsuana',
    country_BRA: 'Brasil',
    country_BRN: 'Brun\u00E9i Darussalam',
    country_BGR: 'Bulgaria',
    country_BFA: 'Burkina Faso',
    country_BDI: 'Burundi',
    country_BTN: 'But\u00E1n',
    country_CPV: 'Cabo Verde',
    country_KHM: 'Camboya',
    country_CMR: 'Camer\u00FAn',
    country_CAN: 'Canad\u00E1',
    country_QAT: 'Catar',
    country_BES: 'Bonaire, San Eustaquio y Saba',
    country_TCD: 'Chad',
    country_CHL: 'Chile',
    country_CHN: 'China',
    country_CYP: 'Chipre',
    country_COL: 'Colombia',
    country_COM: 'Comoras',
    country_PRK: 'Corea (la Rep\u00FAblica Democr\u00E1tica Popular de)',
    country_KOR: 'Corea (la Rep\u00FAblica de)',
    country_CIV: 'Côte dIvoire',
    country_CRI: 'Costa Rica',
    country_HRV: 'Croacia',
    country_CUB: 'Cuba',
    country_CUW: 'Curaçao',
    country_DNK: 'Dinamarca',
    country_DMA: 'Dominica',
    country_ECU: 'Ecuador',
    country_EGY: 'Egipto',
    country_SLV: 'El Salvador',
    country_ARE: 'Emiratos \u00C1rabes Unidos (Los)',
    country_ERI: 'Eritrea',
    country_SVK: 'Eslovaquia',
    country_SVN: 'Eslovenia',
    country_ESP: 'España',
    country_USA: 'Estados Unidos (los)',
    country_EST: 'Estonia',
    country_ETH: 'Etiop\u00EDa',
    country_PHL: 'Filipinas (las)',
    country_FIN: 'Finlandia',
    country_FJI: 'Fiyi',
    country_FRA: 'Francia',
    country_GAB: 'Gab\u00F3n',
    country_GMB: 'Gambia (La)',
    country_GEO: 'Georgia',
    country_GHA: 'Ghana',
    country_GIB: 'Gibraltar',
    country_GRD: 'Granada',
    country_GRC: 'Grecia',
    country_GRL: 'Groenlandia',
    country_GLP: 'Guadalupe',
    country_GUM: 'Guam',
    country_GTM: 'Guatemala',
    country_GUF: 'Guayana Francesa',
    country_GGY: 'Guernsey',
    country_GIN: 'Guinea',
    country_GNB: 'Guinea-Bis\u00E1u',
    country_GNQ: 'Guinea Ecuatorial',
    country_GUY: 'Guyana',
    country_HTI: 'Hait\u00ED',
    country_HND: 'Honduras',
    country_HKG: 'Hong Kong',
    country_HUN: 'Hungr\u00EDa',
    country_IND: 'India',
    country_IDN: 'Indonesia',
    country_IRQ: 'Irak',
    country_IRN: 'Ir\u00E1n (la Rep\u00FAblica Isl\u00E1mica de)',
    country_IRL: 'Irlanda',
    country_BVT: 'Isla Bouvet',
    country_IMN: 'Isla de Man',
    country_CXR: 'Isla de Navidad',
    country_NFK: 'Isla Norfolk',
    country_ISL: 'Islandia',
    country_CYM: 'Islas Caim\u00E1n (las)',
    country_CCK: 'Islas Cocos (Keeling)',
    country_COK: 'Islas Cook (las)',
    country_FRO: 'Islas Feroe (las)',
    country_SGS: 'Georgia del sur y las islas sandwich del sur',
    country_HMD: 'Isla Heard e Islas McDonald',
    country_FLK: 'Islas Malvinas [Falkland] (las)',
    country_MNP: 'Islas Marianas del Norte (las)',
    country_MHL: 'Islas Marshall (las)',
    country_PCN: 'Pitcairn',
    country_SLB: 'Islas Salom\u00F3n (las)',
    country_TCA: 'Islas Turcas y Caicos (las)',
    country_UMI: 'Islas de Ultramar Menores de Estados Unidos (las)',
    country_VGB: 'Islas V\u00EDrgenes (Brit\u00E1nicas)',
    country_VIR: 'Islas V\u00EDrgenes (EE_UU_)',
    country_ISR: 'Israel',
    country_ITA: 'Italia',
    country_JAM: 'Jamaica',
    country_JPN: 'Jap\u00F3n',
    country_JEY: 'Jersey',
    country_JOR: 'Jordania',
    country_KAZ: 'Kazajist\u00E1n',
    country_KEN: 'Kenia',
    country_KGZ: 'Kirguist\u00E1n',
    country_KIR: 'Kiribati',
    country_KWT: 'Kuwait',
    country_LAO: 'Lao, (la) Rep\u00FAblica Democr\u00E1tica Popular',
    country_LSO: 'Lesoto',
    country_LVA: 'Letonia',
    country_LBN: 'L\u00EDbano',
    country_LBR: 'Liberia',
    country_LBY: 'Libia',
    country_LIE: 'Liechtenstein',
    country_LTU: 'Lituania',
    country_LUX: 'Luxemburgo',
    country_MAC: 'Macao',
    country_MDG: 'Madagascar',
    country_MYS: 'Malasia',
    country_MWI: 'Malaui',
    country_MDV: 'Maldivas',
    country_MLI: 'Mal\u00ED',
    country_MLT: 'Malta',
    country_MAR: 'Marruecos',
    country_MTQ: 'Martinica',
    country_MUS: 'Mauricio',
    country_MRT: 'Mauritania',
    country_MYT: 'Mayotte',
    country_MEX: 'M\u00E9xico',
    country_FSM: 'Micronesia (los Estados Federados de)',
    country_MDA: 'Moldavia (la Rep\u00FAblica de)',
    country_MCO: 'M\u00F3naco',
    country_MNG: 'Mongolia',
    country_MNE: 'Montenegro',
    country_MSR: 'Montserrat',
    country_MOZ: 'Mozambique',
    country_NAM: 'Namibia',
    country_NRU: 'Nauru',
    country_NPL: 'Nepal',
    country_NIC: 'Nicaragua',
    country_NER: 'N\u00EDger (el)',
    country_NGA: 'Nigeria',
    country_NIU: 'Niue',
    country_NOR: 'Noruega',
    country_NCL: 'Nueva Caledonia',
    country_NZL: 'Nueva Zelanda',
    country_OMN: 'Om\u00E1n',
    country_NLD: 'Pa\u00EDses Bajos (los)',
    country_PAK: 'Pakist\u00E1n',
    country_PLW: 'Palaos',
    country_PSE: 'Palestina, Estado de',
    country_PAN: 'Panam\u00E1',
    country_PNG: 'Pap\u00FAa Nueva Guinea',
    country_PRY: 'Paraguay',
    country_PER: 'Per\u00FA',
    country_PYF: 'Polinesia Francesa',
    country_POL: 'Polonia',
    country_PRT: 'Portugal',
    country_PRI: 'Puerto Rico',
    country_GBR: 'Reino Unido (el)',
    country_CAF: 'Rep\u00FAblica Centroafricana (la)',
    country_CZE: 'Rep\u00FAblica Checa (la)',
    country_MKD: 'Macedonia (la antigua Rep\u00FAblica Yugoslava de)',
    country_COG: 'Congo',
    country_COD: 'Congo (la Rep\u00FAblica Democr\u00E1tica del)',
    country_DOM: 'Rep\u00FAblica Dominicana (la)',
    country_REU: 'Reuni\u00F3n',
    country_RWA: 'Ruanda',
    country_ROU: 'Rumania',
    country_RUS: 'Rusia, (la) Federaci\u00F3n de',
    country_ESH: 'Sahara Occidental',
    country_WSM: 'Samoa',
    country_ASM: 'Samoa Americana',
    country_BLM: 'San Bartolom\u00E9',
    country_KNA: 'San Crist\u00F3bal y Nieves',
    country_SMR: 'San Marino',
    country_MAF: 'San Mart\u00EDn (parte francesa)',
    country_SPM: 'San Pedro y Miquel\u00F3n',
    country_VCT: 'San Vicente y las Granadinas',
    country_SHN: 'Santa Helena, Ascensi\u00F3n y Trist\u00E1n de Acu\u00F1a',
    country_LCA: 'Santa Luc\u00EDa',
    country_STP: 'Santo Tom\u00E9 y Pr\u00EDncipe',
    country_SEN: 'Senegal',
    country_SRB: 'Serbia',
    country_SYC: 'Seychelles',
    country_SLE: 'Sierra leona',
    country_SGP: 'Singapur',
    country_SXM: 'Sint Maarten (parte holandesa)',
    country_SYR: 'Siria, (la) Rep\u00FAblica \u00C1rabe',
    country_SOM: 'Somalia',
    country_LKA: 'Sri Lanka',
    country_SWZ: 'Suazilandia',
    country_ZAF: 'Sud\u00E1frica',
    country_SDN: 'Sud\u00E1n (el)',
    country_SSD: 'Sud\u00E1n del Sur',
    country_SWE: 'Suecia',
    country_CHE: 'Suiza',
    country_SUR: 'Surinam',
    country_SJM: 'Svalbard y Jan Mayen',
    country_THA: 'Tailandia',
    country_TWN: 'Taiw\u00E1n (Provincia de China)',
    country_TZA: 'Tanzania, Rep\u00FAblica Unida de',
    country_TJK: 'Tayikist\u00E1n',
    country_IOT: 'Territorio Brit\u00E1nico del Oc\u00E9ano \u00CDndico (el)',
    country_ATF: 'Territorios Australes Franceses (los)',
    country_TLS: 'Timor-Leste',
    country_TGO: 'Togo',
    country_TKL: 'Tokelau',
    country_TON: 'Tonga',
    country_TTO: 'Trinidad y Tobago',
    country_TUN: 'T\u00FAnez',
    country_TKM: 'Turkmenist\u00E1n',
    country_TUR: 'Turqu\u00EDa',
    country_TUV: 'Tuvalu',
    country_UKR: 'Ucrania',
    country_UGA: 'Uganda',
    country_URY: 'Uruguay',
    country_UZB: 'Uzbekist\u00E1n',
    country_VUT: 'Vanuatu',
    country_VAT: 'Santa Sede [Estado de la Ciudad del Vaticano] (la)',
    country_VEN: 'Venezuela, Rep\u00FAblica Bolivariana de',
    country_VNM: 'Viet Nam',
    country_WLF: 'Wallis y Futuna',
    country_YEM: 'Yemen',
    country_DJI: 'Yibuti',
    country_ZMB: 'Zambia',
    country_ZWE: 'Zimbabue'
  },

  // Permisos
  authorities: {
    ADMIN_GROUP: 'Administraci\u00F3n de grupos de centros',
    ADMIN_PROFILE: 'Administraci\u00F3n de perfiles',
    ADVANCED_ADMIN_USER: 'Administraci\u00F3n avanzada de usuarios',
    ADVANCED_ADMIN_PARTY: 'Administraci\u00F3n avanzada de empresas',
    ADMIN_USER: 'Administraci\u00F3n de usuarios',
    ADMIN_CERTIFICATE: 'Administraci\u00F3n de certificados',
    ADMIN_DOCUMENTATION: 'Administraci\u00F3n de documentación',
    ADMIN_TAX: 'Administraci\u00F3n de impuestos',
    ADMIN_ARTICLE: 'Administraci\u00F3n de art\u00EDculos',
	  ADMIN_METHODS: 'Administración de métodos de comunicación',
    ADMIN_QUARTZ: 'Administraci\u00F3n de procesos planificados',
    ADMIN_MAP: 'Administraci\u00F3n de mapas',
    ADMIN_GROUP_PARTY: 'Administraci\u00F3n de grupos de empresas',
    ADMIN_CENTRE: 'Administraci\u00F3n de centros',
    ADMIN_PARTY: 'Administraci\u00F3n de empresas',
    ADMIN_PROJECT: 'Administraci\u00F3n de servicio',
    AUDITORY_ACTION: 'Auditor\u00EDa de acciones del usuario o del sistemas',
    AUDITORY_DOCUMENT: 'Auditor\u00EDa de documentos',
    BILLING_MANAGEMENT: 'Facturaci\u00F3n',
    DELETE_INVOICE_ATTACHMENTS: 'Eliminar adjuntos de factura',
    UPLOAD_INVOICE: 'Carga de factura a trav\u00E9s de fichero',
    SEARCH_INVOICE_SALES: 'B\u00FAsqueda de facturas firmadas de ventas',
    SEARCH_INVOICE_PURCHASES: 'B\u00FAsqueda de facturas firmadas de compras',
    SEARCH_REPORT_EMITTED: 'B\u00FAsqueda de reportes emitidos',
    SEARCH_REPORT_RECEIVED: 'B\u00FAsqueda de reportes recibidos',
    SEARCH_INVOICE_THIRD: 'B\u00FAsqueda de facturas de terceros',
    SEARCH_INVOICE_DRAFT: 'B\u00FAsqueda de borradores de factura',
    SEARCH_ACCOUNTING_CLOSE: 'Consulta de cierres contables',
    SEARCH_INVOICE_SENDER: 'B\u00FAsqueda de facturas firmadas enviadas',
    ADD_INVOICE_ATTACHMENTS: 'Añadir adjuntos a la factura',
    SEARCH_INVOICE_RECEIVER: 'B\u00FAsqueda de facturas firmadas recibidas',
    VIEW_INVOICE_PDF: 'Ver PDF de factura',
    VIEW_INVOICE_ATTACHMENT: 'Ver adjuntos de factura',
    VIEW_INVOICE_EVENTS: 'Ver eventos de factura',
    VIEW_INVOICE_DOCUMENTS: 'Ver documentos de cabecera en borradores',
    GET_PAYMENT_DATA: 'Consultar datos de pago/cobro de la factura',
    CHANGE_INVOICE_STATUS: 'Cambio de estado de factura',
    SEARCH_ISSUE: 'B\u00FAsqueda de incidencias',
    CREATE_ISSUE: 'Creaci\u00F3n de incidencia',
    STATISTICS_MANAGEMENT: 'Estad\u00EDsticas',
    UPDATE_ISSUE: 'Actualizar estado de incidencia',
    ADD_ISSUE: 'Creaci\u00F3n de incidencias',
    DELETE_ISSUE: 'Eliminar incidencias',
    DOWNLOAD_INVOICE_WS: 'Descarga de facturas por servicio web',
    INTEGRATION_INVOICE_WS: 'Integraci\u00F3n de facturas por servicio web',
    SEARCH_STATUS_INVOICE_WS: 'Consulta de estados de facturas por servicio web',
    ADMIN_DELIVERY_METHODS: 'Administraci\u00F3n de par\u00E1metros de entrega',
    CANCEL_INVOICE: 'Solicitar anulación de factura',
    COPY_INVOICE: 'Copiar factura',
    CREATE_PROJECT: 'Creaci\u00F3n de servicio',
    CREATE_PARTY: 'Creaci\u00F3n de empresas',
    MODIFY_PROJECT: 'Modificar servicio',
    PROJEC_DELIVERY_METHOD: 'Gesti\u00F3n de m\u00E9todos de entrega de servicio',
    PARTY_DELIVERY_METHOD: 'Gesti\u00F3n de m\u00E9todos de entrega de empresa',
    PARAMS_DELIVERY_METHOD: 'Gesti\u00F3n de par\u00E1metros de entrega',
    CREATE_CENTRE: 'Creaci\u00F3n de centros',
    FORWARD_INVOICE_EMITTED: 'Reenvío de factura emitida',
    FORWARD_INVOICE_RECEIVED: 'Reenvío de factura recibida',
    CREATION_PARTY_WS: 'Creaci\u00F3n de empresas',
    UPDATE_PARTY_WS: 'Actualizaci\u00F3n de empresas',
    ADMIN_USER_WS: 'Administraci\u00F3n de usuarios',
    CREATION_USER_WS: 'Creaci\u00F3n de usuarios',
    UPDATE_USER_WS: 'Modificaci\u00F3n de usuarios',
    REMOVE_USER_WS: 'Eliminaci\u00F3n de usuarios',
    UNLOCK_USER_WS: 'Desbloqueo de usuarios',
    RESET_USER_WS: 'Reseteo de usuarios',
    DRAFT_ACCOUNTING_CLOSE: 'Borradores de cierres contables',
    CREATE_GROUP: 'Creaci\u00F3n de grupos de centros',
    ADMIN_INDRA: 'Administraci\u00F3n de Indra',
    SEARCH_ACCOUNTING_CLOSE_DRAFT: 'B\u00FAsqueda de borradores cierre',
    CHECK_STATUS: 'Consulta de estados online',
    SEARCH_PENDING_TASKS: 'Consulta de tareas pendientes',
    CONSULT_DOCUMENTATION: 'Consultar documentaci\u00F3n',
    CONSULT_SIGNDOCUMENT: 'Consultar documentos de firma delegada',
    UPLOAD_SIGNDOCUMENT: 'Subir documentos de firma delegada',
    DELETE_SIGNDOCUMENT: 'Eliminar documentos de firma delegada',
    CREATE_COVER: 'Crear reiniciar car\u00E1tula',
    SEARCH_RECADV_SENDER: 'Consultar recepciones emitidas',
    SEARCH_RECADV_RECEIVER: 'Consultar recepciones recibidas',
    INVOICE_VALIDATION_WS: 'Validaci\u00F3n de facturas por servicio web',
    CHANGE_INVOICE_STATUS_WS: 'Modificar estado de la factura por servicio web',
    VIEW_INVOICE_BY_LINK: 'Visualizaci\u00F3n de factura mediante enlace externo',
    REJECT_RECADV: 'Rechazar recepciones',
    MODIFY_RECADV: 'Modificar recepciones',
    RECADV_CREATE_INVOICE: 'Crear factura a partir de recepciones',
    RECADV_CREATE_INVOICE_PARCIAL: 'Crear factura a partir de recepciones parciales',
    SEARCH_ORDER_SENDER: 'Consultar pedidos emitidos',
    SEARCH_ORDER_RECEIVER: 'Consultar pedidos recibidos',
    SEARCH_GENRAL_SENDER: 'Consultar genrals emitidos',
    SEARCH_GENRAL_RECEIVER: 'Consultar genrals recibidos',
    SEARCH_SALES_REPORT_VIEW: 'Consultar Reporte de ventas',
    SEARCH_INVENTORY_REPORT_VIEW: 'Consultar Reporte de inventario',
    MULTIPLE_CHANGE_STATUS: 'Cambio múltiple de estado en tareas pendientes',
    SEARCH_DELIVERY_SENDER: 'Consultar albaranes emitidos',
    SEARCH_DELIVERY_RECEIVER: 'Consultar albaranes recibidas',
    EDIT_INVOICE_DATA: 'Editar metadatos de la factura',
    EDIT_INVOICE_NOTE: 'Editar notas de la factura',
    EDIT_CARRIER_CMR: 'Editar datos de transportista en documento de transporte',
    EDIT_CHARGER_CMR: 'Editar datos de cargador en documento de transporte',
    EDIT_CENTRE_PERMANENT_ESTABLISHMENT: 'Modificar y borrar centros con establecimiento permanente',
    ADMIN_APPROVAL_FLOW_BY_LEVELS: 'Administración del flujo de aprobación por niveles y usuarios',
    USER_APPROVAL_FLOW_BY_LEVELS: 'Aprobar, rechazar y enviar facturas en el flujo de aprobación por niveles y usuarios',
    SEARCH_OCR_DOCUMENTS: 'Consulta de documentos OCR pendientes de validar',
    VIEW_INVOICE_NOTE: 'Ver notas de la factura',
    VIEW_ADMINISTRATIVE_CENTRES: 'Ver columnas de centros administrativos',
    VIEW_DISTRIBUTION_CENTRES: 'Vista de distribución en selección de centros',
    DOWNLOAD_DOCUMENT_WS: 'Descarga de documentos por servicio web',
    UPDATE_DOCUMENT_WS: 'Actualizar documento por servicio web',
    CREATE_INVOICE_DRAFT: 'Crear borrador de factura',
    ATTACHMENT_HIDDEN: 'Adjunto no visible',
    VIEW_REQUEST_REDIGITALIZATION: 'Solicitud redigitalizaci\u00F3n',
    VIEW_INVALID_INVOICE_COLOR: 'Ver estado negativo en color rojo',
    SEARCH_CHANNEL: 'Consultar por Canales',
    VIEW_COMERCIAL_RELATION: 'Ver relaciones comerciales',
    VIEW_RELATION_CHANNEL: 'Ver relaciones comerciales con canal',
    CREATE_COMERCIAL_RELATION: 'Crear relaciones comerciales',
    CHANGE_MASTER_DATA: 'Cambiar datos maestros',
    CHANGE_ROLE: 'Cambiar rol',
    NO_EDIT_DATA_USER: 'Usuario de datos sin edici\u00F3n',
    SIGNATURE_DELEGATION: 'Delegaci\u00F3n de firma',
    CHANGE_STATUS_PENDINGTASKS: 'Cambio de estados pendientes',
    CHANGE_STATUS_ORDER: 'Cambio de estado de un pedido',
    CHANGE_STATUS_DELIVERYNOTE: 'Cambio de estado de un albarán',
    CHANGE_STATUS_RECADV: 'Cambio de estado de una recepción',
    VIEW_INVOICE_BPM_EVENTS: 'Ver eventos de BPM de factura',
    CHANGE_STATUS_RECADV_WS: 'Cambio de recepciones por servicio web',
    CHECK_STATUS_RECADV_WS: 'Verificar estado de recepciones por servicio web',
    INTEGRATION_RECADV_WS: 'Integraci\u00F3n de recepciones por servicio web',
    INTEGRATION_ORDER_WS: 'Integraci\u00F3n de pedidos por servicio web',
    VIEW_METADATA: 'Ver metadatos',
    VIEW_ORDER_METADATA: 'Ver metadatos de pedidos',
    VIEW_RECADV_METADATA: 'Ver metadatos de recepciones',
    VIEW_ORDER_ORIGINAL: 'Ver original de pedidos',
    VIEW_RECADV_ORIGINAL: 'Ver original de recepciones',
    VIEW_DESADV_METADATA: 'Ver metadatos de albaranes',
    VIEW_DESADV_ORIGINAL: 'Ver original de albaranes',
    ORDER_CREATE_INVOICE: 'Crear factura a partir de pedidos',
    ORDER_CREATE_DELIVERY_NOTE: 'Crear un albarán desde un pedido',
    CREATE_INVOICE_FROM_DELIVERY_NOTE: 'Crear factura desde un albarán',
    VIEW_BANK_DATA: 'Ver datos bancarios',
    DOWNLOAD_DELIVERY_NOTE_WS: 'Descarga de albaranes por servicio web',
    DOWNLOAD_INVOIC_FORMATTED: 'Descarga del custodiado formateado',
    RECADV_ATTACH: 'Permitir adjuntos en recepciones',
    CHANGE_PARTY_MEDIA: 'Modificar datos de contacto de empresa',
    VIEW_CMR: 'Visualizar documento de transporte',
    CREATE_CMR_DRAFT: 'Crear documento de transporte',
    VIEW_CMR_DRAFT_SELLER_CENTRES: 'Visualizar centros vendedores en borrador de documento de transporte',
    VIEW_CMR_DRAFT_BUYER_CENTRES: 'Visualizar centros compradores en borrador de documento de transporte',
    CREATE_INVOICE_FROM_RECADV: 'Permite rellenar determinados campos al crear la factura desde la recepción',
    CHANGE_CENTRE_ROLE: 'Cambiar roles de centros',
    MODIFY_PAYMENT_METHODS: 'Modificar métodos de pago de empresas',
    CREATE_CORRECTIVE_INVOICE: 'Creación de factura rectificativa a partir de factura emitida',
    NO_VIEW_INVOICE_SERIES_CODE: 'No acceso a número de serie',
    TOTAL_IRPF: 'IRPF en totales de factura',
    NO_VIEW_RECADV_PDF: 'No acceso a pdf de recepción',
    ADD_BUYER_CENTRE: 'Añadir centro comprador',
    VIEW_MENU: 'Ver opciones de menú y miga de pan',
    VIEW_SALES_REPORT_ORIGINAL: 'Ver original de reporte de ventas',
    VIEW_SALES_REPORT_METADATA: 'Ver metadatos de reporte de ventas',
    VIEW_INVENTORY_REPORT_ORIGINAL: 'Ver original de reporte de inventario',
    VIEW_INVENTORY_REPORT_METADATA: 'Ver metadatos de reporte de invetario',
    SEARCH_REMADV_VIEW: 'Consulta aviso de liquidación',
    VIEW_REMADV_ORIGINAL: 'Ver original de aviso de liquidación',
    VIEW_REMADV_METADATA: 'Ver metadatos de aviso de liquidación',
    SEARCH_COACSU_VIEW: 'Consulta relación de entregas',// cambiarlo a search coacsu receiver
    VIEW_COACSU_ORIGINAL: 'Ver original de relación de entrega',
    VIEW_COACSU_METADATA: 'Ver metadatos de relación de entrega',
    SEARCH_COACSU_RECEIVER: 'Consulta relación de entregas recibidas',//la que ya tenemos
    SEARCH_COACSU_SENDER: 'Consulta relación de entregas emitidas',
    CREATE_COACSU: 'Crear resumen de cuenta comercial'
  },
  authorities_module: {
    INVOICE: 'Facturas',
    ADMIN: 'Administraci\u00F3n',
    AUDITORY: 'Auditoría',
    BILLING: 'Facturación',
    ISSUE: 'Incidencias',
    STATISTICS: 'Estadísticas',
    WEBSERVICE: 'Servicio web',
    GROUP: 'Grupo centro',
    DOCUMENTATION: 'Documentaci\u00F3n',
    RECADV: 'Recepción',
    PURCHASEORDER: 'Pedido',
    ORDERRSP: 'Respuesta de Pedido',
    DELIVERY: 'Albarán',
    GENRAL: 'Genral',
    GENERAL: 'Genral note',
    CMR: 'DeCA',
    SALESREPORT: 'Informe de ventas',
    INVENTORYREPORT: 'Informe de inventario',
    COACSU: 'Resumen cuenta comercial',
    REMADV: 'Aviso de liquidación'
  },
  auditaction: {
    create: 'Creaci\u00F3n',
    update: 'Actualizaci\u00F3n',
    delete: 'Borrado',
    resend: 'Reenv\u00EDo',
    reprocess: 'Reproceso',
    updateStatus: 'Actualizaci\u00F3n del estado',
    sendInvoice: 'Env\u00EDo de factura',
    cancel: 'Anulaci\u00F3n',
    demand: 'Solicitud',
    checkStatus: 'Consulta estado',
    sendData: 'Env\u00EDo de datos',
    reject: 'Rechazo',
    send: 'Envío'
  },
  functionalGroup: {
    ROLE: 'Perfiles',
    PROJECT: 'Proyecto',
    PARTY: 'Empresa',
    CENTRE: 'Centro',
    USER: 'Usuario',
    TAXES: 'Impuestos',
    ISSUE: 'Incidencias',
    CERTIFICATE: 'Certificados',
    EMAIL: 'Personalizar correo electr\u00F3nico',
    DOCUMENTATION: 'Documentacion',
    INVOICE: 'Factura',
    ORDER: 'Pedido',
    GENRAL: 'Genral',
    DELIVERYNOTE: 'Albarán',
    RECADV: 'Recepción',
    ORDERRSP: 'Respuesta de Pedido',
    CMR: 'DeCA',
    COMMUNICATION_METHOD: 'Método de entrega'
  },

  // Tipos de medio de contacto
  mediaType: {
    email: 'Correo electrónico',
    telefono_fijo: 'Teléfono fijo',
    telefono_movil: 'Teléfono móvil',
    telefono_trabajo: 'Teléfono de trabajo',
    fax: 'Fax',
    email_to_report_issued: 'Envío de informes',
    contact_person: 'Persona de contacto'
  },

  // Impuestos
  adminTaxes: {
    tax: {
      VAT: 'IVA',
      IGIC: 'IGIC',
      IGI: 'IGIC',
      EXT: 'EXT',
      ENV: 'ENV',
      IRPF: 'IRPF',
      IPSI: 'IPSI',
      ITPAJD: 'ITPAJD',
      IE: 'IE',
      ICIO: 'ICIO',
      IPS: 'IPS',
      RLEA: 'RLEA',
      IGFEI: 'IGFEI',
      Otros: 'Otros',
      Ra: 'Renta aduanas',
      IGTECM: 'IGTECM',
      IECDPCAC: 'IECDPCAC',
      IMVDN: 'IMVDN',
      IMSN: 'IMSN',
      IMGSN: 'IMGSN',
      IMPN: 'IMPN',
      REIVA: 'REIVA',
      REIGIC: 'REIGIC',
      REIPSI: 'REIPSI',
      IVPEE: 'IVPEE',
      IPCNG: 'IPCNG',
      IACNG: 'IACNG',
      IDEC: 'IDEC',
      ILTCC: 'ILTCC',
      IRNR: 'IRNR',
      ISS: 'ISS',
      IIIMAB: 'IIIMAB',
      OTH: 'OTH',
      ITRT01: 'RT01',
      ITRT02: 'RT02',
      ACT: 'ACT'
    }
  },

  tax_type: {
    VAT: 'Impuesto de Valor Añadido',
    IGIC: 'Impuesto General Indirecto Canario',
    EXT: 'Exento',
    ENV: 'Impuesto ambiental',
    IRPF: 'Impuesto sobre la Renta de las Personas Físicas',
    IPSI: 'Impuesto sobre la producción, los servicios y la importación',
    IGI: '@:tax_type.IGIC',
    ITPAJD: 'Impuesto sobre transmisiones patrimoniales y actos jurídicos documentados',
    IE: 'Impuestos especiales',
    ICIO: 'Impuesto sobre las construcciones, instalaciones y obras',
    IPS: 'Impuesto sobre la producción, los servicios y la importación',
    RLEA: 'Recargo destinado a financiar las funciones de liquidación de entidades aseguradoras',
    IGFEI: 'Impuesto sobre los Gases Fluorados de Efecto Invernadero',
    Otros: 'Otros',
    Ra: 'Renta aduanas',
    IGTECM: 'Impuesto general sobre el tráfico de empresas que se aplica en Ceuta y Melilla',
    IECDPCAC: 'Impuesto especial sobre los combustibles derivados del  petróleo en la Comunidad Autonoma Canaria',
    IIIMAB: 'Impuesto sobre las instalaciones que inciden sobre el medio ambiente en las Baleares',
    IMVDN: 'Impuesto municipal sobre las viviendas desocupadas en Navarra',
    IMSN: 'Impuesto municipal sobre solares en Navarra',
    IMGSN: 'Impuesto municipal sobre gastos suntuarios en Navarra',
    IMPN: 'Impuesto municipal sobre publicidad en Navarra',
    REIVA: 'Régimen especial de IVA para agencias de viajes',
    REIGIC: 'Régimen especial de IGIC: para agencias de viajes',
    REIPSI: 'Régimen especial de IPSI para agencias de viajes',
    IVPEE: 'Impuesto sobre el valor de la producción de la energía eléctrica',
    IPCNG: 'Impuesto sobre la producción de combustible nuclear gastado y residuos radiactivos resultantes de la generación de energía nucleoeléctrica',
    IACNG: 'Impuesto sobre el almacenamiento de combustible nuclear gastado y residuos radioactivos en instalaciones centralizadas',
    IDEC: 'Impuesto sobre los Depósitos en las Entidades de Crédito',
    ILTCC: 'Impuesto sobre las labores del tabaco en la Comunidad Autónoma de Canarias',
    IRNR: 'Impuesto sobre la Renta de No Residentes',
    ISS: 'Impuesto sobre Sociedades',
    ITRT01: 'Impuesto fatturapa RT01',
    ITRT02: 'Impuesto fatturapa RT02',
    OTH: 'OTH',
    ACT: 'Impuesto sobre el alcohol'
  },

  // Recepciones estados
  recadv_status: {
    RECEIVED: 'Recibida',
    REJECTED: 'Rechazada',
    REJECTED_SELLER: 'Rechazada Proveedor',
    ERROR: 'Error',
    FULLY_INVOICED: 'Facturado totalmente',
    PARTIALLY_INVOICED: 'Facturado parcialmente',
    ORIGINAL: 'Original',
    MODIFIED: 'Modificada'
  },
  // Recepciones subtype
  recadv_subtype: {
    GOODS: 'Materiales',
    SERVICES: 'Servicios'
  },
  // Pedidos estados
  order_status: {
    RECEIVED: 'Recibido',
    REJECTED: 'Rechazado',
    ACCEPTED: 'Aceptado',
    REJECTED_SELLER: 'Rechazado Proveedor',
    ERROR: 'Error',
    FULLY_INVOICED: 'Facturado totalmente',
    PARTIALLY_INVOICED: 'Facturado parcialmente',
    ORIGINAL: 'Original',
    MODIFIED: 'Modificado',
    DISPATCHED: 'Expedido',
    PARTIALLY_SENT: 'Expedido parcialmente',
    FULLY_SENT: 'Expedido totalmente'
  },

  order_type: {
    ORDER: 'Normal',
    BLANKET_ORDER: 'Comercial',
    RUSH_ORDER: 'Urgente',
    CONSIGNMENT_ORDER: 'En consigna',
    CROSS_DOCKING_ORDER: 'Cross-docking',
    INFO: 'Informativo'
  },

  // Subtipos de pedido
  order_subtype: {
    INVOICED_NOT_REPLENISHED: 'Facturar no reponer',
    FULL_DELIVERY: 'Facturar completo',
    REPLENISHED_NOT_INVOICED: 'Reponer no facturar',
    REPLENISHED_INVOICED: 'Reponer y facturar'
  },

  // Genral estados
  genral_status: {
    RECEIVED: 'Recibido',
    REJECTED: 'Rechazado',
    ACCEPTED: 'Aceptado',
    REJECTED_SELLER: 'Rechazado Proveedor',
    ERROR: 'Error',
    FULLY_INVOICED: 'Facturado totalmente',
    PARTIALLY_INVOICED: 'Facturado parcialmente',
    ORIGINAL: 'Original',
    MODIFIED: 'Modificado'
  },
  party_gln_type: {
    GLN: 'GLN',
    EAS: 'EAS',
    SIREN: 'SIREN',
    SIRET: 'SIRET',
	ENDPOINTID: 'ENDPOINTID'
  },
  // Metodos de entrega y recepcion
  communication_method: {
    INDRAFIN: 'Indra financieras',
    ALAVA: 'DF Alava',
    ANDALUCIA: 'Junta Andalucia',
    AOC: 'AOC',
    CANARIAS: 'Canarias',
    DIPUTACION_VIZCAYA: 'DF Vizcaya',
    EMAIL: 'Email',
    EMAIL_PDF: 'Email PDF',
    FACE: 'FACe',
    GUIPUZCOA: 'DF Guipuzcoa',
    G_VALENCIA: 'Generalitat Valenciana',
    G_VASCO_EUROBITS: 'Gobierno Vasco',
    NO_ENTREGA: 'No entrega',
	NO_ENTREGA_RECEPCION: 'No entrega',
    XUNTA_GALICIA: 'Xunta de Galicia',
    OSAKIDETZA: 'Osakidetza',
    EMAIL_SIGNED: 'Email custodiado',
    EMAIL_SIGNED_ATTACH: 'Email custodiado y adjunto',
    EMAIL_PDF_SIGNED: 'Email PDF custodiado',
    EMAIL_PDF_SIGNED_ATTACH: 'Email PDF, adjuntos y custodiado',
    EMAIL_PDF_ATTACH: 'Email PDF y adjuntos',
    EMAIL_PDF_ATTACH_MERGED: 'Email PDF y adjuntos fusionados',
    EMAIL_LINK: 'Email con link',
    PAPER: 'Papel',
    BANKIA: 'Bankia',
    CONSORCIO_AGUAS_BILBAO: 'Aguas Bilbao',
    ESPUBLICO: 'Espublico',
    AOC_WS: 'AOC servicio web',
    AYUNTAMIENTO_VITORIA: 'Ayuntamiento Vitoria',
    AYUNTAMIENTO_BOADILLA: 'Ayuntamiento Boadilla',
    VOCENTO: 'Vocento',
    MMA: 'Mutua',
    REE: 'Red el\u00E9ctrica',
    AYUNTAMIENTO_AMOREBIETA: 'Ayuntamiento Amorebieta',
    SENADO: 'Senado',
    WS: 'Servicio web',
    UPLOAD: 'Carga',
    MANUAL: 'Manual',
    AYUNTAMIENTO_TORRELODONES: 'Ayuntamiento Torrelodones',
    ADIF: 'Adif',
    RENFE: 'Renfe',
    AYUNTAMIENTO_SANTURCE: 'Ayuntamiento Santurce',
    VAN: 'RVA',
    FACEB2B: 'FaceB2B',
    SFACTURA: 'sFactura',
    DOWNLOAD: 'DOWNLOAD',
    OHLSAP: 'OHLSap',
    OHLGCONS: 'OHLGcons',
    METADATA: 'Entrega datos',
    METADATA_ATTACH: 'Entrega datos y adjuntos',
    METADATA_ATTACH_PDF: 'Entrega datos, adjuntos y PDF',
    ZIPALL: 'Entrega completa',
    ZIPALL_FILES_NAMES_COUNT: 'Redeia',
    ERPEIFFAGE: 'Eiffage',
    ERPPACSA: 'Pacsa',
    ERPSARRION: 'Sarrion',
    ITALIA: 'Italia',
    INDRA: 'SAP Indra',
    AYUNTAMIENTO_COLMENAR_VIEJO: 'Ayuntamiento Colmenar Viejo',
    AYUNTAMIENTO_GALDAKAO: 'Ayuntamiento Galdakao',
    AYUNTAMIENTO_GORLIZ: 'Ayuntamiento Gorliz',
    ECOSYSTEM: 'Ecosystems',
    CECABANK: 'Cecabank',
    REDES: 'Redes',
    ADQUIRA: 'Adquira',
    VAN_EDICOM: 'Rva EDICOM',
    VAN_ARIBA: 'Rva ARIBA',
    VAN_SERES: 'Rva SERES',
    VAN_INDRA: 'Rva INDRA',
    PAVENTURA: 'Port Aventura',
    CANAL_ISABEL_II: 'Canal Isabel II',
    SEDEB2B: 'Sede B2B',
    VWGROUP: 'Grupo Volkswagen',
	PEPPOL: 'Peppol',
    ELECTRONET: 'Electronet',
    BSFACTURA: 'BS Factura',
    MAPFRE: 'Mapfre',
    PGN: 'PGN',
    RSI: 'RSI',
    INDRAFE: 'Indra',
    INDITEX: 'Inditex',
    INDRAFEREC: 'Indra recepción',
    B2BCONNECT: 'B2BConnect',
    TSHIFT: 'TShift',
    INDRATOVODAFONE: 'IndraToVodafone',
    COMEX: 'Comex',
    RECKITT: 'Reckitt',
    RECKITT_DELIVERYNOTE: 'Reckitt',
    LEKEITIO: 'Lekeitio',
    AYUNTAMIENTO_ORDUNA: 'Ayuntamiento Orduna',
    LEA_ARTIBAI: 'Lea Artibai',
    AYUNTAMIENTO_OROZKO: 'Ayuntamiento Orozko',
    AYUNTAMIENTO_GUENES: 'Ayuntamiento Guenes',
    AYUNTAMIENTO_SESTAO: 'Ayuntamiento Sestao',
    AYUNTAMIENTO_ESCORIAL: 'Ayuntamiento Escorial',
    AYUNTAMIENTO_MUSKIZ: 'Ayuntamiento Muskiz',
    AYUNTAMIENTO_LEMOA: 'Ayuntamiento Lemoa',
    JCM: 'Junta de Castilla La Mancha',
    FCC: 'Fcc',
    AYUNTAMIENTO_BILBAO: 'Ayuntamiento Bilbao',
    CAIXAF: 'Caixa Factura',
    CAIXA: 'Caixa servicio web',
    JUNTA_ANDALUCIA: 'JDA',
    DEFAULT: 'Método ya asignado',
    LA_RIOJA: 'La Rioja',
    ARGENTINA: 'AFIP Argentina',
    DISANET: 'Disanet',
    FIRMAE: 'Firma-e',
    LYNTIAEMISSION: 'Lyntia',
    LYNTIARECEPTION: 'Lyntia',
    CANALRECEPTION: 'Canal',
    LYNTIA_ACCESS_EMISSION: 'Elanta',
    LYNTIA_ACCESS_RECEPTION: 'Elanta',
    RUMANIA: 'Rumania',
    FRANCE: 'Francia',
    INDRAFEHANA: 'IndraFE',
    INDRAFINHANA: 'IndraFin',
    COMEXHANA: 'IndraComex',
    AYUNTAMIENTO_ABADINO: 'Ayuntamiento Abadiño',
    AYUNTAMIENTO_BALMASEDA: 'Ayuntamiento Balmaseda',
    AYUNTAMIENTO_BERRIZ: 'Ayuntamiento Berriz',
    AYUNTAMIENTO_BUSTURIA: 'Ayuntamiento Busturia',
    AYUNTAMIENTO_DERIO: 'Ayuntamiento Derio',
    AYUNTAMIENTO_ERANDIO: 'Ayuntamiento Erandio',
    AYUNTAMIENTO_FORUA: 'Ayuntamiento Forua',
    AYTO_GERNIKA_LUMO: 'Ayuntamiento Gernika Lumo',
    AYUNTAMIENTO_LOIU: 'Ayuntamiento Loiu',
    AYUNTAMIENTO_SANTURTZI: 'Ayuntamiento Santurtzi',
    AYTO_GAUTEGIZ_ARTEAGA: 'Ayuntamiento Gautegiz Arteaga',
    AYUNTAMIENTO_BERRIATUA: 'Ayuntamiento Berriatua',
    AYUNTAMIENTO_TRAPAGARAN: 'Ayuntamiento Trapagaran',
    AYUNTAMIENTO_ARTEA: 'Ayuntamiento Artea',
    AYUNTAMIENTO_ABANTO: 'Ayuntamiento Abanto',
    AYUNTAMIENTO_BARRIKA: 'Ayuntamiento Barrika',
    AYUNTAMIENTO_ELORRIO: 'Ayuntamiento Elorrio',
    AYUNTAMIENTO_ERENO: 'Ayuntamiento Ereño',
    AYUNTAMIENTO_IURRETA: 'Ayuntamiento Iurreta',
    AYUNTAMIENTO_LEMOIZ: 'Ayuntamiento Lemoiz',
    AYUNTAMIENTO_LEZAMA: 'Ayuntamiento Lezama',
    AYTO_MARURI_JATABE: 'Ayuntamiento Maruri Jatabe',
    AYUNTAMIENTO_PLENTZIA: 'Ayuntamiento Plentzia',
    AYUNTAMIENTO_SOPUERTA: 'Ayuntamiento Sopuerta',
    AYUNTAMIENTO_ZALDIBAR: 'Ayuntamiento Zaldibar',
    AYUNTAMIENTO_ZAMUDIO: 'Ayuntamiento Zamudio',
    AYUNTAMIENTO_ZARATAMO: 'Ayuntamiento Zarátamo',
    AYUNTAMIENTO_ZIERBENA: 'Ayuntamiento Zierbena',
    AYUNTAMIENTO_ETXEBARRI: 'Ayuntamiento Etxebarri',
    CONSOR_TRANSPOR_BIZKAIA: 'Consorcio de Transportes de Bizkaia',
    MDAD_MERINDAD_DURANGO: 'Mancomunidad Merindad Durango',
    AYUNTAMIENTO_GORDEXOLA: 'Ayuntamiento Gordexola',
    AYUNTAMIENTO_MENDATA: 'Ayuntamiento Mendata',
    AYUNTAMIENTO_BERMEO: 'Ayuntamiento Bermeo',
    AYUNTAMIENTO_GETXO: 'Ayuntamiento Getxo',
    AULA_CULTURA_GETXO: 'Aula Cultura Getxo',
    RESIDENCIA_MPAL_GETXO: 'Residencia Getxo',
    AYUNTAMIENTO_LEIOA: 'Ayuntamiento Leioa',
    AYUNTAMIENTO_LEGAZPI: 'Ayuntamiento Legazpi',
    AYUNTAMIENTO_ZUIA: 'Ayuntamiento Zuia',
    AYUNTAMIENTO_ORTUELLA: 'Ayuntamiento Ortuella',
    PARLAMENTO_VASCO: 'Parlamento Vasco',
    AYUNTAMIENTO_ARANTZAZU: 'Ayuntamiento Arantzazu',
    AYUNTAMIENTO_BAKIO: 'Ayuntamiento Bakio',
    AYUNTAMIENTO_GARAI: 'Ayuntamiento Garai',
    AYUNTAMIENTO_SONDIKA: 'Ayuntamiento Sondika',
    AYUNTAMIENTO_URDULIZ: 'Ayuntamiento Urduliz',
    AYUNTAMIENTO_BEDIA: 'Ayuntamiento Bedia',
    AYUNTAMIENTO_ALONSOTEGI: 'Ayuntamiento Alonsotegi',
    AYUNTAMIENTO_ARAKALDO: 'Ayuntamiento Arakaldo',
    AYUNTAMIENTO_AREATZA: 'Ayuntamiento Areatza',
    AYTO_ARRIGORRIAGA: 'Ayuntamiento Arrigorriaga',
    AYUNTAMIENTO_BERANGO: 'Ayuntamiento Berango',
    AYUNTAMIENTO_DURANGO: 'Ayuntamiento Durango',
    AYUNTAMIENTO_GALDAMES: 'Ayuntamiento Galdames',
    AYUNTAMIENTO_GAMIZ_FIKA: 'Ayuntamiento Gamiz-Fika',
    AYUNTAMIENTO_ISPASTER: 'Ayuntamiento Ispaster',
    AYUNTAMIENTO_IZURTZA: 'Ayuntamiento Izurtza',
    AYUNTAMIENTO_MANARIA: 'Ayuntamiento Manaria',
    AYUNTAMIENTO_MORGA: 'Ayuntamiento Morga',
    AYUNTAMIENTO_MUXIKA: 'Ayuntamiento Muxika',
    AYTO_TRUCIOS_TURTZIOZ: 'Ayuntamiento Trucios-Turtzioz',
    AYUNTAMIENTO_UBIDE: 'Ayuntamiento Ubide',
    AYTO_UGAO_MIRABALLES: 'Ayuntamiento Ugao-Miraballes',
    MDAD_URIBE_KOSTA: 'Mancomunidad Uribe Kosta',
    AYUNTAMIENTO_ZEANURI: 'Ayuntamiento Zeanuri',
    AYUNTAMIENTO_ZEBERIO: 'Ayuntamiento Zeberio',
    AYTO_ZIORTZA_BOLIBAR: 'Ayuntamiento Ziortza-Bolibar',
    ARARTEKO: 'Ararteko',
    AYUNTAMIENTO_BASAURI: 'Ayuntamiento Basauri',
    AYUNTAMIENTO_AJANGIZ: 'Ayuntamiento Ajangiz',
    AYUNTAMIENTO_AMOROTO: 'Ayuntamiento Amoroto',
    AYTO_ARRANKUDIAGA: 'Ayuntamiento Arrankudiaga',
    ARRATIAKO_UDALEN: 'Arratiako Udalen Mankomunitatea',
    AYUNTAMIENTO_ARRATZU: 'Ayuntamiento Arratzu',
    AYUNTAMIENTO_ARRIETA: 'Ayuntamiento Arrieta',
    AYTO_ARTZENTALES: 'Ayuntamiento Artzentales',
    AYUNTAMIENTO_ATXONDO: 'Ayuntamiento Atxondo',
    AYUNTAMIENTO_AULESTI: 'Ayuntamiento Aulesti',
    AYTO_IBARRANGELU: 'Ayuntamiento Ibarrangelu',
    AYUNTAMIENTO_DIMA: 'Ayuntamiento Dima',
    AYUNTAMIENTO_EA: 'Ayuntamiento Ea',
    MDAD_ENCARTACIONES: 'Mancomunidad de las Encartaciones',
    AYUNTAMIENTO_ERRIGOITI: 'Ayuntamiento Errigoiti',
    AYUNTAMIENTO_ETXEBARRIA: 'Ayuntamiento Etxebarria',
    AYUNTAMIENTO_FRUIZ: 'Ayuntamiento Fruiz',
    AYUNTAMIENTO_GATIKA: 'Ayuntamiento Gatika',
    AYUNTAMIENTO_IGORRE: 'Ayuntamiento Igorre',
    AYTO_VALLE_CARRANZA: 'Ayuntamiento Valle de Carranza',
    AYUNTAMIENTO_KORTEZUBI: 'Ayuntamiento Kortezubi',
    AYUNTAMIENTO_LARRABETZU: 'Ayuntamiento Larrabetzu',
    AYUNTAMIENTO_LAUKIZ: 'Ayuntamiento Laukiz',
    AYUNTAMIENTO_MALLABIA: 'Ayuntamiento Mallabia',
    AYTO_MARKINA_XEMEIN: 'Ayuntamiento Markina-Xemein',
    AYUNTAMIENTO_MENDEXA: 'Ayuntamiento Mendexa',
    AYUNTAMIENTO_MENAKA: 'Ayuntamiento Menaka',
    AYUNTAMIENTO_MUNDAKA: 'Ayuntamiento Mundaka',
    AYUNTAMIENTO_MUNITIBAR: 'Ayuntamiento Munitibar',
    AYUNTAMIENTO_MURUETA: 'Ayuntamiento Murueta',
    AYUNTAMIENTO_NABARNIZ: 'Ayuntamiento Nabarniz',
    AYUNTAMIENTO_OTXANDIO: 'Ayuntamiento Otxandio',
    AYTO_SUKARRIETA_PEDERNALES: 'Ayuntamiento Sukarrieta-Pedernales',
    MDAD_TXORIERRI: 'Mancomunidad de Txorierri',
    MDAD_BUSTURIALDE: 'Mancomunidad de Busturialde',
    AYUNTAMIENTO_LANESTOSA: 'Ayuntamiento Lanestosa',
    UDAL_SAREAK: 'Udal Sareak',
    REDE_ES: 'Red.es'
  },

  // modulos estados de tareas pendientes
  module: {
    ACCOUNTING_CLOSE: 'Cierres contables',
    PENDING_TASKS_CHANGE_STATUS: 'Cambio de estado en tareas pendiente',
    PENDING_TASKS: 'Tareas pendientes',
    CMR: 'DeCA',
    CONTROLDOCUMENT: 'Documento de control',
    CONTROLDOCUMENTLINK: 'Documento de control link'
  },
  job_status: {
    RUNNING: 'En ejecución',
    NORMAL: 'En espera',
    PAUSED: 'Pausado',
    NONE: 'Ninguno',
    COMPLETE: 'Completado',
    ERROR: 'Error',
    BLOCKED: 'Bloqueado'
  },
  // Estado de la factura
  invoice_status: {
    ANNULLED: 'Anulada',
    ERROR: 'Error',
    REJECTED: 'Rechazada',
    RECEIVED: 'Recibida',
    CANCELLED: 'Cancelada',
    DISAGREEMENT: 'No conforme',
    PENDING_OF_SIGNING: 'Pendiente firma',
    PENDING_OF_SEND: 'Pendiente de envío',
    PENDING_OF_VERIFYING: 'Pendiente verificación',
    PENDING_OF_GENERATE: 'Pendiente de generación',
    PENDING_OF_REPORTING: 'Pendiente de reporte',
    REPORTED: 'Reportada',
    YIELDED: 'Cedida',
    COMPENSATED: 'Compensada',
    PENDING_OF_COMPENSATION: 'Pendiente de compensación',
    PENDING_OF_CONFIRM: 'Pendiente de confirmar',
    COLLECTED: 'Cobrada',
    PENDING: 'Pendiente',
    PENDING_OF_ACCEPTING: 'Pendiente aceptación',
    PENDING_OF_VALIDATION: 'Pendiente de validación',
    IN_PROCESS: 'En tramitación',
    OPENED: 'Abierta',
    SIGNED: 'Firmada',
    SENDED: 'Enviada',
    REGISTERED: 'Registrada por cliente',
    ACCEPTED: 'Aceptada',
    ACCOUNTED: 'Contabilizada',
    PENDING_OF_PAYMENT: 'Pendiente de pago',
    PARTIALLY_PAID: 'Parcialmente pagada',
    PARTIALLY_ACCEPTED: 'Parcialmente aceptada',
    PAID: 'Pagada',
    RETAINED: 'Retenida',
    AWAITING_PAYMENT: 'En espera de pago',
    CONSOLIDATED: 'Consolidada',
    DELIVERED: 'Entregada',
    DELIVERYCONFIRMED: 'Entrega confirmada',
    SENT_TO_PAYMENT: 'Enviada al pago',
    INVOICE_RESPONSE: 'Pendiente de pago',
    WITHOUT_INTERNAL_STATUS: 'Sin estado interno',
    REJECTED_REDIGITALIZATION: 'Redigitalizada',
    INVOICE_SIGNATURE: 'Factura en firmas',
    PROPOSALS_SIGNATURE: 'Propuesta en firmas',
    SEND_PROPOSED_STATE: 'Enviado estado propuesta',
    SENT: 'Enviada',
    WAITING_CALLBACK: 'Esperando respuesta',
    RETAINED_PAYMENT: 'Pago retenido',
    VALIDATIONACCEPTED: 'Dcumento válido',
    VALIDATIONERROR: 'Documento inválido',
    FINISH: 'Finalizado',
    CHANGE_DRIVER: 'Cambio de conductor',
    ON_RUTE: 'En ruta',
    DRAFT: 'Borrador',
    ACCEPT: 'Aceptado',
    VISUALIZED: 'Visualizado',
    LOADING: 'Cargando',
  },

  // Campo enviada
  invoice_sent_flag: {
    SENT: 'Enviada',
    PENDING_OF_SEND: 'Pendiente de envío',
    NOT_SENT: 'No enviada'
  },

  // Estado del albaran
  deliverynote_status: {
    SENT: 'Enviado',
    ACCEPTED: 'Aceptado',
    REJECTED: 'Rechazado',
    ERROR: 'Error',
    RECEIVED: 'Recepcionado',
    FULLY_INVOICED: 'Facturado totalmente',
    PARTIALLY_INVOICED: 'Facturado parcialmente',
    PARTIALLY_RECEIVED: 'Recepcionado parcialmente',
    IN_PROCESS: 'En tramitación',
    PENDING_OF_SEND: 'Preexpedido',
    PARTIALLY_SENT: 'Expedido parcialmente',
    FULLY_SENT: 'Expedido totalmente'
  },

  // Estado de cmr
  cmr_status: {
    PENDING_OF_SEND: 'Pendiente de envío',
    LOADING: 'Cargando',
    IN_PROCESS: 'En curso',
    FINISH: 'Finalizado',
    CHANGE_DRIVER: 'Cambio de conductor',
    CANCELLED: 'Viaje cancelado',
    ANNULLED: 'Anulado',
    SENT: 'Enviado',
    ON_RUTE: 'En ruta',
    DRAFT: 'Borrador',
    REJECTED: 'Rechazado',
    ACCEPT: 'Aceptado',
    VISUALIZED: 'Visualizado',
    ERROR: 'Error',
  },

  // Divisas
  currency: {
    AUD: 'Dólar australiano',
    ALL: 'Lek albanés',
    DZD: 'Dinar argelino',
    ARS: 'Peso argentino',
    AWG: 'Florín arubeño',
    GBP: 'Libra esterlina',
    BSD: 'Dólar de las Bahamas',
    BHD: 'Dinar de Bahréin',
    BDT: 'Taka de Bangladesh',
    BBD: 'Dólar de Barbados',
    BYR: 'Rublo bielorruso',
    BZD: 'Dólar de Belice',
    BMD: 'Dólar de Bermudas',
    BTN: 'Ngultrum de Bhutan',
    BOB: 'Boliviano',
    BWP: 'Pula de Botsuana',
    BRL: 'Real brasileño',
    BND: 'Dólar de Bruné',
    BGN: 'Lev búlgaro',
    BIF: 'Franco burundí',
    CAD: 'Dólar canadiense',
    CNY: 'Yuan chino',
    KHR: 'Riel camboyano',
    CVE: 'Escudo caboverdiano',
    KYD: 'Dólar de las Islas Caimán',
    XOF: 'Franco CFA (BCEAO)',
    XAF: 'Franco CFA (BEAC)',
    CLP: 'Peso chileno',
    COP: 'Peso colombiano',
    KMF: 'Franco comorano',
    CRC: 'Colón costarricense',
    HRK: 'Kuna croata',
    CUP: 'Peso cubano',
    CZK: 'Corona checa',
    DKK: 'Corona danesa',
    DJF: 'Franco yibutiano',
    DOP: 'Peso dominicano',
    EUR: 'Euro',
    XCD: 'Dólar del Caribe Oriental',
    EGP: 'Libra egipcia',
    SVC: 'El Colon del Salvador',
    EEK: 'Corona estonia',
    ETB: 'Birr etíope',
    FKP: 'Libra malvinense',
    FJD: 'Dólar de Fiji',
    GMD: 'Dalasi gambiano',
    GTQ: 'Quetzal de Guatemala',
    GNF: 'Franco guineano',
    GYD: 'Dólar guyanés',
    GHS: 'Cedi ghanes',
    HKD: 'Dólar de Hong Kong',
    HTG: 'Gourde haitiano',
    HNL: 'Lempira hondureña',
    HUF: 'Florín húngaro',
    IDR: 'Rupia indonesia',
    INR: 'Rupia india',
    ISK: 'Corona islandesa',
    IRR: 'Rial iraní',
    IQD: 'Dinar iraquí',
    ILS: 'Shekel israelí',
    JPY: 'Yen japonés',
    JOD: 'Dinar jordano',
    KZT: 'Tenge kazako',
    KES: 'Chelín keniano',
    KRW: 'Won coreano',
    KWD: 'Dinar kuwaití',
    KGS: 'Kirguistán Som',
    MOP: 'Pataca de Macao',
    MKD: 'Dinar macedonio',
    MWK: 'Kwacha malawiano',
    MYR: 'Ringgit malayo',
    MVR: 'Rupia de Maldivas',
    MRO: 'Ouguiya de Mauritania',
    MUR: 'Rupia mauricia',
    MXN: 'Peso mexicano',
    MDL: 'Leu moldavo',
    MNT: 'Tugrik mongol',
    MAD: 'Dirham marroquí',
    MMK: 'Kyat de Myanmar',
    NAD: 'Dólar de Namibia',
    NPR: 'Rupia nepalí',
    ANG: 'Guilder antillano',
    NZD: 'Dólar neozelandés',
    NIO: 'Córdoba nicarag\u00FCense',
    NGN: 'Naira nigeriano',
    KPW: 'Won de Corea del Norte',
    NOK: 'Corona noruega',
    OMR: 'Rial omaní',
    XPF: 'Franco CFP',
    PKR: 'Rupia pakistaní',
    PAB: 'Balboa panameño',
    PGK: 'Kina de Papúa Nueva Guinea',
    PYG: 'Guaraní paraguayo',
    PEN: 'Nuevo Sol peruano',
    PHP: 'Peso filipino',
    PLN: 'Zloty polaco',
    QAR: 'Riyal Qatarí',
    RON: 'Leu rumano',
    RUB: 'Rublo ruso',
    RWF: 'Franco ruandés',
    CHF: 'Franco suizo',
    WST: 'Tala de Samoa',
    STD: 'Dobra de Santo Tomé',
    SAR: 'Riyal saudí',
    SCR: 'Rupia de Seychelles',
    SLL: 'Leone de Sierra Leona',
    SGD: 'Dólar de Singapur',
    SKK: 'Corona eslovaca',
    SBD: 'Dólar de las Islas Salomón',
    SOS: 'Chelín somalí',
    ZAR: 'Rand sudafricano',
    LKR: 'Rupia de Sri Lanka',
    SHP: 'Libra de Santa Helena',
    SDG: 'Libra sudanesa',
    SZL: 'Lilangeni de Suazilandia',
    SEK: 'Corona sueca',
    SYP: 'Libra siria',
    THB: 'Baht tailandés',
    TRY: 'Lira turca',
    TWD: 'Dólar taiwanés',
    TZS: 'Chelín tanzano',
    TOP: 'Pa\u02BBanga o dólar tongano',
    TTD: 'Dólar de Trinidad y Tobago',
    TND: 'Dinar tunecino',
    USD: 'Dólar estadounidense',
    AED: 'Dirham de Emiratos Arabes Unidos',
    UGX: 'Chel\u00EDn ugandés',
    UAH: 'Grivnia de Ucrania',
    UYU: 'Peso uruguayo',
    UZS: 'Uzbekistán Sum',
    VUV: 'Vatu de Vanuatu',
    VND: 'Dong de Vietnam',
    VES: 'Bolívar venezolano',
    YER: 'Rial yemení',
    ZMK: 'Kwacha zambiano',
    PES: 'Peso',
    JMD: 'Dolar de Jamaica'
  },

  // Estados de auditoría
  auditory_status: {
    DELIVERED: 'Entregado',
    DELIVERYCONFIRMED: 'Entrega confirmada',
    DIVIDED: 'Dividido',
    ERROR: 'Error',
    DELETED: 'Eliminado',
    CREATED: 'Creado',
    UPDATED: 'Actualizado',
    EXTRACTED: 'Extraído',
    GENERATED: 'Generado',
    INCOMINGERROR: 'Error de entrada',
    INTEGRATED: 'Integrado',
    PENDINGOFDELIVERY: 'Pendiente de envío',
    DISCARDED: 'Descartado',
    RECEIVED: 'Recibido',
    RECOGNIZED: 'Reconocido',
    SIGNED: 'Firmado',
    DISAGREEMENT: 'No conforme',
    PENDING_OF_SIGNING: 'Pendiente de firma',
    PENDING_OF_SEND: 'Pendiente de envío',
    TRANSFORMED: 'Transformado',
    ERROR_WS_DOCUMENT: 'Error servicio de integración de documentos',
    ERROR_WS_NOTIFICATION: 'Error servicio de integración de notificaciones',
    SENT_TO_PAYMENT: 'Enviada al pago',
    WAITING_CALLBACK: 'Esperando respuesta',
    WARNING: 'Advertencia',
    VALIDATIONACCEPTED: 'Documento válido',
    VALIDATIONERROR: 'Documento inválido'
  },

  // Tipos de documentos auditoria
  auditory_doc_type: {
    INVOICE: 'Factura',
    DIGITIZEDINVOICE: 'Factura digitalizada',
    ATTACHMENT: 'Adjuntos',
    UPDATE_STATUS: 'Estados de factura',
    UPDATE_INTERNAL_STATUS: 'Estados internos de factura',
    INVOICE_RESPONSE: 'Respuesta de factura',
    BATCHFILE: 'Lote',
    RECADV: 'Recadv',
    OTHER: 'Otros',
    RECEIVEADVICE: 'Recepción',
    PURCHASEORDER: 'Pedido',
    ORDER: 'Pedido',
    ORDERRSP: 'Respuesta de pedido',
    DELIVERYNOTE: 'Albarán',
    GENRAL: 'Genral',
    GENERAL: 'Genral note',
    CMR: 'DeCA',
    USER: 'Usuarios',
    PARTY: 'Empresas',
    STATUS: 'Estados',
    SALESREPORT: 'Informe de ventas',
    INVENTORYREPORT: 'Informe de inventario',
    REMADV: 'Aviso de liquidación',
    COACSU: 'Resumen cuenta comercial',
    CONTROLDOCUMENT: 'Documento de control',
  },

  // Tipos de formatos de documentos auditoria
  auditory_doc_format: {
    FACTURAE32: 'FACTURAE32',
    FACTURAE321: 'FACTURAE321',
    INVOIC_D96A: 'INVOIC_D96A',
    INVOIC_D97A: 'INVOIC_D97A',
    INVOIC_D93A: 'INVOIC_D93A',
    XML_AECOC: 'XML_AECOC',
    PDF: 'PDF',
    PDF_A: 'PDF-A',
    UBL20: 'UBL20',
    ZIP: 'ZIP',
    CSV: 'CSV',
    PLAIN_ALTCLI: 'PLANO ALTA CLIENTES',
    XML_ENVEST: 'XML ENVÍO ESTADOS',
    TXT: 'TXT',
    PLAIN_ENVRES: 'PLANO ENVÍO RESPUESTA',
    XML_SANTILLANA: 'XML SANTILLANA',
    XML_B2B_RECADV: 'XML B2B RECEPCIÓN',
    INVOIC_D01B: 'INVOIC_D01B',
    PLAIN_ALTPRO: 'PLAIN_ALTPRO',
    FACTURAE322: 'FACTURAE322',
    FATTURAPA12: 'FATTURAPA12',
    FATTURAPA_SEMPLIFICATA: 'FATTURAPA_SEMPLIFICATA',
    FATTURAPA12_CADES: 'FATTURAPA12_CADES',
    FATTURAPA_SEMPLIFICATA_CADES: 'FATTURAPA_SEMPLIFICATA_CADES',
    XML_B2B_ORDER: 'XML B2B ORDER',
    XML_B2B_ORDERRSP: 'XML B2B ORDER RESPONSE',
    XML_B2B_DELIVERYNOTE: 'XML B2B DELIVERY NOTE',
    XML_B2B_INVOICE: 'XML B2B METADATOS',
    GENRAL_D96A: 'GENRAL D96A',
    CSV_B2B_PARTY: 'CSV Empresas',
    DIGITALIZED_DELIVERYNOTE: 'Albarán digitalizado',
    CXML_INVOICE: 'CXML',
    FEV1: 'FEV1',
    FATTURAPA11: 'FATTURAPA11',
    FATTURAPA10: 'FATTURAPA10',
    FISI: 'FISI',
    UBL21: 'UBL21',
    ORDERS_D96A: 'ORDERS_D96A',
    FACTURAE30: 'FACTURAE30',
    FACTURAE31: 'FACTURAE31',
    XCBL40: 'XCBL40',
    '3C3': 'RosettaNet',
    XML_B2B_CMR: 'XML_B2B_CMR',
    DESADV_D96A: 'DESADV_D96A',
    XML_B2B_GENRAL: 'XML_B2B_GENRAL',
    CSV_B2B_USER: 'CSV_B2B_USER',
    XML_B2B_INVOICE_STATUS: 'XML_B2B_INVOICE_STATUS',
    XML_B2B_RECADV_STATUS: 'XML_B2B_RECADV_STATUS',
    XML_B2B_SLSRPT: 'XML_B2B_SLSRPT',
    CII: 'CII',
    XML_CANONICAL_B2B_INVOICE: 'XML CANÓNICO B2B INVOICE',
  },

  // Protocolos de comunicación en auditoría
  auditory_communication_protocol: {
    SSH_FTP: 'SFTP',
    WS: 'Servicio web',
    AS2: 'AS2',
    EMAIL: 'Correo electrónico',
    OTX: 'VAN',
    FILESYSTEM: 'Entrega interna',
    VALIDATION_WS: 'Servicio web de validación',
    REST: 'Servicio rest',
    WEB: 'Portal web'
  },

  // Modulos  auditoria
  auditory_module: {
    EXCHANGE_WS_SEND: 'Envio de facturas',
    EXCHANGE_WS_STATUS: 'Consulta de estados',
    EXCHANGE_WS_CHANGE: 'Cambio de estado',
    EXCHANGE_WS_DOWNLOAD: 'Descarga',
    MASSIVE_PARTY: 'Carga masiva de empresas',
    PARTY: 'Empresas',
    CENTRE: 'Centros',
    PAYMENT: 'Datos de pago',
    USER: 'Usuarios',
    WS_VALIDATION: 'Servicio web de validación',
    RECADV: 'Recepciones',
    EDITRACK_DOCUMENT_INTEGRATION: 'Integración',
    EDITRACK_DOCUMENT_NOTIFICATION: 'Notificación',
    CMR: 'DeCA',
    ORDER: 'Pedidos',
    DELIVERY_NOTE: 'Albaranes',
    SIGNATURE_PLATFORM: 'Firma'
  },

  // Categorias de documentos
  documentation_category: {
    EXAMPLE: 'Ejemplo',
    FUNCTIONAL_ANALYSIS: 'Análisis funcional',
    INTEGRATION_DOCUMENT: 'Documento de integración',
    OFFER: 'Oferta',
    USER_MANUAL: 'Manual de usuario',
    INFORMATIVE_DOCUMENT: 'Documento divulgativo',
    USER_INFORMATION: 'Información al usuario'
  },

  // Idioma documentos
  documentation_language: {
    spanish: 'Español',
    english: 'Inglés',
    italian: 'Italiano',
    portuguese: 'Portugués',
    french: 'Francés'
  },

  // Estados de cierres contables
  status_accounting_close: {
    Abierto: 'Abierto',
    Cerrado: 'Cerrado'
  },

  // Clases de documento
  document_class: {
    COPY: 'Copia',
    ORIGINAL: 'Original',
    DUPLICATE: 'Duplicado',
    ADDITIONAL_TRANSMISSION: 'Adicional',
    REPLACE: 'Rectificativa',
    ADDITION: 'Adición'
  },

  // Clases de ciclos de documentos
  document_cycle_class: {
    DELIVERY_VALIDATION_PACKAGE_GTIN14: 'Validación del GTIN14 de las líneas de los embalajes del albarán',
    INVOICE_LINES_EDITABLE_FIELDS: 'Valida segun el subtipo de las lineas de recepcion si hay que crear las lineas y si son editables',
    INVOICE_FROM_ORDER_TYPE_SUBTYPE: 'Valida el tipo y/o subtipo del pedido para crear una factura con algunos campos no editables',
    VALIDATION_ORDER_RESPONSE_REQUIRED: 'Validación de existencia de order response previo'
  },

  // Tipos de factura
  invoice_type: {
    PROFORMA: 'Proforma',
    COMMERCIAL: 'Comercial',
    CREDIT_NOTE: 'Abono',
    DEBIT_NOTE: 'Nota de débito',
    CONSOLIDATED: 'Consolidada',
    SELF_BILLED: 'Autofactura'
  },

  // Tipo de documento de factura
  invoice_document_type: {
    FC: 'Factura completa',
    FA: 'Factura abreviada',
    AF: 'Autofactura',
    AN: 'Factura anticipo',
    PF: 'Factura proforma',
    NL: 'No logístico'
  },

  delivery_note_type: {
    NO_LOGISTIC: 'No logístico',
    LOGISTIC_TWO_LEVELS: 'Logístico de 2 niveles. Mercancía general',
    LOGISTIC_THREE_LEVELS: 'Logístico de 3 niveles. Gran consumo'
  },

  // Tipos de servicios
  project_type: {
    seller: 'Emisión',
    buyer: 'Recepción',
    both: 'Ambos'
  },

  // Tipos de empresa
  party_type: {
    seller: 'Vendedor',
    buyer: 'Comprador',
    third: 'Tercero',
    both: 'Ambos'
  },

  // Método de entrega
  party_type_meth: {
    emission: 'Emisión',
    reception: 'Recepción',
    both: 'Ambos'
  },

  // Método de entrega project
  project_type_meth: {
    emission: 'Emisión',
    reception: 'Recepción'
  },

  chart_legend: {
    from_others: 'Facturas',
    from_orders: 'Facturas de pedidos',
    from_recadvs: 'Facturas de recepciones',
    from_deliverynotes: 'Facturas de albaranes',
    invoices_emitted: 'Facturas emitidas',
    invoices_received: 'Facturas recibidas',
    parties_registered: 'Empresas dadas de alta',
    invoices_redigitized: 'Facturas redigitalizadas',
    invoices_rejected: 'Facturas rechazadas'
  },
  // Tipos de tabla
  chart_type: {
    title: 'Tipo tabla',
    economic: 'Volumen económico',
    invoice: 'Número de facturas'
  },
  //
  // Tipos de persona
  person_type: {
    physical: 'Física',
    legal: 'Jurídica'
  },
  // Forma de pago
  paymentmethod: {
    CASH: 'Efectivo',
    CHECK: 'Cheque',
    CONFIRMING: 'Confirming',
    TRANSFER: 'Transferencia'
  },
  // Formato de document
  document: {
    format: {
      FACTURAE32: 'FACTURAE32',
      FACTURAE321: 'FACTURAE321',
      FACTURAE322: 'FACTURAE322',
      FATTURAPA12: 'FATTURAPA12',
      FATTURAPA_SEMPLIFICATA: 'FATTURAPA_SEMPLIFICATA',
      FATTURAPA12_CADES: 'FATTURAPA12_CADES',
      FATTURAPA_SEMPLIFICATA_CADES: 'FATTURAPA_SEMPLIFICATA_CADES',
      INVOIC_D96A: 'INVOIC_D96A',
      INVOIC_D97A: 'INVOIC_D97A',
      INVOIC_D93A: 'INVOIC_D93A',
      XML_AECOC: 'XML_AECOC',
      PDF: 'PDF',
      PDF_A: 'PDF-A',
      ZIP: 'ZIP',
      CSV: 'CSV',
      UBL20: 'UBL20',
      PLAIN_ALTCLI: 'Plano alta clientes',
      XML_ENVEST: 'XML envío estados',
      PLAIN_ENVRES: 'Plano envío respuesta',
      XML_SANTILLANA: 'XML SANTILLANA',
      XML_B2B_RECADV: 'XML B2B RECEPCIÓN',
      INVOIC_D01B: 'INVOIC_D01B',
      PLAIN_ALTPRO: 'PLAIN_ALTPRO',
      XML_B2B_ORDER: 'XML B2B ORDER',
      XML_B2B_ORDERRSP: 'XML B2B ORDER RESPONSE',
      XML_B2B_DELIVERYNOTE: 'XML B2B DELIVERY NOTE',
      XML_B2B_INVOICE: 'XML B2B METADATOS',
      GENRAL_D96A: 'GENRAL D96A',
      CSV_B2B_PARTY: 'CSV Empresas',
      DIGITALIZED_DELIVERYNOTE: 'Albarán digitalizado',
      CXML_INVOICE: 'CXML',
      FEV1: 'FEV1',
      FATTURAPA11: 'FATTURAPA11',
      FATTURAPA10: 'FATTURAPA10',
      FISI: 'FISI',
      UBL21: 'UBL21',
      ORDERS_D96A: 'ORDERS_D96A',
      FACTURAE30: 'FACTURAE30',
      FACTURAE31: 'FACTURAE31',
      XCBL40: 'XCBL40',
      XML_B2B_SLSRPT: 'XML_B2B_SLSRPT',
      CII: 'CII',
      XML_CANONICAL_B2B_INVOICE: 'XML CANÓNICO B2B INVOICE',
    }
  },
  categories: {
    OTHERS: 'Otros',
    AUTOMATIC: 'Automático',
    INCORRECT_ATTACHS: 'Adjuntos: Falta documentaci\u00F3n o incorrecta',
    INCORRECT_CENTER: 'Centro incorrecto',
    INCORRECT_DETAIL: 'Concepto incorrecto o falta detalle',
    PARTY_CONTRACTING: 'Contrataci\u00F3n empresa',
    INCORRECT_FISCAL: 'Datos fiscales incorrectos',
    INCORRECT_RELATION: 'Documentos relacionados incorrectos',
    ACCOUNTING_NOT_EXIST: 'Factura a la que rectifica no contabilizada o no existe',
    DUPLICATED_INVOICE: 'Factura duplicada',
    INCORRECT_DELIVERY_DATE: 'Fecha/periodo de prestaci\u00F3n de servicios incorrecto',
    INCORRECT_AMOUNTS: 'Importes incorrectos',
    REDIGITALIZATION: 'Redigitalizaci\u00F3n',
    INCORRECT_ENTRY: 'Requisitos de entrada incorrectos',
    PAPER: 'Tramitada en papel',
    WRONG_CAPTURED: 'Campo mal capturado',
    NO_CAPTURED: 'Campo no capturado',
    WRONG_FIELD_CAPTURED: 'Campo capturado incorrecto',
    NO_CATEGORY: 'Sin categoría',
    INCORRECT_OCR_DATA: 'Validación OCR'
  },

  // Tipo de extension de factura
  extension_type: {
    FACEB2B: 'Extensión FACe B2B'
  },

  // Roles para centros
  centre_role_type: {
    payer: 'Pagador/Ud.Tramitadora',
    payee: 'Receptor del cambio',
    invoicee: 'Facturado',
    finalclient: 'Cliente final',
    ship_to: 'Lugar de entrega',
    ship_from: 'Envío desde',
    receiver: 'Receptor/Org.Gestor',
    buyer: 'Comprador/Org.Proponente',
    collector: 'Cobrador',
    seller: 'Vendedor',
    payment_receiver: 'Receptor del pago',
    collection_receiver: 'Receptor del cobro',
    issuer: 'Emisor',
    fiscal: 'Fiscal/Of.Contable'
  },
  centre_role_type_order: {
    payer: 'Pagador',
    payee: 'Receptor del cambio',
    invoicee: 'Facturado',
    finalclient: 'Cliente final',
    ship_to: 'Lugar de entrega',
    ship_from: 'Envío desde',
    receiver: 'Receptor',
    buyer: 'Comprador',
    collector: 'Cobrador',
    seller: 'Vendedor',
    payment_receiver: 'Receptor del pago',
    collection_receiver: 'Receptor del cobro',
    issuer: 'Emisor',
    fiscal: 'Fiscal/Of.Contable'
  },
  // Estadísticas
  statistic: {
    emitted_title: 'Volumen de facturas emitidas',
    received_title: 'Volumen de facturas recibidas',
    other_title: 'Facturas generadas desde otro documento, pedido, recepción o albarán',
    topseller_title: 'Top 20 proveedores por volumen económico y de número de facturas',
    parties_title: 'Volumen de empresas dadas de alta',
    rejected_invoice_title: 'Facturas: Tipología de rechazos y motivos de redigitalización',
    symbol: 'Facturas',
    party_type: 'Tipo de empresas',
    party_sponsor: 'Propietaria',
    invoice_status_title: 'Estado de facturas',
    total_party: 'Total empresas acumuladas'
  },
  // Documentacion
  documentation: {
    documentation_entity_table: {
      project: 'Servicio',
      name: 'Nombre',
      category: 'Categoría',
      language: 'Idioma'
    },
    buttons: {
      new_document: 'Cargar',
      download_multiple: 'Descargar',
      new_document_tooltip: 'Cargar documento',
      download_multiple_tooltip: 'Descargar documento/s'
    },
    dialog_add_documentation: {
      title: 'Cargar documentación',
      deletefile: 'Eliminar fichero documentación',
      updatetitle: 'Actualizar documentación',
      project: {
        label: 'Servicio',
        placeholder: 'Elige un servicio'
      },
      categoria: {
        label: 'Categoría',
        placeholder: 'Elige una categoría'
      },
      nombre: {
        label: 'Nombre documento'
      },
      url: {
        label: 'Enlace documentación'
      },
      idioma: {
        label: 'Idioma',
        placeholder: 'Elige un idioma'
      },
      urlorfile_required: 'Enlace o fichero requerido'
    },
    error: {
      validation: {
        parametro_obligatorio_idioma: 'El idioma es un parámetro obligatorio',
        parametro_obligatorio_nombre: 'El nombre es un parámetro obligatorio',
        parametro_obligatorio_documentation: 'El fichero o enlace es obligatorio',
        duplicated: 'Ya existe la documentación para el servicio',
        size_exceeded: 'El tamaño máximo permitido es de 10MB'
      },
      error_generico: 'Error al cargar la documentación'
    }
  },

  documentation_detail: {
    buttons: {
      document: 'Documento',
      eraseDocument: 'Eliminar'
    },
    documentation_detail_form: {
      project: 'Servicio',
      name: 'Nombre',
      category: 'Categoría',
      language: 'Idioma'
    },
    confirm: {
      title_delete_documentation: '¿Estás seguro de querer eliminar este documento?',
      confirm_button_delete_documentation: 'Eliminar',
      title_upload_documentation: '¿Estás seguro de querer reemplazar este documento?',
      confirm_button_upload_documentation: 'Reemplazar'
    },
    notify: {
      delete_document_ok: 'Se ha eliminado el documento correctamente.',
      upload_document_ok: 'La documentación se ha actualizado correctamente.'
    },
    load: {
      download: 'Descargando documento ...',
      delete_document: 'Eliminando documento ...',
      upload_document: 'Cargando documento ...'
    }
  },
  NO_PENDING_TASK_STATUS: 'No se han encontrado estados configurados para el servicio seleccionado.',
  display_documents: {
    PDF_INDRA: 'PDF Indra',
    PDF_OHL_PERU: 'PDF para OHL Perú',
    PDF_RENFE: 'PDF para Renfe',
    PDF_INDRAFE: 'PDF para IndraFE',
    PDF_SARQUAVITAE: 'PDF para Sarquavitae',
    PDF_RENFE_RECADV: 'PDF para recepciones Renfe',
    PDF_CATEGORY: 'PDF adjunto categorizado',
    PDF_TOYOTA: 'PDF para Toyota Canarias',
    PDF_IDCSALUD: 'PDF para IDC Salud',
    PDF_RECADV: 'PDF recepciones por defecto',
    PDF_ENDESA: 'PDF para Endesa',
    PDF_QUIRON_RECADV: 'PDF para Quiron',
    PDF_ORDER: 'PDF para pedido',
    PDF_QUIRON_ORDER: 'PDF para pedido de Quiron',
    PDF_DELIVERYNOTE: 'PDF para albarán',
    PDF_GENRAL: 'PDF para Genral',
    PDF_RENFE_SUPPLIER_DATA: 'PDF para datos proveedor',
    PDF_RENFE_SOCIETIES_RECADV: 'PDF para sociedad recepción',
    PDF_REDSYS: 'PDF para Redsys',
    PDF_GNUBILA: 'PDF para Gnubila',
    PDF_OHL: 'PDF para OHL',
    PDF_ORDER_INDRA: 'PDF para pedido Indra',
    PDF_NISSAN: 'PDF para Nissan',
    PDF_GONVARRI: 'PDF para Gonvarri',
    PDF_CONSUM: 'PDF para Consum',
    PDF_TELEFONICATECH: 'PDF para Telefónica Tech',
    PDF_DRAFT_INDRA: 'PDF temporal para borradores',
    PDF_OTIS: 'PDF para Otis',
    PDF_LYNTIA_GLOBAL: 'PDF Lyntia Global Fontibre',
    PDF_LYNTIA_CODINET: 'PDF Lyntia Codinet',
    PDF_LYNTIA_NETWORKS: 'PDF Lyntia Networks',
    PDF_LYNTIA_TOWERNET: 'PDF Lyntia Towernet',
    PDF_LYNTIA_ELANTA: 'PDF Lyntia Elanta',
    PDF_CANAL: 'PDF para Canal',
    PDF_REDEIA: 'REDEIA PDF',
    PDF_RENFE_AMERICA: 'PDF Renfe of America',
    PDF_CORREOS_EXPRESS: 'PDF Correos Express',
    PDF_CMR_MAHOU: 'PDF CMR Mahou',
    PDF_CMR_TKAS: 'PDF CMR TKAS',
    PDF_CMR_ECMR: 'PDF documento de transporte',
    PDF_ACCIONA_ENERGIA: 'PDF Acciona Energía',
    PDF_ABOGACIA: 'PDF Abogacía',
    PDF_DOCUMENTO_CONTROL_MAHOU: 'PDF para documento de control de Mahou',
  },

  display_labels: {
    PDF_DELIVERYNOTE_LABEL: 'PDF para etiquetas genéricas de albarán',
    PDF_ALCAMPO_DELIVERYNOTE_LABEL: 'PDF para etiquetas de albarán de Alcampo',
    PDF_CARREFOUR_DELIVERYNOTE_LABEL: 'PDF para etiquetas de albarán de Carrefour',
    PDF_BONPREU_DELIVERYNOTE_LABEL: 'PDF para etiquetas de albarán de Bon Preu',
    PDF_ECI_DELIVERYNOTE_LABEL: 'PDF para etiquetas de albarán de ECI'
  },

  email_type: {
    NEW_USER: 'Nuevo usuario y contraseña',
    RESET_PASSWORD: 'Recuperar contraseña',
    NEW_INVOICE: 'Email informativo nueva factura',
    EMAIL_PDF_ATTACH: 'Email PDF y adjuntos',
    EMAIL_PDF_ATTACH_MERGED: 'Email PDF y adjuntos fusionados',
    EMAIL_SIGNED: 'Email custodiado',
    EMAIL_PDF_SIGNED: 'Email PDF y custodiado',
    EMAIL_PDF_SIGNED_ATTACH: 'Email PDF, custodiado y adjuntos',
    EMAIL_LINK: 'Email con link',
    INVOICE_ERROR_DELIVERY_METHOD: 'Método de entrega no contratado',
    BILLING_REPORT_SERVICE: 'Notificación de un servicio',
    ACK_EMAIL_ERROR: 'Error envio ACK email',
    ERROR_CMR: 'Email de notificación de errores documento de control',
    ANNULLED_CMR: 'Email de notificación de anulación documento de control',
    INVALID_STATUS: 'Error en el envio',
    RESUMEN_BOLETAS_ERROR: 'CDR en resumen de boletas',
    NEW_RECADV: 'Nueva recepción',
    NEW_ORDER: 'Nuevo pedido',
    ERROR_RRVV: 'Email con notificación de error para recepciones valoradas',
    ERROR_ORDER: 'Email con notificación de error para pedidos',
    BILLINGINACTIVE_REPORT: 'Informe de facturas inactivas',
    NEW_INVOICE_PENDING_ACCEPTANCE: 'Nueva factura pendiente de aceptación',
    ANEXO_DOCUMENTATION: 'Nueva propuesta de pago',
    INVALID_INVOICE_NOTE_URL: 'Notificación de acceso erróneo mediante url a consulta de factura',
    REDIGITALIZATION_REQUEST: 'Solicitud Redigitalizacion',
    BILLING_REPORT_SERVICES: 'Notificacion de múltiples servicios',
    ERROR: 'Email de notificacion de error para soporte',
    VALIDATE_FORMAT_ERROR: 'Error de integración con tipo de email',
    EMAIL_PDF: 'Email PDF',
    INTEGRATION_REJECTED: 'Email para proveedores cuando se integra la factura con estado rechazada',
    INVOICE_TIME_EXCEED_NOTIFICATION_EMISSION: 'Email para proveedores cuando el SDI no pueda entregar la factura',
    INVOICE_TIME_EXCEED_NOTIFICATION_RECEPTION: 'Email para receptores cuando el SDI no haya recibido notificaciones',
    CHANGE_STATUS_ERROR: 'Email para avisar de que no es posible efectuar el cambio de estado',
    NEW_DELIVERY_NOTE: 'Nuevo albarán',
    CHANGE_STATUS_DELIVERYNOTE: 'Cambio de estado albarán',
    CHANGE_STATUS_RECADV: 'Cambio de estado de una recepción',
    WS_DOCUMENT: 'Envio de documentos de la empresa por servicio web',
    PARTY_DATA: 'Envio de documentos de la empresa por email',
    EMAIL_TO_REPORT_ISSUED: 'Email para el envío del informe CSV de facturas emitidas',
    INTEGRATION_OCR_ERROR: 'Email de notificacion de errores de integración en facturas OCR',
    EMAIL_NOTIFICATION_CUSTOMER: 'Email que se envía en la llamada al cliente para el envío de la factura',
    EMAIL: 'Email',
    EMAIL_SIGNED_ATTACH: 'Email custodiado y adjuntos',
    EMAIL_INVOICE_NO_OCR: 'Envío centralizado de notificaciones de facturas electrónicas',
    EMAIL_THIRDPARTY: 'Email de envío de facturas a terceros',
    ERROR_CENTRE: 'Email de notificación de errores de integración de centros',
    VERIFY_2FA: 'Email para notificar el código para el doble factor de autenticación',
    APPROVAL_FLOW: 'Notificación del flujo de aprobación por niveles y usuarios de la factura',
    EMAIL_BILLING_REPORT: 'Email con el informe da facturación de Indra Y Telefónica',
    REDES_NOTIFICATION: 'Notificación de error en el ws de recepciones de red.es',
    SHIPMENT_NOTIFICATION: 'Notificación de entrega de factura al comprador'
  },
  configuration_table: {
    GENERATE_ACK: 'Generación de fichero ack',
    GENERATE_ENVEST: 'Generación de fichero de envío de estados de factura (ENVEST)',
    GENERATE_ENVRES: 'Generacion de fichero de envío de respuesta de lote de facturas',
    GENERATE_ACK_EMAIL: 'Envío de Email con ack',
    GENERATE_ACK_ERROR_EMAIL: 'Envío de Email con errores ack',
    GENERATE_ACK_ERROR_EMAIL_WITHOUT_ATTACH: 'Envío de Email con errores ack sin adjuntos',
    GENERATE_ACK_EMAIL_WITHOUT_ATTACH: 'Envío del fichero ack sin adjuntos',
    GENERATE_PDF417: 'Generación del código para las facturas firmada',
    GET_CHANNEL: 'Obtención del canal',
    MANUAL_SEND: 'Envio manual desde tareas pendientes',
    GENERATE_PARTY_REPORT: 'Envio ficheros empresas a Digitalizacion',
    SEND_ALL_INVOICES: 'Envío de todas las facturas sin tener en cuenta el estado',
    PENDING_INVOICES_XML_REPORT: 'Creación de Informe en XML con las facturas en estado no final',
    SEND_EMAIL_INVOICE_RECEIVED: 'Envío de email indicando que se ha recibido una nueva factura',
    STATUS_RECADV_FILE: 'Generación del fichero xml de estados de recepciones',
    NO_INTEGRATE_REJECTED_INVOICE_EMISION: 'Facturas emitidas no integrar rechazadas',
    NO_INTEGRATE_DUPLICATED_INVOICE: 'No integrar facturas duplicadas',
    SET_SPONSOR: 'Al crear o modificar una empresa del servicio, a esta se le asignará el rol propietaria',
    NEW_PARTY_CREATE_CENTRE: 'Crea el centro de la empresa aunque esta no se quiera como sponsor',
    GENERATE_ORDRSP: 'Generación del fichero de respuesta del pedido',
    GENERATE_B2B_STATUS: 'Generación del fichero de estados de la factura',
    DELIVERY_INVOICE_TO_ISSUER: 'Entrega de la factura al emisor según configuración',
    STATUS_RETAINED_INVOICE: 'No enviar las facturas hasta la fecha de emisión',
    CHANGE_SIGNED_TO_OPENED: 'Cambio de estado a abierta al consultar una factura firmada, PDF o custodiada',
    GENERATE_REPORT_ISSUED: 'Informe CSV de facturas emitidas actualizadas desde la última ejecución',
    NO_DELIVER_INVOICE: 'No enviar las facturas registradas con método de entrega',
    STATUS_SIGNED_FROM_INVOICE_RECEIVED: 'Las facturas firmadas, recibidas desde RVA no se verifica su firma',
    SET_EMISSION_NULL_IF_SPONSOR: 'Integración de la factura con el flag de emisión a null si ambas empresas son propietarias',
    SET_EMISSION_NULL_IF_SPONSOR_AF: 'Integración de la autofactura con el flag de emisión a null si ambas empresas son propietarias',
    PENDING_TASK_REJECT_VALIDATION: 'Validación para el rechazo de tareas pendientes',
    PENDING_TASK_SEND_VALIDATION: 'Validación para el envío a sap de una factura desde tareas pendientes',
    CREATE_USER_NO_SPONSOR_PARTY: 'Crear un usuario de empresa en la contratación de la empresa no propietaria desde integración de facturas',
    CREATE_USER_THIRD_PARTY: 'Crear un usuario de terceros en la contratación del tercero desde integración de facturas',
    SEND_TO_THIRDPARTY: 'Proceso de envío de facturas por email a terceros',
    INVOICE_RECADV_MISSING_ORDER_VALIDATION: 'Validación de los datos del pedido para la creación de una factura a partir de una recepción',
    HIDDEN_INVOICE_EXTENSION: 'Eliminar extensión en visualización de borradores',
    NOT_SEND_INTEGRATION_NOTIFICATION: 'No se envía la notificación de integración ni estado del documento (RECADV y/o ORDER)',
    ADD_COUNTRY_PARTY_TO_MANUAL_INVOICE: 'Añadir el país a los NIFs de las empresas desde la creación manual',
    SEND_EMAIL_WITH_COPY_TO_ORIGIN: 'Envía una copia del email para el tipo de email configurado al origen configurado',
    UPDATE_FLAG_OTP_AUTHENTICATION: 'Activar autenticación OTP (doble factor)',
    APPROVAL_FLOW_BY_LEVELS_AND_USERS: 'Flujo de aprobación por niveles y usuarios (Requiere de configuración de los centros)',
    SEE_ONLY_GENERAL_SIGN_DOCUMENT: 'Ver solo documentos de firma delegada generales',
    GET_PERMANENT_ESTABLISHMENT: 'Ver aquellos centros que sean establecimientos permanentes',
    GET_TAXES_PROJECT: 'Ver los impuestos asociados al proyecto',
    GET_TAXES_BUSINESS_RULE_REE: 'Ver los impuestos según las reglas de negocio para los impuestos de REE',
    GENERATE_TEXT_COLLECTION_ADDITIONAL_INFO: 'Texto fijo en información adicional de método de pago en borradores',
    INVOICE_INTEGRATION_NO_CERTIFICATE_VALIDATION: 'Facturas de contrato por integración entren sin pasar por la validación de certificación-pedido',
    GENERATE_TEXT_WITHHOLDING_REASON: 'Texto fijo en motivo de retención en borradores',
    DRAFT_CORRECTIVE_INVOICE_ONLY: 'Desde borradores solo solo se puede crear factura rectificativa',
    DRAFT_INVOICE_DOCUMENT_FILTER: 'Tipos de documento acotados a nivel general y a nivel de línea en un proyecto',
    INVOICE_REJECT_RELEASE_RECADV: 'Liberar la certificación al rechazar una factura',
    CREATE_DOCUMENT_RELATION: 'Crear las relaciones entre documentos en los procesos de integración',
    INVOICE_STATUS_RECADV_INVOICED: 'Factura desde recepción, estado facturado dependiendo de precio por cantidad',
    CALCULATE_NEGATIVE_RETENTION: 'Las retenciones en facturas negativas se sumarán al importe total ejecutable',
    RECADV_SUBTYPE_DEFAULT_GOODS: 'En las recepciones por defecto goods en el caso de no estar informado nada en el tipo recibido',
    HIDDEN_COMMUNICATION_METHOD: 'Eliminar visualizacion de metodos de envio en borradores',
    DRAFT_DOCUMENTS_HEADER: 'Obtener los documentos a nivel de cabecera a partir de las lineas',
    INVOICE_INSTALLMENTS_DATERANGE: 'Fecha de vencimiento(en meses) para borradores de un proyecto',
    GENERATE_INVOICE_INSTALLMENTS: 'Carga por defecto los datos de vencimiento en totales de borradores',
    ATTACHMENTS_REPOSITORY: 'Adjuntar los documentos del repositorio cuyo nombre cumple cierto patrón',
    ATTACHMENTS_REPOSITORY_SUBDIRECTORY_DATE: 'Adjuntar documentos del repositorio cuyo nombre cumple cierto patrón contenidos en subdirectorio fecha',
    CHANGE_OPERATION_PERIOD_DATES: 'Permite modificar en borradores las fechas de operacion y periodo impositivo',
    NOTIFY_ERROR_TO_PROJECT_PARTY_EMAIL_CONTACT: 'Notificar además de al emisor, si viene en la factura, al email configurado en la administración de la empresa en el servicio',
    DRAFT_NO_CHANGE_CURRENCY: 'No se permite modificar la divisa en borradores',
    ALLOWED_EMAIL_DOMAINS: 'Dominios de email permitidos para los envíos por correo (separados por ;)',
    WITHHOLDINGAMOUNT_ABSOLUTE_TO_ACCOUNTING: 'El importe de la retención en garantía se contabiliza como un importe absoluto en las validaciones contables',
    REQUIRED_FIELDS_FOR_FIRST_LEVEL_APPROVAL: 'Campos adicionales para la aprobación de primer nivel',
    VOCENTO_VALIDATION_WS: 'Personalizada Vocento: Validación para los datos adicionales de Vocento',
    VOCENTO_CENTRE_VALIDATION_WS: 'Personalizada Vocento: validación centro en facturas por servicio web',
    SHIPMENT_NOTIFICATION: 'Notificación de entrega de factura al comprador',
    UPDATE_ALL_STATUS_INVOICENOTE: 'Actualización de estados negativos por la VAN',
    NO_INTEGRATE_DOCUMENT_ERROR: 'No integrar documento con estado de error',
    CONFIGURATION_CONTROLDOCUMENT_SENDLINK: 'Envío automático de documentos de control',
    CONFIGURATION_BILLING_SPONSOR_REPORT: 'Añadir empresas sponsor al informe de facturación',
    METADATA_FROM_PATH: 'Obtener el fichero de metadatos de la ruta y no volver a generarlo',
    REPLACE_NIF: 'Reemplazar NIF de origen por el NIF configurado',
	EXTERNAL_PDF: 'Pdf externo no generado por Ecosystems B2B'
  },

  recaptcha: {
    error: 'Debes marcar la casilla de CAPTCHA',
    text: 'Ha hecho varios intentos fallidos de entrar. Por favor, verifique el CAPTCHA para continuar'
  },
  mailServer: {
    new: 'Nuevo servidor de correo',
    notify: {
      add_mailServer: 'Servidor de correo creado correctamente',
      delete_mailServer: 'Servidor de correo eliminado correctamente.',
      save_changes: 'Servidor de correo actualizado correctamente'
    },
    confirm: {
      delete_mailServer: '¿Está seguro de eliminar el servidor de correo?'
    },
    load: {
      add_mailServer: 'Añadiendo servidor de correo ...',
      delete_mailServer: 'Eliminando el servidor de correo ...'
    },
    mailServer_table: {
      host: 'Host',
      user: 'Usuario',
      password: 'Contraseña',
      mailfrom: 'Dirección de correo origen',
      port: 'Puerto',
      auth: 'Auth',
      idClient: 'Id cliente',
      idTenant: 'Id de la organización',
      clientSecret: 'Secreto del cliente',
      validityDateTo: 'Fecha validez de acceso',
      saveToSentItems: 'Guardar mails enviados',
      protocol: 'Protocolo'
    },
    test_error: 'No fue posible establecer la conexión con el servidor de correo',
    duplicate_error: 'Ya existe un servidor de correo con estos datos',
    test_ok: 'La conexión con el servidor de correo se realizó correctamente',
    auth_error: 'Se produjo un error de autenticación',
    delete_mailServer: 'Eliminar',
    delete_mailServer_tooltip: 'Eliminar servidor de correo',
    test_tooltip: 'Comprobar conexión',
    test: 'Test',
    password_too_long: 'La contraseña es demasiado larga. Por favor, utilice una contraseña más corta',
    data_integrity_error: 'Error de integridad de datos al guardar el servidor de correo'
  },
  unit_of_measure: {
    title: 'Unidad de medida',
    UND: 'Unidades',
    HUR: 'Horas',
    KGM: 'Kilogramos',
    LTR: 'Litros',
    OTR: 'Otros',
    BOX: 'Cajas',
    BDJ: 'Bandejas',
    BID: 'Bidones',
    BOL: 'Bolsas',
    BOM: 'Bombonas',
    BTL: 'Botellas',
    BOT: 'Botes',
    CLT: 'Centilitros',
    CMT: 'Centimetros',
    GAR: 'Garrafas',
    GRM: 'Gramos',
    KMT: 'Kilómetros',
    MTR: 'Metros',
    MMT: 'Milimetros',
    PKG: 'Paquetes',
    ROL: 'Rollos',
    SOB: 'Sobres',
    MT3: 'Metro cúbico',
    WAT: 'Vatio',
    HOJ: 'Hojas',
    JUG: 'Juegos',
    CEN: 'Centenas',
    PAR: 'Par/Torque',
    CAR: 'Carrete',
    NTB: 'Notebook',
    MT2: 'Metros cuadrados',
    PCE: 'Piezas',
    XCA: 'Caja',
    TNE: 'Toneladas'
  }
}
